function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8bdb"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8bdb"] = parcelRequire;
}
parcelRequire.register("dLcGf", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $a0498038aab756c7$export$6503ec6e8aabbaf; }, function (v) { return $a0498038aab756c7$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $a0498038aab756c7$export$f7ad0328861e2f03; }, function (v) { return $a0498038aab756c7$export$f7ad0328861e2f03 = v; });
var $a0498038aab756c7$export$6503ec6e8aabbaf;
var $a0498038aab756c7$export$f7ad0328861e2f03;
"use strict";
var $a0498038aab756c7$var$mapping = {};
function $a0498038aab756c7$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$a0498038aab756c7$var$mapping[keys[i]] = pairs[keys[i]];
}
function $a0498038aab756c7$var$resolve(id) {
    var resolved = $a0498038aab756c7$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$a0498038aab756c7$export$6503ec6e8aabbaf = $a0498038aab756c7$var$register;
$a0498038aab756c7$export$f7ad0328861e2f03 = $a0498038aab756c7$var$resolve;

});

parcelRequire.register("8xKIn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6385a46148106318$export$2e2bcd8739ae039; });

var $aSfiK = parcelRequire("aSfiK");

var $eBrda = parcelRequire("eBrda");
var $6385a46148106318$export$2e2bcd8739ae039 = {
    data () {
        return {
            ...(0, $eBrda.default)()
        };
    },
    props: [
        "thrConfig"
    ],
    mounted () {
        // Preselected category if configured
        if (typeof this.thrConfig.preselectCategory === "string") {
            this.$log.debug("Category Preselect: " + this.thrConfig.preselectCategory);
            if (this.selectCategory(this.thrConfig.preselectCategory)) this.showScreen("animalSelection");
            // Preselected category if configured
            if (typeof this.thrConfig.preselectAnimal === "string") {
                this.$log.debug("Animal Preselect: " + this.thrConfig.preselectAnimal);
                if (this.selectAnimal(this.thrConfig.preselectAnimal)) this.showScreen("numberOfAnimals");
            }
        }
        if (this.thrConfig.historyMode === "browser") history.pushState({
            thrScreen: this.screen
        }, null, window.location);
        // Attach onpopstate event handler
        window.onpopstate = ()=>{
            if (history.state !== null && "thrScreen" in history.state && this.previousScreens[this.previousScreens.length - 1] === history.state.thrScreen) this.previousScreen(true);
        };
        // Esc key event handler
        if (this.thrConfig.style === "button") document.addEventListener("keydown", ({ key: key })=>{
            if (key === "Escape") this.closeOverlay();
        });
    },
    methods: {
        logoBlv () {
            if (document.getElementById("trApp").offsetWidth > 756) {
                if (this.thrConfig.locale == "fr_CH") return this.logoBlvFR;
                else if (this.thrConfig.locale == "it_CH") return this.logoBlvIT;
                else return this.logoBlvDE;
            } else {
                if (this.thrConfig.locale == "fr_CH") return this.logoBlvFRMobile;
                else if (this.thrConfig.locale == "it_CH") return this.logoBlvITMobile;
                else return this.logoBlvDEMobile;
            }
        },
        logoSts () {
            if (this.thrConfig.locale == "fr_CH") return this.logoStsFR;
            else if (this.thrConfig.locale == "it_CH") return this.logoStsIT;
            else return this.logoStsDE;
        },
        selectCategory (category) {
            if (typeof category === "object") this.category = category;
            else if (typeof category === "string") {
                for(const categoryName in this.categories)if (categoryName === category) {
                    this.category = this.categories[categoryName];
                    break;
                }
            }
            this.$log.debug("Category selected: " + category);
            this.$log.debug("Category type: " + typeof category);
            this.$log.debug("Animals in this category: " + this.animals[category.index]);
            if (typeof this.category === "object") return true;
            else return false;
        },
        selectAnimal (animal) {
            if (typeof animal === "object") this.animal = animal;
            else if (typeof animal === "string") {
                for(const animalName in this.animals[this.category.index])if (animalName === animal) {
                    this.animal = this.animals[this.category.index][animalName];
                    break;
                }
            }
            if (typeof this.animal === "object") {
                if (this.animal.hasWeightOption) this.animalWeight = this.animal.weightOptions["0"];
                return true;
            } else return false;
        },
        showScreen (screenName) {
            this.$log.debug("Previous Screens:", this.previousScreens);
            this.$log.debug("Current screen: " + this.screen);
            this.$log.debug("screenName: " + screenName);
            this.$log.debug("numberOfAnimals:" + this.numberOfAnimals);
            this.$log.debug("animal:" + this.animal);
            if (this.animal !== false) {
                this.$log.debug(this.animal);
                if (typeof this.animal.minHardLimit == "undefined") this.animal.minHardLimit = 1;
                if (typeof this.animal.maxHardLimit == "undefined") this.animal.maxHardLimit = 99;
                this.$log.debug("minHardLimit: " + this.animal.minHardLimit);
                this.$log.debug("maxHardLimit: " + this.animal.maxHardLimit);
                this.$log.debug("hasWeightOptions: " + this.animal.hasWeightOption);
                // Validate input
                if (screenName === "weight" && this.numberOfAnimals < this.animal.minHardLimit || screenName === "weight" && this.numberOfAnimals > this.animal.maxHardLimit) {
                    // Warning if number of animals is under/over min/max limit
                    this.$log.debug("Show warning");
                    this.showNumberError = true;
                    // Scroll to top of the widget
                    this.$refs.mainTitle.scrollIntoView();
                    return;
                }
                if (screenName === "weight" && typeof this.animalWeight === "undefined" && "weightOptions" in this.animal) this.animalWeight = this.animal.weightOptions[this.thrConfig.locale][0];
                // Validate animal length
                if (screenName === "results" && this.animalLength < this.animal.minLength || screenName === "results" && this.animalLength > this.animal.maxLength) {
                    this.$log.debug("LENGTH ERROR: Show length error");
                    this.showLengthError = true;
                    // Scroll to top of the widget
                    this.$refs.mainTitle.scrollIntoView();
                    return;
                }
                // Validate animals withersHeight
                if (screenName === "results") {
                    const heights = this.animalWithersHeights;
                    for(let i in heights)if (heights[i] < this.animal.minWithersHeight || heights[i] > this.animal.maxWithersHeight) {
                        this.$log.debug("WITHERS HEIGHT ERROR: Show withers height error");
                        this.showWithersHeightError = true;
                        // Scroll to top of the widget
                        this.$refs.mainTitle.scrollIntoView();
                        return;
                    }
                }
            }
            const screenIndex = this.availableScreens.indexOf(screenName);
            let nextScreenIndex = -1;
            if (screenIndex > -1) {
                nextScreenIndex = screenIndex;
                this.$log.debug("nextScreenIndex by name");
            } else {
                // Select next screen in order of available screens
                this.$log.debug(this.availableScreens);
                let nextScreenIndex = this.availableScreens.indexOf(this.screen) + 1;
                this.$log.debug("nextScreenIndex by list order");
            }
            this.$log.debug("Next screen index: " + nextScreenIndex);
            this.$log.debug("Next screen: " + this.availableScreens[nextScreenIndex]);
            // Skip screens that are optional
            if (this.availableScreens[nextScreenIndex] === "weight" && this.animal.hasWeightOption !== true) {
                nextScreenIndex++;
                this.$log.debug("Skipping screen: weight");
            }
            if (this.availableScreens[nextScreenIndex] === "length" && this.animal.hasLengthOption !== true) {
                nextScreenIndex++;
                this.$log.debug("Skipping screen: length");
            }
            if (this.availableScreens[nextScreenIndex] === "withersHeight" && this.animal.hasWithersHeightOption !== true) {
                nextScreenIndex++;
                this.$log.debug("Skipping screen: withersHeight");
            }
            // Set image to use in length screen
            if (this.availableScreens[nextScreenIndex] === "length") this.lengthImage = this.lengthImages[this.animal.lengthMeasurementCategory];
            // Save previous screens path
            this.previousScreens.push(this.screen);
            // Change to new screen
            this.screen = this.availableScreens[nextScreenIndex];
            if (this.thrConfig.historyMode === "browser") history.pushState({
                thrScreen: this.screen
            }, null, "");
            this.$log.debug("New screen: " + this.screen);
            // Make sure the animalWithersHeights array contains the correct number of elements
            if (this.screen === "withersHeight") {
                this.animalWithersHeights.length = this.numberOfAnimals;
                this.$log.debug("Prepare this.animalWithersHeights array");
                this.$log.debug(this.animalWithersHeights);
                // Set the value to an empty string unless it's already a number. If that's the case, we already have values entered by the user.
                for(let i = 0; i < this.animalWithersHeights.length; ++i)if (typeof this.animalWithersHeights[i] !== "number") this.animalWithersHeights[i] = "";
            }
            if (this.screen === "results") {
                // Set ratios for the 3d visual
                const cubeContainer = document.getElementById("results-cube-container");
                if (cubeContainer.style.display !== "none") {
                    let ratios = this.stsRecommendedValuesRatios;
                    //cubeContainer.querySelector(".cube").style.transform = "scale3d(" + ratios.length + ", " + ratios.height + ", " + ratios.width + ")";
                    let root = document.documentElement;
                    root.style.setProperty("--tr-visual-3d-scale-x", ratios.length);
                    root.style.setProperty("--tr-visual-3d-scale-y", ratios.width);
                    root.style.setProperty("--tr-visual-3d-scale-z", ratios.height);
                }
            }
            // Analytics Event
            /* global gtagTR */ if (typeof gtagTR === "function") {
                this.$log.debug("Send UA4 event for screen change.");
                gtagTR("event", "show_screen", {
                    screen: this.screen,
                    animal: this.animal.index,
                    numberOfAnimals: this.numberOfAnimals
                });
            } else this.$log.debug("Not sending UA4 event for screen change. gtagTR not a function.");
        },
        previousScreen (isBrowserHistoryEvent = false) {
            this.$log.debug(this.previousScreens);
            if (typeof this.previousScreens === "object") {
                this.screen = this.previousScreens[this.previousScreens.length - 1];
                this.previousScreens.splice(this.previousScreens.length - 1, 1);
            }
            // reset animal selection when restarted
            if (this.screen === this.availableScreens[0]) this.animal = false;
            if (!isBrowserHistoryEvent && this.thrConfig.historyMode === "browser") // Trigger history event manually
            history.back();
        },
        lawMinimalHeight () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.height === "string") return this.animal.laws.height;
                else if (typeof this.animal.laws.height === "function") {
                    let height;
                    if (this.animal.hasWeightOption) height = this.animal.laws.height(this.numberOfAnimals, this.animalWeight);
                    else if (this.animal.hasLengthOption) {
                        height = this.animal.laws.height(this.animalLength);
                        this.$log.debug("Found minimal height for " + this.animal.index + " with length " + this.animalLength + ": " + height + " cm");
                    } else height = this.animal.laws.height(this.numberOfAnimals);
                    this.$log.debug("Found minimal height for " + this.animal.index + ": " + height + " cm");
                    return height + " cm";
                }
            }
            return "";
        },
        animalTextExists (key) {
            if (typeof key === "string" && this.animal && this.category) {
                const text = (0, (/*@__PURE__*/$parcel$interopDefault($aSfiK)))(this.$i18n.messages[this.thrConfig.locale].txt.animals[this.category.index][this.animal.index], key);
                this.$log.debug("Looking for animal text of for key " + key, "Text found: " + text);
                if (typeof text === "string") {
                    this.$log.debug("Found animal text for key " + key + ": " + text);
                    return true;
                }
            }
            this.$log.debug("Could not find animal text for key " + key);
            return false;
        },
        animalTextsExist (keys) {
            this.$log.debug("Check multiple animal texts: " + keys);
            let found = false;
            if (typeof keys === "object" && this.animal) keys.forEach((key)=>{
                if (this.animalTextExists(key) === true) found = true;
            });
            return found;
        },
        openOverlay (event) {
            console.log(event.target);
            event.target.closest(".sts-tierhaltungsrechner").querySelector(".tr-wrapper").classList.add("open");
            // Customizations for specific websites
            if (window.location.hostname.includes("tierschutz.com")) {
                const appElement = document.querySelector("#trApp .tr-wrapper");
                const parentElement = document.querySelector("body");
                // Move app element into body tag
                if (appElement !== null) parentElement.append(appElement);
                appElement.classList.add("tierschutzcom");
                // Create additional element for lightbox formatting
                const lbDiv = document.createElement("div");
                lbDiv.classList.add("tierhaltungsrechner");
                lbDiv.classList.add("modal-bg");
                parentElement.append(lbDiv);
            }
        },
        closeOverlay (event = false) {
            if (event !== false) {
                event.target.closest(".sts-tierhaltungsrechner").querySelector(".tr-button").classList.remove("hidden");
                event.target.closest(".sts-tierhaltungsrechner").querySelector(".tr-wrapper").classList.remove("open");
            } else {
                document.querySelectorAll(".sts-tierhaltungsrechner .tr-button").forEach((element)=>{
                    element.classList.remove("hidden");
                });
                document.querySelectorAll(".sts-tierhaltungsrechner .tr-wrapper").forEach((element)=>{
                    element.classList.remove("open");
                });
            }
        },
        showMessage (elementId) {
            console.log(elementId);
            const element = document.getElementById(elementId);
            if (element !== null) element.style.display = "block";
        }
    },
    watch: {
        numberOfAnimals: function(val, oldVal) {
            if (val < 1 && val !== "") this.numberOfAnimals = 1;
        }
    },
    computed: {
        weightOptions () {
            if (this.animal !== false && "weightOptions" in this.animal) return this.animal.weightOptions[this.thrConfig.locale];
            else return {};
        },
        numberErrorType () {
            if (this.animal.minHardLimit > this.numberOfAnimals) return "under";
            else if (this.animal.maxHardLimit < this.numberOfAnimals) return "over";
            else this.showNumberError = false;
        },
        numberWarningType () {
            if (this.animal.minSoftLimit > this.numberOfAnimals) return "under";
            else if (this.animal.maxSoftLimit < this.numberOfAnimals) return "over";
            else this.showNumberError = false;
        },
        stsRecommendedArea () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.area === "number") return this.animal.recommendations.area;
                else if (typeof this.animal.recommendations.area === "string") return this.animal.recommendations.area;
                else if (typeof this.animal.recommendations.area === "function") {
                    let area = this.animal.recommendations.area(this.numberOfAnimals);
                    area = Math.round((area + Number.EPSILON) * 100) / 100;
                    this.$log.debug("stsRecommendedArea: " + area);
                    return area;
                }
            }
            return "";
        },
        stsRecommendedLength () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.length === "string") return this.animal.recommendations.length;
            }
            return "";
        },
        stsRecommendedWidth () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.width === "string") return this.animal.recommendations.width;
            }
            return "";
        },
        stsRecommendedHeight () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.height === "string") return this.animal.recommendations.height;
                else if (typeof this.animal.recommendations.height === "function") {
                    if (this.category.index === "reptiles") return this.animal.recommendations.height(this.animalLength);
                    else {
                        let height = this.animal.recommendations.height(this.numberOfAnimals);
                        height = Math.round((height + Number.EPSILON) * 100) / 100;
                        this.$log.debug("stsHeightRecommendation: " + height);
                        return height;
                    }
                } else if (typeof this.animal.recommendations.clearHeight === "function") {
                    let height = this.animal.recommendations.clearHeight(this.animalWithersHeights);
                    this.$log.info("stsHeightRecommendation 1: " + height.value);
                    height = Math.round((height.value + Number.EPSILON) * 100) / 100;
                    this.$log.info(this.animalWithersHeights);
                    this.$log.info("stsHeightRecommendation 2: " + height);
                    return height + " m";
                }
            }
            return "";
        },
        stsRecommendedBedding () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.bedding === "string") return this.animal.recommendations.bedding;
                else if (typeof this.animal.recommendations.bedding === "function") {
                    let bedding = this.animal.recommendations.bedding(this.numberOfAnimals);
                    bedding = Math.round((bedding + Number.EPSILON) * 100) / 100;
                    this.$log.debug("stsBeddingRecommendation: " + bedding);
                    return bedding;
                }
            }
            return "";
        },
        stsLatticeSpacing () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.latticeSpacing === "string") return this.animal.recommendations.latticeSpacing;
            }
        },
        stsRecommendedWidthExample () {
            if (this.animal !== false && "recommendations" in this.animal) {
                let recommendedArea = 0;
                if (typeof this.animal.recommendations.area === "function") recommendedArea = this.animal.recommendations.area(this.numberOfAnimals);
                else if (typeof this.animal.recommendations.layingArea === "function") recommendedArea = this.animal.recommendations.layingArea(this.animalWithersHeights);
                else return 0;
                this.$log.info("Example area: " + recommendedArea);
                // Rectangle with aspect ratio of 1:2, short side
                let width = Math.sqrt(recommendedArea / 2);
                // Round to nearest 10cm
                width = Math.round(width * 10) / 10;
                // Consider minimum width
                if ("width" in this.animal.recommendations) {
                    const widthNumber = this.animal.recommendations.width.match(/\d+/)[0] / 100;
                    this.$log.debug("AREA: Animal has recommended min width: " + widthNumber);
                    if (width < widthNumber) {
                        this.$log.debug("AREA: Set width to " + widthNumber + " insead of: " + width);
                        width = widthNumber;
                    }
                }
                // Consider minumum clearWidth for equidae
                if ("clearWidth" in this.animal.recommendations) {
                    const widthNumber = this.animal.recommendations.clearWidth(this.animalWithersHeights);
                    this.$log.info("AREA: this.animalsWithersHeights: " + this.animalWithersHeights);
                    this.$log.info("AREA: Animal has recommended min width: " + widthNumber);
                    if (width < widthNumber) {
                        this.$log.info("AREA: Set width to " + widthNumber + " insead of: " + width);
                        width = widthNumber;
                    }
                }
                // Consider minimum length
                if ("length" in this.animal.recommendations) {
                    const minimalLengthNumber = this.animal.recommendations.length.match(/\d+/)[0] / 100;
                    this.$log.info("AREA: Animal has recommended min length: " + minimalLengthNumber);
                    const currentExampleLength = recommendedArea / width;
                    if (currentExampleLength < minimalLengthNumber) {
                        this.$log.debug("AREA: currentExampleLength " + currentExampleLength + "m is shorter than the recommended " + this.animal.recommendations.length);
                        width = recommendedArea / minimalLengthNumber;
                    }
                }
                // Consider certain animal special cases
                if (this.animal.index === "madagascarDayGecko" || this.animal.index === "goldDustDayGecko") {
                    // Needs a square area
                    width = Math.sqrt(recommendedArea);
                    this.$log.debug("AREA: Set area to square for day geckos. Width: " + width);
                }
                this.$log.info("stsRecommendedWidthExample: " + Math.round((width + Number.EPSILON) * 100));
                return Math.round((width + Number.EPSILON) * 100);
            }
            return 0;
        },
        stsRecommendedLengthExample () {
            this.$log.info(this.animal);
            this.$log.info(this.animalWithersHeights);
            this.$log.info("stsRecommendedWidthExample: " + this.stsRecommendedWidthExample);
            if (this.animal !== false && "recommendations" in this.animal) {
                let length = 0;
                if (typeof this.animal.recommendations.area === "function") length = this.animal.recommendations.area(this.numberOfAnimals) / (this.stsRecommendedWidthExample / 100);
                else if (typeof this.animal.recommendations.layingArea === "function") length = this.animal.recommendations.layingArea(this.animalWithersHeights) / (this.stsRecommendedWidthExample / 100);
                else return 0;
                // Consider minimum length
                // this.stsRecommendedWidthExample already adapts to minimum width, due to rounding we sometimes need to increase the number for the length as well
                if ("length" in this.animal.recommendations) {
                    const minimalLengthNumber = this.animal.recommendations.length.match(/\d+/)[0] / 100;
                    if (minimalLengthNumber > length) length = minimalLengthNumber;
                }
                this.$log.info("stsRecommendedLengthExample: " + Math.round((length + Number.EPSILON) * 100));
                return Math.round((length + Number.EPSILON) * 100);
            }
            this.$log.info("stsRecommendedLengthExample: not calculated");
            return 0;
        },
        stsRecommendedLengthExampleText () {
            const length = this.stsRecommendedLengthExample;
            if (length >= 100) return length / 100 + " m";
            else return length + " cm";
        },
        stsRecommendedWidthExampleText () {
            const width = this.stsRecommendedWidthExample;
            if (width >= 100) return width / 100 + " m";
            else return width + " cm";
        },
        stsRecommendedValuesRatios () {
            let exampleDimensions = {};
            this.$log.info(this.category.index);
            if (this.category.index === "equidae") {
                this.$log.info(this.animal.recommendations.clearHeight());
                this.$log.info(this.animal.recommendations.clearHeight().value);
                exampleDimensions = {
                    length: this.stsRecommendedLengthExample,
                    width: this.stsRecommendedWidthExample,
                    height: this.animal.recommendations.clearHeight().value * 100
                };
            } else exampleDimensions = {
                length: this.stsRecommendedLengthExample,
                width: this.stsRecommendedWidthExample,
                height: this.animal.recommendations.heightNumeric
            };
            this.$log.info("exampleDimensions");
            this.$log.info(exampleDimensions);
            const largestNumber = Math.max(exampleDimensions.length, exampleDimensions.width, exampleDimensions.height);
            // Arbitrary number we scale by
            const factor = 1.2;
            const ratios = {
                "width": exampleDimensions.width / largestNumber * factor,
                "length": exampleDimensions.length / largestNumber * factor,
                "height": exampleDimensions.height / largestNumber * factor
            };
            this.$log.info(ratios);
            return ratios;
        },
        stsRecommendedWaterBasin () {
            if (this.animal !== false && "recommendations" in this.animal) {
                let waterBasinText = "";
                // Get formulas
                if ("waterBasin" in this.animal.recommendations) {
                    if (typeof this.animal.recommendations.waterBasin === "function") waterBasinText = this.animal.recommendations.waterBasin(this.numberOfAnimals, this.animalLength);
                }
                // Grab texts
                const recommendationTexts = this.$i18n.messages[this.thrConfig.locale].txt.animals[this.category.index][this.animal.index].recommendations;
                this.$log.debug("recommendationTexts: " + recommendationTexts);
                if ("waterBasin" in recommendationTexts) waterBasinText += recommendationTexts.waterBasin;
                return waterBasinText;
            }
            return "";
        },
        stsRecommendedLayingArea () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.layingArea === "string") return this.animal.recommendations.layingArea;
                else if (typeof this.animal.recommendations.layingArea === "function") return this.animal.recommendations.layingArea(this.animalWithersHeights);
            }
            return "";
        },
        stsRecommendedClearWidth () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.clearWidth === "string") return this.animal.recommendations.clearWidth;
                else if (typeof this.animal.recommendations.clearWidth === "function") return this.animal.recommendations.clearWidth(this.animalWithersHeights);
            }
            return "";
        },
        stsRecommendedClearHeight () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.clearHeight === "string") return this.animal.recommendations.clearHeight;
                else if (typeof this.animal.recommendations.clearHeight === "function") return this.animal.recommendations.clearHeight(this.animalWithersHeights);
            }
            return "";
        },
        stsRecommendedRunoutArea () {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.runoutArea === "string") return this.animal.recommendations.runoutArea;
                else if (typeof this.animal.recommendations.runoutArea === "function") return this.animal.recommendations.runoutArea(this.numberOfAnimals);
            }
            return "";
        },
        lawMinimalArea () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.area === "string") return this.animal.laws.area;
                else if (typeof this.animal.laws.area === "function") {
                    let area;
                    if (this.animal.hasWeightOption && this.category.index === "rodents") area = this.animal.laws.area(this.numberOfAnimals, this.animalWeight);
                    else if (this.category.index === "reptiles") area = this.animal.laws.area(this.numberOfAnimals, this.animalLength / 100);
                    else area = this.animal.laws.area(this.numberOfAnimals);
                    area = Math.round((area + Number.EPSILON) * 100) / 100;
                    this.$log.debug("minimalArea: " + area);
                    return area + " m\xb2";
                }
            }
            return "";
        },
        lawMinimalLength () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.length === "string") return this.animal.laws.length;
                else if (typeof this.animal.laws.length === "function") {
                    let length = this.animal.laws.length(this.animalLength);
                    length = Math.round((length + Number.EPSILON) * 100) / 100;
                    this.$log.debug("minimalLength: " + length);
                    return length + " cm";
                }
            }
            return "";
        },
        lawMinimalWidth () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.width === "string") return this.animal.laws.width;
                else if (typeof this.animal.laws.width === "function") {
                    let width = this.animal.laws.width(this.animalLength);
                    width = Math.round((width + Number.EPSILON) * 100) / 100;
                    this.$log.debug("minimalLength: " + width);
                    return width + " cm";
                }
            }
            return "";
        },
        lawMinimalBedding () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.bedding === "string") return this.animal.laws.bedding;
                else if (typeof this.animal.laws.bedding === "function") {
                    let bedding = this.animal.laws.bedding(this.numberOfAnimals);
                    bedding = Math.round((bedding + Number.EPSILON) * 100) / 100;
                    this.$log.debug("bedding: " + bedding);
                    return bedding + " m";
                }
            }
            return "";
        },
        lawWaterBasin () {
            if (this.animal !== false && "laws" in this.animal) {
                let waterBasinText = "";
                // Get formulas
                if ("waterBasin" in this.animal.laws) {
                    if (typeof this.animal.laws.waterBasin === "function") waterBasinText = this.animal.laws.waterBasin(this.numberOfAnimals, this.animalLength);
                }
                // Grab texts
                const lawTexts = this.$i18n.messages[this.thrConfig.locale].txt.animals[this.category.index][this.animal.index].laws;
                this.$log.debug("lawTexts: " + lawTexts);
                if ("waterBasin" in lawTexts) waterBasinText += lawTexts.waterBasin;
                return waterBasinText;
            }
            return "";
        },
        lawVolume () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.volume === "string") return this.animal.laws.volume;
                else if (typeof this.animal.laws.volume === "function") {
                    let volume = this.animal.laws.volume(this.numberOfAnimals);
                    volume = Math.round((volume + Number.EPSILON) * 100) / 100;
                    this.$log.debug("volume: " + volume);
                    return volume + " m\xb3";
                }
            }
            return "";
        },
        lawLayingArea () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.layingArea === "string") return this.animal.laws.layingArea;
                else if (typeof this.animal.laws.layingArea === "function") return this.animal.laws.layingArea(this.animalWithersHeights);
            }
            return "";
        },
        lawLayingAreaMultiroom () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.layingAreaMultiroom === "string") return this.animal.laws.layingAreaMultiroom;
                else if (typeof this.animal.laws.layingAreaMultiroom === "function") return this.animal.laws.layingAreaMultiroom(this.animalWithersHeights);
            }
            return "";
        },
        lawClearWidth () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.clearWidth === "string") return this.animal.laws.clearWidth;
                else if (typeof this.animal.laws.clearWidth === "function") return this.animal.laws.clearWidth(this.animalWithersHeights);
            }
            return "";
        },
        lawClearHeight () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.clearHeight === "string") return this.animal.laws.clearHeight;
                else if (typeof this.animal.laws.clearHeight === "function") return this.animal.laws.clearHeight(this.animalWithersHeights);
            }
            return "";
        },
        lawRunoutArea () {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.runoutArea === "string") return this.animal.laws.runoutArea;
                else if (typeof this.animal.laws.runoutArea === "function") return this.animal.laws.runoutArea(this.animalWithersHeights);
            }
            return "";
        },
        showNumberWarning () {
            if (this.animal.minSoftLimit > this.numberOfAnimals || this.animal.maxSoftLimit < this.numberOfAnimals) return true;
            else return false;
        },
        animalLinks () {
            if (this.animal) return this.$i18n.messages[this.thrConfig.locale].txt.animals[this.category.index][this.animal.index].links;
            return false;
        }
    }
};

});
parcelRequire.register("aSfiK", function(module, exports) {

var $6vf4x = parcelRequire("6vf4x");
/**
 *
 * @param {Object} o
 * @param {String} path
 * @returns {*}
 */ module.exports = function(o, path) {
    if (typeof path !== "string") throw new TypeError("path must be a string");
    if (typeof o !== "object") throw new TypeError("object must be passed");
    var pathObj = $6vf4x.get(path);
    if (!pathObj.valid) throw new Error("path is not a valid object path");
    return pathObj.getValueFrom(o);
};

});
parcelRequire.register("6vf4x", function(module, exports) {
// gutted from https://github.com/Polymer/observe-js/blob/master/src/observe.js
function $0138cbaef6f9375a$var$noop() {}
function $0138cbaef6f9375a$var$detectEval() {
    // Don't test for eval if we're running in a Chrome App environment.
    // We check for APIs set that only exist in a Chrome App context.
    if (typeof chrome !== "undefined" && chrome.app && chrome.app.runtime) return false;
    // Firefox OS Apps do not allow eval. This feature detection is very hacky
    // but even if some other platform adds support for this function this code
    // will continue to work.
    if (typeof navigator != "undefined" && navigator.getDeviceStorage) return false;
    try {
        var f = new Function("", "return true;");
        return f();
    } catch (ex) {
        return false;
    }
}
var $0138cbaef6f9375a$var$hasEval = $0138cbaef6f9375a$var$detectEval();
function $0138cbaef6f9375a$var$isIndex(s) {
    return +s === s >>> 0 && s !== "";
}
function $0138cbaef6f9375a$var$isObject(obj) {
    return obj === Object(obj);
}
var $0138cbaef6f9375a$var$createObject = "__proto__" in {} ? function(obj) {
    return obj;
} : function(obj) {
    var proto = obj.__proto__;
    if (!proto) return obj;
    var newObject = Object.create(proto);
    Object.getOwnPropertyNames(obj).forEach(function(name) {
        Object.defineProperty(newObject, name, Object.getOwnPropertyDescriptor(obj, name));
    });
    return newObject;
};
function $0138cbaef6f9375a$var$parsePath(path) {
    var keys = [];
    var index = -1;
    var c, newChar, key, type, transition, action, typeMap, mode = "beforePath";
    var actions = {
        push: function() {
            if (key === undefined) return;
            keys.push(key);
            key = undefined;
        },
        append: function() {
            if (key === undefined) key = newChar;
            else key += newChar;
        }
    };
    function maybeUnescapeQuote() {
        if (index >= path.length) return;
        var nextChar = path[index + 1];
        if (mode == "inSingleQuote" && nextChar == "'" || mode == "inDoubleQuote" && nextChar == '"') {
            index++;
            newChar = nextChar;
            actions.append();
            return true;
        }
    }
    while(mode){
        index++;
        c = path[index];
        if (c == "\\" && maybeUnescapeQuote(mode)) continue;
        type = $0138cbaef6f9375a$var$getPathCharType(c);
        typeMap = $0138cbaef6f9375a$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["else"] || "error";
        if (transition == "error") return; // parse error
        mode = transition[0];
        action = actions[transition[1]] || $0138cbaef6f9375a$var$noop;
        newChar = transition[2] === undefined ? c : transition[2];
        action();
        if (mode === "afterPath") return keys;
    }
    return; // parse error
}
var $0138cbaef6f9375a$var$identStart = "[$_a-zA-Z]";
var $0138cbaef6f9375a$var$identPart = "[$_a-zA-Z0-9]";
var $0138cbaef6f9375a$var$identRegExp = new RegExp("^" + $0138cbaef6f9375a$var$identStart + "+" + $0138cbaef6f9375a$var$identPart + "*" + "$");
function $0138cbaef6f9375a$var$isIdent(s) {
    return $0138cbaef6f9375a$var$identRegExp.test(s);
}
var $0138cbaef6f9375a$var$constructorIsPrivate = {};
function $0138cbaef6f9375a$var$Path(parts, privateToken) {
    if (privateToken !== $0138cbaef6f9375a$var$constructorIsPrivate) throw Error("Use Path.get to retrieve path objects");
    for(var i = 0; i < parts.length; i++)this.push(String(parts[i]));
    if ($0138cbaef6f9375a$var$hasEval && this.length) this.getValueFrom = this.compiledGetValueFromFn();
}
var $0138cbaef6f9375a$var$pathCache = {};
function $0138cbaef6f9375a$var$getPath(pathString) {
    if (pathString instanceof $0138cbaef6f9375a$var$Path) return pathString;
    if (pathString == null || pathString.length == 0) pathString = "";
    if (typeof pathString != "string") {
        if ($0138cbaef6f9375a$var$isIndex(pathString.length)) // Constructed with array-like (pre-parsed) keys
        return new $0138cbaef6f9375a$var$Path(pathString, $0138cbaef6f9375a$var$constructorIsPrivate);
        pathString = String(pathString);
    }
    var path = $0138cbaef6f9375a$var$pathCache[pathString];
    if (path) return path;
    var parts = $0138cbaef6f9375a$var$parsePath(pathString);
    if (!parts) return $0138cbaef6f9375a$var$invalidPath;
    var path = new $0138cbaef6f9375a$var$Path(parts, $0138cbaef6f9375a$var$constructorIsPrivate);
    $0138cbaef6f9375a$var$pathCache[pathString] = path;
    return path;
}
$0138cbaef6f9375a$var$Path.get = $0138cbaef6f9375a$var$getPath;
function $0138cbaef6f9375a$var$formatAccessor(key) {
    if ($0138cbaef6f9375a$var$isIndex(key)) return "[" + key + "]";
    else return '["' + key.replace(/"/g, '\\"') + '"]';
}
$0138cbaef6f9375a$var$Path.prototype = $0138cbaef6f9375a$var$createObject({
    __proto__: [],
    valid: true,
    toString: function() {
        var pathString = "";
        for(var i = 0; i < this.length; i++){
            var key = this[i];
            if ($0138cbaef6f9375a$var$isIdent(key)) pathString += i ? "." + key : key;
            else pathString += $0138cbaef6f9375a$var$formatAccessor(key);
        }
        return pathString;
    },
    getValueFrom: function(obj, directObserver) {
        for(var i = 0; i < this.length; i++){
            if (obj == null) return;
            obj = obj[this[i]];
        }
        return obj;
    },
    iterateObjects: function(obj, observe) {
        for(var i = 0; i < this.length; i++){
            if (i) obj = obj[this[i - 1]];
            if (!$0138cbaef6f9375a$var$isObject(obj)) return;
            observe(obj, this[i]);
        }
    },
    compiledGetValueFromFn: function() {
        var str = "";
        var pathString = "obj";
        str += "if (obj != null";
        var i = 0;
        var key;
        for(; i < this.length - 1; i++){
            key = this[i];
            pathString += $0138cbaef6f9375a$var$isIdent(key) ? "." + key : $0138cbaef6f9375a$var$formatAccessor(key);
            str += " &&\n     " + pathString + " != null";
        }
        str += ")\n";
        var key = this[i];
        pathString += $0138cbaef6f9375a$var$isIdent(key) ? "." + key : $0138cbaef6f9375a$var$formatAccessor(key);
        str += "  return " + pathString + ";\nelse\n  return undefined;";
        return new Function("obj", str);
    },
    setValueFrom: function(obj, value) {
        if (!this.length) return false;
        for(var i = 0; i < this.length - 1; i++){
            if (!$0138cbaef6f9375a$var$isObject(obj)) return false;
            obj = obj[this[i]];
        }
        if (!$0138cbaef6f9375a$var$isObject(obj)) return false;
        obj[this[i]] = value;
        return true;
    }
});
function $0138cbaef6f9375a$var$getPathCharType(char) {
    if (char === undefined) return "eof";
    var code = char.charCodeAt(0);
    switch(code){
        case 0x5B:
        case 0x5D:
        case 0x2E:
        case 0x22:
        case 0x27:
        case 0x30:
            return char;
        case 0x5F:
        case 0x24:
            return "ident";
        case 0x20:
        case 0x09:
        case 0x0A:
        case 0x0D:
        case 0xA0:
        case 0xFEFF:
        case 0x2028:
        case 0x2029:
            return "ws";
    }
    // a-z, A-Z
    if (0x61 <= code && code <= 0x7A || 0x41 <= code && code <= 0x5A) return "ident";
    // 1-9
    if (0x31 <= code && code <= 0x39) return "number";
    return "else";
}
var $0138cbaef6f9375a$var$pathStateMachine = {
    "beforePath": {
        "ws": [
            "beforePath"
        ],
        "ident": [
            "inIdent",
            "append"
        ],
        "[": [
            "beforeElement"
        ],
        "eof": [
            "afterPath"
        ]
    },
    "inPath": {
        "ws": [
            "inPath"
        ],
        ".": [
            "beforeIdent"
        ],
        "[": [
            "beforeElement"
        ],
        "eof": [
            "afterPath"
        ]
    },
    "beforeIdent": {
        "ws": [
            "beforeIdent"
        ],
        "ident": [
            "inIdent",
            "append"
        ]
    },
    "inIdent": {
        "ident": [
            "inIdent",
            "append"
        ],
        "0": [
            "inIdent",
            "append"
        ],
        "number": [
            "inIdent",
            "append"
        ],
        "ws": [
            "inPath",
            "push"
        ],
        ".": [
            "beforeIdent",
            "push"
        ],
        "[": [
            "beforeElement",
            "push"
        ],
        "eof": [
            "afterPath",
            "push"
        ]
    },
    "beforeElement": {
        "ws": [
            "beforeElement"
        ],
        "0": [
            "afterZero",
            "append"
        ],
        "number": [
            "inIndex",
            "append"
        ],
        "'": [
            "inSingleQuote",
            "append",
            ""
        ],
        '"': [
            "inDoubleQuote",
            "append",
            ""
        ]
    },
    "afterZero": {
        "ws": [
            "afterElement",
            "push"
        ],
        "]": [
            "inPath",
            "push"
        ]
    },
    "inIndex": {
        "0": [
            "inIndex",
            "append"
        ],
        "number": [
            "inIndex",
            "append"
        ],
        "ws": [
            "afterElement"
        ],
        "]": [
            "inPath",
            "push"
        ]
    },
    "inSingleQuote": {
        "'": [
            "afterElement"
        ],
        "eof": [
            "error"
        ],
        "else": [
            "inSingleQuote",
            "append"
        ]
    },
    "inDoubleQuote": {
        '"': [
            "afterElement"
        ],
        "eof": [
            "error"
        ],
        "else": [
            "inDoubleQuote",
            "append"
        ]
    },
    "afterElement": {
        "ws": [
            "afterElement"
        ],
        "]": [
            "inPath",
            "push"
        ]
    }
};
var $0138cbaef6f9375a$var$invalidPath = new $0138cbaef6f9375a$var$Path("", $0138cbaef6f9375a$var$constructorIsPrivate);
$0138cbaef6f9375a$var$invalidPath.valid = false;
$0138cbaef6f9375a$var$invalidPath.getValueFrom = $0138cbaef6f9375a$var$invalidPath.setValueFrom = function() {};
module.exports = $0138cbaef6f9375a$var$Path;

});


parcelRequire.register("eBrda", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa19a10047f4bae9$export$2e2bcd8739ae039; });
















































































































































































































function $aa19a10047f4bae9$export$2e2bcd8739ae039() {
    return {
        title: "Tierhaltungs-Rechner",
        logoStsDE: (parcelRequire("4MTjz")),
        logoStsFR: (parcelRequire("ftBil")),
        logoStsIT: (parcelRequire("5hQg5")),
        logoBlvDE: (parcelRequire("jmbUb")),
        logoBlvDEMobile: (parcelRequire("hQ7mc")),
        logoBlvFR: (parcelRequire("gCCtT")),
        logoBlvFRMobile: (parcelRequire("80eyo")),
        logoBlvIT: (parcelRequire("Yenyq")),
        logoBlvITMobile: (parcelRequire("bdiEL")),
        icon68: (parcelRequire("6LeKK")),
        iconWarning: (parcelRequire("jXOPO")),
        iconWarningWhite: (parcelRequire("gm0R4")),
        screen: "categorySelection",
        category: false,
        animal: false,
        numberOfAnimals: 1,
        animalWeight: false,
        animalLength: false,
        lengthImage: null,
        lengthImages: {
            lizards: (parcelRequire("77Qib")),
            snakes: (parcelRequire("6Xvd8")),
            turtles: (parcelRequire("l3HZB"))
        },
        animalWithersHeights: [],
        withersHeightImage: (parcelRequire("5mXWS")),
        showNumberError: false,
        showLengthError: false,
        showWithersHeightError: false,
        availableScreens: [
            "categorySelection",
            "animalSelection",
            "multipleBirds",
            "numberOfAnimals",
            "weight",
            "length",
            "withersHeight",
            "results"
        ],
        previousScreens: [],
        categories: {
            rodents: {
                index: "rodents",
                img: (parcelRequire("9FMlx")),
                imgSmall: (parcelRequire("8xnez")),
                imgMedium: (parcelRequire("8Qtry")),
                imgLarge: (parcelRequire("5GtYp"))
            },
            reptiles: {
                index: "reptiles",
                img: (parcelRequire("5I2Ke")),
                imgSmall: (parcelRequire("6iff5")),
                imgMedium: (parcelRequire("fU9SR")),
                imgLarge: (parcelRequire("f4LR8"))
            },
            birds: {
                index: "birds",
                img: (parcelRequire("7c9qL")),
                imgSmall: (parcelRequire("5vJe8")),
                imgMedium: (parcelRequire("1Ke2W")),
                imgLarge: (parcelRequire("jNfGL")),
                imgMultiple: (parcelRequire("3SGCS")),
                imgMultipleSmall: (parcelRequire("djzAO")),
                imgMultipleMedium: (parcelRequire("g2jQX")),
                imgMultipleLarge: (parcelRequire("2g0QR"))
            },
            equidae: {
                index: "equidae",
                img: (parcelRequire("1q5SW")),
                imgSmall: (parcelRequire("eM0uv")),
                imgMedium: (parcelRequire("aqWO3")),
                imgLarge: (parcelRequire("jVMtt"))
            }
        },
        animals: {
            rodents: {
                degu: {
                    index: "degu",
                    img: (parcelRequire("ivWYv")),
                    imgSmall: (parcelRequire("l2f2S")),
                    imgMedium: (parcelRequire("d0JD4")),
                    imgLarge: (parcelRequire("8nk7J")),
                    minHardLimit: 2,
                    maxSoftLimit: 5,
                    maxHardLimit: 8,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 5, 0) * 0.4;
                        },
                        height: "200 cm",
                        bedding: "50 - 60 cm",
                        latticeSpacing: "1.3 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 5, 0) * 0.2;
                        },
                        height: "70 cm",
                        bedding: "30 cm"
                    }
                },
                fancyMouse: {
                    index: "fancyMouse",
                    img: (parcelRequire("83atf")),
                    imgSmall: (parcelRequire("1YYrM")),
                    imgMedium: (parcelRequire("bm3u4")),
                    imgLarge: (parcelRequire("bK2SC")),
                    minHardLimit: 2,
                    maxSoftLimit: 6,
                    maxHardLimit: 10,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 0.8 + Math.max(numberOfAnimals - 2, 0) * 0.3;
                        },
                        height: "100 cm",
                        bedding: "20 - 40 cm",
                        latticeSpacing: "0.7 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.18 + Math.max(numberOfAnimals - 2, 0) * 0.05;
                        },
                        height: "-",
                        bedding: "-"
                    }
                },
                goldenHamster: {
                    index: "goldenHamster",
                    img: (parcelRequire("jUvL2")),
                    imgSmall: (parcelRequire("hHyip")),
                    imgMedium: (parcelRequire("7rMNk")),
                    imgLarge: (parcelRequire("rx8Xw")),
                    maxHardLimit: 1,
                    recommendations: {
                        area: function() {
                            return 1;
                        },
                        height: "100 cm",
                        bedding: "40 - 80 cm",
                        latticeSpacing: "0.7 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.18;
                        },
                        height: "-",
                        bedding: "15 cm"
                    }
                },
                rabbit: {
                    index: "rabbit",
                    img: (parcelRequire("9xnaf")),
                    imgSmall: (parcelRequire("kjrgL")),
                    imgMedium: (parcelRequire("9uFBA")),
                    imgLarge: (parcelRequire("l1cDN")),
                    minHardLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 6,
                    hasWeightOption: true,
                    weightOptions: {
                        de_CH: {
                            0: "bis 2.3 Kg",
                            1: "2.3 bis 3.5 Kg",
                            2: "3.5 bis 5.5 Kg",
                            3: "mehr als 5.5 Kg"
                        },
                        fr_CH: {
                            0: "jusqu'\xe0 2,3 kg",
                            1: "entre 2,3 et 3,5 kg",
                            2: "entre 3,5 et 5,5 kg",
                            3: "plus de 5,5 kg"
                        },
                        it_CH: {
                            0: "fino a 2.3 Kg",
                            1: "da 2.3 a 3.5 Kg",
                            2: "da 3.5 a 5.5 Kg",
                            3: "pi\xf9 di 5.5 Kg"
                        }
                    },
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 6 + Math.max(numberOfAnimals - 2, 0) * 0.5;
                        },
                        height: "70 - 100 cm",
                        bedding: "5 - 10 cm",
                        latticeSpacing: "2.5 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalWeight = null) {
                            const weightOptionStrings = {
                                "bis 2.3 Kg": "bis 2.3 Kg",
                                "2.3 bis 3.5 Kg": "2.3 bis 3.5 Kg",
                                "3.5 bis 5.5 Kg": "3.5 bis 5.5 Kg",
                                "mehr als 5.5 Kg": "mehr als 5.5 Kg",
                                "jusqu'\xe0 2,3 kg": "bis 2.3 Kg",
                                "entre 2,3 et 3,5 kg": "2.3 bis 3.5 Kg",
                                "entre 3,5 et 5,5 kg": "3.5 bis 5.5 Kg",
                                "plus de 5,5 kg": "mehr als 5.5 Kg",
                                "fino a 2.3 Kg": "bis 2.3 Kg",
                                "da 2.3 a 3.5 Kg": "2.3 bis 3.5 Kg",
                                "da 3.5 a 5.5 Kg": "3.5 bis 5.5 Kg",
                                "pi\xf9 di 5.5 Kg": "mehr als 5.5 Kg"
                            };
                            animalWeight = weightOptionStrings[animalWeight];
                            const values = {
                                "bis 2.3 Kg": {
                                    2: 0.48,
                                    3: 0.815,
                                    4: 1.15,
                                    5: 1.418,
                                    6: 1.686
                                },
                                "2.3 bis 3.5 Kg": {
                                    2: 0.48,
                                    3: 0.815,
                                    4: 1.15,
                                    5: 1.418,
                                    6: 1.686
                                },
                                "3.5 bis 5.5 Kg": {
                                    2: 0.72,
                                    3: 1.22,
                                    4: 1.72,
                                    5: 2.12,
                                    6: 2.52
                                },
                                "mehr als 5.5 Kg": {
                                    2: 0.93,
                                    3: 1.53,
                                    4: 2.28,
                                    5: 2.76,
                                    6: 3.24
                                }
                            };
                            if (animalWeight in values && numberOfAnimals in values[animalWeight]) {
                                const area = values[animalWeight][numberOfAnimals];
                                return area;
                            } else return "0";
                        },
                        height: function(numberOfAnimals, animalWeight) {
                            const weightOptionStrings = {
                                "bis 2.3 Kg": "bis 2.3 Kg",
                                "2.3 bis 3.5 Kg": "2.3 bis 3.5 Kg",
                                "3.5 bis 5.5 Kg": "3.5 bis 5.5 Kg",
                                "mehr als 5.5 Kg": "mehr als 5.5 Kg",
                                "jusqu'\xe0 2,3 kg": "bis 2.3 Kg",
                                "entre 2,3 et 3,5 kg": "2.3 bis 3.5 Kg",
                                "entre 3,5 et 5,5 kg": "3.5 bis 5.5 Kg",
                                "plus de 5,5 kg": "mehr als 5.5 Kg",
                                "fino a 2.3 Kg": "bis 2.3 Kg",
                                "da 2.3 a 3.5 Kg": "2.3 bis 3.5 Kg",
                                "da 3.5 a 5.5 Kg": "3.5 bis 5.5 Kg",
                                "pi\xf9 di 5.5 Kg": "mehr als 5.5 Kg"
                            };
                            animalWeight = weightOptionStrings[animalWeight];
                            switch(animalWeight){
                                case "bis 2.3 Kg":
                                    return "40 ";
                                case "2.3 bis 3.5 Kg":
                                    return "50 ";
                                case "3.5 bis 5.5 Kg":
                                    return "60 ";
                                case "mehr als 5.5 Kg":
                                    return "60 ";
                                default:
                                    return 0;
                            }
                        },
                        bedding: "-"
                    }
                },
                guineaPig: {
                    index: "guineaPig",
                    img: (parcelRequire("bm01k")),
                    imgSmall: (parcelRequire("2TmbY")),
                    imgMedium: (parcelRequire("9ljoa")),
                    imgLarge: (parcelRequire("djySE")),
                    minHardLimit: 2,
                    maxSoftLimit: 6,
                    maxHardLimit: 8,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 4 + Math.max(numberOfAnimals - 4, 0) * 0.5;
                        },
                        height: "50 cm",
                        bedding: "5 - 10 cm",
                        latticeSpacing: "2.5 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 2, 0) * 0.2;
                        },
                        height: "-",
                        bedding: "-"
                    }
                },
                rat: {
                    index: "rat",
                    img: (parcelRequire("cGZip")),
                    imgSmall: (parcelRequire("2MnsN")),
                    imgMedium: (parcelRequire("crctI")),
                    imgLarge: (parcelRequire("lVbnu")),
                    minHardLimit: 2,
                    maxSoftLimit: 6,
                    maxHardLimit: 8,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 5, 0) * 0.4;
                        },
                        height: "200 cm",
                        bedding: "-",
                        latticeSpacing: "1.2 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 5, 0) * 0.05;
                        },
                        height: "70 cm",
                        bedding: "-"
                    }
                },
                gerbil: {
                    index: "gerbil",
                    img: (parcelRequire("9oXv8")),
                    imgSmall: (parcelRequire("8g3Cl")),
                    imgMedium: (parcelRequire("9E87i")),
                    imgLarge: (parcelRequire("kdB5n")),
                    minHardLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 5,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 1 + Math.max(numberOfAnimals - 2, 0) * 0.4;
                        },
                        height: "100 cm",
                        bedding: "40 - 80 cm",
                        latticeSpacing: "1 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 5, 0) * 0.05;
                        },
                        height: "-",
                        bedding: "25 cm"
                    }
                },
                dwarfHamster: {
                    index: "dwarfHamster",
                    img: (parcelRequire("bpd43")),
                    imgSmall: (parcelRequire("1bfTi")),
                    imgMedium: (parcelRequire("2WS1S")),
                    imgLarge: (parcelRequire("h9uQD")),
                    minSoftLimit: 4,
                    maxHardLimit: 5,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 0.8 + Math.max(numberOfAnimals - 2, 0) * 0.3;
                        },
                        height: "100 cm",
                        bedding: "40 - 80 cm",
                        latticeSpacing: "0.7 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.18 + Math.max(numberOfAnimals - 1, 0) * 0.05;
                        },
                        height: "-",
                        bedding: "15 cm"
                    }
                }
            },
            reptiles: {
                royalPython: {
                    index: "royalPython",
                    img: (parcelRequire("3eHOZ")),
                    imgSmall: (parcelRequire("6K203")),
                    imgMedium: (parcelRequire("7cyV5")),
                    imgLarge: (parcelRequire("7PgG0")),
                    lengthMeasurementCategory: "snakes",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 5,
                    minLength: 20,
                    maxLength: 140,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 1.8 + Math.max(numberOfAnimals - 2, 0) * 0.5;
                        },
                        length: "180 cm",
                        width: "100 cm",
                        height: function(animalLength) {
                            if (animalLength >= 130) return "110 cm";
                            else return "100 cm";
                        }
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 0.5 * animalLength + Math.max(numberOfAnimals - 2, 0) * 0.2 * animalLength * 0.5 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength;
                        },
                        width: function(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        },
                        height: function(animalLength) {
                            return Math.round(animalLength * 0.75 + Number.EPSILON);
                        }
                    }
                },
                cornSnake: {
                    index: "cornSnake",
                    img: (parcelRequire("5SWPw")),
                    imgSmall: (parcelRequire("4wmqh")),
                    imgMedium: (parcelRequire("a5ir0")),
                    imgLarge: (parcelRequire("bX3gM")),
                    lengthMeasurementCategory: "snakes",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 3,
                    maxHardLimit: 5,
                    minLength: 20,
                    maxLength: 150,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 1.44 + Math.max(numberOfAnimals - 2, 0) * 0.4;
                        },
                        length: "180 cm",
                        width: "80 cm",
                        height: function(animalLength) {
                            if (animalLength >= 140) return "110 cm";
                            else return "100 cm";
                        }
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 0.5 * animalLength + Math.max(numberOfAnimals - 2, 0) * 0.2 * animalLength * 0.5 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength;
                        },
                        width: function(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        },
                        height: function(animalLength) {
                            return Math.round(animalLength * 0.7 + Number.EPSILON);
                        }
                    }
                },
                greekTortoise: {
                    index: "greekTortoise",
                    img: (parcelRequire("jZBlV")),
                    imgSmall: (parcelRequire("d8zQB")),
                    imgMedium: (parcelRequire("7FN0k")),
                    imgLarge: (parcelRequire("jEzLx")),
                    lengthMeasurementCategory: "turtles",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    maxHardLimit: 9,
                    minLength: 3,
                    maxLength: 40,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 10 + Math.max(numberOfAnimals - 4, 0) * 2.5;
                        },
                        length: "400 cm",
                        width: "250 cm",
                        height: "-"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 8 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 8;
                        },
                        width: function(animalLength) {
                            return animalLength * 4;
                        },
                        height: "-"
                    }
                },
                moorishTortoise: {
                    index: "moorishTortoise",
                    img: (parcelRequire("h36RQ")),
                    imgSmall: (parcelRequire("3q1Q0")),
                    imgMedium: (parcelRequire("k6u7t")),
                    imgLarge: (parcelRequire("4ISrE")),
                    lengthMeasurementCategory: "turtles",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    maxHardLimit: 9,
                    minLength: 3,
                    maxLength: 40,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 10 + Math.max(numberOfAnimals - 4, 0) * 2.5;
                        },
                        length: "400 cm",
                        width: "250 cm",
                        height: "-"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 8 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 8;
                        },
                        width: function(animalLength) {
                            return animalLength * 4;
                        },
                        height: "-"
                    }
                },
                wideShelledTortoise: {
                    index: "wideShelledTortoise",
                    img: (parcelRequire("cXpgr")),
                    imgSmall: (parcelRequire("25OO5")),
                    imgMedium: (parcelRequire("3DGU0")),
                    imgLarge: (parcelRequire("9SmsB")),
                    lengthMeasurementCategory: "turtles",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    maxHardLimit: 9,
                    minLength: 3,
                    maxLength: 40,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 10 + Math.max(numberOfAnimals - 4, 0) * 2.5;
                        },
                        length: "400 cm",
                        width: "250 cm",
                        height: "-"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 8 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 8;
                        },
                        width: function(animalLength) {
                            return animalLength * 4;
                        },
                        height: "-"
                    }
                },
                crownedGecko: {
                    index: "crownedGecko",
                    img: (parcelRequire("kgEhZ")),
                    imgSmall: (parcelRequire("6B2wJ")),
                    imgMedium: (parcelRequire("8wK4e")),
                    imgLarge: (parcelRequire("acCTf")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 1,
                    maxLength: 12,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 0.48 + Math.max(numberOfAnimals - 2, 0) * 0.2;
                        },
                        length: "80 cm",
                        width: "60 cm",
                        height: "120 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 6 * animalLength * 2 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 6;
                        },
                        width: function(animalLength) {
                            return animalLength * 2;
                        },
                        height: function(animalLength) {
                            return animalLength * 8;
                        }
                    }
                },
                boaConstrictor: {
                    index: "boaConstrictor",
                    img: (parcelRequire("7zgU1")),
                    imgSmall: (parcelRequire("c0olu")),
                    imgMedium: (parcelRequire("kYuLC")),
                    imgLarge: (parcelRequire("8Ly44")),
                    lengthMeasurementCategory: "snakes",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 20,
                    maxLength: 300,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 5.25 + Math.max(numberOfAnimals - 2, 0) * 1;
                        },
                        length: "350 cm",
                        width: "150 cm",
                        height: function(animalLength) {
                            if (animalLength >= 260) return "225 cm";
                            else return "200 cm";
                        }
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 1 * animalLength * 0.5 + Math.max(numberOfAnimals - 2, 0) * 0.5 * animalLength * 0.2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 1;
                        },
                        width: function(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        },
                        height: function(animalLength) {
                            return Math.round(animalLength * 0.75 + Number.EPSILON);
                        }
                    }
                },
                muskTurtle: {
                    index: "muskTurtle",
                    img: (parcelRequire("2n1jA")),
                    imgSmall: (parcelRequire("gPxs4")),
                    imgMedium: (parcelRequire("eHNJx")),
                    imgLarge: (parcelRequire("avAF3")),
                    lengthMeasurementCategory: "turtles",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 4,
                    minLength: 2,
                    maxLength: 15,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 0.9 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                        },
                        length: "150 cm",
                        width: "60 cm",
                        height: "50 cm",
                        waterBasin: function(numberOfAnimals, animalLength) {
                            const area = 0.9 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                            return Math.round(area * 67 + Number.EPSILON) / 100 + " m\xb2 ";
                        }
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 2 * animalLength * 2 + Math.max(numberOfAnimals - 2, 0) * 1 * animalLength * 1 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 2;
                        },
                        width: function(animalLength) {
                            return animalLength * 2;
                        },
                        height: "-",
                        waterBasin: function(numberOfAnimals, animalLength) {
                            const area = animalLength * 4 * animalLength * 3 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                            return Math.ceil(area / 100 + Number.EPSILON) / 100 + " m\xb2 ";
                        }
                    }
                },
                kingSnake: {
                    index: "kingSnake",
                    img: (parcelRequire("iiygs")),
                    imgSmall: (parcelRequire("WhQWG")),
                    imgMedium: (parcelRequire("aETax")),
                    imgLarge: (parcelRequire("h2mrK")),
                    lengthMeasurementCategory: "snakes",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 1,
                    maxHardLimit: 5,
                    minLength: 15,
                    maxLength: 140,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 1.44 + Math.max(numberOfAnimals - 2, 0) * 0.4;
                        },
                        length: "180 cm",
                        width: "80 cm",
                        height: "80 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 1 * animalLength * 0.5 + Math.max(numberOfAnimals - 2, 0) * 0.5 * animalLength * 0.2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 1;
                        },
                        width: function(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        },
                        height: function(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        }
                    }
                },
                madagascarDayGecko: {
                    index: "madagascarDayGecko",
                    img: (parcelRequire("eNs8G")),
                    imgSmall: (parcelRequire("3ma3s")),
                    imgMedium: (parcelRequire("Sl1zA")),
                    imgLarge: (parcelRequire("j5qFL")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 4,
                    minLength: 2,
                    maxLength: 15,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 1 + Math.max(numberOfAnimals - 2, 0) * 0.25;
                        },
                        length: "100 cm",
                        width: "100 cm",
                        height: "150 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 6 * animalLength * 6 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 6;
                        },
                        width: function(animalLength) {
                            return animalLength * 6;
                        },
                        height: function(animalLength) {
                            return animalLength * 8;
                        }
                    }
                },
                goldDustDayGecko: {
                    index: "goldDustDayGecko",
                    img: (parcelRequire("75rgV")),
                    imgSmall: (parcelRequire("TJfWn")),
                    imgMedium: (parcelRequire("h1Amz")),
                    imgLarge: (parcelRequire("hHl8b")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 4,
                    minLength: 1,
                    maxLength: 7,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 0.25 + Math.max(numberOfAnimals - 2, 0) * 0.15;
                        },
                        length: "50 cm",
                        width: "50 cm",
                        height: "70 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 6 * animalLength * 6 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 6;
                        },
                        width: function(animalLength) {
                            return animalLength * 6;
                        },
                        height: function(animalLength) {
                            return animalLength * 8;
                        }
                    }
                },
                leopardGecko: {
                    index: "leopardGecko",
                    img: (parcelRequire("5I2Ke")),
                    imgSmall: (parcelRequire("6iff5")),
                    imgMedium: (parcelRequire("fU9SR")),
                    imgLarge: (parcelRequire("f4LR8")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 2,
                    maxLength: 12,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 1.05 + Math.max(numberOfAnimals - 2, 0) * 0.15;
                        },
                        length: "140 cm",
                        width: "75 cm",
                        height: "75 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 6 * animalLength * 6 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 6;
                        },
                        width: function(animalLength) {
                            return animalLength * 6;
                        },
                        height: function(animalLength) {
                            return animalLength * 2;
                        }
                    }
                },
                dwarfBeardedDragon: {
                    index: "dwarfBeardedDragon",
                    img: (parcelRequire("55EeV")),
                    imgSmall: (parcelRequire("bqpvx")),
                    imgMedium: (parcelRequire("5ghm4")),
                    imgLarge: (parcelRequire("i2T8L")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 2,
                    maxLength: 14,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 0.9 + Math.max(numberOfAnimals - 2, 0) * 0.2;
                        },
                        length: "150 cm",
                        width: "60 cm",
                        height: "100 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 5 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 5;
                        },
                        width: function(animalLength) {
                            return animalLength * 4;
                        },
                        height: function(animalLength) {
                            return animalLength * 4;
                        }
                    }
                },
                centralBeardedDragon: {
                    index: "centralBeardedDragon",
                    img: (parcelRequire("avik4")),
                    imgSmall: (parcelRequire("exwe9")),
                    imgMedium: (parcelRequire("eD4Hx")),
                    imgLarge: (parcelRequire("1a7T5")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 2,
                    maxLength: 20,
                    hasLengthOption: true,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 2, 0) * 0.5;
                        },
                        length: "250 cm",
                        width: "80 cm",
                        height: "100 cm"
                    },
                    laws: {
                        area: function(numberOfAnimals, animalLength) {
                            return animalLength * 5 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function(animalLength) {
                            return animalLength * 5;
                        },
                        width: function(animalLength) {
                            return animalLength * 4;
                        },
                        height: function(animalLength) {
                            return animalLength * 4;
                        }
                    }
                }
            },
            birds: {
                budgerigar: {
                    index: "budgerigar",
                    img: (parcelRequire("2ejpd")),
                    imgSmall: (parcelRequire("6jLCd")),
                    imgMedium: (parcelRequire("4PTwK")),
                    imgLarge: (parcelRequire("3FRJl")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                cockatiel: {
                    index: "cockatiel",
                    img: (parcelRequire("7c9qL")),
                    imgSmall: (parcelRequire("5vJe8")),
                    imgMedium: (parcelRequire("1Ke2W")),
                    imgLarge: (parcelRequire("jNfGL")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 6, 0) * 0.05;
                        },
                        height: "0.6 m",
                        volume: function(numberOfAnimals) {
                            return 0.3 + Math.max(numberOfAnimals - 6, 0) * 0.03;
                        }
                    }
                },
                agapornid: {
                    index: "agapornid",
                    img: (parcelRequire("8ecqJ")),
                    imgSmall: (parcelRequire("aswbU")),
                    imgMedium: (parcelRequire("90wje")),
                    imgLarge: (parcelRequire("eFfyh")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                amazon: {
                    index: "amazon",
                    img: (parcelRequire("5LPtO")),
                    imgSmall: (parcelRequire("aiY8E")),
                    imgMedium: (parcelRequire("39ZYM")),
                    imgLarge: (parcelRequire("gS0Xx")),
                    minHardLimit: 2,
                    maxSoftLimit: 5,
                    maxHardLimit: 6,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 6 + Math.max(numberOfAnimals - 4, 0) * 1;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.7 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                        },
                        height: "1.2 m",
                        volume: function(numberOfAnimals) {
                            return 0.84 + Math.max(numberOfAnimals - 2, 0) * 0.12;
                        }
                    }
                },
                congoGreyParrot: {
                    index: "congoGreyParrot",
                    img: (parcelRequire("hKaSv")),
                    imgSmall: (parcelRequire("lDyV8")),
                    imgMedium: (parcelRequire("l3ebM")),
                    imgLarge: (parcelRequire("fXl6c")),
                    minHardLimit: 2,
                    maxSoftLimit: 4,
                    maxHardLimit: 6,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 6 + Math.max(numberOfAnimals - 4, 0) * 1;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.7 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                        },
                        height: "1.2 m",
                        volume: function(numberOfAnimals) {
                            return 0.84 + Math.max(numberOfAnimals - 2, 0) * 0.12;
                        }
                    }
                },
                tarantaParrot: {
                    index: "tarantaParrot",
                    img: (parcelRequire("gdAWJ")),
                    imgSmall: (parcelRequire("lhLVu")),
                    imgMedium: (parcelRequire("h77gC")),
                    imgLarge: (parcelRequire("inasa")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 6, 0) * 0.05;
                        },
                        height: "0.6 m",
                        volume: function(numberOfAnimals) {
                            return 0.3 + Math.max(numberOfAnimals - 6, 0) * 0.03;
                        }
                    }
                },
                rosellaConure: {
                    index: "rosellaConure",
                    img: (parcelRequire("4YcMz")),
                    imgSmall: (parcelRequire("5RQU1")),
                    imgMedium: (parcelRequire("ccVpl")),
                    imgLarge: (parcelRequire("lxIG8")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 6;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.7 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                        },
                        height: "1.2 m",
                        volume: function(numberOfAnimals) {
                            return 0.84 + Math.max(numberOfAnimals - 2, 0) * 0.12;
                        }
                    }
                },
                beautifulParakeet: {
                    index: "beautifulParakeet",
                    img: (parcelRequire("lvPYl")),
                    imgSmall: (parcelRequire("9bK1Q")),
                    imgMedium: (parcelRequire("f8dVT")),
                    imgLarge: (parcelRequire("l6lr7")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 6, 0) * 0.05;
                        },
                        height: "0.6 m",
                        volume: function(numberOfAnimals) {
                            return 0.3 + Math.max(numberOfAnimals - 6, 0) * 0.03;
                        }
                    }
                },
                canary: {
                    index: "canary",
                    img: (parcelRequire("gqFy2")),
                    imgSmall: (parcelRequire("3i2id")),
                    imgMedium: (parcelRequire("1yMmm")),
                    imgLarge: (parcelRequire("fsMbk")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                gouldianMadine: {
                    index: "gouldianMadine",
                    img: (parcelRequire("hluWT")),
                    imgSmall: (parcelRequire("iwZ4i")),
                    imgMedium: (parcelRequire("iraty")),
                    imgLarge: (parcelRequire("kBVkN")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                zebraFinch: {
                    index: "zebraFinch",
                    img: (parcelRequire("55g03")),
                    imgSmall: (parcelRequire("lcQGl")),
                    imgMedium: (parcelRequire("BOH1b")),
                    imgLarge: (parcelRequire("fVZmO")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                goldenBreasted: {
                    index: "goldenBreasted",
                    img: (parcelRequire("gdocT")),
                    imgSmall: (parcelRequire("gFpjG")),
                    imgMedium: (parcelRequire("M4bnM")),
                    imgLarge: (parcelRequire("ks70l")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                grayWaxbill: {
                    index: "grayWaxbill",
                    img: (parcelRequire("7bpn5")),
                    imgSmall: (parcelRequire("4KDG9")),
                    imgMedium: (parcelRequire("gdezl")),
                    imgLarge: (parcelRequire("jqVJR")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                diamondDove: {
                    index: "diamondDove",
                    img: (parcelRequire("9nD1v")),
                    imgSmall: (parcelRequire("6Kj79")),
                    imgMedium: (parcelRequire("7pmGq")),
                    imgLarge: (parcelRequire("eyT2C")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 6, 0) * 0.05;
                        },
                        height: "0.6 m",
                        volume: function(numberOfAnimals) {
                            return 0.3 + Math.max(numberOfAnimals - 6, 0) * 0.03;
                        }
                    }
                },
                macaw: {
                    index: "macaw",
                    img: (parcelRequire("alCMs")),
                    imgSmall: (parcelRequire("fuexU")),
                    imgMedium: (parcelRequire("7QiEd")),
                    imgLarge: (parcelRequire("7cFIp")),
                    minHardLimit: 2,
                    maxSoftLimit: 1,
                    maxHardLimit: 2,
                    recommendations: {
                        area: "Aus Tierschutzgr\xfcnden r\xe4t der Schweizer Tierschutz STS von der privaten Ara-Haltung ab. Der Platzbedarf f\xfcr eine tiergerechte Ara-Haltung ist immens und kann von privaten Haltern meistens nicht erf\xfcllt werden.",
                        height: "-"
                    },
                    laws: {
                        area: "10 m\xb2",
                        height: "3 m (zu erg\xe4nzen mit 80%-Regelung)",
                        volume: function(numberOfAnimals) {
                            return 30 + Math.max(numberOfAnimals - 2, 0) * 3;
                        }
                    }
                },
                cockatoo: {
                    index: "cockatoo",
                    img: (parcelRequire("lhmLt")),
                    imgSmall: (parcelRequire("c4gJm")),
                    imgMedium: (parcelRequire("hOUVy")),
                    imgLarge: (parcelRequire("eBTBS")),
                    minHardLimit: 2,
                    maxSoftLimit: 1,
                    maxHardLimit: 2,
                    recommendations: {
                        area: "Aus Tierschutzgr\xfcnden r\xe4t der Schweizer Tierschutz STS von der privaten Kakadu-Haltung ab (ausser Nymphensittich). Der Platzbedarf f\xfcr eine tiergerechte Kakadu-Haltung ist immens und kann von privaten Haltern meistens nicht erf\xfcllt werden. ",
                        height: "-"
                    },
                    laws: {
                        area: "10 m\xb2",
                        height: "3 m (zu erg\xe4nzen mit 80%-Regelung)",
                        volume: function(numberOfAnimals) {
                            return 30 + Math.max(numberOfAnimals - 2, 0) * 3;
                        }
                    }
                }
            },
            equidae: {
                horse: {
                    index: "horse",
                    img: (parcelRequire("1q5SW")),
                    imgSmall: (parcelRequire("eM0uv")),
                    imgMedium: (parcelRequire("aqWO3")),
                    imgLarge: (parcelRequire("jVMtt")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 149,
                    maxWithersHeight: 200,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function(witherHeights) {
                            let layingArea = 0;
                            for(let i in witherHeights){
                                if (witherHeights[i] < 162) layingArea += 13.5;
                                else if (witherHeights[i] < 175) layingArea += 15.75;
                                else layingArea += 18;
                            }
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else if (highest < 175) clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function(witherHeights) {
                            let layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 162) {
                                    layingArea.value += 9;
                                    layingArea.tolerance += 8;
                                    layingArea.multiroom += 6;
                                } else if (witherHeights[i] < 175) {
                                    layingArea.value += 10.5;
                                    layingArea.tolerance += 9;
                                    layingArea.multiroom += 7.5;
                                } else {
                                    layingArea.value += 12;
                                    layingArea.tolerance += 10.5;
                                    layingArea.multiroom += 8;
                                }
                            }
                            if (witherHeights.length >= 5) layingArea.multiroom = layingArea.multiroom * 0.8;
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else if (highest < 175) clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(witherHeights) {
                            let runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 162) {
                                    runoutArea.adjacent += 20;
                                    runoutArea.nonadjacent += 30;
                                } else if (witherHeights[i] < 175) {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                } else {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                }
                            }
                            return runoutArea;
                        }
                    }
                },
                pony: {
                    index: "pony",
                    img: (parcelRequire("goinG")),
                    imgSmall: (parcelRequire("bwnyY")),
                    imgMedium: (parcelRequire("c05q1")),
                    imgLarge: (parcelRequire("hfpca")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 40,
                    maxWithersHeight: 148,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function(witherHeights) {
                            let layingArea = 0;
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) layingArea += 7.75;
                                else if (witherHeights[i] < 134) layingArea += 10.5;
                                else layingArea += 12;
                            }
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9
                            };
                            else clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function(witherHeights) {
                            let layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    layingArea.value += 5.5;
                                    layingArea.tolerance += 5.5;
                                    layingArea.multiroom += 4;
                                } else if (witherHeights[i] < 134) {
                                    layingArea.value += 7;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 4.5;
                                } else {
                                    layingArea.value += 8;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 5.5;
                                }
                            }
                            if (layingArea.tolerance >= layingArea.value) layingArea.tolerance = 0;
                            if (witherHeights.length >= 5) layingArea.multiroom = Math.round(layingArea.multiroom * 8) / 10;
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8,
                                tolerance: 0
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9,
                                tolerance: 0
                            };
                            else clearHeight = {
                                value: 2.1,
                                tolerance: 2.0
                            };
                            return clearHeight;
                        },
                        runoutArea: function(witherHeights) {
                            let runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    runoutArea.adjacent += 12;
                                    runoutArea.nonadjacent += 18;
                                } else if (witherHeights[i] < 134) {
                                    runoutArea.adjacent += 14;
                                    runoutArea.nonadjacent += 21;
                                } else {
                                    runoutArea.adjacent += 16;
                                    runoutArea.nonadjacent += 24;
                                }
                            }
                            return runoutArea;
                        }
                    }
                },
                donkey: {
                    index: "donkey",
                    img: (parcelRequire("8FNBW")),
                    imgSmall: (parcelRequire("5OF7N")),
                    imgMedium: (parcelRequire("csTGY")),
                    imgLarge: (parcelRequire("8MtMy")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 40,
                    maxWithersHeight: 180,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function(witherHeights) {
                            let layingArea = 0;
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) layingArea += 7.75;
                                else if (witherHeights[i] < 134) layingArea += 10.5;
                                else if (witherHeights[i] < 148) layingArea += 12;
                                else if (witherHeights[i] < 162) layingArea += 13.5;
                                else layingArea += 15.75;
                            }
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function(witherHeights) {
                            let layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    layingArea.value += 5.5;
                                    layingArea.tolerance += 5.5;
                                    layingArea.multiroom += 4;
                                } else if (witherHeights[i] < 134) {
                                    layingArea.value += 7;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 4.5;
                                } else if (witherHeights[i] < 148) {
                                    layingArea.value += 8;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 5.5;
                                } else if (witherHeights[i] < 162) {
                                    layingArea.value += 9;
                                    layingArea.tolerance += 8;
                                    layingArea.multiroom += 6;
                                } else {
                                    layingArea.value += 10.5;
                                    layingArea.tolerance += 9;
                                    layingArea.multiroom += 7.5;
                                }
                            }
                            if (witherHeights.length >= 5) layingArea.multiroom = Math.round(layingArea.multiroom * 8) / 10;
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8,
                                tolerance: 0
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9,
                                tolerance: 0
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(witherHeights) {
                            let runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    runoutArea.adjacent += 12;
                                    runoutArea.nonadjacent += 18;
                                } else if (witherHeights[i] < 134) {
                                    runoutArea.adjacent += 14;
                                    runoutArea.nonadjacent += 21;
                                } else if (witherHeights[i] < 148) {
                                    runoutArea.adjacent += 16;
                                    runoutArea.nonadjacent += 24;
                                } else if (witherHeights[i] < 162) {
                                    runoutArea.adjacent += 20;
                                    runoutArea.nonadjacent += 30;
                                } else {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                }
                            }
                            return runoutArea;
                        }
                    }
                },
                mule: {
                    index: "mule",
                    img: (parcelRequire("fpRTp")),
                    imgSmall: (parcelRequire("9oPZn")),
                    imgMedium: (parcelRequire("5mH2H")),
                    imgLarge: (parcelRequire("6fgHT")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 80,
                    maxWithersHeight: 190,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function(witherHeights) {
                            let layingArea = 0;
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) layingArea += 7.75;
                                else if (witherHeights[i] < 134) layingArea += 10.5;
                                else if (witherHeights[i] < 148) layingArea += 12;
                                else if (witherHeights[i] < 162) layingArea += 13.5;
                                else layingArea += 15.75;
                            }
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else if (highest < 175) clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function(witherHeights) {
                            let layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    layingArea.value += 5.5;
                                    layingArea.tolerance += 5.5;
                                    layingArea.multiroom += 4;
                                } else if (witherHeights[i] < 134) {
                                    layingArea.value += 7;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 4.5;
                                } else if (witherHeights[i] < 148) {
                                    layingArea.value += 8;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 5.5;
                                } else if (witherHeights[i] < 162) {
                                    layingArea.value += 9;
                                    layingArea.tolerance += 8;
                                    layingArea.multiroom += 6;
                                } else {
                                    layingArea.value += 10.5;
                                    layingArea.tolerance += 9;
                                    layingArea.multiroom += 7.5;
                                }
                            }
                            if (witherHeights.length >= 5) layingArea.multiroom = Math.round(layingArea.multiroom * 8) / 10;
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8,
                                tolerance: 0
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9,
                                tolerance: 0
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(witherHeights) {
                            let runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    runoutArea.adjacent += 12;
                                    runoutArea.nonadjacent += 18;
                                } else if (witherHeights[i] < 134) {
                                    runoutArea.adjacent += 14;
                                    runoutArea.nonadjacent += 21;
                                } else if (witherHeights[i] < 148) {
                                    runoutArea.adjacent += 16;
                                    runoutArea.nonadjacent += 24;
                                } else if (witherHeights[i] < 162) {
                                    runoutArea.adjacent += 20;
                                    runoutArea.nonadjacent += 30;
                                } else {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                }
                            }
                            return runoutArea;
                        }
                    }
                },
                hinny: {
                    index: "hinny",
                    img: (parcelRequire("1TMjT")),
                    imgSmall: (parcelRequire("l5Xax")),
                    imgMedium: (parcelRequire("eGsTy")),
                    imgLarge: (parcelRequire("5cLlw")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 80,
                    maxWithersHeight: 190,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function(witherHeights) {
                            let layingArea = 0;
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) layingArea += 7.75;
                                else if (witherHeights[i] < 134) layingArea += 10.5;
                                else if (witherHeights[i] < 148) layingArea += 12;
                                else if (witherHeights[i] < 162) layingArea += 13.5;
                                else layingArea += 15.75;
                            }
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else if (highest < 175) clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function(witherHeights) {
                            let layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    layingArea.value += 5.5;
                                    layingArea.tolerance += 5.5;
                                    layingArea.multiroom += 4;
                                } else if (witherHeights[i] < 134) {
                                    layingArea.value += 7;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 4.5;
                                } else if (witherHeights[i] < 148) {
                                    layingArea.value += 8;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 5.5;
                                } else if (witherHeights[i] < 162) {
                                    layingArea.value += 9;
                                    layingArea.tolerance += 8;
                                    layingArea.multiroom += 6;
                                } else {
                                    layingArea.value += 10.5;
                                    layingArea.tolerance += 9;
                                    layingArea.multiroom += 7.5;
                                }
                            }
                            if (witherHeights.length >= 5) layingArea.multiroom = Math.round(layingArea.multiroom * 8) / 10;
                            return layingArea;
                        },
                        clearWidth: function(witherHeights) {
                            let highest = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function(witherHeights) {
                            let highest = 0;
                            let clearHeight = 0;
                            for(let i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8,
                                tolerance: 0
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9,
                                tolerance: 0
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function(witherHeights) {
                            let runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(let i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    runoutArea.adjacent += 12;
                                    runoutArea.nonadjacent += 18;
                                } else if (witherHeights[i] < 134) {
                                    runoutArea.adjacent += 14;
                                    runoutArea.nonadjacent += 21;
                                } else if (witherHeights[i] < 148) {
                                    runoutArea.adjacent += 16;
                                    runoutArea.nonadjacent += 24;
                                } else if (witherHeights[i] < 162) {
                                    runoutArea.adjacent += 20;
                                    runoutArea.nonadjacent += 30;
                                } else {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                }
                            }
                            return runoutArea;
                        }
                    }
                }
            }
        }
    };
}

});
parcelRequire.register("4MTjz", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("jY4bm"), import.meta.url).toString();

});

parcelRequire.register("ftBil", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("8ZjZd"), import.meta.url).toString();

});

parcelRequire.register("5hQg5", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("b3rVS"), import.meta.url).toString();

});

parcelRequire.register("jmbUb", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("kPVET"), import.meta.url).toString();

});

parcelRequire.register("hQ7mc", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("l35Q3"), import.meta.url).toString();

});

parcelRequire.register("gCCtT", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("aTEjB"), import.meta.url).toString();

});

parcelRequire.register("80eyo", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("aHDCm"), import.meta.url).toString();

});

parcelRequire.register("Yenyq", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dXkPS"), import.meta.url).toString();

});

parcelRequire.register("bdiEL", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cFdiX"), import.meta.url).toString();

});

parcelRequire.register("6LeKK", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3Sb0H"), import.meta.url).toString();

});

parcelRequire.register("jXOPO", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("5vOAG"), import.meta.url).toString();

});

parcelRequire.register("gm0R4", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("iZ9dP"), import.meta.url).toString();

});

parcelRequire.register("77Qib", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("2TqXA"), import.meta.url).toString();

});

parcelRequire.register("6Xvd8", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("5ih3K"), import.meta.url).toString();

});

parcelRequire.register("l3HZB", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("i9E6K"), import.meta.url).toString();

});

parcelRequire.register("5mXWS", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("fUpOD"), import.meta.url).toString();

});

parcelRequire.register("9FMlx", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3ETZs"), import.meta.url).toString();

});

parcelRequire.register("8xnez", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("d6Ply"), import.meta.url).toString();

});

parcelRequire.register("8Qtry", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("fzxxb"), import.meta.url).toString();

});

parcelRequire.register("5GtYp", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("bibHD"), import.meta.url).toString();

});

parcelRequire.register("5I2Ke", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6lmMf"), import.meta.url).toString();

});

parcelRequire.register("6iff5", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("9MBi1"), import.meta.url).toString();

});

parcelRequire.register("fU9SR", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("l46AA"), import.meta.url).toString();

});

parcelRequire.register("f4LR8", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7UL1x"), import.meta.url).toString();

});

parcelRequire.register("7c9qL", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("2atpP"), import.meta.url).toString();

});

parcelRequire.register("5vJe8", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("k1uG6"), import.meta.url).toString();

});

parcelRequire.register("1Ke2W", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("8649q"), import.meta.url).toString();

});

parcelRequire.register("jNfGL", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7yWcA"), import.meta.url).toString();

});

parcelRequire.register("3SGCS", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("fJCvy"), import.meta.url).toString();

});

parcelRequire.register("djzAO", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("lJG3Q"), import.meta.url).toString();

});

parcelRequire.register("g2jQX", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("4k5as"), import.meta.url).toString();

});

parcelRequire.register("2g0QR", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6rvLH"), import.meta.url).toString();

});

parcelRequire.register("1q5SW", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("jkY6N"), import.meta.url).toString();

});

parcelRequire.register("eM0uv", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("iGSFZ"), import.meta.url).toString();

});

parcelRequire.register("aqWO3", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("jHdtW"), import.meta.url).toString();

});

parcelRequire.register("jVMtt", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("4blqD"), import.meta.url).toString();

});

parcelRequire.register("ivWYv", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("Hu3v5"), import.meta.url).toString();

});

parcelRequire.register("l2f2S", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("bPoJz"), import.meta.url).toString();

});

parcelRequire.register("d0JD4", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6xA3l"), import.meta.url).toString();

});

parcelRequire.register("8nk7J", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("caGBU"), import.meta.url).toString();

});

parcelRequire.register("83atf", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("je4k7"), import.meta.url).toString();

});

parcelRequire.register("1YYrM", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6lEil"), import.meta.url).toString();

});

parcelRequire.register("bm3u4", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("BtUBK"), import.meta.url).toString();

});

parcelRequire.register("bK2SC", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7dEWJ"), import.meta.url).toString();

});

parcelRequire.register("jUvL2", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("8i9XK"), import.meta.url).toString();

});

parcelRequire.register("hHyip", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("jZbt7"), import.meta.url).toString();

});

parcelRequire.register("7rMNk", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("4OC3A"), import.meta.url).toString();

});

parcelRequire.register("rx8Xw", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("8L2Vi"), import.meta.url).toString();

});

parcelRequire.register("9xnaf", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7oSro"), import.meta.url).toString();

});

parcelRequire.register("kjrgL", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("1osmp"), import.meta.url).toString();

});

parcelRequire.register("9uFBA", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dHoKZ"), import.meta.url).toString();

});

parcelRequire.register("l1cDN", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("iT0aN"), import.meta.url).toString();

});

parcelRequire.register("bm01k", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("bux6D"), import.meta.url).toString();

});

parcelRequire.register("2TmbY", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6yWTY"), import.meta.url).toString();

});

parcelRequire.register("9ljoa", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("JZMjB"), import.meta.url).toString();

});

parcelRequire.register("djySE", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("8ldT9"), import.meta.url).toString();

});

parcelRequire.register("cGZip", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("aDnsR"), import.meta.url).toString();

});

parcelRequire.register("2MnsN", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3xuqo"), import.meta.url).toString();

});

parcelRequire.register("crctI", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("fF6Fw"), import.meta.url).toString();

});

parcelRequire.register("lVbnu", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("74W4F"), import.meta.url).toString();

});

parcelRequire.register("9oXv8", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("gBFtS"), import.meta.url).toString();

});

parcelRequire.register("8g3Cl", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("eMoo2"), import.meta.url).toString();

});

parcelRequire.register("9E87i", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("EkB08"), import.meta.url).toString();

});

parcelRequire.register("kdB5n", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3ovpu"), import.meta.url).toString();

});

parcelRequire.register("bpd43", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("4AN6m"), import.meta.url).toString();

});

parcelRequire.register("1bfTi", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3G98G"), import.meta.url).toString();

});

parcelRequire.register("2WS1S", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("hvsc7"), import.meta.url).toString();

});

parcelRequire.register("h9uQD", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("kmbCO"), import.meta.url).toString();

});

parcelRequire.register("3eHOZ", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cGEq8"), import.meta.url).toString();

});

parcelRequire.register("6K203", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("2dLiz"), import.meta.url).toString();

});

parcelRequire.register("7cyV5", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("gQ2lg"), import.meta.url).toString();

});

parcelRequire.register("7PgG0", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("aasbI"), import.meta.url).toString();

});

parcelRequire.register("5SWPw", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6TqiD"), import.meta.url).toString();

});

parcelRequire.register("4wmqh", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("5Yiai"), import.meta.url).toString();

});

parcelRequire.register("a5ir0", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("ey0sZ"), import.meta.url).toString();

});

parcelRequire.register("bX3gM", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7tXLx"), import.meta.url).toString();

});

parcelRequire.register("jZBlV", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("37ilj"), import.meta.url).toString();

});

parcelRequire.register("d8zQB", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("5ihCS"), import.meta.url).toString();

});

parcelRequire.register("7FN0k", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("kFbEu"), import.meta.url).toString();

});

parcelRequire.register("jEzLx", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("hX6D8"), import.meta.url).toString();

});

parcelRequire.register("h36RQ", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7qhqF"), import.meta.url).toString();

});

parcelRequire.register("3q1Q0", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("8rcRF"), import.meta.url).toString();

});

parcelRequire.register("k6u7t", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("aw63G"), import.meta.url).toString();

});

parcelRequire.register("4ISrE", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("czTlV"), import.meta.url).toString();

});

parcelRequire.register("cXpgr", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6nnTr"), import.meta.url).toString();

});

parcelRequire.register("25OO5", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("g3FCn"), import.meta.url).toString();

});

parcelRequire.register("3DGU0", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("56yQj"), import.meta.url).toString();

});

parcelRequire.register("9SmsB", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cxCFP"), import.meta.url).toString();

});

parcelRequire.register("kgEhZ", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("1VCyG"), import.meta.url).toString();

});

parcelRequire.register("6B2wJ", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("hUffu"), import.meta.url).toString();

});

parcelRequire.register("8wK4e", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("avmnH"), import.meta.url).toString();

});

parcelRequire.register("acCTf", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7wKS0"), import.meta.url).toString();

});

parcelRequire.register("7zgU1", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3L384"), import.meta.url).toString();

});

parcelRequire.register("c0olu", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7zLxF"), import.meta.url).toString();

});

parcelRequire.register("kYuLC", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("drMAt"), import.meta.url).toString();

});

parcelRequire.register("8Ly44", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("iMsTD"), import.meta.url).toString();

});

parcelRequire.register("2n1jA", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cBiA3"), import.meta.url).toString();

});

parcelRequire.register("gPxs4", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dMMW0"), import.meta.url).toString();

});

parcelRequire.register("eHNJx", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7pcnh"), import.meta.url).toString();

});

parcelRequire.register("avAF3", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cElOz"), import.meta.url).toString();

});

parcelRequire.register("iiygs", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cCOIM"), import.meta.url).toString();

});

parcelRequire.register("WhQWG", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("2MvAA"), import.meta.url).toString();

});

parcelRequire.register("aETax", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("g7yWT"), import.meta.url).toString();

});

parcelRequire.register("h2mrK", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("aTlcS"), import.meta.url).toString();

});

parcelRequire.register("eNs8G", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cdaQq"), import.meta.url).toString();

});

parcelRequire.register("3ma3s", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3pYfn"), import.meta.url).toString();

});

parcelRequire.register("Sl1zA", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("lrknx"), import.meta.url).toString();

});

parcelRequire.register("j5qFL", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("izluQ"), import.meta.url).toString();

});

parcelRequire.register("75rgV", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("9Zr3K"), import.meta.url).toString();

});

parcelRequire.register("TJfWn", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("k7s45"), import.meta.url).toString();

});

parcelRequire.register("h1Amz", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("fWr2r"), import.meta.url).toString();

});

parcelRequire.register("hHl8b", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7gBty"), import.meta.url).toString();

});

parcelRequire.register("55EeV", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("hKQX7"), import.meta.url).toString();

});

parcelRequire.register("bqpvx", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3LPto"), import.meta.url).toString();

});

parcelRequire.register("5ghm4", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dBDJC"), import.meta.url).toString();

});

parcelRequire.register("i2T8L", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cCyu7"), import.meta.url).toString();

});

parcelRequire.register("avik4", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("9elqM"), import.meta.url).toString();

});

parcelRequire.register("exwe9", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("1cLrY"), import.meta.url).toString();

});

parcelRequire.register("eD4Hx", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("a6buq"), import.meta.url).toString();

});

parcelRequire.register("1a7T5", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("lvnRf"), import.meta.url).toString();

});

parcelRequire.register("2ejpd", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("8QDQW"), import.meta.url).toString();

});

parcelRequire.register("6jLCd", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("1xw5u"), import.meta.url).toString();

});

parcelRequire.register("4PTwK", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("kpt4O"), import.meta.url).toString();

});

parcelRequire.register("3FRJl", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("9x37q"), import.meta.url).toString();

});

parcelRequire.register("8ecqJ", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("b3HWt"), import.meta.url).toString();

});

parcelRequire.register("aswbU", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("bgYj5"), import.meta.url).toString();

});

parcelRequire.register("90wje", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("b1Iq7"), import.meta.url).toString();

});

parcelRequire.register("eFfyh", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cJT1i"), import.meta.url).toString();

});

parcelRequire.register("5LPtO", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("9fiKX"), import.meta.url).toString();

});

parcelRequire.register("aiY8E", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("bxOMi"), import.meta.url).toString();

});

parcelRequire.register("39ZYM", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("i2wOh"), import.meta.url).toString();

});

parcelRequire.register("gS0Xx", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("jQi9F"), import.meta.url).toString();

});

parcelRequire.register("hKaSv", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6f2zm"), import.meta.url).toString();

});

parcelRequire.register("lDyV8", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("isBGw"), import.meta.url).toString();

});

parcelRequire.register("l3ebM", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("9I5ya"), import.meta.url).toString();

});

parcelRequire.register("fXl6c", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("37MWX"), import.meta.url).toString();

});

parcelRequire.register("gdAWJ", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("fJg2G"), import.meta.url).toString();

});

parcelRequire.register("lhLVu", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("knXjb"), import.meta.url).toString();

});

parcelRequire.register("h77gC", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dY6hS"), import.meta.url).toString();

});

parcelRequire.register("inasa", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("SpUba"), import.meta.url).toString();

});

parcelRequire.register("4YcMz", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("1aGlb"), import.meta.url).toString();

});

parcelRequire.register("5RQU1", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("2wuIu"), import.meta.url).toString();

});

parcelRequire.register("ccVpl", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("FLy8b"), import.meta.url).toString();

});

parcelRequire.register("lxIG8", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("kdas1"), import.meta.url).toString();

});

parcelRequire.register("lvPYl", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("jXCiD"), import.meta.url).toString();

});

parcelRequire.register("9bK1Q", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("h1Ccd"), import.meta.url).toString();

});

parcelRequire.register("f8dVT", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("466qm"), import.meta.url).toString();

});

parcelRequire.register("l6lr7", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("iuOgR"), import.meta.url).toString();

});

parcelRequire.register("gqFy2", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("gVGaS"), import.meta.url).toString();

});

parcelRequire.register("3i2id", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("bC3qB"), import.meta.url).toString();

});

parcelRequire.register("1yMmm", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dpzrj"), import.meta.url).toString();

});

parcelRequire.register("fsMbk", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("gwQ80"), import.meta.url).toString();

});

parcelRequire.register("hluWT", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("bhb7P"), import.meta.url).toString();

});

parcelRequire.register("iwZ4i", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dM2ST"), import.meta.url).toString();

});

parcelRequire.register("iraty", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("1FmQ9"), import.meta.url).toString();

});

parcelRequire.register("kBVkN", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3ELMP"), import.meta.url).toString();

});

parcelRequire.register("55g03", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("37dOA"), import.meta.url).toString();

});

parcelRequire.register("lcQGl", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("aWJC0"), import.meta.url).toString();

});

parcelRequire.register("BOH1b", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6Fyh0"), import.meta.url).toString();

});

parcelRequire.register("fVZmO", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("9uHvS"), import.meta.url).toString();

});

parcelRequire.register("gdocT", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("amIiM"), import.meta.url).toString();

});

parcelRequire.register("gFpjG", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("jkB3n"), import.meta.url).toString();

});

parcelRequire.register("M4bnM", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7RvSV"), import.meta.url).toString();

});

parcelRequire.register("ks70l", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("2zcGU"), import.meta.url).toString();

});

parcelRequire.register("7bpn5", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dW1Kg"), import.meta.url).toString();

});

parcelRequire.register("4KDG9", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("gpYen"), import.meta.url).toString();

});

parcelRequire.register("gdezl", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("cUXNh"), import.meta.url).toString();

});

parcelRequire.register("jqVJR", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("7Hpyv"), import.meta.url).toString();

});

parcelRequire.register("9nD1v", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dkUCF"), import.meta.url).toString();

});

parcelRequire.register("6Kj79", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("fDxHZ"), import.meta.url).toString();

});

parcelRequire.register("7pmGq", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("4MGI6"), import.meta.url).toString();

});

parcelRequire.register("eyT2C", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("iPfHZ"), import.meta.url).toString();

});

parcelRequire.register("alCMs", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("8QGTr"), import.meta.url).toString();

});

parcelRequire.register("fuexU", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("4C1hb"), import.meta.url).toString();

});

parcelRequire.register("7QiEd", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("ep6VQ"), import.meta.url).toString();

});

parcelRequire.register("7cFIp", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("5YteT"), import.meta.url).toString();

});

parcelRequire.register("lhmLt", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("dlAIQ"), import.meta.url).toString();

});

parcelRequire.register("c4gJm", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("11RzX"), import.meta.url).toString();

});

parcelRequire.register("hOUVy", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("fuIsP"), import.meta.url).toString();

});

parcelRequire.register("eBTBS", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("6ct3X"), import.meta.url).toString();

});

parcelRequire.register("goinG", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("62Hjr"), import.meta.url).toString();

});

parcelRequire.register("bwnyY", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("3nOqd"), import.meta.url).toString();

});

parcelRequire.register("c05q1", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("bWbd2"), import.meta.url).toString();

});

parcelRequire.register("hfpca", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("9x0FD"), import.meta.url).toString();

});

parcelRequire.register("8FNBW", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("ldoTN"), import.meta.url).toString();

});

parcelRequire.register("5OF7N", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("76dZU"), import.meta.url).toString();

});

parcelRequire.register("csTGY", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("iRtWm"), import.meta.url).toString();

});

parcelRequire.register("8MtMy", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("2E2Et"), import.meta.url).toString();

});

parcelRequire.register("fpRTp", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("2txkT"), import.meta.url).toString();

});

parcelRequire.register("9oPZn", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("45RDH"), import.meta.url).toString();

});

parcelRequire.register("5mH2H", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("b9HK5"), import.meta.url).toString();

});

parcelRequire.register("6fgHT", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("1F0LH"), import.meta.url).toString();

});

parcelRequire.register("1TMjT", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("224TU"), import.meta.url).toString();

});

parcelRequire.register("l5Xax", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("j6xpQ"), import.meta.url).toString();

});

parcelRequire.register("eGsTy", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("98DtU"), import.meta.url).toString();

});

parcelRequire.register("5cLlw", function(module, exports) {

module.exports = new URL("images/" + (parcelRequire("dLcGf")).resolve("59pW8"), import.meta.url).toString();

});



parcelRequire.register("ghqC1", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $bda2e07d720a01f4$export$b3890eb0ae9dca99; });
parcelRequire("ecovD");
var $6A78m = parcelRequire("6A78m");
var $l44RV = parcelRequire("l44RV");
var $90kfS = parcelRequire("90kfS");
const $bda2e07d720a01f4$var$_withScopeId = (n)=>((0, $6A78m.pushScopeId)("data-v-e74703"), n = n(), (0, $6A78m.popScopeId)(), n);
const $bda2e07d720a01f4$var$_hoisted_1 = {
    class: "logo"
};
const $bda2e07d720a01f4$var$_hoisted_2 = [
    "src"
];
const $bda2e07d720a01f4$var$_hoisted_3 = {
    class: "content"
};
const $bda2e07d720a01f4$var$_hoisted_4 = {
    class: "tr-icon"
};
const $bda2e07d720a01f4$var$_hoisted_5 = [
    "src"
];
const $bda2e07d720a01f4$var$_hoisted_6 = {
    class: "tr-button-text"
};
const $bda2e07d720a01f4$var$_hoisted_7 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("span", {
        class: "icon-cross"
    }, null, -1));
const $bda2e07d720a01f4$var$_hoisted_8 = [
    $bda2e07d720a01f4$var$_hoisted_7
];
const $bda2e07d720a01f4$var$_hoisted_9 = {
    class: "screen reptiles-revision"
};
const $bda2e07d720a01f4$var$_hoisted_10 = {
    class: "screen screen-category-selection"
};
const $bda2e07d720a01f4$var$_hoisted_11 = {
    class: "buttons image-buttons"
};
const $bda2e07d720a01f4$var$_hoisted_12 = [
    "onClick"
];
const $bda2e07d720a01f4$var$_hoisted_13 = {
    class: "image-wrapper"
};
const $bda2e07d720a01f4$var$_hoisted_14 = [
    "src",
    "srcset"
];
const $bda2e07d720a01f4$var$_hoisted_15 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("div", {
        style: {
            "min-width": "220px"
        }
    }, null, -1));
const $bda2e07d720a01f4$var$_hoisted_16 = {
    class: "screen screen-animal-selection"
};
const $bda2e07d720a01f4$var$_hoisted_17 = {
    class: "buttons image-buttons"
};
const $bda2e07d720a01f4$var$_hoisted_18 = [
    "onClick"
];
const $bda2e07d720a01f4$var$_hoisted_19 = {
    class: "image-wrapper"
};
const $bda2e07d720a01f4$var$_hoisted_20 = [
    "src",
    "srcset"
];
const $bda2e07d720a01f4$var$_hoisted_21 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("div", {
        style: {
            "min-width": "220px"
        }
    }, null, -1));
const $bda2e07d720a01f4$var$_hoisted_22 = {
    class: "image-wrapper"
};
const $bda2e07d720a01f4$var$_hoisted_23 = [
    "src",
    "srcset"
];
const $bda2e07d720a01f4$var$_hoisted_24 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("div", {
        style: {
            "min-width": "220px"
        }
    }, null, -1));
const $bda2e07d720a01f4$var$_hoisted_25 = {
    class: "screen screen-multiple-birds"
};
const $bda2e07d720a01f4$var$_hoisted_26 = {
    class: "warning"
};
const $bda2e07d720a01f4$var$_hoisted_27 = {
    class: "details"
};
const $bda2e07d720a01f4$var$_hoisted_28 = {
    class: "additional-recommendations"
};
const $bda2e07d720a01f4$var$_hoisted_29 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_30 = {
    class: "screen screen-number"
};
const $bda2e07d720a01f4$var$_hoisted_31 = {
    for: "numberOfAnimals"
};
const $bda2e07d720a01f4$var$_hoisted_32 = {
    class: "screen-image-wrapper"
};
const $bda2e07d720a01f4$var$_hoisted_33 = [
    "src",
    "srcset"
];
const $bda2e07d720a01f4$var$_hoisted_34 = {
    class: "number-input"
};
const $bda2e07d720a01f4$var$_hoisted_35 = {
    key: 0,
    class: "error-overlay"
};
const $bda2e07d720a01f4$var$_hoisted_36 = {
    class: "warning-icon"
};
const $bda2e07d720a01f4$var$_hoisted_37 = [
    "data"
];
const $bda2e07d720a01f4$var$_hoisted_38 = {
    key: 0
};
const $bda2e07d720a01f4$var$_hoisted_39 = {
    key: 1
};
const $bda2e07d720a01f4$var$_hoisted_40 = {
    class: "screen screen-weight"
};
const $bda2e07d720a01f4$var$_hoisted_41 = {
    for: "animalWeight"
};
const $bda2e07d720a01f4$var$_hoisted_42 = {
    class: "screen-image-wrapper"
};
const $bda2e07d720a01f4$var$_hoisted_43 = [
    "src",
    "srcset"
];
const $bda2e07d720a01f4$var$_hoisted_44 = {
    class: "select-wrapper"
};
const $bda2e07d720a01f4$var$_hoisted_45 = {
    class: "screen screen-length"
};
const $bda2e07d720a01f4$var$_hoisted_46 = {
    for: "animalLength"
};
const $bda2e07d720a01f4$var$_hoisted_47 = {
    class: "screen-image-wrapper"
};
const $bda2e07d720a01f4$var$_hoisted_48 = [
    "src"
];
const $bda2e07d720a01f4$var$_hoisted_49 = {
    class: "length-input"
};
const $bda2e07d720a01f4$var$_hoisted_50 = {
    key: 0,
    class: "error-overlay"
};
const $bda2e07d720a01f4$var$_hoisted_51 = {
    class: "warning-icon"
};
const $bda2e07d720a01f4$var$_hoisted_52 = [
    "data"
];
const $bda2e07d720a01f4$var$_hoisted_53 = {
    class: "screen screen-withers-height"
};
const $bda2e07d720a01f4$var$_hoisted_54 = {
    for: "withersHeight"
};
const $bda2e07d720a01f4$var$_hoisted_55 = {
    class: "screen-image-wrapper"
};
const $bda2e07d720a01f4$var$_hoisted_56 = [
    "src"
];
const $bda2e07d720a01f4$var$_hoisted_57 = {
    class: "withers-height-input"
};
const $bda2e07d720a01f4$var$_hoisted_58 = [
    "onUpdate:modelValue"
];
const $bda2e07d720a01f4$var$_hoisted_59 = {
    key: 0,
    class: "error-overlay"
};
const $bda2e07d720a01f4$var$_hoisted_60 = {
    class: "warning-icon"
};
const $bda2e07d720a01f4$var$_hoisted_61 = [
    "data"
];
const $bda2e07d720a01f4$var$_hoisted_62 = {
    key: 0
};
const $bda2e07d720a01f4$var$_hoisted_63 = {
    key: 1
};
const $bda2e07d720a01f4$var$_hoisted_64 = {
    key: 2,
    class: "warning"
};
const $bda2e07d720a01f4$var$_hoisted_65 = {
    class: "warning-icon"
};
const $bda2e07d720a01f4$var$_hoisted_66 = [
    "data"
];
const $bda2e07d720a01f4$var$_hoisted_67 = {
    key: 0
};
const $bda2e07d720a01f4$var$_hoisted_68 = {
    key: 1
};
const $bda2e07d720a01f4$var$_hoisted_69 = {
    class: "results"
};
const $bda2e07d720a01f4$var$_hoisted_70 = {
    class: "results-panel results-visual"
};
const $bda2e07d720a01f4$var$_hoisted_71 = {
    key: 0,
    class: "rectangle"
};
const $bda2e07d720a01f4$var$_hoisted_72 = {
    class: "right-pane"
};
const $bda2e07d720a01f4$var$_hoisted_73 = {
    class: "height"
};
const $bda2e07d720a01f4$var$_hoisted_74 = {
    class: "bottom-pane"
};
const $bda2e07d720a01f4$var$_hoisted_75 = {
    class: "width"
};
const $bda2e07d720a01f4$var$_hoisted_76 = {
    class: "area"
};
const $bda2e07d720a01f4$var$_hoisted_77 = {
    class: "caption"
};
const $bda2e07d720a01f4$var$_hoisted_78 = {
    class: "cube-container",
    id: "results-cube-container"
};
const $bda2e07d720a01f4$var$_hoisted_79 = {
    class: "cube"
};
const $bda2e07d720a01f4$var$_hoisted_80 = /*#__PURE__*/ (0, $6A78m.createStaticVNode)('<div class="face top" data-v-e74703></div><div class="face bottom" data-v-e74703></div><div class="face left" data-v-e74703></div><div class="face right" data-v-e74703></div><div class="face front" data-v-e74703></div><div class="face back" data-v-e74703></div>', 6);
const $bda2e07d720a01f4$var$_hoisted_86 = {
    class: "measurement length"
};
const $bda2e07d720a01f4$var$_hoisted_87 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_88 = {
    class: "measurement height"
};
const $bda2e07d720a01f4$var$_hoisted_89 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_90 = {
    class: "measurement width"
};
const $bda2e07d720a01f4$var$_hoisted_91 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_92 = {
    class: "results-panel results-text"
};
const $bda2e07d720a01f4$var$_hoisted_93 = {
    class: "results-text-recommendations"
};
const $bda2e07d720a01f4$var$_hoisted_94 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_95 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_96 = {
    class: "recommendation-length"
};
const $bda2e07d720a01f4$var$_hoisted_97 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_98 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_99 = {
    class: "recommendation-width"
};
const $bda2e07d720a01f4$var$_hoisted_100 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_101 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_102 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_103 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_104 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_105 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_106 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_107 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_108 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_109 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_110 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_111 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_112 = [
    "data-tooltip"
];
const $bda2e07d720a01f4$var$_hoisted_113 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_114 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_115 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_116 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_117 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_118 = {
    key: 0,
    class: "tolerance"
};
const $bda2e07d720a01f4$var$_hoisted_119 = [
    "data-tooltip"
];
const $bda2e07d720a01f4$var$_hoisted_120 = {
    key: 1,
    class: "tolerance"
};
const $bda2e07d720a01f4$var$_hoisted_121 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_122 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_123 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_124 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_125 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_126 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_127 = {
    class: "results-text-laws"
};
const $bda2e07d720a01f4$var$_hoisted_128 = {
    key: 0
};
const $bda2e07d720a01f4$var$_hoisted_129 = [
    "href"
];
const $bda2e07d720a01f4$var$_hoisted_130 = {
    key: 1
};
const $bda2e07d720a01f4$var$_hoisted_131 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_132 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_133 = {
    class: "law-length"
};
const $bda2e07d720a01f4$var$_hoisted_134 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_135 = {
    class: "law-width"
};
const $bda2e07d720a01f4$var$_hoisted_136 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_137 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_138 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_139 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_140 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_141 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_142 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_143 = [
    "data-tooltip"
];
const $bda2e07d720a01f4$var$_hoisted_144 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_145 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_146 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_147 = {
    key: 0,
    class: "tolerance"
};
const $bda2e07d720a01f4$var$_hoisted_148 = [
    "data-tooltip"
];
const $bda2e07d720a01f4$var$_hoisted_149 = {
    key: 1,
    class: "tolerance"
};
const $bda2e07d720a01f4$var$_hoisted_150 = [
    "data-tooltip"
];
const $bda2e07d720a01f4$var$_hoisted_151 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_152 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_153 = [
    "data-tooltip"
];
const $bda2e07d720a01f4$var$_hoisted_154 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_155 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_156 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_157 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_158 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_159 = {
    key: 0,
    class: "tolerance"
};
const $bda2e07d720a01f4$var$_hoisted_160 = [
    "data-tooltip"
];
const $bda2e07d720a01f4$var$_hoisted_161 = {
    key: 1,
    class: "tolerance"
};
const $bda2e07d720a01f4$var$_hoisted_162 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_163 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_164 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_165 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_166 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_167 = {
    class: "value"
};
const $bda2e07d720a01f4$var$_hoisted_168 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("br", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_169 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_170 = {
    class: "details"
};
const $bda2e07d720a01f4$var$_hoisted_171 = {
    key: 0,
    class: "additional-recommendations"
};
const $bda2e07d720a01f4$var$_hoisted_172 = {
    key: 0
};
const $bda2e07d720a01f4$var$_hoisted_173 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_174 = {
    key: 1
};
const $bda2e07d720a01f4$var$_hoisted_175 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_176 = {
    key: 2
};
const $bda2e07d720a01f4$var$_hoisted_177 = {
    key: 0
};
const $bda2e07d720a01f4$var$_hoisted_178 = {
    key: 1
};
const $bda2e07d720a01f4$var$_hoisted_179 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_180 = {
    key: 3
};
const $bda2e07d720a01f4$var$_hoisted_181 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_182 = {
    key: 4
};
const $bda2e07d720a01f4$var$_hoisted_183 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_184 = {
    key: 5
};
const $bda2e07d720a01f4$var$_hoisted_185 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_186 = {
    key: 6
};
const $bda2e07d720a01f4$var$_hoisted_187 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_188 = {
    key: 7
};
const $bda2e07d720a01f4$var$_hoisted_189 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_190 = {
    key: 8
};
const $bda2e07d720a01f4$var$_hoisted_191 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_192 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("hr", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_193 = {
    key: 1,
    class: "additional-laws"
};
const $bda2e07d720a01f4$var$_hoisted_194 = {
    key: 0
};
const $bda2e07d720a01f4$var$_hoisted_195 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_196 = {
    key: 1
};
const $bda2e07d720a01f4$var$_hoisted_197 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_198 = {
    key: 2
};
const $bda2e07d720a01f4$var$_hoisted_199 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_200 = {
    key: 3
};
const $bda2e07d720a01f4$var$_hoisted_201 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_202 = {
    key: 4
};
const $bda2e07d720a01f4$var$_hoisted_203 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_204 = {
    key: 5
};
const $bda2e07d720a01f4$var$_hoisted_205 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_206 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("hr", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_207 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_208 = [
    "innerHTML"
];
const $bda2e07d720a01f4$var$_hoisted_209 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("hr", null, null, -1));
const $bda2e07d720a01f4$var$_hoisted_210 = {
    key: 2,
    class: "links"
};
const $bda2e07d720a01f4$var$_hoisted_211 = [
    "href"
];
const $bda2e07d720a01f4$var$_hoisted_212 = {
    class: "bottom-navi"
};
const $bda2e07d720a01f4$var$_hoisted_213 = {
    class: "footer"
};
const $bda2e07d720a01f4$var$_hoisted_214 = {
    class: "backlinks"
};
const $bda2e07d720a01f4$var$_hoisted_215 = {
    class: "website"
};
const $bda2e07d720a01f4$var$_hoisted_216 = [
    "href"
];
const $bda2e07d720a01f4$var$_hoisted_217 = /*#__PURE__*/ $bda2e07d720a01f4$var$_withScopeId(()=>/*#__PURE__*/ (0, $6A78m.createElementVNode)("p", {
        class: "email"
    }, [
        /*#__PURE__*/ (0, $6A78m.createElementVNode)("a", {
            href: "mailto:sts@tierschutz.com",
            rel: "noopener noreferrer",
            target: "_blank"
        }, "sts@tierschutz.com")
    ], -1));
const $bda2e07d720a01f4$var$_hoisted_218 = {
    class: "logos logos-bottom"
};
const $bda2e07d720a01f4$var$_hoisted_219 = {
    href: "https://www.tierschutz.com/",
    rel: "noopener noreferrer",
    target: "_blank"
};
const $bda2e07d720a01f4$var$_hoisted_220 = [
    "src"
];
function $bda2e07d720a01f4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_i18n_t = (0, $6A78m.resolveComponent)("i18n-t");
    return (0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)((0, $6A78m.Fragment), null, [
        (0, $6A78m.createElementVNode)("div", {
            class: (0, $l44RV.normalizeClass)("tr-button style-" + [
                _ctx.thrConfig.style
            ])
        }, [
            (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_1, [
                (0, $6A78m.createElementVNode)("img", {
                    src: _ctx.logoSts(),
                    class: "logo logo-sts"
                }, null, 8, $bda2e07d720a01f4$var$_hoisted_2)
            ]),
            (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_3, [
                (0, $6A78m.createElementVNode)("p", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.trButton.cta")), 1),
                (0, $6A78m.createElementVNode)("button", {
                    onClick: _cache[0] || (_cache[0] = (...args)=>_ctx.openOverlay && _ctx.openOverlay(...args))
                }, [
                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_4, [
                        (0, $6A78m.createElementVNode)("img", {
                            src: _ctx.icon68
                        }, null, 8, $bda2e07d720a01f4$var$_hoisted_5)
                    ]),
                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_6, (0, $l44RV.toDisplayString)(_ctx.$t("txt.trButton.buttonText")), 1)
                ])
            ])
        ], 2),
        (0, $6A78m.createElementVNode)("div", {
            class: (0, $l44RV.normalizeClass)("tr-wrapper style-" + [
                _ctx.thrConfig.style
            ]),
            ref: "trWrapper"
        }, [
            (0, $6A78m.createElementVNode)("button", {
                onClick: _cache[1] || (_cache[1] = (...args)=>_ctx.closeOverlay && _ctx.closeOverlay(...args)),
                class: "close-button"
            }, $bda2e07d720a01f4$var$_hoisted_8),
            (0, $6A78m.createElementVNode)("div", {
                class: (0, $l44RV.normalizeClass)([
                    "tierschutz-rechner",
                    _ctx.thrConfig.reptilesRevision && _ctx.category.index == "reptiles" ? "reptiles-revision" : ""
                ])
            }, [
                (0, $6A78m.createElementVNode)("h2", {
                    ref: "mainTitle"
                }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.title")), 513),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_9, [
                    (0, $6A78m.createElementVNode)("p", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.reptilesRevision")), 1)
                ], 512), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.thrConfig.reptilesRevision && _ctx.category.index == "reptiles"
                    ]
                ]),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_10, [
                    (0, $6A78m.createElementVNode)("p", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenCategory.title")), 1),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_11, [
                        ((0, $6A78m.openBlock)(true), (0, $6A78m.createElementBlock)((0, $6A78m.Fragment), null, (0, $6A78m.renderList)(_ctx.categories, (category)=>{
                            return (0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("button", {
                                class: "image-button",
                                onClick: ($event)=>(_ctx.selectCategory(category), _ctx.showScreen("animalSelection"))
                            }, [
                                (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_13, [
                                    category.img ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("img", {
                                        key: 0,
                                        class: "animal-image",
                                        src: category.img,
                                        srcset: `${category.imgSmall} 320w,${category.imgMedium} 480w,${category.imgLarge} 640w`,
                                        sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                                    }, null, 8, $bda2e07d720a01f4$var$_hoisted_14)) : (0, $6A78m.createCommentVNode)("", true),
                                    $bda2e07d720a01f4$var$_hoisted_15
                                ]),
                                (0, $6A78m.createElementVNode)("span", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.categories." + category.index + ".name")), 1)
                            ], 8, $bda2e07d720a01f4$var$_hoisted_12);
                        }), 256))
                    ])
                ], 512), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.screen == "categorySelection"
                    ]
                ]),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_16, [
                    (0, $6A78m.createElementVNode)("p", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenAnimal.title")), 1),
                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", {
                        class: "animal-info"
                    }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenAnimal.equidaeInfo")), 513), [
                        [
                            (0, $90kfS.vShow),
                            _ctx.category.index == "equidae"
                        ]
                    ]),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_17, [
                        ((0, $6A78m.openBlock)(true), (0, $6A78m.createElementBlock)((0, $6A78m.Fragment), null, (0, $6A78m.renderList)(_ctx.animals[_ctx.category.index], (animal)=>{
                            return (0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("button", {
                                class: "image-button",
                                onClick: ($event)=>(_ctx.selectAnimal(animal), _ctx.showScreen("numberOfAnimals"))
                            }, [
                                (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_19, [
                                    animal.img ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("img", {
                                        key: 0,
                                        class: "animal-image",
                                        src: animal.img,
                                        srcset: `${animal.imgSmall} 320w,${animal.imgMedium} 480w,${animal.imgLarge} 640w`,
                                        sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                                    }, null, 8, $bda2e07d720a01f4$var$_hoisted_20)) : (0, $6A78m.createCommentVNode)("", true),
                                    $bda2e07d720a01f4$var$_hoisted_21
                                ]),
                                (0, $6A78m.createElementVNode)("span", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + animal.index + ".name")), 1)
                            ], 8, $bda2e07d720a01f4$var$_hoisted_18);
                        }), 256)),
                        _ctx.category.index == "birds" ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("button", {
                            key: 0,
                            class: "image-button",
                            onClick: _cache[2] || (_cache[2] = ($event)=>(_ctx.selectAnimal(false), _ctx.showScreen("multipleBirds")))
                        }, [
                            (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_22, [
                                _ctx.categories.birds.imgMultiple ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("img", {
                                    key: 0,
                                    class: "animal-image",
                                    src: _ctx.categories.birds.imgMultiple,
                                    srcset: `${_ctx.categories.birds.imgMultipleSmall} 320w,${_ctx.categories.birds.imgMultipleMedium} 480w,${_ctx.categories.birds.imgMultipleLarge} 640w`,
                                    sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_23)) : (0, $6A78m.createCommentVNode)("", true),
                                $bda2e07d720a01f4$var$_hoisted_24
                            ]),
                            (0, $6A78m.createElementVNode)("span", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenAnimal.multipleBirdsButton")), 1)
                        ])) : (0, $6A78m.createCommentVNode)("", true)
                    ])
                ], 512), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.screen == "animalSelection"
                    ]
                ]),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_25, [
                    (0, $6A78m.createElementVNode)("h3", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenAnimal.multipleBirdsButton")) + ":", 1),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_26, [
                        (0, $6A78m.createElementVNode)("p", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenMultipleBirds.warning")), 1)
                    ]),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_27, [
                        (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_28, [
                            (0, $6A78m.createElementVNode)("h4", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.title")), 1),
                            (0, $6A78m.createElementVNode)("p", {
                                innerHTML: _ctx.$t("txt.screenMultipleBirds.infoText").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                            }, null, 8, $bda2e07d720a01f4$var$_hoisted_29)
                        ])
                    ])
                ], 512), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.screen == "multipleBirds"
                    ]
                ]),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_30, [
                    (0, $6A78m.createElementVNode)("label", $bda2e07d720a01f4$var$_hoisted_31, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenNumber.title", {
                        animals: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".namePlural")
                    })), 1),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_32, [
                        _ctx.animal.img ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("img", {
                            key: 0,
                            class: "animal-image",
                            src: _ctx.animal.img,
                            srcset: `${_ctx.animal.imgSmall} 320w,${_ctx.animal.imgMedium} 480w,${_ctx.animal.imgLarge} 640w`,
                            sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                        }, null, 8, $bda2e07d720a01f4$var$_hoisted_33)) : (0, $6A78m.createCommentVNode)("", true)
                    ]),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_34, [
                        (0, $6A78m.createElementVNode)("button", {
                            onClick: _cache[3] || (_cache[3] = ($event)=>_ctx.numberOfAnimals -= 1),
                            class: "minus"
                        }),
                        (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("input", {
                            class: "quantity",
                            type: "number",
                            id: "numberOfAnimals",
                            ref: "numberOfAnimalsInput",
                            name: "numberOfAnimals",
                            min: "1",
                            max: "100",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>_ctx.numberOfAnimals = $event),
                            onKeyup: _cache[5] || (_cache[5] = (0, $90kfS.withKeys)(($event)=>_ctx.showScreen("weight"), [
                                "enter"
                            ]))
                        }, null, 544), [
                            [
                                (0, $90kfS.vModelText),
                                _ctx.numberOfAnimals
                            ]
                        ]),
                        (0, $6A78m.createElementVNode)("button", {
                            onClick: _cache[6] || (_cache[6] = ($event)=>_ctx.numberOfAnimals += 1),
                            class: "plus"
                        })
                    ]),
                    (0, $6A78m.createElementVNode)("button", {
                        class: "button button-forward",
                        onClick: _cache[7] || (_cache[7] = ($event)=>_ctx.showScreen("weight"))
                    }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.buttonNext")), 1),
                    _ctx.showNumberError ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_35, [
                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_36, [
                            (0, $6A78m.createElementVNode)("object", {
                                type: "image/svg+xml",
                                data: _ctx.iconWarningWhite
                            }, null, 8, $bda2e07d720a01f4$var$_hoisted_37)
                        ]),
                        _ctx.numberErrorType === "under" ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("p", $bda2e07d720a01f4$var$_hoisted_38, (0, $l44RV.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".minAnimalsErrorMessage")), 1)) : (0, $6A78m.createCommentVNode)("", true),
                        _ctx.numberErrorType === "over" ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("p", $bda2e07d720a01f4$var$_hoisted_39, (0, $l44RV.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".maxAnimalsErrorMessage")), 1)) : (0, $6A78m.createCommentVNode)("", true),
                        (0, $6A78m.createElementVNode)("button", {
                            onClick: _cache[8] || (_cache[8] = ($event)=>_ctx.showNumberError = false)
                        }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.buttonAcceptWarning")), 1)
                    ])) : (0, $6A78m.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.screen == "numberOfAnimals"
                    ]
                ]),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_40, [
                    (0, $6A78m.createElementVNode)("label", $bda2e07d720a01f4$var$_hoisted_41, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenWeight.title", {
                        animals: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".namePlural")
                    })), 1),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_42, [
                        _ctx.animal.img ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("img", {
                            key: 0,
                            class: "animal-image",
                            src: _ctx.animal.img,
                            srcset: `${_ctx.animal.imgSmall} 320w,${_ctx.animal.imgMedium} 480w,${_ctx.animal.imgLarge} 640w`,
                            sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                        }, null, 8, $bda2e07d720a01f4$var$_hoisted_43)) : (0, $6A78m.createCommentVNode)("", true)
                    ]),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_44, [
                        (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("select", {
                            id: "animalWeight",
                            name: "animalWeight",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>_ctx.animalWeight = $event),
                            onKeyup: _cache[10] || (_cache[10] = (0, $90kfS.withKeys)(($event)=>_ctx.showScreen("results"), [
                                "enter"
                            ]))
                        }, [
                            ((0, $6A78m.openBlock)(true), (0, $6A78m.createElementBlock)((0, $6A78m.Fragment), null, (0, $6A78m.renderList)(_ctx.weightOptions, (weightOption)=>{
                                return (0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("option", null, (0, $l44RV.toDisplayString)(weightOption), 1);
                            }), 256))
                        ], 544), [
                            [
                                (0, $90kfS.vModelSelect),
                                _ctx.animalWeight
                            ]
                        ])
                    ]),
                    (0, $6A78m.createElementVNode)("button", {
                        class: "button button-forward",
                        onClick: _cache[11] || (_cache[11] = ($event)=>_ctx.showScreen("results"))
                    }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.buttonNext")), 1)
                ], 512), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.screen == "weight"
                    ]
                ]),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_45, [
                    (0, $6A78m.createElementVNode)("label", $bda2e07d720a01f4$var$_hoisted_46, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenLength.title", {
                        article: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".article"),
                        animal: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".name")
                    })), 1),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_47, [
                        _ctx.lengthImage ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("img", {
                            key: 0,
                            class: "animal-length-image",
                            src: _ctx.lengthImage
                        }, null, 8, $bda2e07d720a01f4$var$_hoisted_48)) : (0, $6A78m.createCommentVNode)("", true)
                    ]),
                    (0, $6A78m.createElementVNode)("p", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".textLength")), 1),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_49, [
                        (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("input", {
                            class: "animalLength",
                            type: "number",
                            id: "animalLength",
                            ref: "animalLengthInput",
                            name: "animalLength",
                            min: "1",
                            max: "1000",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>_ctx.animalLength = $event),
                            onKeyup: _cache[13] || (_cache[13] = (0, $90kfS.withKeys)(($event)=>_ctx.showScreen("results"), [
                                "enter"
                            ]))
                        }, null, 544), [
                            [
                                (0, $90kfS.vModelText),
                                _ctx.animalLength
                            ]
                        ]),
                        (0, $6A78m.createTextVNode)(" cm")
                    ]),
                    (0, $6A78m.createElementVNode)("button", {
                        class: "button button-forward",
                        onClick: _cache[14] || (_cache[14] = ($event)=>_ctx.showScreen("results"))
                    }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.buttonNext")), 1),
                    _ctx.showLengthError ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_50, [
                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_51, [
                            (0, $6A78m.createElementVNode)("object", {
                                type: "image/svg+xml",
                                data: _ctx.iconWarningWhite
                            }, null, 8, $bda2e07d720a01f4$var$_hoisted_52)
                        ]),
                        (0, $6A78m.createElementVNode)("p", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenLength.error", {
                            min: _ctx.animal.minLength,
                            max: _ctx.animal.maxLength
                        })), 1),
                        (0, $6A78m.createElementVNode)("button", {
                            onClick: _cache[15] || (_cache[15] = ($event)=>_ctx.showLengthError = false)
                        }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.buttonAcceptWarning")), 1)
                    ])) : (0, $6A78m.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.screen == "length"
                    ]
                ]),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_53, [
                    (0, $6A78m.createElementVNode)("label", $bda2e07d720a01f4$var$_hoisted_54, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenWithersHeight.title")), 1),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_55, [
                        _ctx.withersHeightImage ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("img", {
                            key: 0,
                            class: "animal-length-image",
                            src: _ctx.withersHeightImage
                        }, null, 8, $bda2e07d720a01f4$var$_hoisted_56)) : (0, $6A78m.createCommentVNode)("", true)
                    ]),
                    ((0, $6A78m.openBlock)(true), (0, $6A78m.createElementBlock)((0, $6A78m.Fragment), null, (0, $6A78m.renderList)(_ctx.animalWithersHeights, (withersHeight, index)=>{
                        return (0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_57, [
                            (0, $6A78m.createElementVNode)("span", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenWithersHeight.animal")) + " " + (0, $l44RV.toDisplayString)(index + 1) + ": ", 1),
                            (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("input", {
                                class: "animalWithersHeight",
                                type: "number",
                                id: "animalWithersHeight",
                                ref_for: true,
                                ref: "animalWithersHeightInput",
                                name: "animalWithersHeight",
                                min: "50",
                                max: "250",
                                "onUpdate:modelValue": ($event)=>_ctx.animalWithersHeights[index] = $event,
                                onKeyup: _cache[16] || (_cache[16] = (0, $90kfS.withKeys)(($event)=>_ctx.showScreen("results"), [
                                    "enter"
                                ]))
                            }, null, 40, $bda2e07d720a01f4$var$_hoisted_58), [
                                [
                                    (0, $90kfS.vModelText),
                                    _ctx.animalWithersHeights[index]
                                ]
                            ]),
                            (0, $6A78m.createTextVNode)(" cm ")
                        ]);
                    }), 256)),
                    (0, $6A78m.createElementVNode)("button", {
                        class: "button button-forward",
                        onClick: _cache[17] || (_cache[17] = ($event)=>_ctx.showScreen("results"))
                    }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.buttonNext")), 1),
                    _ctx.showWithersHeightError ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_59, [
                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_60, [
                            (0, $6A78m.createElementVNode)("object", {
                                type: "image/svg+xml",
                                data: _ctx.iconWarning
                            }, null, 8, $bda2e07d720a01f4$var$_hoisted_61)
                        ]),
                        (0, $6A78m.createElementVNode)("p", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenWithersHeight.error", {
                            min: _ctx.animal.minWithersHeight,
                            max: _ctx.animal.maxWithersHeight
                        })), 1),
                        (0, $6A78m.createElementVNode)("button", {
                            onClick: _cache[18] || (_cache[18] = ($event)=>_ctx.showWithersHeightError = false)
                        }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.buttonAcceptWarning")), 1)
                    ])) : (0, $6A78m.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.screen == "withersHeight"
                    ]
                ]),
                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", {
                    class: (0, $l44RV.normalizeClass)("screen screen-results " + [
                        _ctx.category.index
                    ] + " " + [
                        _ctx.animal.index
                    ])
                }, [
                    this.numberOfAnimals > 1 ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("h3", $bda2e07d720a01f4$var$_hoisted_62, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.title", {
                        number: _ctx.numberOfAnimals,
                        animals: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".namePlural")
                    })) + ":", 1)) : (0, $6A78m.createCommentVNode)("", true),
                    this.numberOfAnimals === 1 ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("h3", $bda2e07d720a01f4$var$_hoisted_63, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.title", {
                        number: _ctx.numberOfAnimals,
                        animals: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".name")
                    })) + ":", 1)) : (0, $6A78m.createCommentVNode)("", true),
                    _ctx.showNumberWarning ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_64, [
                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_65, [
                            (0, $6A78m.createElementVNode)("object", {
                                type: "image/svg+xml",
                                data: _ctx.iconWarning
                            }, null, 8, $bda2e07d720a01f4$var$_hoisted_66)
                        ]),
                        _ctx.numberWarningType === "under" ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("p", $bda2e07d720a01f4$var$_hoisted_67, (0, $l44RV.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".minAnimalsWarningMessage")), 1)) : (0, $6A78m.createCommentVNode)("", true),
                        _ctx.numberWarningType === "over" ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("p", $bda2e07d720a01f4$var$_hoisted_68, (0, $l44RV.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".maxAnimalsWarningMessage")), 1)) : (0, $6A78m.createCommentVNode)("", true)
                    ])) : (0, $6A78m.createCommentVNode)("", true),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_69, [
                        (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_70, [
                            typeof _ctx.stsRecommendedArea === "number" ? (0, $6A78m.withDirectives)(((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_71, [
                                (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_72, [
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_73, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedWidthExample) + " cm", 1)
                                ]),
                                (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_74, [
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_75, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedLengthExample) + " cm", 1)
                                ]),
                                (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_76, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedArea) + " m\xb2", 1),
                                (0, $6A78m.createElementVNode)("p", $bda2e07d720a01f4$var$_hoisted_77, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.example")), 1)
                            ], 512)), [
                                [
                                    (0, $90kfS.vShow),
                                    _ctx.category.index != "birds"
                                ]
                            ]) : (0, $6A78m.createCommentVNode)("", true),
                            (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_78, [
                                (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_79, [
                                    $bda2e07d720a01f4$var$_hoisted_80,
                                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_86, [
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_87, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedLengthExampleText), 1)
                                    ]),
                                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_88, [
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_89, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedHeight), 1)
                                    ]),
                                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_90, [
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_91, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedWidthExampleText), 1)
                                    ])
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", {
                                    class: "caption"
                                }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.exampleEquidae")), 513), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ])
                            ], 512), [
                                [
                                    (0, $90kfS.vShow),
                                    (_ctx.category.index == "birds" || _ctx.category.index == "equidae") && typeof _ctx.stsRecommendedLengthExample === "number" && _ctx.stsRecommendedLengthExample > 0
                                ]
                            ])
                        ]),
                        (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_92, [
                            (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_93, [
                                (0, $6A78m.createElementVNode)("h4", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsRecommendation")), 1),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsAreaRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_94,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_95, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedArea) + " m\xb2", 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "rodents" || _ctx.category.index == "reptiles" || _ctx.category.index == "birds"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", $bda2e07d720a01f4$var$_hoisted_96, [
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("span", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsLengthRecommendation.upto2reptiles")) + ": ", 1),
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_97, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedLength), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.numberOfAnimals <= 2
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("span", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsLengthRecommendation.morethan2reptiles")) + ": ", 1),
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_98, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedLength), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.numberOfAnimals > 2
                                        ]
                                    ])
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "reptiles"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", $bda2e07d720a01f4$var$_hoisted_99, [
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("span", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsWidthRecommendation.upto2reptiles")) + ": ", 1),
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_100, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedWidth), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.numberOfAnimals <= 2
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("span", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsWidthRecommendation.morethan2reptiles")) + ": ", 1),
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_101, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedWidth), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.numberOfAnimals > 2
                                        ]
                                    ])
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "reptiles"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsHeightRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_102,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_103, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedHeight), 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "rodents" || _ctx.category.index == "reptiles" || _ctx.category.index == "birds"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsBeddingRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_104,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_105, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedBedding), 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "rodents"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsLatticeSpacing")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_106,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_107, (0, $l44RV.toDisplayString)(_ctx.stsLatticeSpacing), 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "rodents"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsWaterBasinRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_108,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_109, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedWaterBasin), 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "reptiles"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsLayingAreaRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_110,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_111, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedLayingArea) + " m\xb2", 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsClearWidthRecommendation")) + " ", 1),
                                    (0, $6A78m.createElementVNode)("span", {
                                        "data-tooltip": _ctx.$t("txt.screenResults.stsClearWidthRecommendationInfo"),
                                        "data-flow": "down"
                                    }, "ⓘ", 8, $bda2e07d720a01f4$var$_hoisted_112),
                                    $bda2e07d720a01f4$var$_hoisted_113,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_114, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedClearWidth) + " m", 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsClearHeightRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_115,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_116, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedClearHeight.value) + " m", 1),
                                    $bda2e07d720a01f4$var$_hoisted_117,
                                    _ctx.stsRecommendedClearHeight.tolerance ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("span", $bda2e07d720a01f4$var$_hoisted_118, [
                                        (0, $6A78m.createTextVNode)("(" + (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.tolerance")) + " " + (0, $l44RV.toDisplayString)(_ctx.stsRecommendedClearHeight.tolerance) + " m) ", 1),
                                        (0, $6A78m.createElementVNode)("span", {
                                            "data-tooltip": _ctx.$t("txt.screenResults.toleranceInfo"),
                                            "data-flow": "down"
                                        }, "ⓘ", 8, $bda2e07d720a01f4$var$_hoisted_119)
                                    ])) : ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("span", $bda2e07d720a01f4$var$_hoisted_120, "(" + (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.noTolerance")) + ")", 1))
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsRunoutTimeRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_121,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_122, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsRunoutTimeRecommendationText")), 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsRunoutAreaRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_123,
                                    (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_124, (0, $l44RV.toDisplayString)(_ctx.stsRecommendedRunoutArea) + " m\xb2", 1)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                    (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.stsPasturingRecommendation")), 1),
                                    $bda2e07d720a01f4$var$_hoisted_125,
                                    (0, $6A78m.createElementVNode)("span", {
                                        class: "value",
                                        innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.pasturing")
                                    }, null, 8, $bda2e07d720a01f4$var$_hoisted_126)
                                ], 512), [
                                    [
                                        (0, $90kfS.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ])
                            ]),
                            (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_127, [
                                (0, $6A78m.createElementVNode)("h4", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.law")), 1),
                                _ctx.category.index == "reptiles" && _ctx.numberOfAnimals > 2 ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_128, [
                                    (0, $6A78m.createVNode)(_component_i18n_t, {
                                        keypath: "txt.screenResults.lawReptilesInfo.text",
                                        tag: "p",
                                        class: "reptiles-law-text"
                                    }, {
                                        link: (0, $6A78m.withCtx)(()=>[
                                                (0, $6A78m.createElementVNode)("a", {
                                                    href: _ctx.$t("txt.screenResults.lawReptilesInfo.linkURL")
                                                }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawReptilesInfo.linkText")), 9, $bda2e07d720a01f4$var$_hoisted_129)
                                            ]),
                                        _: 1
                                    })
                                ])) : ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_130, [
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalArea")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_131,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_132, (0, $l44RV.toDisplayString)(_ctx.lawMinimalArea), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "rodents" || _ctx.category.index == "reptiles" || _ctx.category.index == "birds"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", $bda2e07d720a01f4$var$_hoisted_133, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalLength")) + ": ", 1),
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_134, (0, $l44RV.toDisplayString)(_ctx.lawMinimalLength), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "reptiles"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", $bda2e07d720a01f4$var$_hoisted_135, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalWidth")) + ": ", 1),
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_136, (0, $l44RV.toDisplayString)(_ctx.lawMinimalWidth), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "reptiles"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalHeight")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_137,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_138, (0, $l44RV.toDisplayString)(_ctx.lawMinimalHeight()), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "rodents" || _ctx.category.index == "reptiles" || _ctx.category.index == "birds"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalBedding")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_139,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_140, (0, $l44RV.toDisplayString)(_ctx.lawMinimalBedding), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "rodents"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawWaterBasin")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_141,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_142, (0, $l44RV.toDisplayString)(_ctx.lawWaterBasin), 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "reptiles"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawLayingArea")) + " ", 1),
                                        (0, $6A78m.createElementVNode)("span", {
                                            "data-tooltip": _ctx.$t("txt.screenResults.layingAreaInfo"),
                                            "data-flow": "down"
                                        }, "ⓘ", 8, $bda2e07d720a01f4$var$_hoisted_143),
                                        $bda2e07d720a01f4$var$_hoisted_144,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_145, (0, $l44RV.toDisplayString)(_ctx.lawLayingArea.value) + " m\xb2", 1),
                                        (0, $6A78m.createTextVNode)(),
                                        $bda2e07d720a01f4$var$_hoisted_146,
                                        _ctx.lawLayingArea.tolerance ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("span", $bda2e07d720a01f4$var$_hoisted_147, [
                                            (0, $6A78m.createTextVNode)("(" + (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.tolerance")) + " " + (0, $l44RV.toDisplayString)(_ctx.lawLayingArea.tolerance) + " m\xb2) ", 1),
                                            (0, $6A78m.createElementVNode)("span", {
                                                "data-tooltip": _ctx.$t("txt.screenResults.toleranceInfo"),
                                                "data-flow": "down"
                                            }, "ⓘ", 8, $bda2e07d720a01f4$var$_hoisted_148)
                                        ])) : ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("span", $bda2e07d720a01f4$var$_hoisted_149, "(" + (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.noTolerance")) + ")", 1))
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawLayingAreaMultiroom")) + " ", 1),
                                        (0, $6A78m.createElementVNode)("span", {
                                            "data-tooltip": _ctx.$t("txt.screenResults.layingAreaMultiroomInfo"),
                                            "data-flow": "down"
                                        }, "ⓘ", 8, $bda2e07d720a01f4$var$_hoisted_150),
                                        $bda2e07d720a01f4$var$_hoisted_151,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_152, (0, $l44RV.toDisplayString)(_ctx.lawLayingArea.multiroom) + " m\xb2", 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawClearWidth")) + " ", 1),
                                        (0, $6A78m.createElementVNode)("span", {
                                            "data-tooltip": _ctx.$t("txt.screenResults.lawClearWidthInfo"),
                                            "data-flow": "down"
                                        }, "ⓘ", 8, $bda2e07d720a01f4$var$_hoisted_153),
                                        $bda2e07d720a01f4$var$_hoisted_154,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_155, (0, $l44RV.toDisplayString)(_ctx.lawClearWidth) + " m", 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawClearHeight")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_156,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_157, (0, $l44RV.toDisplayString)(_ctx.lawClearHeight.value) + " m", 1),
                                        $bda2e07d720a01f4$var$_hoisted_158,
                                        _ctx.lawClearHeight.tolerance ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("span", $bda2e07d720a01f4$var$_hoisted_159, [
                                            (0, $6A78m.createTextVNode)("(" + (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.tolerance")) + " " + (0, $l44RV.toDisplayString)(_ctx.lawClearHeight.tolerance) + " m) ", 1),
                                            (0, $6A78m.createElementVNode)("span", {
                                                "data-tooltip": _ctx.$t("txt.screenResults.toleranceInfo"),
                                                "data-flow": "down"
                                            }, "ⓘ", 8, $bda2e07d720a01f4$var$_hoisted_160)
                                        ])) : ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("span", $bda2e07d720a01f4$var$_hoisted_161, "(" + (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.noTolerance")) + ")", 1))
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawRunoutTime")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_162,
                                        (0, $6A78m.createElementVNode)("span", {
                                            class: "value",
                                            innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.runoutTime")
                                        }, null, 8, $bda2e07d720a01f4$var$_hoisted_163)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawRunoutAreaAdjacent")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_164,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_165, (0, $l44RV.toDisplayString)(_ctx.lawRunoutArea.adjacent) + " m\xb2", 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawRunoutAreaNonadjacent")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_166,
                                        (0, $6A78m.createElementVNode)("span", $bda2e07d720a01f4$var$_hoisted_167, (0, $l44RV.toDisplayString)(_ctx.lawRunoutArea.nonadjacent) + " m\xb2", 1)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $6A78m.withDirectives)((0, $6A78m.createElementVNode)("p", null, [
                                        (0, $6A78m.createTextVNode)((0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.lawPasturing")), 1),
                                        $bda2e07d720a01f4$var$_hoisted_168,
                                        (0, $6A78m.createElementVNode)("span", {
                                            class: "value",
                                            innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.pasturing")
                                        }, null, 8, $bda2e07d720a01f4$var$_hoisted_169)
                                    ], 512), [
                                        [
                                            (0, $90kfS.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ])
                                ]))
                            ])
                        ])
                    ]),
                    (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_170, [
                        _ctx.animalTextsExist([
                            "recommendations.general",
                            "recommendations.furnishing",
                            "recommendations.socialStructure"
                        ]) ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_171, [
                            (0, $6A78m.createElementVNode)("h4", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.title")), 1),
                            _ctx.animalTextExists("recommendations.general") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_172, [
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.general").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_173)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.furnishing") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_174, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.furnishing")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.furnishing").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_175)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.socialStructure") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_176, [
                                _ctx.category.index == "reptiles" ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("h5", $bda2e07d720a01f4$var$_hoisted_177, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.socialSturctureAndSpecificNeeds")), 1)) : (0, $6A78m.createCommentVNode)("", true),
                                _ctx.category.index != "reptiles" ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("h5", $bda2e07d720a01f4$var$_hoisted_178, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.socialStructure")), 1)) : (0, $6A78m.createCommentVNode)("", true),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.socialStructure").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_179)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.indoor") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_180, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.indoor")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.indoor").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_181)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.outdoor") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_182, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.outdoor")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.outdoor").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_183)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.specificNeeds") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_184, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.specificNeeds")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.specificNeeds").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_185)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.specialRequirements") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_186, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.specialRequirements")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.specialRequirements").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_187)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.activity") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_188, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.activity")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.activity").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_189)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.more") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_190, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.more")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.more").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_191)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            $bda2e07d720a01f4$var$_hoisted_192
                        ])) : (0, $6A78m.createCommentVNode)("", true),
                        _ctx.animalTextsExist([
                            "laws.furnishing",
                            "laws.raisedAreas",
                            "laws.socialStructure"
                        ]) ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_193, [
                            (0, $6A78m.createElementVNode)("h4", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.title")), 1),
                            _ctx.animalTextExists("laws.furnishing") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_194, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.furnishing")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.furnishing").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_195)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.raisedAreas") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_196, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.raisedAreas")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.raisedAreas").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_197)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.socialStructure") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_198, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.socialStructure")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.socialStructure").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_199)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.structuring") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_200, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.structuring")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.structuring").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_201)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.activity") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_202, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.activity")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.activity").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_203)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.exercise") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_204, [
                                (0, $6A78m.createElementVNode)("h5", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.exercise")), 1),
                                (0, $6A78m.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.exercise").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $bda2e07d720a01f4$var$_hoisted_205)
                            ])) : (0, $6A78m.createCommentVNode)("", true),
                            $bda2e07d720a01f4$var$_hoisted_206,
                            _ctx.animalTextExists("laws.lawDetails") ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("p", {
                                key: 6,
                                innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.lawDetails").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                            }, null, 8, $bda2e07d720a01f4$var$_hoisted_207)) : ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("p", {
                                key: 7,
                                innerHTML: _ctx.$t("txt.screenResults.lawDetails").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                            }, null, 8, $bda2e07d720a01f4$var$_hoisted_208)),
                            $bda2e07d720a01f4$var$_hoisted_209
                        ])) : (0, $6A78m.createCommentVNode)("", true),
                        _ctx.animalLinks ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("div", $bda2e07d720a01f4$var$_hoisted_210, [
                            (0, $6A78m.createElementVNode)("h4", null, (0, $l44RV.toDisplayString)(_ctx.$t("txt.screenResults.additionalInfo")), 1),
                            (0, $6A78m.createElementVNode)("ul", null, [
                                ((0, $6A78m.openBlock)(true), (0, $6A78m.createElementBlock)((0, $6A78m.Fragment), null, (0, $6A78m.renderList)(_ctx.animalLinks, (link)=>{
                                    return (0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("li", null, [
                                        (0, $6A78m.createElementVNode)("a", {
                                            href: link.file,
                                            rel: "noopener noreferrer",
                                            target: "_blank"
                                        }, (0, $l44RV.toDisplayString)(link.text), 9, $bda2e07d720a01f4$var$_hoisted_211)
                                    ]);
                                }), 256))
                            ])
                        ])) : (0, $6A78m.createCommentVNode)("", true)
                    ])
                ], 2), [
                    [
                        (0, $90kfS.vShow),
                        _ctx.screen == "results"
                    ]
                ]),
                (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_212, [
                    _ctx.previousScreens.length > 0 ? ((0, $6A78m.openBlock)(), (0, $6A78m.createElementBlock)("button", {
                        key: 0,
                        class: "button button-back",
                        onClick: _cache[19] || (_cache[19] = ($event)=>_ctx.previousScreen())
                    }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.buttonPrevious")), 1)) : (0, $6A78m.createCommentVNode)("", true)
                ])
            ], 2),
            (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_213, [
                (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_214, [
                    (0, $6A78m.createElementVNode)("p", $bda2e07d720a01f4$var$_hoisted_215, [
                        (0, $6A78m.createElementVNode)("a", {
                            href: _ctx.$t("txt.link"),
                            rel: "noopener noreferrer",
                            target: "_blank"
                        }, (0, $l44RV.toDisplayString)(_ctx.$t("txt.domain")), 9, $bda2e07d720a01f4$var$_hoisted_216)
                    ]),
                    $bda2e07d720a01f4$var$_hoisted_217
                ]),
                (0, $6A78m.createElementVNode)("div", $bda2e07d720a01f4$var$_hoisted_218, [
                    (0, $6A78m.createElementVNode)("a", $bda2e07d720a01f4$var$_hoisted_219, [
                        (0, $6A78m.createElementVNode)("img", {
                            src: _ctx.logoSts(),
                            class: "logo logo-sts"
                        }, null, 8, $bda2e07d720a01f4$var$_hoisted_220)
                    ])
                ])
            ])
        ], 2)
    ], 64);
}

});
parcelRequire.register("ecovD", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("6A78m")).computed; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("6A78m")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("6A78m")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("6A78m")).createElementVNode; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("6A78m")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("6A78m")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("6A78m")).createVNode; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("6A78m")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("6A78m")).getCurrentInstance; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("6A78m")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("6A78m")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("6A78m")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("57ryt")).isRef; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("l44RV")).normalizeClass; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("6A78m")).onBeforeMount; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("6A78m")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("6A78m")).onUnmounted; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("6A78m")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("6A78m")).popScopeId; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("6A78m")).pushScopeId; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("57ryt")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("6A78m")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("6A78m")).resolveComponent; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("6A78m")).Text; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("6A78m")).watch; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("6A78m")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("6A78m")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("90kfS")).createApp; });
$parcel$export(module.exports, "vModelSelect", function () { return (parcelRequire("90kfS")).vModelSelect; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("90kfS")).vModelText; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("90kfS")).vShow; });
$parcel$export(module.exports, "withKeys", function () { return (parcelRequire("90kfS")).withKeys; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("57ryt")).effectScope; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("57ryt")).shallowRef; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("l44RV")).toDisplayString; });

var $6A78m = parcelRequire("6A78m");parcelRequire("90kfS");parcelRequire("57ryt");parcelRequire("l44RV");
function $a56532b493892d86$var$initDev() {
    (0, $6A78m.initCustomFormatter)();
}
const $a56532b493892d86$export$ef7acd7185315e22 = ()=>{};

});
parcelRequire.register("6A78m", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $4caba3856406beb4$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $4caba3856406beb4$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $4caba3856406beb4$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $4caba3856406beb4$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $4caba3856406beb4$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Static", function () { return $4caba3856406beb4$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "pushScopeId", function () { return $4caba3856406beb4$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $4caba3856406beb4$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withCtx", function () { return $4caba3856406beb4$export$694b237e827a3d23; });
$parcel$export(module.exports, "createVNode", function () { return $4caba3856406beb4$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $4caba3856406beb4$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "watchPostEffect", function () { return $4caba3856406beb4$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watch", function () { return $4caba3856406beb4$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "withDirectives", function () { return $4caba3856406beb4$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "useTransitionState", function () { return $4caba3856406beb4$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $4caba3856406beb4$export$6d1641039221b5cb; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $4caba3856406beb4$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $4caba3856406beb4$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $4caba3856406beb4$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $4caba3856406beb4$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $4caba3856406beb4$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $4caba3856406beb4$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $4caba3856406beb4$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "onUpdated", function () { return $4caba3856406beb4$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onUnmounted", function () { return $4caba3856406beb4$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onBeforeMount", function () { return $4caba3856406beb4$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "resolveComponent", function () { return $4caba3856406beb4$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "renderList", function () { return $4caba3856406beb4$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "computed", function () { return $4caba3856406beb4$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "inject", function () { return $4caba3856406beb4$export$a976684a0efeb93f; });
$parcel$export(module.exports, "createTextVNode", function () { return $4caba3856406beb4$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $4caba3856406beb4$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $4caba3856406beb4$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $4caba3856406beb4$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $4caba3856406beb4$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "createStaticVNode", function () { return $4caba3856406beb4$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "createCommentVNode", function () { return $4caba3856406beb4$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $4caba3856406beb4$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $4caba3856406beb4$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $4caba3856406beb4$export$aed4979be6a60047; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("57ryt")).isRef; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("57ryt")).ref; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("57ryt")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("l44RV")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("l44RV")).normalizeClass; });

var $57ryt = parcelRequire("57ryt");

var $l44RV = parcelRequire("l44RV");
const $4caba3856406beb4$var$stack = [];
function $4caba3856406beb4$var$pushWarningContext(vnode) {
    $4caba3856406beb4$var$stack.push(vnode);
}
function $4caba3856406beb4$var$popWarningContext() {
    $4caba3856406beb4$var$stack.pop();
}
function $4caba3856406beb4$export$c106dd0671a0fc2d(msg, ...args) {
    var vnode;
    return;
}
function $4caba3856406beb4$var$getComponentTrace() {
    let currentVNode = $4caba3856406beb4$var$stack[$4caba3856406beb4$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $4caba3856406beb4$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$4caba3856406beb4$var$formatTraceEntry(entry));
    });
    return logs;
}
function $4caba3856406beb4$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$4caba3856406beb4$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$4caba3856406beb4$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $4caba3856406beb4$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$4caba3856406beb4$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $4caba3856406beb4$var$formatProp(key, value1, raw) {
    if ((0, $l44RV.isString)(value1)) {
        value1 = JSON.stringify(value1);
        return raw ? value1 : [
            `${key}=${value1}`
        ];
    } else if (typeof value1 === "number" || typeof value1 === "boolean" || value1 == null) return raw ? value1 : [
        `${key}=${value1}`
    ];
    else if ((0, $57ryt.isRef)(value1)) {
        value1 = $4caba3856406beb4$var$formatProp(key, (0, $57ryt.toRaw)(value1.value), true);
        return raw ? value1 : [
            `${key}=Ref<`,
            value1,
            `>`
        ];
    } else if ((0, $l44RV.isFunction)(value1)) return [
        `${key}=fn${value1.name ? `<${value1.name}>` : ``}`
    ];
    else {
        value1 = (0, $57ryt.toRaw)(value1);
        return raw ? value1 : [
            `${key}=`,
            value1
        ];
    }
}
function $4caba3856406beb4$export$dfbcecb440255e4a(val, type) {
    return;
}
const $4caba3856406beb4$var$ErrorTypeStrings = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"
};
function $4caba3856406beb4$export$b22fcaf88446e9bf(fn, instance, type, args) {
    let res;
    try {
        res = args ? fn(...args) : fn();
    } catch (err) {
        $4caba3856406beb4$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $4caba3856406beb4$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $l44RV.isFunction)(fn)) {
        const res = $4caba3856406beb4$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $l44RV.isPromise)(res)) res.catch((err)=>{
            $4caba3856406beb4$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    const values = [];
    for(let i = 0; i < fn.length; i++)values.push($4caba3856406beb4$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $4caba3856406beb4$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = type;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        const appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $4caba3856406beb4$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $4caba3856406beb4$var$logError(err, type, contextVNode, throwInDev);
}
function $4caba3856406beb4$var$logError(err, type, contextVNode, throwInDev = true) {
    console.error(err);
}
let $4caba3856406beb4$var$isFlushing = false;
let $4caba3856406beb4$var$isFlushPending = false;
const $4caba3856406beb4$var$queue = [];
let $4caba3856406beb4$var$flushIndex = 0;
const $4caba3856406beb4$var$pendingPostFlushCbs = [];
let $4caba3856406beb4$var$activePostFlushCbs = null;
let $4caba3856406beb4$var$postFlushIndex = 0;
const $4caba3856406beb4$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $4caba3856406beb4$var$currentFlushPromise = null;
const $4caba3856406beb4$var$RECURSION_LIMIT = 100;
function $4caba3856406beb4$export$bdd553fddd433dcb(fn) {
    const p = $4caba3856406beb4$var$currentFlushPromise || $4caba3856406beb4$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $4caba3856406beb4$var$findInsertionIndex(id) {
    let start = $4caba3856406beb4$var$flushIndex + 1;
    let end = $4caba3856406beb4$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJobId = $4caba3856406beb4$var$getId($4caba3856406beb4$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $4caba3856406beb4$var$queueJob(job) {
    if (!$4caba3856406beb4$var$queue.length || !$4caba3856406beb4$var$queue.includes(job, $4caba3856406beb4$var$isFlushing && job.allowRecurse ? $4caba3856406beb4$var$flushIndex + 1 : $4caba3856406beb4$var$flushIndex)) {
        if (job.id == null) $4caba3856406beb4$var$queue.push(job);
        else $4caba3856406beb4$var$queue.splice($4caba3856406beb4$var$findInsertionIndex(job.id), 0, job);
        $4caba3856406beb4$var$queueFlush();
    }
}
function $4caba3856406beb4$var$queueFlush() {
    if (!$4caba3856406beb4$var$isFlushing && !$4caba3856406beb4$var$isFlushPending) {
        $4caba3856406beb4$var$isFlushPending = true;
        $4caba3856406beb4$var$currentFlushPromise = $4caba3856406beb4$var$resolvedPromise.then($4caba3856406beb4$var$flushJobs);
    }
}
function $4caba3856406beb4$var$invalidateJob(job) {
    const i = $4caba3856406beb4$var$queue.indexOf(job);
    if (i > $4caba3856406beb4$var$flushIndex) $4caba3856406beb4$var$queue.splice(i, 1);
}
function $4caba3856406beb4$export$59536a0199721cab(cb) {
    if (!(0, $l44RV.isArray)(cb)) {
        if (!$4caba3856406beb4$var$activePostFlushCbs || !$4caba3856406beb4$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $4caba3856406beb4$var$postFlushIndex + 1 : $4caba3856406beb4$var$postFlushIndex)) $4caba3856406beb4$var$pendingPostFlushCbs.push(cb);
    } else $4caba3856406beb4$var$pendingPostFlushCbs.push(...cb);
    $4caba3856406beb4$var$queueFlush();
}
function $4caba3856406beb4$var$flushPreFlushCbs(seen, i = $4caba3856406beb4$var$isFlushing ? $4caba3856406beb4$var$flushIndex + 1 : 0) {
    for(; i < $4caba3856406beb4$var$queue.length; i++){
        const cb = $4caba3856406beb4$var$queue[i];
        if (cb && cb.pre) {
            $4caba3856406beb4$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $4caba3856406beb4$var$flushPostFlushCbs(seen) {
    if ($4caba3856406beb4$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($4caba3856406beb4$var$pendingPostFlushCbs)
        ];
        $4caba3856406beb4$var$pendingPostFlushCbs.length = 0;
        if ($4caba3856406beb4$var$activePostFlushCbs) {
            $4caba3856406beb4$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $4caba3856406beb4$var$activePostFlushCbs = deduped;
        $4caba3856406beb4$var$activePostFlushCbs.sort((a, b)=>$4caba3856406beb4$var$getId(a) - $4caba3856406beb4$var$getId(b));
        for($4caba3856406beb4$var$postFlushIndex = 0; $4caba3856406beb4$var$postFlushIndex < $4caba3856406beb4$var$activePostFlushCbs.length; $4caba3856406beb4$var$postFlushIndex++)$4caba3856406beb4$var$activePostFlushCbs[$4caba3856406beb4$var$postFlushIndex]();
        $4caba3856406beb4$var$activePostFlushCbs = null;
        $4caba3856406beb4$var$postFlushIndex = 0;
    }
}
const $4caba3856406beb4$var$getId = (job)=>job.id == null ? Infinity : job.id;
const $4caba3856406beb4$var$comparator = (a, b)=>{
    const diff = $4caba3856406beb4$var$getId(a) - $4caba3856406beb4$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $4caba3856406beb4$var$flushJobs(seen) {
    $4caba3856406beb4$var$isFlushPending = false;
    $4caba3856406beb4$var$isFlushing = true;
    $4caba3856406beb4$var$queue.sort($4caba3856406beb4$var$comparator);
    const check = (0, $l44RV.NOOP);
    try {
        for($4caba3856406beb4$var$flushIndex = 0; $4caba3856406beb4$var$flushIndex < $4caba3856406beb4$var$queue.length; $4caba3856406beb4$var$flushIndex++){
            const job = $4caba3856406beb4$var$queue[$4caba3856406beb4$var$flushIndex];
            if (job && job.active !== false) $4caba3856406beb4$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $4caba3856406beb4$var$flushIndex = 0;
        $4caba3856406beb4$var$queue.length = 0;
        $4caba3856406beb4$var$flushPostFlushCbs(seen);
        $4caba3856406beb4$var$isFlushing = false;
        $4caba3856406beb4$var$currentFlushPromise = null;
        if ($4caba3856406beb4$var$queue.length || $4caba3856406beb4$var$pendingPostFlushCbs.length) $4caba3856406beb4$var$flushJobs(seen);
    }
}
function $4caba3856406beb4$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        const count = seen.get(fn);
        if (count > $4caba3856406beb4$var$RECURSION_LIMIT) {
            const instance = fn.ownerInstance;
            const componentName = instance && $4caba3856406beb4$var$getComponentName(instance.type);
            $4caba3856406beb4$export$c106dd0671a0fc2d(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`);
            return true;
        } else seen.set(fn, count + 1);
    }
}
let $4caba3856406beb4$var$isHmrUpdating = false;
const $4caba3856406beb4$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
const $4caba3856406beb4$var$map = /* @__PURE__ */ new Map();
function $4caba3856406beb4$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $4caba3856406beb4$var$map.get(id);
    if (!record) {
        $4caba3856406beb4$var$createRecord(id, instance.type);
        record = $4caba3856406beb4$var$map.get(id);
    }
    record.instances.add(instance);
}
function $4caba3856406beb4$var$unregisterHMR(instance) {
    $4caba3856406beb4$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $4caba3856406beb4$var$createRecord(id, initialDef) {
    if ($4caba3856406beb4$var$map.has(id)) return false;
    $4caba3856406beb4$var$map.set(id, {
        initialDef: $4caba3856406beb4$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $4caba3856406beb4$var$normalizeClassComponent(component) {
    return $4caba3856406beb4$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $4caba3856406beb4$var$rerender(id, newRender) {
    const record = $4caba3856406beb4$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $4caba3856406beb4$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $4caba3856406beb4$var$isHmrUpdating = true;
        instance.update();
        $4caba3856406beb4$var$isHmrUpdating = false;
    });
}
function $4caba3856406beb4$var$reload(id, newComp) {
    const record = $4caba3856406beb4$var$map.get(id);
    if (!record) return;
    newComp = $4caba3856406beb4$var$normalizeClassComponent(newComp);
    $4caba3856406beb4$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for (const instance of instances){
        const oldComp = $4caba3856406beb4$var$normalizeClassComponent(instance.type);
        if (!$4caba3856406beb4$var$hmrDirtyComponents.has(oldComp)) {
            if (oldComp !== record.initialDef) $4caba3856406beb4$var$updateComponentDef(oldComp, newComp);
            $4caba3856406beb4$var$hmrDirtyComponents.add(oldComp);
        }
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            $4caba3856406beb4$var$hmrDirtyComponents.add(oldComp);
            instance.ceReload(newComp.styles);
            $4caba3856406beb4$var$hmrDirtyComponents.delete(oldComp);
        } else if (instance.parent) $4caba3856406beb4$var$queueJob(instance.parent.update);
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
    }
    $4caba3856406beb4$export$59536a0199721cab(()=>{
        for (const instance of instances)$4caba3856406beb4$var$hmrDirtyComponents.delete($4caba3856406beb4$var$normalizeClassComponent(instance.type));
    });
}
function $4caba3856406beb4$var$updateComponentDef(oldComp, newComp) {
    (0, $l44RV.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $4caba3856406beb4$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $4caba3856406beb4$export$6922d3b3a607469e;
let $4caba3856406beb4$var$buffer = [];
let $4caba3856406beb4$var$devtoolsNotInstalled = false;
function $4caba3856406beb4$var$emit$1(event, ...args) {
    if ($4caba3856406beb4$export$6922d3b3a607469e) $4caba3856406beb4$export$6922d3b3a607469e.emit(event, ...args);
    else if (!$4caba3856406beb4$var$devtoolsNotInstalled) $4caba3856406beb4$var$buffer.push({
        event: event,
        args: args
    });
}
function $4caba3856406beb4$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $4caba3856406beb4$export$6922d3b3a607469e = hook;
    if ($4caba3856406beb4$export$6922d3b3a607469e) {
        $4caba3856406beb4$export$6922d3b3a607469e.enabled = true;
        $4caba3856406beb4$var$buffer.forEach(({ event: event, args: args })=>$4caba3856406beb4$export$6922d3b3a607469e.emit(event, ...args));
        $4caba3856406beb4$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $4caba3856406beb4$export$b0c258b32c26c785(newHook, target);
        });
        setTimeout(()=>{
            if (!$4caba3856406beb4$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $4caba3856406beb4$var$devtoolsNotInstalled = true;
                $4caba3856406beb4$var$buffer = [];
            }
        }, 3e3);
    } else {
        $4caba3856406beb4$var$devtoolsNotInstalled = true;
        $4caba3856406beb4$var$buffer = [];
    }
}
function $4caba3856406beb4$var$devtoolsInitApp(app, version) {
    $4caba3856406beb4$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $4caba3856406beb4$export$ffb0004e005737fa,
        Text: $4caba3856406beb4$export$5f1af8db9871e1d6,
        Comment: $4caba3856406beb4$export$4d299b491347818a,
        Static: $4caba3856406beb4$export$c1b9a1d3af45b7b6
    });
}
function $4caba3856406beb4$var$devtoolsUnmountApp(app) {
    $4caba3856406beb4$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $4caba3856406beb4$var$devtoolsComponentAdded = /* @__PURE__ */ $4caba3856406beb4$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $4caba3856406beb4$var$devtoolsComponentUpdated = /* @__PURE__ */ $4caba3856406beb4$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $4caba3856406beb4$var$_devtoolsComponentRemoved = /* @__PURE__ */ $4caba3856406beb4$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $4caba3856406beb4$var$devtoolsComponentRemoved = (component)=>{
    if ($4caba3856406beb4$export$6922d3b3a607469e && typeof $4caba3856406beb4$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$4caba3856406beb4$export$6922d3b3a607469e.cleanupBuffer(component)) $4caba3856406beb4$var$_devtoolsComponentRemoved(component);
};
function $4caba3856406beb4$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $4caba3856406beb4$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $4caba3856406beb4$var$devtoolsPerfStart = /* @__PURE__ */ $4caba3856406beb4$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $4caba3856406beb4$var$devtoolsPerfEnd = /* @__PURE__ */ $4caba3856406beb4$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $4caba3856406beb4$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $4caba3856406beb4$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $4caba3856406beb4$var$devtoolsComponentEmit(component, event, params) {
    $4caba3856406beb4$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $4caba3856406beb4$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $l44RV.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        const modifiersKey = `${modelArg === "modelValue" ? "model" : modelArg}Modifiers`;
        const { number: number, trim: trim } = props[modifiersKey] || (0, $l44RV.EMPTY_OBJ);
        if (trim) args = rawArgs.map((a)=>(0, $l44RV.isString)(a) ? a.trim() : a);
        if (number) args = rawArgs.map((0, $l44RV.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $l44RV.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $l44RV.toHandlerKey)((0, $l44RV.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $l44RV.toHandlerKey)((0, $l44RV.hyphenate)(event))];
    if (handler) $4caba3856406beb4$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $4caba3856406beb4$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $4caba3856406beb4$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $l44RV.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $4caba3856406beb4$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $l44RV.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $l44RV.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $l44RV.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $l44RV.extend)(normalized, raw);
    if ((0, $l44RV.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $4caba3856406beb4$var$isEmitListener(options, key) {
    if (!options || !(0, $l44RV.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $l44RV.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $l44RV.hasOwn)(options, (0, $l44RV.hyphenate)(key)) || (0, $l44RV.hasOwn)(options, key);
}
let $4caba3856406beb4$var$currentRenderingInstance = null;
let $4caba3856406beb4$var$currentScopeId = null;
function $4caba3856406beb4$var$setCurrentRenderingInstance(instance) {
    const prev = $4caba3856406beb4$var$currentRenderingInstance;
    $4caba3856406beb4$var$currentRenderingInstance = instance;
    $4caba3856406beb4$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $4caba3856406beb4$export$ac020265ca2cc4cd(id) {
    $4caba3856406beb4$var$currentScopeId = id;
}
function $4caba3856406beb4$export$f2dc6805dc11834e() {
    $4caba3856406beb4$var$currentScopeId = null;
}
const $4caba3856406beb4$export$15ba313e13f3dd04 = (_id)=>$4caba3856406beb4$export$694b237e827a3d23;
function $4caba3856406beb4$export$694b237e827a3d23(fn, ctx = $4caba3856406beb4$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $4caba3856406beb4$export$c20bee82f26f1e27(-1);
        const prevInstance = $4caba3856406beb4$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $4caba3856406beb4$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $4caba3856406beb4$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
let $4caba3856406beb4$var$accessedAttrs = false;
function $4caba3856406beb4$var$markAttrsAccessed() {
    $4caba3856406beb4$var$accessedAttrs = true;
}
function $4caba3856406beb4$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, props: props, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    let result;
    let fallthroughAttrs;
    const prev = $4caba3856406beb4$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            result = $4caba3856406beb4$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $4caba3856406beb4$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $4caba3856406beb4$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $4caba3856406beb4$var$blockStack.length = 0;
        $4caba3856406beb4$export$d3da1ecaf1206c58(err, instance, 1);
        result = $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $l44RV.isModelListener))) fallthroughAttrs = $4caba3856406beb4$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $4caba3856406beb4$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $4caba3856406beb4$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $4caba3856406beb4$var$setCurrentRenderingInstance(prev);
    return result;
}
const $4caba3856406beb4$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $4caba3856406beb4$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $4caba3856406beb4$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $4caba3856406beb4$var$filterSingleRoot(children) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($4caba3856406beb4$export$3868d13f8734ae81(child)) {
            if (child.type !== $4caba3856406beb4$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $4caba3856406beb4$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $l44RV.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $4caba3856406beb4$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $l44RV.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $4caba3856406beb4$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $4caba3856406beb4$export$4d299b491347818a;
};
function $4caba3856406beb4$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $4caba3856406beb4$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$4caba3856406beb4$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $4caba3856406beb4$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $4caba3856406beb4$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$4caba3856406beb4$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $4caba3856406beb4$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
const $4caba3856406beb4$var$isSuspense = (type)=>type.__isSuspense;
const $4caba3856406beb4$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $4caba3856406beb4$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $4caba3856406beb4$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $4caba3856406beb4$var$hydrateSuspense,
    create: $4caba3856406beb4$var$createSuspenseBoundary,
    normalize: $4caba3856406beb4$var$normalizeSuspenseChildren
};
const $4caba3856406beb4$export$74bf444e3cd11ea5 = $4caba3856406beb4$var$SuspenseImpl;
function $4caba3856406beb4$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $l44RV.isFunction)(eventListener)) eventListener();
}
function $4caba3856406beb4$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $4caba3856406beb4$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    if (suspense.deps > 0) {
        $4caba3856406beb4$var$triggerEvent(vnode, "onPending");
        $4caba3856406beb4$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        $4caba3856406beb4$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $4caba3856406beb4$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($4caba3856406beb4$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                $4caba3856406beb4$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            suspense.pendingId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    $4caba3856406beb4$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $4caba3856406beb4$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $4caba3856406beb4$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $4caba3856406beb4$var$setActiveBranch(suspense, newBranch);
    } else {
        $4caba3856406beb4$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $4caba3856406beb4$var$hasWarned = false;
function $4caba3856406beb4$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $4caba3856406beb4$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $l44RV.toNumber)(vnode.props.timeout) : void 0;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2 } = suspense;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                const delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) move(pendingBranch, container2, anchor2, 0);
                };
                let { anchor: anchor2 } = suspense;
                if (activeBranch) {
                    anchor2 = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor2, 0);
            }
            $4caba3856406beb4$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor) $4caba3856406beb4$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $4caba3856406beb4$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, isSVG: isSVG2 } = suspense;
            $4caba3856406beb4$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                isSVG2, slotScopeIds, optimized);
                $4caba3856406beb4$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $4caba3856406beb4$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $4caba3856406beb4$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
                if (placeholder) remove(placeholder);
                $4caba3856406beb4$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $4caba3856406beb4$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $4caba3856406beb4$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $4caba3856406beb4$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $4caba3856406beb4$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $4caba3856406beb4$var$normalizeSuspenseSlot(children.fallback) : $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$4d299b491347818a);
}
function $4caba3856406beb4$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $l44RV.isFunction)(s)) {
        const trackBlock = $4caba3856406beb4$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $4caba3856406beb4$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $4caba3856406beb4$var$currentBlock;
            $4caba3856406beb4$var$closeBlock();
        }
    }
    if ((0, $l44RV.isArray)(s)) {
        const singleChild = $4caba3856406beb4$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $4caba3856406beb4$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $4caba3856406beb4$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $l44RV.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $4caba3856406beb4$export$59536a0199721cab(fn);
}
function $4caba3856406beb4$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    const el = vnode.el = branch.el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $4caba3856406beb4$var$updateHOCHostEl(parentComponent, el);
    }
}
function $4caba3856406beb4$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
function $4caba3856406beb4$export$ede35fc0e5500309(effect, options) {
    return $4caba3856406beb4$var$doWatch(effect, null, options);
}
function $4caba3856406beb4$export$b7f27ea67102d543(effect, options) {
    return $4caba3856406beb4$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $4caba3856406beb4$export$2035654f31b0e555(effect, options) {
    return $4caba3856406beb4$var$doWatch(effect, null, {
        flush: "sync"
    });
}
const $4caba3856406beb4$var$INITIAL_WATCHER_VALUE = {};
function $4caba3856406beb4$export$3db5d71bdb2d5499(source, cb, options) {
    return $4caba3856406beb4$var$doWatch(source, cb, options);
}
function $4caba3856406beb4$var$doWatch(source, cb, { immediate: immediate, deep: deep, flush: flush, onTrack: onTrack, onTrigger: onTrigger } = (0, $l44RV.EMPTY_OBJ)) {
    var _a;
    const warnInvalidSource = (s)=>{
        $4caba3856406beb4$export$c106dd0671a0fc2d(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const instance = (0, $57ryt.getCurrentScope)() === ((_a = $4caba3856406beb4$var$currentInstance) == null ? void 0 : _a.scope) ? $4caba3856406beb4$var$currentInstance : null;
    let getter;
    let forceTrigger = false;
    let isMultiSource = false;
    if ((0, $57ryt.isRef)(source)) {
        getter = ()=>source.value;
        forceTrigger = (0, $57ryt.isShallow)(source);
    } else if ((0, $57ryt.isReactive)(source)) {
        getter = ()=>source;
        deep = true;
    } else if ((0, $l44RV.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>(0, $57ryt.isReactive)(s) || (0, $57ryt.isShallow)(s));
        getter = ()=>source.map((s)=>{
                if ((0, $57ryt.isRef)(s)) return s.value;
                else if ((0, $57ryt.isReactive)(s)) return $4caba3856406beb4$var$traverse(s);
                else if ((0, $l44RV.isFunction)(s)) return $4caba3856406beb4$export$b22fcaf88446e9bf(s, instance, 2);
            });
    } else if ((0, $l44RV.isFunction)(source)) {
        if (cb) getter = ()=>$4caba3856406beb4$export$b22fcaf88446e9bf(source, instance, 2);
        else getter = ()=>{
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $4caba3856406beb4$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $l44RV.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        getter = ()=>$4caba3856406beb4$var$traverse(baseGetter());
    }
    let cleanup;
    let onCleanup = (fn)=>{
        cleanup = effect.onStop = ()=>{
            $4caba3856406beb4$export$b22fcaf88446e9bf(fn, instance, 4);
        };
    };
    let ssrCleanup;
    if ($4caba3856406beb4$var$isInSSRComponentSetup) {
        onCleanup = (0, $l44RV.NOOP);
        if (!cb) getter();
        else if (immediate) $4caba3856406beb4$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            const ctx = $4caba3856406beb4$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $l44RV.NOOP;
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($4caba3856406beb4$var$INITIAL_WATCHER_VALUE) : $4caba3856406beb4$var$INITIAL_WATCHER_VALUE;
    const job = ()=>{
        if (!effect.active) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v1, i)=>(0, $l44RV.hasChanged)(v1, oldValue[i])) : (0, $l44RV.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $4caba3856406beb4$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $4caba3856406beb4$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $4caba3856406beb4$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    let scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = ()=>$4caba3856406beb4$var$queuePostRenderEffect(job, instance && instance.suspense);
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = ()=>$4caba3856406beb4$var$queueJob(job);
    }
    const effect = new (0, $57ryt.ReactiveEffect)(getter, scheduler);
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $4caba3856406beb4$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    const unwatch = ()=>{
        effect.stop();
        if (instance && instance.scope) (0, $l44RV.remove)(instance.scope.effects, effect);
    };
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $4caba3856406beb4$var$instanceWatch(source, value1, options) {
    const publicThis = this.proxy;
    const getter = (0, $l44RV.isString)(source) ? source.includes(".") ? $4caba3856406beb4$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $l44RV.isFunction)(value1)) cb = value1;
    else {
        cb = value1.handler;
        options = value1;
    }
    const cur = $4caba3856406beb4$var$currentInstance;
    $4caba3856406beb4$var$setCurrentInstance(this);
    const res = $4caba3856406beb4$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $4caba3856406beb4$var$setCurrentInstance(cur);
    else $4caba3856406beb4$var$unsetCurrentInstance();
    return res;
}
function $4caba3856406beb4$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $4caba3856406beb4$var$traverse(value1, seen) {
    if (!(0, $l44RV.isObject)(value1) || value1["__v_skip"]) return value1;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value1)) return value1;
    seen.add(value1);
    if ((0, $57ryt.isRef)(value1)) $4caba3856406beb4$var$traverse(value1.value, seen);
    else if ((0, $l44RV.isArray)(value1)) for(let i = 0; i < value1.length; i++)$4caba3856406beb4$var$traverse(value1[i], seen);
    else if ((0, $l44RV.isSet)(value1) || (0, $l44RV.isMap)(value1)) value1.forEach((v1)=>{
        $4caba3856406beb4$var$traverse(v1, seen);
    });
    else if ((0, $l44RV.isPlainObject)(value1)) for(const key in value1)$4caba3856406beb4$var$traverse(value1[key], seen);
    return value1;
}
function $4caba3856406beb4$var$validateDirectiveName(name) {
    if ((0, $l44RV.isBuiltInDirective)(name)) $4caba3856406beb4$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
function $4caba3856406beb4$export$49729353e7c1e6c5(vnode, directives) {
    const internalInstance = $4caba3856406beb4$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    const instance = $4caba3856406beb4$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value1, arg, modifiers = (0, $l44RV.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $l44RV.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $4caba3856406beb4$var$traverse(value1);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value1,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $4caba3856406beb4$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $57ryt.pauseTracking)();
            $4caba3856406beb4$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $57ryt.resetTracking)();
        }
    }
}
function $4caba3856406beb4$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $4caba3856406beb4$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $4caba3856406beb4$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $4caba3856406beb4$var$TransitionHookValidator = [
    Function,
    Array
];
const $4caba3856406beb4$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $4caba3856406beb4$var$TransitionHookValidator,
    onEnter: $4caba3856406beb4$var$TransitionHookValidator,
    onAfterEnter: $4caba3856406beb4$var$TransitionHookValidator,
    onEnterCancelled: $4caba3856406beb4$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $4caba3856406beb4$var$TransitionHookValidator,
    onLeave: $4caba3856406beb4$var$TransitionHookValidator,
    onAfterLeave: $4caba3856406beb4$var$TransitionHookValidator,
    onLeaveCancelled: $4caba3856406beb4$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $4caba3856406beb4$var$TransitionHookValidator,
    onAppear: $4caba3856406beb4$var$TransitionHookValidator,
    onAfterAppear: $4caba3856406beb4$var$TransitionHookValidator,
    onAppearCancelled: $4caba3856406beb4$var$TransitionHookValidator
};
const $4caba3856406beb4$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $4caba3856406beb4$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $4caba3856406beb4$export$f13e630aa3915748();
        const state = $4caba3856406beb4$export$d2a0a1bc267c90f6();
        let prevTransitionKey;
        return ()=>{
            const children = slots.default && $4caba3856406beb4$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            let child = children[0];
            if (children.length > 1) {
                let hasFound = false;
                for (const c of children)if (c.type !== $4caba3856406beb4$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
            const rawProps = (0, $57ryt.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $4caba3856406beb4$var$emptyPlaceholder(child);
            const innerChild = $4caba3856406beb4$var$getKeepAliveChild(child);
            if (!innerChild) return $4caba3856406beb4$var$emptyPlaceholder(child);
            const enterHooks = $4caba3856406beb4$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $4caba3856406beb4$export$7770a22486565649(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && $4caba3856406beb4$var$getKeepAliveChild(oldChild);
            let transitionKeyChanged = false;
            const { getTransitionKey: getTransitionKey } = innerChild.type;
            if (getTransitionKey) {
                const key = getTransitionKey();
                if (prevTransitionKey === void 0) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            if (oldInnerChild && oldInnerChild.type !== $4caba3856406beb4$export$4d299b491347818a && (!$4caba3856406beb4$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                const leavingHooks = $4caba3856406beb4$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $4caba3856406beb4$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (instance.update.active !== false) instance.update();
                    };
                    return $4caba3856406beb4$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $4caba3856406beb4$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $4caba3856406beb4$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el._leaveCb = ()=>{
                        earlyRemove();
                        el._leaveCb = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
const $4caba3856406beb4$export$abd95b5f5e8a8837 = $4caba3856406beb4$var$BaseTransitionImpl;
function $4caba3856406beb4$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $4caba3856406beb4$export$76ac1779589cd824(vnode, props, state, instance) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $4caba3856406beb4$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $4caba3856406beb4$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $l44RV.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el._leaveCb) el._leaveCb(true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $4caba3856406beb4$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el._enterCb = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el._leaveCb = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            return $4caba3856406beb4$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $4caba3856406beb4$var$emptyPlaceholder(vnode) {
    if ($4caba3856406beb4$var$isKeepAlive(vnode)) {
        vnode = $4caba3856406beb4$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $4caba3856406beb4$var$getKeepAliveChild(vnode) {
    return $4caba3856406beb4$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $4caba3856406beb4$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $4caba3856406beb4$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $4caba3856406beb4$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $4caba3856406beb4$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($4caba3856406beb4$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $4caba3856406beb4$export$4d299b491347818a) ret.push(key != null ? $4caba3856406beb4$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
function $4caba3856406beb4$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $l44RV.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $l44RV.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
const $4caba3856406beb4$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
function $4caba3856406beb4$export$d75d499b4c16cf21(source) {
    if ((0, $l44RV.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $4caba3856406beb4$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $4caba3856406beb4$var$currentInstance;
            if (resolvedComp) return ()=>$4caba3856406beb4$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $4caba3856406beb4$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $4caba3856406beb4$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$4caba3856406beb4$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $4caba3856406beb4$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $57ryt.ref)(false);
            const error = (0, $57ryt.ref)();
            const delayed = (0, $57ryt.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $4caba3856406beb4$var$isKeepAlive(instance.parent.vnode)) $4caba3856406beb4$var$queueJob(instance.parent.update);
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $4caba3856406beb4$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $4caba3856406beb4$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $4caba3856406beb4$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $4caba3856406beb4$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $4caba3856406beb4$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $4caba3856406beb4$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $4caba3856406beb4$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $4caba3856406beb4$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, isSVG, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $4caba3856406beb4$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $l44RV.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $4caba3856406beb4$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $l44RV.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $4caba3856406beb4$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $4caba3856406beb4$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (!current || !$4caba3856406beb4$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $4caba3856406beb4$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $4caba3856406beb4$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$4caba3856406beb4$var$matches(include, name));
            exclude && pruneCache((name)=>!$4caba3856406beb4$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $4caba3856406beb4$var$getInnerChild(instance.subTree));
        };
        $4caba3856406beb4$export$6d1641039221b5cb(cacheSubtree);
        $4caba3856406beb4$export$5876c47052fb88b1(cacheSubtree);
        $4caba3856406beb4$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $4caba3856406beb4$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $4caba3856406beb4$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $4caba3856406beb4$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$4caba3856406beb4$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $4caba3856406beb4$var$getInnerChild(rawVNode);
            const comp = vnode.type;
            const name = $4caba3856406beb4$var$getComponentName($4caba3856406beb4$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$4caba3856406beb4$var$matches(include, name)) || exclude && name && $4caba3856406beb4$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $4caba3856406beb4$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $4caba3856406beb4$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $4caba3856406beb4$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $4caba3856406beb4$export$70eb8a58709972df = $4caba3856406beb4$var$KeepAliveImpl;
function $4caba3856406beb4$var$matches(pattern, name) {
    if ((0, $l44RV.isArray)(pattern)) return pattern.some((p)=>$4caba3856406beb4$var$matches(p, name));
    else if ((0, $l44RV.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $l44RV.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $4caba3856406beb4$export$ba52d824b95a2154(hook, target) {
    $4caba3856406beb4$var$registerKeepAliveHook(hook, "a", target);
}
function $4caba3856406beb4$export$bf1440eeaf5fa709(hook, target) {
    $4caba3856406beb4$var$registerKeepAliveHook(hook, "da", target);
}
function $4caba3856406beb4$var$registerKeepAliveHook(hook, type, target = $4caba3856406beb4$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $4caba3856406beb4$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($4caba3856406beb4$var$isKeepAlive(current.parent.vnode)) $4caba3856406beb4$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $4caba3856406beb4$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $4caba3856406beb4$var$injectHook(type, hook, keepAliveRoot, true);
    $4caba3856406beb4$export$13348a43ccacfe58(()=>{
        (0, $l44RV.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $4caba3856406beb4$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $4caba3856406beb4$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $4caba3856406beb4$var$injectHook(type, hook, target = $4caba3856406beb4$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            if (target.isUnmounted) return;
            (0, $57ryt.pauseTracking)();
            $4caba3856406beb4$var$setCurrentInstance(target);
            const res = $4caba3856406beb4$export$dae85862a8d94378(hook, target, type, args);
            $4caba3856406beb4$var$unsetCurrentInstance();
            (0, $57ryt.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $4caba3856406beb4$var$createHook = (lifecycle)=>(hook, target = $4caba3856406beb4$var$currentInstance)=>// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$4caba3856406beb4$var$isInSSRComponentSetup || lifecycle === "sp") && $4caba3856406beb4$var$injectHook(lifecycle, (...args)=>hook(...args), target);
const $4caba3856406beb4$export$23b7aeb0d671f804 = $4caba3856406beb4$var$createHook("bm");
const $4caba3856406beb4$export$6d1641039221b5cb = $4caba3856406beb4$var$createHook("m");
const $4caba3856406beb4$export$ab91988a13872e4c = $4caba3856406beb4$var$createHook("bu");
const $4caba3856406beb4$export$5876c47052fb88b1 = $4caba3856406beb4$var$createHook("u");
const $4caba3856406beb4$export$40c420df62d2614 = $4caba3856406beb4$var$createHook("bum");
const $4caba3856406beb4$export$13348a43ccacfe58 = $4caba3856406beb4$var$createHook("um");
const $4caba3856406beb4$export$ebf0c601f267bceb = $4caba3856406beb4$var$createHook("sp");
const $4caba3856406beb4$export$898295a813d662eb = $4caba3856406beb4$var$createHook("rtg");
const $4caba3856406beb4$export$2b41f4235363e921 = $4caba3856406beb4$var$createHook("rtc");
function $4caba3856406beb4$export$6a3a15856e50ad19(hook, target = $4caba3856406beb4$var$currentInstance) {
    $4caba3856406beb4$var$injectHook("ec", hook, target);
}
const $4caba3856406beb4$var$COMPONENTS = "components";
const $4caba3856406beb4$var$DIRECTIVES = "directives";
function $4caba3856406beb4$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $4caba3856406beb4$var$resolveAsset($4caba3856406beb4$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $4caba3856406beb4$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $4caba3856406beb4$export$b44c564a05ca975(component) {
    if ((0, $l44RV.isString)(component)) return $4caba3856406beb4$var$resolveAsset($4caba3856406beb4$var$COMPONENTS, component, false) || component;
    else return component || $4caba3856406beb4$var$NULL_DYNAMIC_COMPONENT;
}
function $4caba3856406beb4$export$a1989e995cd481be(name) {
    return $4caba3856406beb4$var$resolveAsset($4caba3856406beb4$var$DIRECTIVES, name);
}
function $4caba3856406beb4$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $4caba3856406beb4$var$currentRenderingInstance || $4caba3856406beb4$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $4caba3856406beb4$var$COMPONENTS) {
            const selfName = $4caba3856406beb4$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $l44RV.camelize)(name) || selfName === (0, $l44RV.capitalize)((0, $l44RV.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $4caba3856406beb4$var$resolve(instance[type] || Component[type], name) || // global registration
        $4caba3856406beb4$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $4caba3856406beb4$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $l44RV.camelize)(name)] || registry[(0, $l44RV.capitalize)((0, $l44RV.camelize)(name))]);
}
function $4caba3856406beb4$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    if ((0, $l44RV.isArray)(source) || (0, $l44RV.isString)(source)) {
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $l44RV.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $4caba3856406beb4$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $l44RV.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $4caba3856406beb4$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($4caba3856406beb4$var$currentRenderingInstance.isCE || $4caba3856406beb4$var$currentRenderingInstance.parent && $4caba3856406beb4$var$isAsyncWrapper($4caba3856406beb4$var$currentRenderingInstance.parent) && $4caba3856406beb4$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $4caba3856406beb4$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $4caba3856406beb4$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $4caba3856406beb4$var$ensureValidVNode(slot(props));
    const rendered = $4caba3856406beb4$export$9f2dfe8048dfb22b($4caba3856406beb4$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || `_${name}`
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $4caba3856406beb4$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$4caba3856406beb4$export$3868d13f8734ae81(child)) return true;
        if (child.type === $4caba3856406beb4$export$4d299b491347818a) return false;
        if (child.type === $4caba3856406beb4$export$ffb0004e005737fa && !$4caba3856406beb4$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $4caba3856406beb4$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $l44RV.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $4caba3856406beb4$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($4caba3856406beb4$var$isStatefulComponent(i)) return $4caba3856406beb4$var$getExposeProxy(i) || i.proxy;
    return $4caba3856406beb4$var$getPublicInstance(i.parent);
};
const $4caba3856406beb4$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $l44RV.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$4caba3856406beb4$var$getPublicInstance(i.parent),
    $root: (i)=>$4caba3856406beb4$var$getPublicInstance(i.root),
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $4caba3856406beb4$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>$4caba3856406beb4$var$queueJob(i.update)),
    $nextTick: (i)=>i.n || (i.n = $4caba3856406beb4$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $4caba3856406beb4$var$instanceWatch.bind(i) : (0, $l44RV.NOOP)
});
const $4caba3856406beb4$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $4caba3856406beb4$var$hasSetupBinding = (state, key)=>state !== (0, $l44RV.EMPTY_OBJ) && !state.__isScriptSetup && (0, $l44RV.hasOwn)(state, key);
const $4caba3856406beb4$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($4caba3856406beb4$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $l44RV.EMPTY_OBJ) && (0, $l44RV.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $l44RV.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $l44RV.EMPTY_OBJ) && (0, $l44RV.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $4caba3856406beb4$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $4caba3856406beb4$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $57ryt.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $l44RV.EMPTY_OBJ) && (0, $l44RV.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $l44RV.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value1) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($4caba3856406beb4$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value1;
            return true;
        } else {
            if (data !== (0, $l44RV.EMPTY_OBJ) && (0, $l44RV.hasOwn)(data, key)) {
                data[key] = value1;
                return true;
            } else if ((0, $l44RV.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value1;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, propsOptions: propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, $l44RV.EMPTY_OBJ) && (0, $l44RV.hasOwn)(data, key) || $4caba3856406beb4$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $l44RV.hasOwn)(normalizedProps, key) || (0, $l44RV.hasOwn)(ctx, key) || (0, $l44RV.hasOwn)($4caba3856406beb4$var$publicPropertiesMap, key) || (0, $l44RV.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $l44RV.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $4caba3856406beb4$var$target;
const $4caba3856406beb4$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $l44RV.extend)({}, $4caba3856406beb4$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $4caba3856406beb4$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $l44RV.isGloballyWhitelisted)(key);
        return has;
    }
});
function $4caba3856406beb4$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($4caba3856406beb4$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$4caba3856406beb4$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $l44RV.NOOP)
        });
    });
    return target;
}
function $4caba3856406beb4$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $l44RV.NOOP)
        });
    });
}
function $4caba3856406beb4$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $57ryt.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($4caba3856406beb4$var$isReservedPrefix(key[0])) {
                $4caba3856406beb4$export$c106dd0671a0fc2d(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $l44RV.NOOP)
            });
        }
    });
}
const $4caba3856406beb4$var$warnRuntimeUsage = (method)=>$4caba3856406beb4$export$c106dd0671a0fc2d(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $4caba3856406beb4$export$80b33eababae110e() {
    return null;
}
function $4caba3856406beb4$export$51ecece22fc17ddc() {
    return null;
}
function $4caba3856406beb4$export$da25b65ca24b518a(exposed) {}
function $4caba3856406beb4$export$77e79129327f3d0d(options) {}
function $4caba3856406beb4$export$1b3acd4bb805b712() {
    return null;
}
function $4caba3856406beb4$export$acd55aa037e791bb() {}
function $4caba3856406beb4$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $4caba3856406beb4$export$9203a8e84125433c() {
    return $4caba3856406beb4$var$getContext().slots;
}
function $4caba3856406beb4$export$75e29435042cd2ea() {
    return $4caba3856406beb4$var$getContext().attrs;
}
function $4caba3856406beb4$export$fb78bd113157f1a1(props, name, options) {
    const i = $4caba3856406beb4$export$f13e630aa3915748();
    if (options && options.local) {
        const proxy = (0, $57ryt.ref)(props[name]);
        $4caba3856406beb4$export$3db5d71bdb2d5499(()=>props[name], (v1)=>proxy.value = v1);
        $4caba3856406beb4$export$3db5d71bdb2d5499(proxy, (value1)=>{
            if (value1 !== props[name]) i.emit(`update:${name}`, value1);
        });
        return proxy;
    } else return {
        __v_isRef: true,
        get value () {
            return props[name];
        },
        set value (value){
            i.emit(`update:${name}`, value);
        }
    };
}
function $4caba3856406beb4$var$getContext() {
    const i = $4caba3856406beb4$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $4caba3856406beb4$var$createSetupContext(i));
}
function $4caba3856406beb4$var$normalizePropsOrEmits(props) {
    return (0, $l44RV.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $4caba3856406beb4$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $4caba3856406beb4$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $l44RV.isArray)(opt) || (0, $l44RV.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $4caba3856406beb4$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $l44RV.isArray)(a) && (0, $l44RV.isArray)(b)) return a.concat(b);
    return (0, $l44RV.extend)({}, $4caba3856406beb4$var$normalizePropsOrEmits(a), $4caba3856406beb4$var$normalizePropsOrEmits(b));
}
function $4caba3856406beb4$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $4caba3856406beb4$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $4caba3856406beb4$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $4caba3856406beb4$var$unsetCurrentInstance();
    if ((0, $l44RV.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $4caba3856406beb4$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$4caba3856406beb4$var$setCurrentInstance(ctx)
    ];
}
function $4caba3856406beb4$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $4caba3856406beb4$export$c106dd0671a0fc2d(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $4caba3856406beb4$var$shouldCacheAccess = true;
function $4caba3856406beb4$var$applyOptions(instance) {
    const options = $4caba3856406beb4$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $4caba3856406beb4$var$shouldCacheAccess = false;
    if (options.beforeCreate) $4caba3856406beb4$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $4caba3856406beb4$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $l44RV.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $l44RV.isObject)(data)) ;
        else instance.data = (0, $57ryt.reactive)(data);
    }
    $4caba3856406beb4$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $l44RV.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $l44RV.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $l44RV.NOOP);
        const set = !(0, $l44RV.isFunction)(opt) && (0, $l44RV.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $l44RV.NOOP);
        const c = $4caba3856406beb4$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$4caba3856406beb4$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $l44RV.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $4caba3856406beb4$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $4caba3856406beb4$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $l44RV.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($4caba3856406beb4$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($4caba3856406beb4$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($4caba3856406beb4$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($4caba3856406beb4$export$5876c47052fb88b1, updated);
    registerLifecycleHook($4caba3856406beb4$export$ba52d824b95a2154, activated);
    registerLifecycleHook($4caba3856406beb4$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($4caba3856406beb4$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($4caba3856406beb4$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($4caba3856406beb4$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($4caba3856406beb4$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($4caba3856406beb4$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($4caba3856406beb4$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $l44RV.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $l44RV.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $4caba3856406beb4$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $l44RV.NOOP)) {
    if ((0, $l44RV.isArray)(injectOptions)) injectOptions = $4caba3856406beb4$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $l44RV.isObject)(opt)) {
            if ("default" in opt) injected = $4caba3856406beb4$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $4caba3856406beb4$export$a976684a0efeb93f(opt.from || key);
        } else injected = $4caba3856406beb4$export$a976684a0efeb93f(opt);
        if ((0, $57ryt.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $4caba3856406beb4$var$callHook(hook, instance, type) {
    $4caba3856406beb4$export$dae85862a8d94378((0, $l44RV.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $4caba3856406beb4$var$createWatcher(raw, ctx, publicThis, key) {
    const getter = key.includes(".") ? $4caba3856406beb4$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $l44RV.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $l44RV.isFunction)(handler)) $4caba3856406beb4$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $l44RV.isFunction)(raw)) $4caba3856406beb4$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $l44RV.isObject)(raw)) {
        if ((0, $l44RV.isArray)(raw)) raw.forEach((r)=>$4caba3856406beb4$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $l44RV.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $l44RV.isFunction)(handler)) $4caba3856406beb4$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $4caba3856406beb4$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$4caba3856406beb4$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $4caba3856406beb4$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $l44RV.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $4caba3856406beb4$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $4caba3856406beb4$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$4caba3856406beb4$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $4caba3856406beb4$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $4caba3856406beb4$var$internalOptionMergeStrats = {
    data: $4caba3856406beb4$var$mergeDataFn,
    props: $4caba3856406beb4$var$mergeEmitsOrPropsOptions,
    emits: $4caba3856406beb4$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $4caba3856406beb4$var$mergeObjectOptions,
    computed: $4caba3856406beb4$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $4caba3856406beb4$var$mergeAsArray,
    created: $4caba3856406beb4$var$mergeAsArray,
    beforeMount: $4caba3856406beb4$var$mergeAsArray,
    mounted: $4caba3856406beb4$var$mergeAsArray,
    beforeUpdate: $4caba3856406beb4$var$mergeAsArray,
    updated: $4caba3856406beb4$var$mergeAsArray,
    beforeDestroy: $4caba3856406beb4$var$mergeAsArray,
    beforeUnmount: $4caba3856406beb4$var$mergeAsArray,
    destroyed: $4caba3856406beb4$var$mergeAsArray,
    unmounted: $4caba3856406beb4$var$mergeAsArray,
    activated: $4caba3856406beb4$var$mergeAsArray,
    deactivated: $4caba3856406beb4$var$mergeAsArray,
    errorCaptured: $4caba3856406beb4$var$mergeAsArray,
    serverPrefetch: $4caba3856406beb4$var$mergeAsArray,
    // assets
    components: $4caba3856406beb4$var$mergeObjectOptions,
    directives: $4caba3856406beb4$var$mergeObjectOptions,
    // watch
    watch: $4caba3856406beb4$var$mergeWatchOptions,
    // provide / inject
    provide: $4caba3856406beb4$var$mergeDataFn,
    inject: $4caba3856406beb4$var$mergeInject
};
function $4caba3856406beb4$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $l44RV.extend)((0, $l44RV.isFunction)(to) ? to.call(this, this) : to, (0, $l44RV.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $4caba3856406beb4$var$mergeInject(to, from) {
    return $4caba3856406beb4$var$mergeObjectOptions($4caba3856406beb4$var$normalizeInject(to), $4caba3856406beb4$var$normalizeInject(from));
}
function $4caba3856406beb4$var$normalizeInject(raw) {
    if ((0, $l44RV.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $4caba3856406beb4$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $4caba3856406beb4$var$mergeObjectOptions(to, from) {
    return to ? (0, $l44RV.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $4caba3856406beb4$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $l44RV.isArray)(to) && (0, $l44RV.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $l44RV.extend)(/* @__PURE__ */ Object.create(null), $4caba3856406beb4$var$normalizePropsOrEmits(to), $4caba3856406beb4$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $4caba3856406beb4$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $l44RV.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $4caba3856406beb4$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $4caba3856406beb4$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $l44RV.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $4caba3856406beb4$var$uid$1 = 0;
function $4caba3856406beb4$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $l44RV.isFunction)(rootComponent)) rootComponent = (0, $l44RV.extend)({}, rootComponent);
        if (rootProps != null && !(0, $l44RV.isObject)(rootProps)) rootProps = null;
        const context = $4caba3856406beb4$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new Set();
        let isMounted = false;
        const app = context.app = {
            _uid: $4caba3856406beb4$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $4caba3856406beb4$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $l44RV.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $l44RV.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    const vnode = $4caba3856406beb4$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $4caba3856406beb4$var$devtoolsInitApp(app, $4caba3856406beb4$export$83d89fbfd8236492);
                    }
                    return $4caba3856406beb4$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount () {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $4caba3856406beb4$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value1) {
                context.provides[key] = value1;
                return app;
            },
            runWithContext (fn) {
                $4caba3856406beb4$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $4caba3856406beb4$var$currentApp = null;
                }
            }
        };
        return app;
    };
}
let $4caba3856406beb4$var$currentApp = null;
function $4caba3856406beb4$export$abe1e183e22e10ad(key, value1) {
    if (!$4caba3856406beb4$var$currentInstance) ;
    else {
        let provides = $4caba3856406beb4$var$currentInstance.provides;
        const parentProvides = $4caba3856406beb4$var$currentInstance.parent && $4caba3856406beb4$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $4caba3856406beb4$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value1;
    }
}
function $4caba3856406beb4$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $4caba3856406beb4$var$currentInstance || $4caba3856406beb4$var$currentRenderingInstance;
    if (instance || $4caba3856406beb4$var$currentApp) {
        const provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $4caba3856406beb4$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $l44RV.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $4caba3856406beb4$export$caf6761f24fc571a() {
    return !!($4caba3856406beb4$var$currentInstance || $4caba3856406beb4$var$currentRenderingInstance || $4caba3856406beb4$var$currentApp);
}
function $4caba3856406beb4$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = {};
    (0, $l44RV.def)(attrs, $4caba3856406beb4$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $4caba3856406beb4$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $57ryt.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $4caba3856406beb4$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $4caba3856406beb4$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $57ryt.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($4caba3856406beb4$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value1 = rawProps[key];
                if (options) {
                    if ((0, $l44RV.hasOwn)(attrs, key)) {
                        if (value1 !== attrs[key]) {
                            attrs[key] = value1;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $l44RV.camelize)(key);
                        props[camelizedKey] = $4caba3856406beb4$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value1, instance, false);
                    }
                } else if (value1 !== attrs[key]) {
                    attrs[key] = value1;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($4caba3856406beb4$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $l44RV.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $l44RV.hyphenate)(key)) === key || !(0, $l44RV.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $4caba3856406beb4$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $l44RV.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $57ryt.trigger)(instance, "set", "$attrs");
}
function $4caba3856406beb4$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $l44RV.isReservedProp)(key)) continue;
        const value1 = rawProps[key];
        let camelKey;
        if (options && (0, $l44RV.hasOwn)(options, camelKey = (0, $l44RV.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value1;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value1;
        } else if (!$4caba3856406beb4$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value1 !== attrs[key]) {
                attrs[key] = value1;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $57ryt.toRaw)(props);
        const castValues = rawCastValues || (0, $l44RV.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $4caba3856406beb4$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $l44RV.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $4caba3856406beb4$var$resolvePropValue(options, props, key, value1, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $l44RV.hasOwn)(opt, "default");
        if (hasDefault && value1 === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $l44RV.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value1 = propsDefaults[key];
                else {
                    $4caba3856406beb4$var$setCurrentInstance(instance);
                    value1 = propsDefaults[key] = defaultValue.call(null, props);
                    $4caba3856406beb4$var$unsetCurrentInstance();
                }
            } else value1 = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value1 = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value1 === "" || value1 === (0, $l44RV.hyphenate)(key))) value1 = true;
        }
    }
    return value1;
}
function $4caba3856406beb4$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $l44RV.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $4caba3856406beb4$var$normalizePropsOptions(raw2, appContext, true);
            (0, $l44RV.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $l44RV.isObject)(comp)) cache.set(comp, (0, $l44RV.EMPTY_ARR));
        return 0, $l44RV.EMPTY_ARR;
    }
    if ((0, $l44RV.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $l44RV.camelize)(raw[i]);
        if ($4caba3856406beb4$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $l44RV.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $l44RV.camelize)(key);
        if ($4caba3856406beb4$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $l44RV.isArray)(opt) || (0, $l44RV.isFunction)(opt) ? {
                type: opt
            } : (0, $l44RV.extend)({}, opt);
            if (prop) {
                const booleanIndex = $4caba3856406beb4$var$getTypeIndex(Boolean, prop.type);
                const stringIndex = $4caba3856406beb4$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $l44RV.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
            }
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $l44RV.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $4caba3856406beb4$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
function $4caba3856406beb4$var$getType(ctor) {
    const match = ctor && ctor.toString().match(/^\s*(function|class) (\w+)/);
    return match ? match[2] : ctor === null ? "null" : "";
}
function $4caba3856406beb4$var$isSameType(a, b) {
    return $4caba3856406beb4$var$getType(a) === $4caba3856406beb4$var$getType(b);
}
function $4caba3856406beb4$var$getTypeIndex(type, expectedTypes) {
    if ((0, $l44RV.isArray)(expectedTypes)) return expectedTypes.findIndex((t)=>$4caba3856406beb4$var$isSameType(t, type));
    else if ((0, $l44RV.isFunction)(expectedTypes)) return $4caba3856406beb4$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $4caba3856406beb4$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $57ryt.toRaw)(props);
    const options = instance.propsOptions[0];
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $4caba3856406beb4$var$validateProp(key, resolvedValues[key], opt, !(0, $l44RV.hasOwn)(rawProps, key) && !(0, $l44RV.hasOwn)(rawProps, (0, $l44RV.hyphenate)(key)));
    }
}
function $4caba3856406beb4$var$validateProp(name, value1, prop, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $4caba3856406beb4$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    if (value1 == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $l44RV.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $4caba3856406beb4$var$assertType(value1, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $4caba3856406beb4$export$c106dd0671a0fc2d($4caba3856406beb4$var$getInvalidTypeMessage(name, value1, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value1)) $4caba3856406beb4$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $4caba3856406beb4$var$isSimpleType = /* @__PURE__ */ (0, $l44RV.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $4caba3856406beb4$var$assertType(value1, type) {
    let valid;
    const expectedType = $4caba3856406beb4$var$getType(type);
    if ($4caba3856406beb4$var$isSimpleType(expectedType)) {
        const t = typeof value1;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value1 instanceof type;
    } else if (expectedType === "Object") valid = (0, $l44RV.isObject)(value1);
    else if (expectedType === "Array") valid = (0, $l44RV.isArray)(value1);
    else if (expectedType === "null") valid = value1 === null;
    else valid = value1 instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $4caba3856406beb4$var$getInvalidTypeMessage(name, value1, expectedTypes) {
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $l44RV.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $l44RV.toRawType)(value1);
    const expectedValue = $4caba3856406beb4$var$styleValue(value1, expectedType);
    const receivedValue = $4caba3856406beb4$var$styleValue(value1, receivedType);
    if (expectedTypes.length === 1 && $4caba3856406beb4$var$isExplicable(expectedType) && !$4caba3856406beb4$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($4caba3856406beb4$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $4caba3856406beb4$var$styleValue(value1, type) {
    if (type === "String") return `"${value1}"`;
    else if (type === "Number") return `${Number(value1)}`;
    else return `${value1}`;
}
function $4caba3856406beb4$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $4caba3856406beb4$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $4caba3856406beb4$var$isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const $4caba3856406beb4$var$normalizeSlotValue = (value1)=>(0, $l44RV.isArray)(value1) ? value1.map($4caba3856406beb4$var$normalizeVNode) : [
        $4caba3856406beb4$var$normalizeVNode(value1)
    ];
const $4caba3856406beb4$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $4caba3856406beb4$export$694b237e827a3d23((...args)=>{
        return $4caba3856406beb4$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $4caba3856406beb4$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($4caba3856406beb4$var$isInternalKey(key)) continue;
        const value1 = rawSlots[key];
        if ((0, $l44RV.isFunction)(value1)) slots[key] = $4caba3856406beb4$var$normalizeSlot(key, value1, ctx);
        else if (value1 != null) {
            const normalized = $4caba3856406beb4$var$normalizeSlotValue(value1);
            slots[key] = ()=>normalized;
        }
    }
};
const $4caba3856406beb4$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $4caba3856406beb4$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $4caba3856406beb4$var$initSlots = (instance, children)=>{
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            instance.slots = (0, $57ryt.toRaw)(children);
            (0, $l44RV.def)(children, "_", type);
        } else $4caba3856406beb4$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $4caba3856406beb4$var$normalizeVNodeSlots(instance, children);
    }
    (0, $l44RV.def)(instance.slots, $4caba3856406beb4$var$InternalObjectKey, 1);
};
const $4caba3856406beb4$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $l44RV.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $l44RV.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $4caba3856406beb4$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $4caba3856406beb4$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$4caba3856406beb4$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $4caba3856406beb4$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $l44RV.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$4caba3856406beb4$var$setRef(r, oldRawRef && ((0, $l44RV.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($4caba3856406beb4$var$isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? $4caba3856406beb4$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    const value1 = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $l44RV.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $l44RV.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $l44RV.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $57ryt.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $l44RV.isFunction)(ref)) $4caba3856406beb4$export$b22fcaf88446e9bf(ref, owner, 12, [
        value1,
        refs
    ]);
    else {
        const _isString = (0, $l44RV.isString)(ref);
        const _isRef = (0, $57ryt.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? (0, $l44RV.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $l44RV.isArray)(existing) && (0, $l44RV.remove)(existing, refValue);
                    else {
                        if (!(0, $l44RV.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $l44RV.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value1;
                    if ((0, $l44RV.hasOwn)(setupState, ref)) setupState[ref] = value1;
                } else if (_isRef) {
                    ref.value = value1;
                    if (rawRef.k) refs[rawRef.k] = value1;
                }
            };
            if (value1) {
                doSet.id = -1;
                $4caba3856406beb4$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let $4caba3856406beb4$var$hasMismatch = false;
const $4caba3856406beb4$var$isSVGContainer = (container)=>/svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
const $4caba3856406beb4$var$isComment = (node)=>node.nodeType === 8 /* COMMENT */ ;
function $4caba3856406beb4$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $4caba3856406beb4$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $4caba3856406beb4$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $4caba3856406beb4$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($4caba3856406beb4$var$hasMismatch && true) console.error(`Hydration completed but contains mismatches.`);
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        const isFragmentStart = $4caba3856406beb4$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $4caba3856406beb4$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $4caba3856406beb4$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $4caba3856406beb4$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $4caba3856406beb4$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $4caba3856406beb4$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $4caba3856406beb4$var$isSVGContainer(container), optimized);
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    if (nextNode && $4caba3856406beb4$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    if ($4caba3856406beb4$var$isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $4caba3856406beb4$export$22f9b5ffd89dac9("") : $4caba3856406beb4$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $4caba3856406beb4$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $4caba3856406beb4$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs } = vnode;
        const forcePatchValue = type === "input" && dirs || type === "option";
        if (forcePatchValue || patchFlag !== -1) {
            if (dirs) $4caba3856406beb4$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48) {
                    for(const key in props)if (forcePatchValue && key.endsWith("value") || (0, $l44RV.isOn)(key) && !(0, $l44RV.isReservedProp)(key)) patchProp(el, key, null, props[key], false, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, false, void 0, parentComponent);
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $4caba3856406beb4$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $4caba3856406beb4$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $4caba3856406beb4$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $4caba3856406beb4$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $4caba3856406beb4$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    $4caba3856406beb4$var$hasMismatch = true;
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $4caba3856406beb4$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $4caba3856406beb4$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $4caba3856406beb4$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $4caba3856406beb4$var$hasMismatch = true;
                patch(null, vnode, container, null, parentComponent, parentSuspense, $4caba3856406beb4$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $4caba3856406beb4$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $4caba3856406beb4$var$hasMismatch = true;
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        $4caba3856406beb4$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAsyncAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $4caba3856406beb4$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    const locateClosingAsyncAnchor = (node)=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $4caba3856406beb4$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
let $4caba3856406beb4$var$supported;
let $4caba3856406beb4$var$perf;
function $4caba3856406beb4$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $4caba3856406beb4$var$isSupported()) $4caba3856406beb4$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsPerfStart(instance, type, $4caba3856406beb4$var$isSupported() ? $4caba3856406beb4$var$perf.now() : Date.now());
}
function $4caba3856406beb4$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $4caba3856406beb4$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        $4caba3856406beb4$var$perf.mark(endTag);
        $4caba3856406beb4$var$perf.measure(`<${$4caba3856406beb4$var$formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        $4caba3856406beb4$var$perf.clearMarks(startTag);
        $4caba3856406beb4$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsPerfEnd(instance, type, $4caba3856406beb4$var$isSupported() ? $4caba3856406beb4$var$perf.now() : Date.now());
}
function $4caba3856406beb4$var$isSupported() {
    if ($4caba3856406beb4$var$supported !== void 0) return $4caba3856406beb4$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $4caba3856406beb4$var$supported = true;
        $4caba3856406beb4$var$perf = window.performance;
    } else $4caba3856406beb4$var$supported = false;
    return $4caba3856406beb4$var$supported;
}
function $4caba3856406beb4$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $l44RV.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $l44RV.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
const $4caba3856406beb4$var$queuePostRenderEffect = $4caba3856406beb4$var$queueEffectWithSuspense;
function $4caba3856406beb4$export$53ae2f996c64e9a(options) {
    return $4caba3856406beb4$var$baseCreateRenderer(options);
}
function $4caba3856406beb4$export$200524cf0d997ff0(options) {
    return $4caba3856406beb4$var$baseCreateRenderer(options, $4caba3856406beb4$var$createHydrationFunctions);
}
function $4caba3856406beb4$var$baseCreateRenderer(options, createHydrationFns) {
    $4caba3856406beb4$var$initFeatureFlags();
    const target = (0, $l44RV.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $l44RV.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, isSVG = false, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$4caba3856406beb4$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $4caba3856406beb4$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $4caba3856406beb4$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $4caba3856406beb4$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $4caba3856406beb4$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $4caba3856406beb4$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, isSVG)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, isSVG)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, isSVG);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { type: type, props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $4caba3856406beb4$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $l44RV.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $4caba3856406beb4$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $4caba3856406beb4$var$queuePostRenderEffect(()=>{
            vnodeHook && $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $4caba3856406beb4$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $4caba3856406beb4$var$cloneIfMounted(children[i]) : $4caba3856406beb4$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $l44RV.EMPTY_OBJ);
        const newProps = n2.props || (0, $l44RV.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $4caba3856406beb4$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $4caba3856406beb4$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $4caba3856406beb4$var$toggleRecurse(parentComponent, true);
        const areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $4caba3856406beb4$var$queuePostRenderEffect(()=>{
            vnodeHook && $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $4caba3856406beb4$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $4caba3856406beb4$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$4caba3856406beb4$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    const patchProps = (el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $l44RV.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $l44RV.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(const key in newProps){
                if ((0, $l44RV.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $4caba3856406beb4$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized)=>{
        const instance = initialVNode.component = $4caba3856406beb4$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($4caba3856406beb4$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $4caba3856406beb4$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($4caba3856406beb4$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $4caba3856406beb4$var$invalidateJob(instance.update);
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent } = instance;
                const isAsyncWrapperVNode = $4caba3856406beb4$var$isAsyncWrapper(initialVNode);
                $4caba3856406beb4$var$toggleRecurse(instance, false);
                if (bm) (0, $l44RV.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $4caba3856406beb4$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $4caba3856406beb4$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    ()=>!instance.isUnmounted && hydrateSubTree());
                    else hydrateSubTree();
                } else {
                    const subTree = instance.subTree = $4caba3856406beb4$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                if (m) $4caba3856406beb4$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $4caba3856406beb4$var$queuePostRenderEffect(()=>$4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $4caba3856406beb4$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $4caba3856406beb4$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                let originNext = next;
                let vnodeHook;
                $4caba3856406beb4$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $l44RV.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $4caba3856406beb4$var$toggleRecurse(instance, true);
                const nextTree = $4caba3856406beb4$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) $4caba3856406beb4$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $4caba3856406beb4$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $4caba3856406beb4$var$queuePostRenderEffect(()=>$4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsComponentUpdated(instance);
            }
        };
        const effect = instance.effect = new (0, $57ryt.ReactiveEffect)(componentUpdateFn, ()=>$4caba3856406beb4$var$queueJob(update), instance.scope);
        const update = instance.update = ()=>effect.run();
        update.id = instance.uid;
        $4caba3856406beb4$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $4caba3856406beb4$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $4caba3856406beb4$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $57ryt.pauseTracking)();
        $4caba3856406beb4$var$flushPreFlushCbs();
        (0, $57ryt.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $l44RV.EMPTY_ARR);
        c2 = c2 || (0, $l44RV.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $4caba3856406beb4$var$cloneIfMounted(c2[i]) : $4caba3856406beb4$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $4caba3856406beb4$var$cloneIfMounted(c2[i]) : $4caba3856406beb4$var$normalizeVNode(c2[i]);
            if ($4caba3856406beb4$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $4caba3856406beb4$var$cloneIfMounted(c2[e2]) : $4caba3856406beb4$var$normalizeVNode(c2[e2]);
            if ($4caba3856406beb4$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $4caba3856406beb4$var$cloneIfMounted(c2[i]) : $4caba3856406beb4$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $4caba3856406beb4$var$cloneIfMounted(c2[i]) : $4caba3856406beb4$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $4caba3856406beb4$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $4caba3856406beb4$var$getSequence(newIndexToOldIndexMap) : (0, $l44RV.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $4caba3856406beb4$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $4caba3856406beb4$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $4caba3856406beb4$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs } = vnode;
        if (ref != null) $4caba3856406beb4$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$4caba3856406beb4$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $4caba3856406beb4$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $4caba3856406beb4$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $4caba3856406beb4$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $4caba3856406beb4$var$queuePostRenderEffect(()=>{
            vnodeHook && $4caba3856406beb4$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $4caba3856406beb4$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $4caba3856406beb4$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $4caba3856406beb4$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, update: update, subTree: subTree, um: um } = instance;
        if (bum) (0, $l44RV.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $4caba3856406beb4$var$queuePostRenderEffect(um, parentSuspense);
        $4caba3856406beb4$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $4caba3856406beb4$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    const render = (vnode, container, isSVG)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $4caba3856406beb4$var$flushPreFlushCbs();
        $4caba3856406beb4$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $4caba3856406beb4$var$createAppAPI(render, hydrate)
    };
}
function $4caba3856406beb4$var$toggleRecurse({ effect: effect, update: update }, allowed) {
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $4caba3856406beb4$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $l44RV.isArray)(ch1) && (0, $l44RV.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $4caba3856406beb4$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $4caba3856406beb4$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $4caba3856406beb4$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $4caba3856406beb4$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
const $4caba3856406beb4$var$isTeleport = (type)=>type.__isTeleport;
const $4caba3856406beb4$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $4caba3856406beb4$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $4caba3856406beb4$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $l44RV.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
const $4caba3856406beb4$var$TeleportImpl = {
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $4caba3856406beb4$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const target = n2.target = $4caba3856406beb4$var$resolveTarget(n2.props, querySelector);
            const targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                isSVG = isSVG || $4caba3856406beb4$var$isTargetSVG(target);
            }
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $4caba3856406beb4$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            isSVG = isSVG || $4caba3856406beb4$var$isTargetSVG(target);
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                $4caba3856406beb4$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $4caba3856406beb4$var$moveTeleport(n2, container, mainAnchor, internals, 1);
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $4caba3856406beb4$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $4caba3856406beb4$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $4caba3856406beb4$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
        }
        $4caba3856406beb4$var$updateCssVars(n2);
    },
    remove (vnode, parentComponent, parentSuspense, optimized, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) hostRemove(targetAnchor);
        if (doRemove || !$4caba3856406beb4$var$isTeleportDisabled(props)) {
            hostRemove(anchor);
            if (shapeFlag & 16) for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
            }
        }
    },
    move: $4caba3856406beb4$var$moveTeleport,
    hydrate: $4caba3856406beb4$var$hydrateTeleport
};
function $4caba3856406beb4$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $4caba3856406beb4$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $4caba3856406beb4$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector } }, hydrateChildren) {
    const target = vnode.target = $4caba3856406beb4$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($4caba3856406beb4$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $4caba3856406beb4$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $4caba3856406beb4$export$76d55a0304a371f4 = $4caba3856406beb4$var$TeleportImpl;
function $4caba3856406beb4$var$updateCssVars(vnode) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node = vnode.children[0].el;
        while(node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
const $4caba3856406beb4$export$ffb0004e005737fa = Symbol.for("v-fgt");
const $4caba3856406beb4$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
const $4caba3856406beb4$export$4d299b491347818a = Symbol.for("v-cmt");
const $4caba3856406beb4$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
const $4caba3856406beb4$var$blockStack = [];
let $4caba3856406beb4$var$currentBlock = null;
function $4caba3856406beb4$export$e7eaa45e502fe5cc(disableTracking = false) {
    $4caba3856406beb4$var$blockStack.push($4caba3856406beb4$var$currentBlock = disableTracking ? null : []);
}
function $4caba3856406beb4$var$closeBlock() {
    $4caba3856406beb4$var$blockStack.pop();
    $4caba3856406beb4$var$currentBlock = $4caba3856406beb4$var$blockStack[$4caba3856406beb4$var$blockStack.length - 1] || null;
}
let $4caba3856406beb4$var$isBlockTreeEnabled = 1;
function $4caba3856406beb4$export$c20bee82f26f1e27(value1) {
    $4caba3856406beb4$var$isBlockTreeEnabled += value1;
}
function $4caba3856406beb4$var$setupBlock(vnode) {
    vnode.dynamicChildren = $4caba3856406beb4$var$isBlockTreeEnabled > 0 ? $4caba3856406beb4$var$currentBlock || (0, $l44RV.EMPTY_ARR) : null;
    $4caba3856406beb4$var$closeBlock();
    if ($4caba3856406beb4$var$isBlockTreeEnabled > 0 && $4caba3856406beb4$var$currentBlock) $4caba3856406beb4$var$currentBlock.push(vnode);
    return vnode;
}
function $4caba3856406beb4$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $4caba3856406beb4$var$setupBlock($4caba3856406beb4$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $4caba3856406beb4$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $4caba3856406beb4$var$setupBlock($4caba3856406beb4$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $4caba3856406beb4$export$3868d13f8734ae81(value1) {
    return value1 ? value1.__v_isVNode === true : false;
}
function $4caba3856406beb4$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $4caba3856406beb4$var$vnodeArgsTransformer;
function $4caba3856406beb4$export$83beccd3afeeb809(transformer) {
    $4caba3856406beb4$var$vnodeArgsTransformer = transformer;
}
const $4caba3856406beb4$var$createVNodeWithArgsTransform = (...args)=>{
    return $4caba3856406beb4$var$_createVNode(...$4caba3856406beb4$var$vnodeArgsTransformer ? $4caba3856406beb4$var$vnodeArgsTransformer(args, $4caba3856406beb4$var$currentRenderingInstance) : args);
};
const $4caba3856406beb4$var$InternalObjectKey = `__vInternal`;
const $4caba3856406beb4$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $4caba3856406beb4$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $l44RV.isString)(ref) || (0, $57ryt.isRef)(ref) || (0, $l44RV.isFunction)(ref) ? {
        i: $4caba3856406beb4$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $4caba3856406beb4$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $4caba3856406beb4$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $4caba3856406beb4$var$normalizeKey(props),
        ref: props && $4caba3856406beb4$var$normalizeRef(props),
        scopeId: $4caba3856406beb4$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $4caba3856406beb4$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $4caba3856406beb4$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $l44RV.isString)(children) ? 8 : 16;
    if ($4caba3856406beb4$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $4caba3856406beb4$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $4caba3856406beb4$var$currentBlock.push(vnode);
    return vnode;
}
const $4caba3856406beb4$export$bf5c4cf060303d58 = $4caba3856406beb4$var$_createVNode;
function $4caba3856406beb4$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $4caba3856406beb4$var$NULL_DYNAMIC_COMPONENT) type = $4caba3856406beb4$export$4d299b491347818a;
    if ($4caba3856406beb4$export$3868d13f8734ae81(type)) {
        const cloned = $4caba3856406beb4$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $4caba3856406beb4$var$normalizeChildren(cloned, children);
        if ($4caba3856406beb4$var$isBlockTreeEnabled > 0 && !isBlockNode && $4caba3856406beb4$var$currentBlock) {
            if (cloned.shapeFlag & 6) $4caba3856406beb4$var$currentBlock[$4caba3856406beb4$var$currentBlock.indexOf(type)] = cloned;
            else $4caba3856406beb4$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($4caba3856406beb4$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $4caba3856406beb4$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $l44RV.isString)(klass)) props.class = (0, $l44RV.normalizeClass)(klass);
        if ((0, $l44RV.isObject)(style)) {
            if ((0, $57ryt.isProxy)(style) && !(0, $l44RV.isArray)(style)) style = (0, $l44RV.extend)({}, style);
            props.style = (0, $l44RV.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $l44RV.isString)(type) ? 1 : $4caba3856406beb4$var$isSuspense(type) ? 128 : $4caba3856406beb4$var$isTeleport(type) ? 64 : (0, $l44RV.isObject)(type) ? 4 : (0, $l44RV.isFunction)(type) ? 2 : 0;
    return $4caba3856406beb4$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $4caba3856406beb4$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $57ryt.isProxy)(props) || $4caba3856406beb4$var$InternalObjectKey in props ? (0, $l44RV.extend)({}, props) : props;
}
function $4caba3856406beb4$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children } = vnode;
    const mergedProps = extraProps ? $4caba3856406beb4$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $4caba3856406beb4$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $l44RV.isArray)(ref) ? ref.concat($4caba3856406beb4$var$normalizeRef(extraProps)) : [
            ref,
            $4caba3856406beb4$var$normalizeRef(extraProps)
        ] : $4caba3856406beb4$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $4caba3856406beb4$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $4caba3856406beb4$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $4caba3856406beb4$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $4caba3856406beb4$var$deepCloneVNode(vnode) {
    const cloned = $4caba3856406beb4$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $l44RV.isArray)(vnode.children)) cloned.children = vnode.children.map($4caba3856406beb4$var$deepCloneVNode);
    return cloned;
}
function $4caba3856406beb4$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$5f1af8db9871e1d6, null, text, flag);
}
function $4caba3856406beb4$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $4caba3856406beb4$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($4caba3856406beb4$export$e7eaa45e502fe5cc(), $4caba3856406beb4$export$9f2dfe8048dfb22b($4caba3856406beb4$export$4d299b491347818a, null, text)) : $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$4d299b491347818a, null, text);
}
function $4caba3856406beb4$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$4d299b491347818a);
    else if ((0, $l44RV.isArray)(child)) return $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $4caba3856406beb4$var$cloneIfMounted(child);
    else return $4caba3856406beb4$export$bf5c4cf060303d58($4caba3856406beb4$export$5f1af8db9871e1d6, null, String(child));
}
function $4caba3856406beb4$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $4caba3856406beb4$export$ee4f9e12c0a92a1a(child);
}
function $4caba3856406beb4$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $l44RV.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $4caba3856406beb4$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !($4caba3856406beb4$var$InternalObjectKey in children)) children._ctx = $4caba3856406beb4$var$currentRenderingInstance;
            else if (slotFlag === 3 && $4caba3856406beb4$var$currentRenderingInstance) {
                if ($4caba3856406beb4$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $l44RV.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $4caba3856406beb4$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $4caba3856406beb4$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $4caba3856406beb4$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $l44RV.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $l44RV.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $l44RV.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $l44RV.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $4caba3856406beb4$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $4caba3856406beb4$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $4caba3856406beb4$var$emptyAppContext = $4caba3856406beb4$var$createAppContext();
let $4caba3856406beb4$var$uid = 0;
function $4caba3856406beb4$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $4caba3856406beb4$var$emptyAppContext;
    const instance = {
        uid: $4caba3856406beb4$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $57ryt.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $4caba3856406beb4$var$normalizePropsOptions(type, appContext),
        emitsOptions: $4caba3856406beb4$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $l44RV.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $l44RV.EMPTY_OBJ),
        data: (0, $l44RV.EMPTY_OBJ),
        props: (0, $l44RV.EMPTY_OBJ),
        attrs: (0, $l44RV.EMPTY_OBJ),
        slots: (0, $l44RV.EMPTY_OBJ),
        refs: (0, $l44RV.EMPTY_OBJ),
        setupState: (0, $l44RV.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $4caba3856406beb4$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $4caba3856406beb4$var$currentInstance = null;
const $4caba3856406beb4$export$f13e630aa3915748 = ()=>$4caba3856406beb4$var$currentInstance || $4caba3856406beb4$var$currentRenderingInstance;
let $4caba3856406beb4$var$internalSetCurrentInstance;
let $4caba3856406beb4$var$globalCurrentInstanceSetters;
let $4caba3856406beb4$var$settersKey = "__VUE_INSTANCE_SETTERS__";
if (!($4caba3856406beb4$var$globalCurrentInstanceSetters = (0, $l44RV.getGlobalThis)()[$4caba3856406beb4$var$settersKey])) $4caba3856406beb4$var$globalCurrentInstanceSetters = (0, $l44RV.getGlobalThis)()[$4caba3856406beb4$var$settersKey] = [];
$4caba3856406beb4$var$globalCurrentInstanceSetters.push((i)=>$4caba3856406beb4$var$currentInstance = i);
$4caba3856406beb4$var$internalSetCurrentInstance = (instance)=>{
    if ($4caba3856406beb4$var$globalCurrentInstanceSetters.length > 1) $4caba3856406beb4$var$globalCurrentInstanceSetters.forEach((s)=>s(instance));
    else $4caba3856406beb4$var$globalCurrentInstanceSetters[0](instance);
};
const $4caba3856406beb4$var$setCurrentInstance = (instance)=>{
    $4caba3856406beb4$var$internalSetCurrentInstance(instance);
    instance.scope.on();
};
const $4caba3856406beb4$var$unsetCurrentInstance = ()=>{
    $4caba3856406beb4$var$currentInstance && $4caba3856406beb4$var$currentInstance.scope.off();
    $4caba3856406beb4$var$internalSetCurrentInstance(null);
};
const $4caba3856406beb4$var$isBuiltInTag = /* @__PURE__ */ (0, $l44RV.makeMap)("slot,component");
function $4caba3856406beb4$var$validateComponentName(name, config) {
    const appIsNativeTag = config.isNativeTag || (0, $l44RV.NO);
    if ($4caba3856406beb4$var$isBuiltInTag(name) || appIsNativeTag(name)) $4caba3856406beb4$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $4caba3856406beb4$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $4caba3856406beb4$var$isInSSRComponentSetup = false;
function $4caba3856406beb4$var$setupComponent(instance, isSSR = false) {
    $4caba3856406beb4$var$isInSSRComponentSetup = isSSR;
    const { props: props, children: children } = instance.vnode;
    const isStateful = $4caba3856406beb4$var$isStatefulComponent(instance);
    $4caba3856406beb4$var$initProps(instance, props, isStateful, isSSR);
    $4caba3856406beb4$var$initSlots(instance, children);
    const setupResult = isStateful ? $4caba3856406beb4$var$setupStatefulComponent(instance, isSSR) : void 0;
    $4caba3856406beb4$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $4caba3856406beb4$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $57ryt.markRaw)(new Proxy(instance.ctx, $4caba3856406beb4$var$PublicInstanceProxyHandlers));
    const { setup: setup } = Component;
    if (setup) {
        const setupContext = instance.setupContext = setup.length > 1 ? $4caba3856406beb4$var$createSetupContext(instance) : null;
        $4caba3856406beb4$var$setCurrentInstance(instance);
        (0, $57ryt.pauseTracking)();
        const setupResult = $4caba3856406beb4$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $57ryt.resetTracking)();
        $4caba3856406beb4$var$unsetCurrentInstance();
        if ((0, $l44RV.isPromise)(setupResult)) {
            setupResult.then($4caba3856406beb4$var$unsetCurrentInstance, $4caba3856406beb4$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $4caba3856406beb4$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $4caba3856406beb4$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $4caba3856406beb4$var$handleSetupResult(instance, setupResult, isSSR);
    } else $4caba3856406beb4$var$finishComponentSetup(instance, isSSR);
}
function $4caba3856406beb4$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $l44RV.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $l44RV.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $57ryt.proxyRefs)(setupResult);
    }
    $4caba3856406beb4$var$finishComponentSetup(instance, isSSR);
}
let $4caba3856406beb4$var$compile;
let $4caba3856406beb4$var$installWithProxy;
function $4caba3856406beb4$export$667bb5a67822b941(_compile) {
    $4caba3856406beb4$var$compile = _compile;
    $4caba3856406beb4$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $4caba3856406beb4$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $4caba3856406beb4$export$c93a9c496c5211fa = ()=>!$4caba3856406beb4$var$compile;
function $4caba3856406beb4$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $4caba3856406beb4$var$compile && !Component.render) {
            const template = Component.template || $4caba3856406beb4$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $l44RV.extend)((0, $l44RV.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $4caba3856406beb4$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $l44RV.NOOP);
        if ($4caba3856406beb4$var$installWithProxy) $4caba3856406beb4$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        $4caba3856406beb4$var$setCurrentInstance(instance);
        (0, $57ryt.pauseTracking)();
        $4caba3856406beb4$var$applyOptions(instance);
        (0, $57ryt.resetTracking)();
        $4caba3856406beb4$var$unsetCurrentInstance();
    }
}
function $4caba3856406beb4$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get (target, key) {
            (0, $57ryt.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $4caba3856406beb4$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get (target, key) {
            (0, $57ryt.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $4caba3856406beb4$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $4caba3856406beb4$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $4caba3856406beb4$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $57ryt.proxyRefs)((0, $57ryt.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $4caba3856406beb4$var$publicPropertiesMap) return $4caba3856406beb4$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $4caba3856406beb4$var$publicPropertiesMap;
        }
    }));
}
const $4caba3856406beb4$var$classifyRE = /(?:^|[-_])(\w)/g;
const $4caba3856406beb4$var$classify = (str)=>str.replace($4caba3856406beb4$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $4caba3856406beb4$var$getComponentName(Component, includeInferred = true) {
    return (0, $l44RV.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $4caba3856406beb4$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $4caba3856406beb4$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $4caba3856406beb4$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $4caba3856406beb4$var$isClassComponent(value1) {
    return (0, $l44RV.isFunction)(value1) && "__vccOpts" in value1;
}
const $4caba3856406beb4$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    return (0, $57ryt.computed)(getterOrOptions, debugOptions, $4caba3856406beb4$var$isInSSRComponentSetup);
};
function $4caba3856406beb4$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, $l44RV.isObject)(propsOrChildren) && !(0, $l44RV.isArray)(propsOrChildren)) {
            if ($4caba3856406beb4$export$3868d13f8734ae81(propsOrChildren)) return $4caba3856406beb4$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $4caba3856406beb4$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $4caba3856406beb4$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $4caba3856406beb4$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $4caba3856406beb4$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
const $4caba3856406beb4$export$f2549a27e18acf2d = Symbol.for("v-scx");
const $4caba3856406beb4$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $4caba3856406beb4$export$a976684a0efeb93f($4caba3856406beb4$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $4caba3856406beb4$var$isShallow(value1) {
    return !!(value1 && value1["__v_isShallow"]);
}
function $4caba3856406beb4$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $57ryt.toRaw)(instance.props)));
        if (instance.setupState !== (0, $l44RV.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $l44RV.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $57ryt.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $l44RV.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $l44RV.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $57ryt.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $l44RV.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $l44RV.isArray)(opts) && opts.includes(key) || (0, $l44RV.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ($4caba3856406beb4$var$isShallow(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $4caba3856406beb4$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $4caba3856406beb4$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $4caba3856406beb4$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $l44RV.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($4caba3856406beb4$var$isBlockTreeEnabled > 0 && $4caba3856406beb4$var$currentBlock) $4caba3856406beb4$var$currentBlock.push(cached);
    return true;
}
const $4caba3856406beb4$export$83d89fbfd8236492 = "3.3.4";
const $4caba3856406beb4$var$_ssrUtils = {
    createComponentInstance: $4caba3856406beb4$var$createComponentInstance,
    setupComponent: $4caba3856406beb4$var$setupComponent,
    renderComponentRoot: $4caba3856406beb4$var$renderComponentRoot,
    setCurrentRenderingInstance: $4caba3856406beb4$var$setCurrentRenderingInstance,
    isVNode: $4caba3856406beb4$export$3868d13f8734ae81,
    normalizeVNode: $4caba3856406beb4$var$normalizeVNode
};
const $4caba3856406beb4$export$a9679033567b336d = $4caba3856406beb4$var$_ssrUtils;
const $4caba3856406beb4$export$83cf26e06ea620e1 = null;
const $4caba3856406beb4$export$dc678eddf276286e = null;

});
parcelRequire.register("57ryt", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $3ba2fb0e8202e0a0$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $3ba2fb0e8202e0a0$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $3ba2fb0e8202e0a0$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $3ba2fb0e8202e0a0$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $3ba2fb0e8202e0a0$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $3ba2fb0e8202e0a0$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $3ba2fb0e8202e0a0$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $3ba2fb0e8202e0a0$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $3ba2fb0e8202e0a0$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $3ba2fb0e8202e0a0$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $3ba2fb0e8202e0a0$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $3ba2fb0e8202e0a0$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $3ba2fb0e8202e0a0$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $3ba2fb0e8202e0a0$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $3ba2fb0e8202e0a0$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $3ba2fb0e8202e0a0$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $3ba2fb0e8202e0a0$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "proxyRefs", function () { return $3ba2fb0e8202e0a0$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "computed", function () { return $3ba2fb0e8202e0a0$export$2983e091f1a1e8e2; });

var $l44RV = parcelRequire("l44RV");
function $3ba2fb0e8202e0a0$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $3ba2fb0e8202e0a0$var$activeEffectScope;
class $3ba2fb0e8202e0a0$export$1168ed9dbc71ddbd {
    get active() {
        return this._active;
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $3ba2fb0e8202e0a0$var$activeEffectScope;
            try {
                $3ba2fb0e8202e0a0$var$activeEffectScope = this;
                return fn();
            } finally{
                $3ba2fb0e8202e0a0$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        $3ba2fb0e8202e0a0$var$activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        $3ba2fb0e8202e0a0$var$activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $3ba2fb0e8202e0a0$var$activeEffectScope;
        if (!detached && $3ba2fb0e8202e0a0$var$activeEffectScope) this.index = ($3ba2fb0e8202e0a0$var$activeEffectScope.scopes || ($3ba2fb0e8202e0a0$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
}
function $3ba2fb0e8202e0a0$export$7056603ea81600be(detached) {
    return new $3ba2fb0e8202e0a0$export$1168ed9dbc71ddbd(detached);
}
function $3ba2fb0e8202e0a0$var$recordEffectScope(effect, scope = $3ba2fb0e8202e0a0$var$activeEffectScope) {
    if (scope && scope.active) scope.effects.push(effect);
}
function $3ba2fb0e8202e0a0$export$c7be4b0125a10cba() {
    return $3ba2fb0e8202e0a0$var$activeEffectScope;
}
function $3ba2fb0e8202e0a0$export$a780418acd4762da(fn) {
    if ($3ba2fb0e8202e0a0$var$activeEffectScope) $3ba2fb0e8202e0a0$var$activeEffectScope.cleanups.push(fn);
}
const $3ba2fb0e8202e0a0$var$createDep = (effects)=>{
    const dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
const $3ba2fb0e8202e0a0$var$wasTracked = (dep)=>(dep.w & $3ba2fb0e8202e0a0$var$trackOpBit) > 0;
const $3ba2fb0e8202e0a0$var$newTracked = (dep)=>(dep.n & $3ba2fb0e8202e0a0$var$trackOpBit) > 0;
const $3ba2fb0e8202e0a0$var$initDepMarkers = ({ deps: deps })=>{
    if (deps.length) for(let i = 0; i < deps.length; i++)deps[i].w |= $3ba2fb0e8202e0a0$var$trackOpBit;
};
const $3ba2fb0e8202e0a0$var$finalizeDepMarkers = (effect)=>{
    const { deps: deps } = effect;
    if (deps.length) {
        let ptr = 0;
        for(let i = 0; i < deps.length; i++){
            const dep = deps[i];
            if ($3ba2fb0e8202e0a0$var$wasTracked(dep) && !$3ba2fb0e8202e0a0$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            dep.w &= ~$3ba2fb0e8202e0a0$var$trackOpBit;
            dep.n &= ~$3ba2fb0e8202e0a0$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
const $3ba2fb0e8202e0a0$var$targetMap = /* @__PURE__ */ new WeakMap();
let $3ba2fb0e8202e0a0$var$effectTrackDepth = 0;
let $3ba2fb0e8202e0a0$var$trackOpBit = 1;
const $3ba2fb0e8202e0a0$var$maxMarkerBits = 30;
let $3ba2fb0e8202e0a0$var$activeEffect;
const $3ba2fb0e8202e0a0$export$3c41b1a4e06acc14 = Symbol("");
const $3ba2fb0e8202e0a0$var$MAP_KEY_ITERATE_KEY = Symbol("");
class $3ba2fb0e8202e0a0$export$28352bb4dd362521 {
    run() {
        if (!this.active) return this.fn();
        let parent = $3ba2fb0e8202e0a0$var$activeEffect;
        let lastShouldTrack = $3ba2fb0e8202e0a0$var$shouldTrack;
        while(parent){
            if (parent === this) return;
            parent = parent.parent;
        }
        try {
            this.parent = $3ba2fb0e8202e0a0$var$activeEffect;
            $3ba2fb0e8202e0a0$var$activeEffect = this;
            $3ba2fb0e8202e0a0$var$shouldTrack = true;
            $3ba2fb0e8202e0a0$var$trackOpBit = 1 << ++$3ba2fb0e8202e0a0$var$effectTrackDepth;
            if ($3ba2fb0e8202e0a0$var$effectTrackDepth <= $3ba2fb0e8202e0a0$var$maxMarkerBits) $3ba2fb0e8202e0a0$var$initDepMarkers(this);
            else $3ba2fb0e8202e0a0$var$cleanupEffect(this);
            return this.fn();
        } finally{
            if ($3ba2fb0e8202e0a0$var$effectTrackDepth <= $3ba2fb0e8202e0a0$var$maxMarkerBits) $3ba2fb0e8202e0a0$var$finalizeDepMarkers(this);
            $3ba2fb0e8202e0a0$var$trackOpBit = 1 << --$3ba2fb0e8202e0a0$var$effectTrackDepth;
            $3ba2fb0e8202e0a0$var$activeEffect = this.parent;
            $3ba2fb0e8202e0a0$var$shouldTrack = lastShouldTrack;
            this.parent = void 0;
            if (this.deferStop) this.stop();
        }
    }
    stop() {
        if ($3ba2fb0e8202e0a0$var$activeEffect === this) this.deferStop = true;
        else if (this.active) {
            $3ba2fb0e8202e0a0$var$cleanupEffect(this);
            if (this.onStop) this.onStop();
            this.active = false;
        }
    }
    constructor(fn, scheduler = null, scope){
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = void 0;
        $3ba2fb0e8202e0a0$var$recordEffectScope(this, scope);
    }
}
function $3ba2fb0e8202e0a0$var$cleanupEffect(effect2) {
    const { deps: deps } = effect2;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect2);
        deps.length = 0;
    }
}
function $3ba2fb0e8202e0a0$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    const _effect = new $3ba2fb0e8202e0a0$export$28352bb4dd362521(fn);
    if (options) {
        (0, $l44RV.extend)(_effect, options);
        if (options.scope) $3ba2fb0e8202e0a0$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    const runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $3ba2fb0e8202e0a0$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $3ba2fb0e8202e0a0$var$shouldTrack = true;
const $3ba2fb0e8202e0a0$var$trackStack = [];
function $3ba2fb0e8202e0a0$export$938a971395fef855() {
    $3ba2fb0e8202e0a0$var$trackStack.push($3ba2fb0e8202e0a0$var$shouldTrack);
    $3ba2fb0e8202e0a0$var$shouldTrack = false;
}
function $3ba2fb0e8202e0a0$export$1f8ffc6fd33b1d16() {
    $3ba2fb0e8202e0a0$var$trackStack.push($3ba2fb0e8202e0a0$var$shouldTrack);
    $3ba2fb0e8202e0a0$var$shouldTrack = true;
}
function $3ba2fb0e8202e0a0$export$c39176b1babaa8b8() {
    const last = $3ba2fb0e8202e0a0$var$trackStack.pop();
    $3ba2fb0e8202e0a0$var$shouldTrack = last === void 0 ? true : last;
}
function $3ba2fb0e8202e0a0$export$6b2a7d5132615086(target, type, key) {
    if ($3ba2fb0e8202e0a0$var$shouldTrack && $3ba2fb0e8202e0a0$var$activeEffect) {
        let depsMap = $3ba2fb0e8202e0a0$var$targetMap.get(target);
        if (!depsMap) $3ba2fb0e8202e0a0$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $3ba2fb0e8202e0a0$var$createDep());
        const eventInfo = void 0;
        $3ba2fb0e8202e0a0$var$trackEffects(dep, eventInfo);
    }
}
function $3ba2fb0e8202e0a0$var$trackEffects(dep, debuggerEventExtraInfo) {
    let shouldTrack2 = false;
    if ($3ba2fb0e8202e0a0$var$effectTrackDepth <= $3ba2fb0e8202e0a0$var$maxMarkerBits) {
        if (!$3ba2fb0e8202e0a0$var$newTracked(dep)) {
            dep.n |= $3ba2fb0e8202e0a0$var$trackOpBit;
            shouldTrack2 = !$3ba2fb0e8202e0a0$var$wasTracked(dep);
        }
    } else shouldTrack2 = !dep.has($3ba2fb0e8202e0a0$var$activeEffect);
    if (shouldTrack2) {
        dep.add($3ba2fb0e8202e0a0$var$activeEffect);
        $3ba2fb0e8202e0a0$var$activeEffect.deps.push(dep);
    }
}
function $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $3ba2fb0e8202e0a0$var$targetMap.get(target);
    if (!depsMap) return;
    let deps = [];
    if (type === "clear") deps = [
        ...depsMap.values()
    ];
    else if (key === "length" && (0, $l44RV.isArray)(target)) {
        const newLength = Number(newValue);
        depsMap.forEach((dep, key2)=>{
            if (key2 === "length" || key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $l44RV.isArray)(target)) {
                    deps.push(depsMap.get($3ba2fb0e8202e0a0$export$3c41b1a4e06acc14));
                    if ((0, $l44RV.isMap)(target)) deps.push(depsMap.get($3ba2fb0e8202e0a0$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $l44RV.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $l44RV.isArray)(target)) {
                    deps.push(depsMap.get($3ba2fb0e8202e0a0$export$3c41b1a4e06acc14));
                    if ((0, $l44RV.isMap)(target)) deps.push(depsMap.get($3ba2fb0e8202e0a0$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $l44RV.isMap)(target)) deps.push(depsMap.get($3ba2fb0e8202e0a0$export$3c41b1a4e06acc14));
                break;
        }
    }
    const eventInfo = void 0;
    if (deps.length === 1) {
        if (deps[0]) $3ba2fb0e8202e0a0$var$triggerEffects(deps[0]);
    } else {
        const effects = [];
        for (const dep of deps)if (dep) effects.push(...dep);
        $3ba2fb0e8202e0a0$var$triggerEffects($3ba2fb0e8202e0a0$var$createDep(effects));
    }
}
function $3ba2fb0e8202e0a0$var$triggerEffects(dep, debuggerEventExtraInfo) {
    const effects = (0, $l44RV.isArray)(dep) ? dep : [
        ...dep
    ];
    for (const effect2 of effects)if (effect2.computed) $3ba2fb0e8202e0a0$var$triggerEffect(effect2, debuggerEventExtraInfo);
    for (const effect2 of effects)if (!effect2.computed) $3ba2fb0e8202e0a0$var$triggerEffect(effect2, debuggerEventExtraInfo);
}
function $3ba2fb0e8202e0a0$var$triggerEffect(effect2, debuggerEventExtraInfo) {
    if (effect2 !== $3ba2fb0e8202e0a0$var$activeEffect || effect2.allowRecurse) {
        if (effect2.scheduler) effect2.scheduler();
        else effect2.run();
    }
}
function $3ba2fb0e8202e0a0$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $3ba2fb0e8202e0a0$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
const $3ba2fb0e8202e0a0$var$isNonTrackableKeys = /* @__PURE__ */ (0, $l44RV.makeMap)(`__proto__,__v_isRef,__isVue`);
const $3ba2fb0e8202e0a0$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $l44RV.isSymbol)));
const $3ba2fb0e8202e0a0$var$get$1 = /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createGetter();
const $3ba2fb0e8202e0a0$var$shallowGet = /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createGetter(false, true);
const $3ba2fb0e8202e0a0$var$readonlyGet = /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createGetter(true);
const $3ba2fb0e8202e0a0$var$shallowReadonlyGet = /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createGetter(true, true);
const $3ba2fb0e8202e0a0$var$arrayInstrumentations = /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createArrayInstrumentations();
function $3ba2fb0e8202e0a0$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this);
            for(let i = 0, l = this.length; i < l; i++)$3ba2fb0e8202e0a0$export$6b2a7d5132615086(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($3ba2fb0e8202e0a0$export$ab18938b9fc5f28e));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $3ba2fb0e8202e0a0$export$938a971395fef855();
            const res = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $3ba2fb0e8202e0a0$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $3ba2fb0e8202e0a0$var$hasOwnProperty(key) {
    const obj = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this);
    $3ba2fb0e8202e0a0$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
function $3ba2fb0e8202e0a0$var$createGetter(isReadonly2 = false, shallow = false) {
    return function get2(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? $3ba2fb0e8202e0a0$var$shallowReadonlyMap : $3ba2fb0e8202e0a0$var$readonlyMap : shallow ? $3ba2fb0e8202e0a0$var$shallowReactiveMap : $3ba2fb0e8202e0a0$var$reactiveMap).get(target)) return target;
        const targetIsArray = (0, $l44RV.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $l44RV.hasOwn)($3ba2fb0e8202e0a0$var$arrayInstrumentations, key)) return Reflect.get($3ba2fb0e8202e0a0$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $3ba2fb0e8202e0a0$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, receiver);
        if ((0, $l44RV.isSymbol)(key) ? $3ba2fb0e8202e0a0$var$builtInSymbols.has(key) : $3ba2fb0e8202e0a0$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $3ba2fb0e8202e0a0$export$6b2a7d5132615086(target, "get", key);
        if (shallow) return res;
        if ($3ba2fb0e8202e0a0$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $l44RV.isIntegerKey)(key) ? res : res.value;
        if ((0, $l44RV.isObject)(res)) return isReadonly2 ? $3ba2fb0e8202e0a0$export$6ec456bd5b7b3c51(res) : $3ba2fb0e8202e0a0$export$90a44edba14e47be(res);
        return res;
    };
}
const $3ba2fb0e8202e0a0$var$set$1 = /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createSetter();
const $3ba2fb0e8202e0a0$var$shallowSet = /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createSetter(true);
function $3ba2fb0e8202e0a0$var$createSetter(shallow = false) {
    return function set2(target, key, value, receiver) {
        let oldValue = target[key];
        if ($3ba2fb0e8202e0a0$export$92d09b48637741e7(oldValue) && $3ba2fb0e8202e0a0$export$4f9f5282de18fc69(oldValue) && !$3ba2fb0e8202e0a0$export$4f9f5282de18fc69(value)) return false;
        if (!shallow) {
            if (!$3ba2fb0e8202e0a0$export$7f3fe6025abfa26e(value) && !$3ba2fb0e8202e0a0$export$92d09b48637741e7(value)) {
                oldValue = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(oldValue);
                value = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $l44RV.isArray)(target) && $3ba2fb0e8202e0a0$export$4f9f5282de18fc69(oldValue) && !$3ba2fb0e8202e0a0$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = (0, $l44RV.isArray)(target) && (0, $l44RV.isIntegerKey)(key) ? Number(key) < target.length : (0, $l44RV.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $l44RV.hasChanged)(value, oldValue)) $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $3ba2fb0e8202e0a0$var$deleteProperty(target, key) {
    const hadKey = (0, $l44RV.hasOwn)(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $3ba2fb0e8202e0a0$var$has$1(target, key) {
    const result = Reflect.has(target, key);
    if (!(0, $l44RV.isSymbol)(key) || !$3ba2fb0e8202e0a0$var$builtInSymbols.has(key)) $3ba2fb0e8202e0a0$export$6b2a7d5132615086(target, "has", key);
    return result;
}
function $3ba2fb0e8202e0a0$var$ownKeys(target) {
    $3ba2fb0e8202e0a0$export$6b2a7d5132615086(target, "iterate", (0, $l44RV.isArray)(target) ? "length" : $3ba2fb0e8202e0a0$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
const $3ba2fb0e8202e0a0$var$mutableHandlers = {
    get: $3ba2fb0e8202e0a0$var$get$1,
    set: $3ba2fb0e8202e0a0$var$set$1,
    deleteProperty: $3ba2fb0e8202e0a0$var$deleteProperty,
    has: $3ba2fb0e8202e0a0$var$has$1,
    ownKeys: $3ba2fb0e8202e0a0$var$ownKeys
};
const $3ba2fb0e8202e0a0$var$readonlyHandlers = {
    get: $3ba2fb0e8202e0a0$var$readonlyGet,
    set (target, key) {
        return true;
    },
    deleteProperty (target, key) {
        return true;
    }
};
const $3ba2fb0e8202e0a0$var$shallowReactiveHandlers = /* @__PURE__ */ (0, $l44RV.extend)({}, $3ba2fb0e8202e0a0$var$mutableHandlers, {
    get: $3ba2fb0e8202e0a0$var$shallowGet,
    set: $3ba2fb0e8202e0a0$var$shallowSet
});
const $3ba2fb0e8202e0a0$var$shallowReadonlyHandlers = /* @__PURE__ */ (0, $l44RV.extend)({}, $3ba2fb0e8202e0a0$var$readonlyHandlers, {
    get: $3ba2fb0e8202e0a0$var$shallowReadonlyGet
});
const $3ba2fb0e8202e0a0$var$toShallow = (value)=>value;
const $3ba2fb0e8202e0a0$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $3ba2fb0e8202e0a0$var$get(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(target);
    const rawKey = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $3ba2fb0e8202e0a0$export$6b2a7d5132615086(rawTarget, "get", key);
        $3ba2fb0e8202e0a0$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    const { has: has2 } = $3ba2fb0e8202e0a0$var$getProto(rawTarget);
    const wrap = isShallow ? $3ba2fb0e8202e0a0$var$toShallow : isReadonly ? $3ba2fb0e8202e0a0$var$toReadonly : $3ba2fb0e8202e0a0$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $3ba2fb0e8202e0a0$var$has(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(target);
    const rawKey = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $3ba2fb0e8202e0a0$export$6b2a7d5132615086(rawTarget, "has", key);
        $3ba2fb0e8202e0a0$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $3ba2fb0e8202e0a0$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $3ba2fb0e8202e0a0$export$6b2a7d5132615086($3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(target), "iterate", $3ba2fb0e8202e0a0$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $3ba2fb0e8202e0a0$var$add(value) {
    value = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(value);
    const target = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this);
    const proto = $3ba2fb0e8202e0a0$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $3ba2fb0e8202e0a0$var$set(key, value) {
    value = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(value);
    const target = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $3ba2fb0e8202e0a0$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $l44RV.hasChanged)(value, oldValue)) $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $3ba2fb0e8202e0a0$var$deleteEntry(key) {
    const target = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this);
    const { has: has2, get: get2 } = $3ba2fb0e8202e0a0$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    const oldValue = get2 ? get2.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $3ba2fb0e8202e0a0$var$clear() {
    const target = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this);
    const hadItems = target.size !== 0;
    const oldTarget = void 0;
    const result = target.clear();
    if (hadItems) $3ba2fb0e8202e0a0$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $3ba2fb0e8202e0a0$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(target);
        const wrap = isShallow ? $3ba2fb0e8202e0a0$var$toShallow : isReadonly ? $3ba2fb0e8202e0a0$var$toReadonly : $3ba2fb0e8202e0a0$var$toReactive;
        !isReadonly && $3ba2fb0e8202e0a0$export$6b2a7d5132615086(rawTarget, "iterate", $3ba2fb0e8202e0a0$export$3c41b1a4e06acc14);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $3ba2fb0e8202e0a0$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $l44RV.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $3ba2fb0e8202e0a0$var$toShallow : isReadonly ? $3ba2fb0e8202e0a0$var$toReadonly : $3ba2fb0e8202e0a0$var$toReactive;
        !isReadonly && $3ba2fb0e8202e0a0$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $3ba2fb0e8202e0a0$var$MAP_KEY_ITERATE_KEY : $3ba2fb0e8202e0a0$export$3c41b1a4e06acc14);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $3ba2fb0e8202e0a0$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : this;
    };
}
function $3ba2fb0e8202e0a0$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $3ba2fb0e8202e0a0$var$get(this, key);
        },
        get size () {
            return $3ba2fb0e8202e0a0$var$size(this);
        },
        has: $3ba2fb0e8202e0a0$var$has,
        add: $3ba2fb0e8202e0a0$var$add,
        set: $3ba2fb0e8202e0a0$var$set,
        delete: $3ba2fb0e8202e0a0$var$deleteEntry,
        clear: $3ba2fb0e8202e0a0$var$clear,
        forEach: $3ba2fb0e8202e0a0$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $3ba2fb0e8202e0a0$var$get(this, key, false, true);
        },
        get size () {
            return $3ba2fb0e8202e0a0$var$size(this);
        },
        has: $3ba2fb0e8202e0a0$var$has,
        add: $3ba2fb0e8202e0a0$var$add,
        set: $3ba2fb0e8202e0a0$var$set,
        delete: $3ba2fb0e8202e0a0$var$deleteEntry,
        clear: $3ba2fb0e8202e0a0$var$clear,
        forEach: $3ba2fb0e8202e0a0$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $3ba2fb0e8202e0a0$var$get(this, key, true);
        },
        get size () {
            return $3ba2fb0e8202e0a0$var$size(this, true);
        },
        has (key) {
            return $3ba2fb0e8202e0a0$var$has.call(this, key, true);
        },
        add: $3ba2fb0e8202e0a0$var$createReadonlyMethod("add"),
        set: $3ba2fb0e8202e0a0$var$createReadonlyMethod("set"),
        delete: $3ba2fb0e8202e0a0$var$createReadonlyMethod("delete"),
        clear: $3ba2fb0e8202e0a0$var$createReadonlyMethod("clear"),
        forEach: $3ba2fb0e8202e0a0$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $3ba2fb0e8202e0a0$var$get(this, key, true, true);
        },
        get size () {
            return $3ba2fb0e8202e0a0$var$size(this, true);
        },
        has (key) {
            return $3ba2fb0e8202e0a0$var$has.call(this, key, true);
        },
        add: $3ba2fb0e8202e0a0$var$createReadonlyMethod("add"),
        set: $3ba2fb0e8202e0a0$var$createReadonlyMethod("set"),
        delete: $3ba2fb0e8202e0a0$var$createReadonlyMethod("delete"),
        clear: $3ba2fb0e8202e0a0$var$createReadonlyMethod("clear"),
        forEach: $3ba2fb0e8202e0a0$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $3ba2fb0e8202e0a0$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $3ba2fb0e8202e0a0$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $3ba2fb0e8202e0a0$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $3ba2fb0e8202e0a0$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
const [$3ba2fb0e8202e0a0$var$mutableInstrumentations, $3ba2fb0e8202e0a0$var$readonlyInstrumentations, $3ba2fb0e8202e0a0$var$shallowInstrumentations, $3ba2fb0e8202e0a0$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createInstrumentations();
function $3ba2fb0e8202e0a0$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $3ba2fb0e8202e0a0$var$shallowReadonlyInstrumentations : $3ba2fb0e8202e0a0$var$shallowInstrumentations : isReadonly ? $3ba2fb0e8202e0a0$var$readonlyInstrumentations : $3ba2fb0e8202e0a0$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $l44RV.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $3ba2fb0e8202e0a0$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createInstrumentationGetter(false, false)
};
const $3ba2fb0e8202e0a0$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createInstrumentationGetter(false, true)
};
const $3ba2fb0e8202e0a0$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createInstrumentationGetter(true, false)
};
const $3ba2fb0e8202e0a0$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $3ba2fb0e8202e0a0$var$createInstrumentationGetter(true, true)
};
function $3ba2fb0e8202e0a0$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = (0, $l44RV.toRawType)(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $3ba2fb0e8202e0a0$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $3ba2fb0e8202e0a0$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $3ba2fb0e8202e0a0$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $3ba2fb0e8202e0a0$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $3ba2fb0e8202e0a0$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $3ba2fb0e8202e0a0$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $3ba2fb0e8202e0a0$var$targetTypeMap((0, $l44RV.toRawType)(value));
}
function $3ba2fb0e8202e0a0$export$90a44edba14e47be(target) {
    if ($3ba2fb0e8202e0a0$export$92d09b48637741e7(target)) return target;
    return $3ba2fb0e8202e0a0$var$createReactiveObject(target, false, $3ba2fb0e8202e0a0$var$mutableHandlers, $3ba2fb0e8202e0a0$var$mutableCollectionHandlers, $3ba2fb0e8202e0a0$var$reactiveMap);
}
function $3ba2fb0e8202e0a0$export$8d81cefd22d22260(target) {
    return $3ba2fb0e8202e0a0$var$createReactiveObject(target, false, $3ba2fb0e8202e0a0$var$shallowReactiveHandlers, $3ba2fb0e8202e0a0$var$shallowCollectionHandlers, $3ba2fb0e8202e0a0$var$shallowReactiveMap);
}
function $3ba2fb0e8202e0a0$export$6ec456bd5b7b3c51(target) {
    return $3ba2fb0e8202e0a0$var$createReactiveObject(target, true, $3ba2fb0e8202e0a0$var$readonlyHandlers, $3ba2fb0e8202e0a0$var$readonlyCollectionHandlers, $3ba2fb0e8202e0a0$var$readonlyMap);
}
function $3ba2fb0e8202e0a0$export$7c4b5f2b50f09f6b(target) {
    return $3ba2fb0e8202e0a0$var$createReactiveObject(target, true, $3ba2fb0e8202e0a0$var$shallowReadonlyHandlers, $3ba2fb0e8202e0a0$var$shallowReadonlyCollectionHandlers, $3ba2fb0e8202e0a0$var$shallowReadonlyMap);
}
function $3ba2fb0e8202e0a0$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $l44RV.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $3ba2fb0e8202e0a0$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $3ba2fb0e8202e0a0$export$352205f445242f02(value) {
    if ($3ba2fb0e8202e0a0$export$92d09b48637741e7(value)) return $3ba2fb0e8202e0a0$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $3ba2fb0e8202e0a0$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $3ba2fb0e8202e0a0$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $3ba2fb0e8202e0a0$export$5f3ca29d057519b3(value) {
    return $3ba2fb0e8202e0a0$export$352205f445242f02(value) || $3ba2fb0e8202e0a0$export$92d09b48637741e7(value);
}
function $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(raw) : observed;
}
function $3ba2fb0e8202e0a0$export$995ab8b13ad7a9d0(value) {
    (0, $l44RV.def)(value, "__v_skip", true);
    return value;
}
const $3ba2fb0e8202e0a0$var$toReactive = (value)=>(0, $l44RV.isObject)(value) ? $3ba2fb0e8202e0a0$export$90a44edba14e47be(value) : value;
const $3ba2fb0e8202e0a0$var$toReadonly = (value)=>(0, $l44RV.isObject)(value) ? $3ba2fb0e8202e0a0$export$6ec456bd5b7b3c51(value) : value;
function $3ba2fb0e8202e0a0$var$trackRefValue(ref2) {
    if ($3ba2fb0e8202e0a0$var$shouldTrack && $3ba2fb0e8202e0a0$var$activeEffect) {
        ref2 = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(ref2);
        $3ba2fb0e8202e0a0$var$trackEffects(ref2.dep || (ref2.dep = $3ba2fb0e8202e0a0$var$createDep()));
    }
}
function $3ba2fb0e8202e0a0$var$triggerRefValue(ref2, newVal) {
    ref2 = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(ref2);
    const dep = ref2.dep;
    if (dep) $3ba2fb0e8202e0a0$var$triggerEffects(dep);
}
function $3ba2fb0e8202e0a0$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $3ba2fb0e8202e0a0$export$eff4d24c3ff7876e(value) {
    return $3ba2fb0e8202e0a0$var$createRef(value, false);
}
function $3ba2fb0e8202e0a0$export$9b7bc5fe3b17c8b3(value) {
    return $3ba2fb0e8202e0a0$var$createRef(value, true);
}
function $3ba2fb0e8202e0a0$var$createRef(rawValue, shallow) {
    if ($3ba2fb0e8202e0a0$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $3ba2fb0e8202e0a0$var$RefImpl(rawValue, shallow);
}
class $3ba2fb0e8202e0a0$var$RefImpl {
    get value() {
        $3ba2fb0e8202e0a0$var$trackRefValue(this);
        return this._value;
    }
    set value(newVal) {
        const useDirectValue = this.__v_isShallow || $3ba2fb0e8202e0a0$export$7f3fe6025abfa26e(newVal) || $3ba2fb0e8202e0a0$export$92d09b48637741e7(newVal);
        newVal = useDirectValue ? newVal : $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(newVal);
        if ((0, $l44RV.hasChanged)(newVal, this._rawValue)) {
            this._rawValue = newVal;
            this._value = useDirectValue ? newVal : $3ba2fb0e8202e0a0$var$toReactive(newVal);
            $3ba2fb0e8202e0a0$var$triggerRefValue(this, newVal);
        }
    }
    constructor(value, __v_isShallow){
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $3ba2fb0e8202e0a0$var$toReactive(value);
    }
}
function $3ba2fb0e8202e0a0$export$f402f86588575ccc(ref2) {
    $3ba2fb0e8202e0a0$var$triggerRefValue(ref2, void 0);
}
function $3ba2fb0e8202e0a0$export$a239a76781616204(ref2) {
    return $3ba2fb0e8202e0a0$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $3ba2fb0e8202e0a0$export$30bdcc2218aa9458(source) {
    return (0, $l44RV.isFunction)(source) ? source() : $3ba2fb0e8202e0a0$export$a239a76781616204(source);
}
const $3ba2fb0e8202e0a0$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>$3ba2fb0e8202e0a0$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if ($3ba2fb0e8202e0a0$export$4f9f5282de18fc69(oldValue) && !$3ba2fb0e8202e0a0$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $3ba2fb0e8202e0a0$export$f353fd1b97db3fa0(objectWithRefs) {
    return $3ba2fb0e8202e0a0$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $3ba2fb0e8202e0a0$var$shallowUnwrapHandlers);
}
class $3ba2fb0e8202e0a0$var$CustomRefImpl {
    get value() {
        return this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
    constructor(factory){
        this.dep = void 0;
        this.__v_isRef = true;
        const { get: get, set: set } = factory(()=>$3ba2fb0e8202e0a0$var$trackRefValue(this), ()=>$3ba2fb0e8202e0a0$var$triggerRefValue(this));
        this._get = get;
        this._set = set;
    }
}
function $3ba2fb0e8202e0a0$export$a20c2dd6199824cb(factory) {
    return new $3ba2fb0e8202e0a0$var$CustomRefImpl(factory);
}
function $3ba2fb0e8202e0a0$export$2e9533675e5e70e0(object) {
    const ret = (0, $l44RV.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $3ba2fb0e8202e0a0$var$propertyToRef(object, key);
    return ret;
}
class $3ba2fb0e8202e0a0$var$ObjectRefImpl {
    get value() {
        const val = this._object[this._key];
        return val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return $3ba2fb0e8202e0a0$var$getDepFromReactive($3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this._object), this._key);
    }
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
}
class $3ba2fb0e8202e0a0$var$GetterRefImpl {
    get value() {
        return this._getter();
    }
    constructor(_getter){
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
}
function $3ba2fb0e8202e0a0$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($3ba2fb0e8202e0a0$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $l44RV.isFunction)(source)) return new $3ba2fb0e8202e0a0$var$GetterRefImpl(source);
    else if ((0, $l44RV.isObject)(source) && arguments.length > 1) return $3ba2fb0e8202e0a0$var$propertyToRef(source, key, defaultValue);
    else return $3ba2fb0e8202e0a0$export$eff4d24c3ff7876e(source);
}
function $3ba2fb0e8202e0a0$var$propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return $3ba2fb0e8202e0a0$export$4f9f5282de18fc69(val) ? val : new $3ba2fb0e8202e0a0$var$ObjectRefImpl(source, key, defaultValue);
}
class $3ba2fb0e8202e0a0$var$ComputedRefImpl {
    get value() {
        const self = $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this);
        $3ba2fb0e8202e0a0$var$trackRefValue(self);
        if (self._dirty || !self._cacheable) {
            self._dirty = false;
            self._value = self.effect.run();
        }
        return self._value;
    }
    set value(newValue) {
        this._setter(newValue);
    }
    constructor(getter, _setter, isReadonly, isSSR){
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this._dirty = true;
        this.effect = new $3ba2fb0e8202e0a0$export$28352bb4dd362521(getter, ()=>{
            if (!this._dirty) {
                this._dirty = true;
                $3ba2fb0e8202e0a0$var$triggerRefValue(this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
}
function $3ba2fb0e8202e0a0$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    const onlyGetter = (0, $l44RV.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $l44RV.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $3ba2fb0e8202e0a0$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
const $3ba2fb0e8202e0a0$var$tick = /* @__PURE__ */ Promise.resolve();
const $3ba2fb0e8202e0a0$var$queue = [];
let $3ba2fb0e8202e0a0$var$queued = false;
const $3ba2fb0e8202e0a0$var$scheduler = (fn)=>{
    $3ba2fb0e8202e0a0$var$queue.push(fn);
    if (!$3ba2fb0e8202e0a0$var$queued) {
        $3ba2fb0e8202e0a0$var$queued = true;
        $3ba2fb0e8202e0a0$var$tick.then($3ba2fb0e8202e0a0$var$flush);
    }
};
const $3ba2fb0e8202e0a0$var$flush = ()=>{
    for(let i = 0; i < $3ba2fb0e8202e0a0$var$queue.length; i++)$3ba2fb0e8202e0a0$var$queue[i]();
    $3ba2fb0e8202e0a0$var$queue.length = 0;
    $3ba2fb0e8202e0a0$var$queued = false;
};
class $3ba2fb0e8202e0a0$var$DeferredComputedRefImpl {
    _get() {
        if (this._dirty) {
            this._dirty = false;
            return this._value = this.effect.run();
        }
        return this._value;
    }
    get value() {
        $3ba2fb0e8202e0a0$var$trackRefValue(this);
        return $3ba2fb0e8202e0a0$export$ab18938b9fc5f28e(this)._get();
    }
    constructor(getter){
        this.dep = void 0;
        this._dirty = true;
        this.__v_isRef = true;
        this["__v_isReadonly"] = true;
        let compareTarget;
        let hasCompareTarget = false;
        let scheduled = false;
        this.effect = new $3ba2fb0e8202e0a0$export$28352bb4dd362521(getter, (computedTrigger)=>{
            if (this.dep) {
                if (computedTrigger) {
                    compareTarget = this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    const valueToCompare = hasCompareTarget ? compareTarget : this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $3ba2fb0e8202e0a0$var$scheduler(()=>{
                        if (this.effect.active && this._get() !== valueToCompare) $3ba2fb0e8202e0a0$var$triggerRefValue(this);
                        scheduled = false;
                    });
                }
                for (const e of this.dep)if (e.computed instanceof $3ba2fb0e8202e0a0$var$DeferredComputedRefImpl) e.scheduler(true);
            }
            this._dirty = true;
        });
        this.effect.computed = this;
    }
}
function $3ba2fb0e8202e0a0$export$483264c4ec4c46ce(getter) {
    return new $3ba2fb0e8202e0a0$var$DeferredComputedRefImpl(getter);
}

});
parcelRequire.register("l44RV", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $f55dbf8cca008d4d$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $f55dbf8cca008d4d$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $f55dbf8cca008d4d$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $f55dbf8cca008d4d$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $f55dbf8cca008d4d$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $f55dbf8cca008d4d$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $f55dbf8cca008d4d$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $f55dbf8cca008d4d$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $f55dbf8cca008d4d$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $f55dbf8cca008d4d$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $f55dbf8cca008d4d$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $f55dbf8cca008d4d$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $f55dbf8cca008d4d$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $f55dbf8cca008d4d$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $f55dbf8cca008d4d$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $f55dbf8cca008d4d$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $f55dbf8cca008d4d$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $f55dbf8cca008d4d$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $f55dbf8cca008d4d$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $f55dbf8cca008d4d$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $f55dbf8cca008d4d$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $f55dbf8cca008d4d$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $f55dbf8cca008d4d$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $f55dbf8cca008d4d$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $f55dbf8cca008d4d$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $f55dbf8cca008d4d$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $f55dbf8cca008d4d$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $f55dbf8cca008d4d$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $f55dbf8cca008d4d$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $f55dbf8cca008d4d$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $f55dbf8cca008d4d$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $f55dbf8cca008d4d$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $f55dbf8cca008d4d$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $f55dbf8cca008d4d$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyWhitelisted", function () { return $f55dbf8cca008d4d$export$d6571a1911e4f27e; });
$parcel$export(module.exports, "normalizeStyle", function () { return $f55dbf8cca008d4d$export$8756898546458274; });
$parcel$export(module.exports, "normalizeClass", function () { return $f55dbf8cca008d4d$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $f55dbf8cca008d4d$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $f55dbf8cca008d4d$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $f55dbf8cca008d4d$export$d186f5eb2e810715; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $f55dbf8cca008d4d$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "looseEqual", function () { return $f55dbf8cca008d4d$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $f55dbf8cca008d4d$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $f55dbf8cca008d4d$export$b5b1545233b45293; });
function $f55dbf8cca008d4d$export$b41394a5437791c8(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
const $f55dbf8cca008d4d$export$cf583d23ab39677c = {};
const $f55dbf8cca008d4d$export$6bd8558f433f1cc1 = [];
const $f55dbf8cca008d4d$export$5702a91a6f42969f = ()=>{};
const $f55dbf8cca008d4d$export$c01351c0af048e39 = ()=>false;
const $f55dbf8cca008d4d$var$onRE = /^on[^a-z]/;
const $f55dbf8cca008d4d$export$1a2d97de39ecbb75 = (key)=>$f55dbf8cca008d4d$var$onRE.test(key);
const $f55dbf8cca008d4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $f55dbf8cca008d4d$export$8b58be045bf06082 = Object.assign;
const $f55dbf8cca008d4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $f55dbf8cca008d4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $f55dbf8cca008d4d$export$b5a638e9b3fff9f3 = (val, key)=>$f55dbf8cca008d4d$var$hasOwnProperty.call(val, key);
const $f55dbf8cca008d4d$export$43bee75e5e14138e = Array.isArray;
const $f55dbf8cca008d4d$export$5c90113a285f2241 = (val)=>$f55dbf8cca008d4d$export$1dccc787cc36538b(val) === "[object Map]";
const $f55dbf8cca008d4d$export$6750766a7c7ec627 = (val)=>$f55dbf8cca008d4d$export$1dccc787cc36538b(val) === "[object Set]";
const $f55dbf8cca008d4d$export$871608497c498473 = (val)=>$f55dbf8cca008d4d$export$1dccc787cc36538b(val) === "[object Date]";
const $f55dbf8cca008d4d$export$49841c62b9eff15 = (val)=>$f55dbf8cca008d4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $f55dbf8cca008d4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $f55dbf8cca008d4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $f55dbf8cca008d4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $f55dbf8cca008d4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $f55dbf8cca008d4d$export$4369c812aac99591 = (val)=>{
    return $f55dbf8cca008d4d$export$a6cdc56e425d0d0a(val) && $f55dbf8cca008d4d$export$f6e2535fb5126e54(val.then) && $f55dbf8cca008d4d$export$f6e2535fb5126e54(val.catch);
};
const $f55dbf8cca008d4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $f55dbf8cca008d4d$export$1dccc787cc36538b = (value)=>$f55dbf8cca008d4d$export$830c053460e5ddf6.call(value);
const $f55dbf8cca008d4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $f55dbf8cca008d4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $f55dbf8cca008d4d$export$53b83ca8eaab0383 = (val)=>$f55dbf8cca008d4d$export$1dccc787cc36538b(val) === "[object Object]";
const $f55dbf8cca008d4d$export$e2a2b93446ec9fe = (key)=>$f55dbf8cca008d4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $f55dbf8cca008d4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $f55dbf8cca008d4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $f55dbf8cca008d4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $f55dbf8cca008d4d$var$camelizeRE = /-(\w)/g;
const $f55dbf8cca008d4d$export$161d051f5dd25de7 = $f55dbf8cca008d4d$var$cacheStringFunction((str)=>{
    return str.replace($f55dbf8cca008d4d$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const $f55dbf8cca008d4d$var$hyphenateRE = /\B([A-Z])/g;
const $f55dbf8cca008d4d$export$6e6a0a3676c4b8bb = $f55dbf8cca008d4d$var$cacheStringFunction((str)=>str.replace($f55dbf8cca008d4d$var$hyphenateRE, "-$1").toLowerCase());
const $f55dbf8cca008d4d$export$9a00dee1beb8f576 = $f55dbf8cca008d4d$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
const $f55dbf8cca008d4d$export$8c022799eeaaefcd = $f55dbf8cca008d4d$var$cacheStringFunction((str)=>str ? `on${$f55dbf8cca008d4d$export$9a00dee1beb8f576(str)}` : ``);
const $f55dbf8cca008d4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $f55dbf8cca008d4d$export$39951422d618a9d3 = (fns, arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](arg);
};
const $f55dbf8cca008d4d$export$8afb76124cf08683 = (obj, key, value)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
const $f55dbf8cca008d4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $f55dbf8cca008d4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $f55dbf8cca008d4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $f55dbf8cca008d4d$var$_globalThis;
const $f55dbf8cca008d4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $f55dbf8cca008d4d$var$_globalThis || ($f55dbf8cca008d4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $f55dbf8cca008d4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $f55dbf8cca008d4d$export$53d5e12f9a1d3cde(name) {
    return $f55dbf8cca008d4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
const $f55dbf8cca008d4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `HYDRATE_EVENTS`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const $f55dbf8cca008d4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $f55dbf8cca008d4d$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
const $f55dbf8cca008d4d$export$d6571a1911e4f27e = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8($f55dbf8cca008d4d$var$GLOBALS_WHITE_LISTED);
const $f55dbf8cca008d4d$var$range = 2;
function $f55dbf8cca008d4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $f55dbf8cca008d4d$var$range; j <= i + $f55dbf8cca008d4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $f55dbf8cca008d4d$export$8756898546458274(value) {
    if ($f55dbf8cca008d4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $f55dbf8cca008d4d$export$844ec244b1367d54(item) ? $f55dbf8cca008d4d$export$76a205ce979d066a(item) : $f55dbf8cca008d4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($f55dbf8cca008d4d$export$844ec244b1367d54(value)) return value;
    else if ($f55dbf8cca008d4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $f55dbf8cca008d4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $f55dbf8cca008d4d$var$propertyDelimiterRE = /:([^]+)/;
const $f55dbf8cca008d4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $f55dbf8cca008d4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($f55dbf8cca008d4d$var$styleCommentRE, "").split($f55dbf8cca008d4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($f55dbf8cca008d4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $f55dbf8cca008d4d$export$9466a5a0ee6f1479(styles) {
    let ret = "";
    if (!styles || $f55dbf8cca008d4d$export$844ec244b1367d54(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        const normalizedKey = key.startsWith(`--`) ? key : $f55dbf8cca008d4d$export$6e6a0a3676c4b8bb(key);
        if ($f55dbf8cca008d4d$export$844ec244b1367d54(value) || typeof value === "number") ret += `${normalizedKey}:${value};`;
    }
    return ret;
}
function $f55dbf8cca008d4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($f55dbf8cca008d4d$export$844ec244b1367d54(value)) res = value;
    else if ($f55dbf8cca008d4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $f55dbf8cca008d4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($f55dbf8cca008d4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $f55dbf8cca008d4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$f55dbf8cca008d4d$export$844ec244b1367d54(klass)) props.class = $f55dbf8cca008d4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $f55dbf8cca008d4d$export$8756898546458274(style);
    return props;
}
const $f55dbf8cca008d4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $f55dbf8cca008d4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $f55dbf8cca008d4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $f55dbf8cca008d4d$export$1ccf854a0984f890 = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8($f55dbf8cca008d4d$var$HTML_TAGS);
const $f55dbf8cca008d4d$export$6328ce7565ea1049 = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8($f55dbf8cca008d4d$var$SVG_TAGS);
const $f55dbf8cca008d4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8($f55dbf8cca008d4d$var$VOID_TAGS);
const $f55dbf8cca008d4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $f55dbf8cca008d4d$export$d186f5eb2e810715 = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8($f55dbf8cca008d4d$var$specialBooleanAttrs);
const $f55dbf8cca008d4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8($f55dbf8cca008d4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $f55dbf8cca008d4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $f55dbf8cca008d4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $f55dbf8cca008d4d$var$attrValidationCache = {};
function $f55dbf8cca008d4d$export$d55ef77660f30d12(name) {
    if ($f55dbf8cca008d4d$var$attrValidationCache.hasOwnProperty(name)) return $f55dbf8cca008d4d$var$attrValidationCache[name];
    const isUnsafe = $f55dbf8cca008d4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $f55dbf8cca008d4d$var$attrValidationCache[name] = !isUnsafe;
}
const $f55dbf8cca008d4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $f55dbf8cca008d4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $f55dbf8cca008d4d$export$80da416f43933831 = /* @__PURE__ */ $f55dbf8cca008d4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $f55dbf8cca008d4d$var$escapeRE = /["'&<>]/;
function $f55dbf8cca008d4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $f55dbf8cca008d4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $f55dbf8cca008d4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $f55dbf8cca008d4d$export$7b105034a53bde5f(src) {
    return src.replace($f55dbf8cca008d4d$var$commentStripRE, "");
}
function $f55dbf8cca008d4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $f55dbf8cca008d4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $f55dbf8cca008d4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $f55dbf8cca008d4d$export$871608497c498473(a);
    let bValidType = $f55dbf8cca008d4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $f55dbf8cca008d4d$export$a244864fd9645c7f(a);
    bValidType = $f55dbf8cca008d4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $f55dbf8cca008d4d$export$43bee75e5e14138e(a);
    bValidType = $f55dbf8cca008d4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $f55dbf8cca008d4d$var$looseCompareArrays(a, b) : false;
    aValidType = $f55dbf8cca008d4d$export$a6cdc56e425d0d0a(a);
    bValidType = $f55dbf8cca008d4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$f55dbf8cca008d4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $f55dbf8cca008d4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$f55dbf8cca008d4d$export$ae8015769846262c(item, val));
}
const $f55dbf8cca008d4d$export$b5b1545233b45293 = (val)=>{
    return $f55dbf8cca008d4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $f55dbf8cca008d4d$export$43bee75e5e14138e(val) || $f55dbf8cca008d4d$export$a6cdc56e425d0d0a(val) && (val.toString === $f55dbf8cca008d4d$export$830c053460e5ddf6 || !$f55dbf8cca008d4d$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $f55dbf8cca008d4d$var$replacer, 2) : String(val);
};
const $f55dbf8cca008d4d$var$replacer = (_key, val)=>{
    if (val && val.__v_isRef) return $f55dbf8cca008d4d$var$replacer(_key, val.value);
    else if ($f55dbf8cca008d4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2])=>{
            entries[`${key} =>`] = val2;
            return entries;
        }, {})
    };
    else if ($f55dbf8cca008d4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ]
    };
    else if ($f55dbf8cca008d4d$export$a6cdc56e425d0d0a(val) && !$f55dbf8cca008d4d$export$43bee75e5e14138e(val) && !$f55dbf8cca008d4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});



parcelRequire.register("90kfS", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("6A78m")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("6A78m")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("6A78m")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("l44RV")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("6A78m")).computed; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("6A78m")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("6A78m")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("6A78m")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("6A78m")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("6A78m")).createRenderer; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("6A78m")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("6A78m")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("6A78m")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("6A78m")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("6A78m")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("6A78m")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("6A78m")).getTransitionRawChildren; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("6A78m")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("6A78m")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("6A78m")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("57ryt")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("6A78m")).isRuntimeOnly; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("6A78m")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("l44RV")).normalizeClass; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("6A78m")).onBeforeMount; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("6A78m")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("6A78m")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("6A78m")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("6A78m")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("6A78m")).popScopeId; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("6A78m")).pushScopeId; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("57ryt")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("6A78m")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("6A78m")).resolveComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("6A78m")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("6A78m")).setTransitionHooks; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("6A78m")).Static; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("6A78m")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("57ryt")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("6A78m")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("6A78m")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("6A78m")).watch; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("6A78m")).watchPostEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("6A78m")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("6A78m")).withDirectives; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("57ryt")).effectScope; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("57ryt")).shallowRef; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("l44RV")).toDisplayString; });

$parcel$export(module.exports, "vModelText", function () { return $68e3d36378531a9f$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelSelect", function () { return $68e3d36378531a9f$export$87d227567b51ca39; });
$parcel$export(module.exports, "withKeys", function () { return $68e3d36378531a9f$export$f691a8759658f782; });
$parcel$export(module.exports, "vShow", function () { return $68e3d36378531a9f$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "createApp", function () { return $68e3d36378531a9f$export$4e373c34abfa8c68; });
parcelRequire("6A78m");
var $l44RV = parcelRequire("l44RV");
var $6A78m = parcelRequire("6A78m");
var $57ryt = parcelRequire("57ryt");parcelRequire("57ryt");parcelRequire("l44RV");

var $l44RV = parcelRequire("l44RV");
const $68e3d36378531a9f$var$svgNS = "http://www.w3.org/2000/svg";
const $68e3d36378531a9f$var$doc = typeof document !== "undefined" ? document : null;
const $68e3d36378531a9f$var$templateContainer = $68e3d36378531a9f$var$doc && /* @__PURE__ */ $68e3d36378531a9f$var$doc.createElement("template");
const $68e3d36378531a9f$var$nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, isSVG, is, props)=>{
        const el = isSVG ? $68e3d36378531a9f$var$doc.createElementNS($68e3d36378531a9f$var$svgNS, tag) : $68e3d36378531a9f$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$68e3d36378531a9f$var$doc.createTextNode(text),
    createComment: (text)=>$68e3d36378531a9f$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$68e3d36378531a9f$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, isSVG, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $68e3d36378531a9f$var$templateContainer.innerHTML = isSVG ? `<svg>${content}</svg>` : content;
            const template = $68e3d36378531a9f$var$templateContainer.content;
            if (isSVG) {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
function $68e3d36378531a9f$var$patchClass(el, value, isSVG) {
    const transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $68e3d36378531a9f$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $l44RV.isString)(next);
    if (next && !isCssString) {
        if (prev && !(0, $l44RV.isString)(prev)) {
            for(const key in prev)if (next[key] == null) $68e3d36378531a9f$var$setStyle(style, key, "");
        }
        for(const key in next)$68e3d36378531a9f$var$setStyle(style, key, next[key]);
    } else {
        const currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        if ("_vod" in el) style.display = currentDisplay;
    }
}
const $68e3d36378531a9f$var$semicolonRE = /[^\\];\s*$/;
const $68e3d36378531a9f$var$importantRE = /\s*!important$/;
function $68e3d36378531a9f$var$setStyle(style, name, val) {
    if ((0, $l44RV.isArray)(val)) val.forEach((v)=>$68e3d36378531a9f$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $68e3d36378531a9f$var$autoPrefix(style, name);
            if ($68e3d36378531a9f$var$importantRE.test(val)) style.setProperty((0, $l44RV.hyphenate)(prefixed), val.replace($68e3d36378531a9f$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $68e3d36378531a9f$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $68e3d36378531a9f$var$prefixCache = {};
function $68e3d36378531a9f$var$autoPrefix(style, rawName) {
    const cached = $68e3d36378531a9f$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $l44RV.camelize)(rawName);
    if (name !== "filter" && name in style) return $68e3d36378531a9f$var$prefixCache[rawName] = name;
    name = (0, $l44RV.capitalize)(name);
    for(let i = 0; i < $68e3d36378531a9f$var$prefixes.length; i++){
        const prefixed = $68e3d36378531a9f$var$prefixes[i] + name;
        if (prefixed in style) return $68e3d36378531a9f$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $68e3d36378531a9f$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $68e3d36378531a9f$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($68e3d36378531a9f$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($68e3d36378531a9f$var$xlinkNS, key, value);
    } else {
        const isBoolean = (0, $l44RV.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $l44RV.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $68e3d36378531a9f$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        el._value = value;
        const oldValue = tag === "OPTION" ? el.getAttribute("value") : el.value;
        const newValue = value == null ? "" : value;
        if (oldValue !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $l44RV.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $68e3d36378531a9f$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $68e3d36378531a9f$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $68e3d36378531a9f$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el._vei || (el._vei = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $68e3d36378531a9f$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $68e3d36378531a9f$var$createInvoker(nextValue, instance);
            $68e3d36378531a9f$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $68e3d36378531a9f$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $68e3d36378531a9f$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $68e3d36378531a9f$var$parseName(name) {
    let options;
    if ($68e3d36378531a9f$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($68e3d36378531a9f$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $l44RV.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $68e3d36378531a9f$var$cachedNow = 0;
const $68e3d36378531a9f$var$p = /* @__PURE__ */ Promise.resolve();
const $68e3d36378531a9f$var$getNow = ()=>$68e3d36378531a9f$var$cachedNow || ($68e3d36378531a9f$var$p.then(()=>$68e3d36378531a9f$var$cachedNow = 0), $68e3d36378531a9f$var$cachedNow = Date.now());
function $68e3d36378531a9f$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $6A78m.callWithAsyncErrorHandling)($68e3d36378531a9f$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $68e3d36378531a9f$var$getNow();
    return invoker;
}
function $68e3d36378531a9f$var$patchStopImmediatePropagation(e, value) {
    if ((0, $l44RV.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $68e3d36378531a9f$var$nativeOnRE = /^on[a-z]/;
const $68e3d36378531a9f$var$patchProp = (el, key, prevValue, nextValue, isSVG = false, prevChildren, parentComponent, parentSuspense, unmountChildren)=>{
    if (key === "class") $68e3d36378531a9f$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $68e3d36378531a9f$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $l44RV.isOn)(key)) {
        if (!(0, $l44RV.isModelListener)(key)) $68e3d36378531a9f$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $68e3d36378531a9f$var$shouldSetAsProp(el, key, nextValue, isSVG)) $68e3d36378531a9f$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $68e3d36378531a9f$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $68e3d36378531a9f$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $68e3d36378531a9f$var$nativeOnRE.test(key) && (0, $l44RV.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if ($68e3d36378531a9f$var$nativeOnRE.test(key) && (0, $l44RV.isString)(value)) return false;
    return key in el;
}
function $68e3d36378531a9f$export$a00e2346eabbdbef(options, hydrate2) {
    const Comp = (0, $6A78m.defineComponent)(options);
    class VueCustomElement extends $68e3d36378531a9f$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, hydrate2);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $68e3d36378531a9f$export$6debb2e68f212638 = (options)=>{
    return $68e3d36378531a9f$export$a00e2346eabbdbef(options, $68e3d36378531a9f$export$fa8d919ba61d84db);
};
const $68e3d36378531a9f$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $68e3d36378531a9f$export$b337c1a55163dbe3 extends $68e3d36378531a9f$var$BaseClass {
    connectedCallback() {
        this._connected = true;
        if (!this._instance) {
            if (this._resolved) this._update();
            else this._resolveDef();
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $6A78m.nextTick)(()=>{
            if (!this._connected) {
                $68e3d36378531a9f$export$b3890eb0ae9dca99(null, this.shadowRoot);
                this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        this._resolved = true;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        }).observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $l44RV.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $l44RV.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $l44RV.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            this._applyStyles(styles);
            this._update();
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) asyncDef().then((def)=>resolve(def, true));
        else resolve(this._def);
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $l44RV.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
        for (const key of declaredPropKeys.map((0, $l44RV.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val);
            }
        });
    }
    _setAttr(key) {
        let value = this.getAttribute(key);
        const camelKey = (0, $l44RV.camelize)(key);
        if (this._numberProps && this._numberProps[camelKey]) value = (0, $l44RV.toNumber)(value);
        this._setProp(camelKey, value, false);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = true) {
        if (val !== this._props[key]) {
            this._props[key] = val;
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, $l44RV.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $l44RV.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $l44RV.hyphenate)(key));
            }
        }
    }
    _update() {
        $68e3d36378531a9f$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
    }
    _createVNode() {
        const vnode = (0, $6A78m.createVNode)(this._def, (0, $l44RV.extend)({}, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $l44RV.hyphenate)(event) !== event) dispatch((0, $l44RV.hyphenate)(event), args);
            };
            let parent = this;
            while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $68e3d36378531a9f$export$b337c1a55163dbe3) {
                instance.parent = parent._instance;
                instance.provides = parent._instance.provides;
                break;
            }
        };
        return vnode;
    }
    _applyStyles(styles) {
        if (styles) styles.forEach((css)=>{
            const s = document.createElement("style");
            s.textContent = css;
            this.shadowRoot.appendChild(s);
        });
    }
    constructor(_def, _props = {}, hydrate2){
        super();
        this._def = _def;
        this._props = _props;
        /**
     * @internal
     */ this._instance = null;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        if (this.shadowRoot && hydrate2) hydrate2(this._createVNode(), this.shadowRoot);
        else {
            this.attachShadow({
                mode: "open"
            });
            if (!this._def.__asyncLoader) this._resolveProps(this._def);
        }
    }
}
function $68e3d36378531a9f$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $6A78m.getCurrentInstance)();
        if (!instance) return 0, $l44RV.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $l44RV.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $l44RV.EMPTY_OBJ;
        return mod;
    }
}
function $68e3d36378531a9f$export$ef28b76f07940108(getter) {
    const instance = (0, $6A78m.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$68e3d36378531a9f$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        $68e3d36378531a9f$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $6A78m.watchPostEffect)(setVars);
    (0, $6A78m.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $6A78m.onUnmounted)(()=>ob.disconnect());
    });
}
function $68e3d36378531a9f$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $68e3d36378531a9f$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $68e3d36378531a9f$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $6A78m.Fragment)) vnode.children.forEach((c)=>$68e3d36378531a9f$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $6A78m.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $68e3d36378531a9f$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $68e3d36378531a9f$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        for(const key in vars)style.setProperty(`--${key}`, vars[key]);
    }
}
const $68e3d36378531a9f$var$TRANSITION = "transition";
const $68e3d36378531a9f$var$ANIMATION = "animation";
const $68e3d36378531a9f$export$be58926105124dd4 = (props, { slots: slots })=>(0, $6A78m.h)((0, $6A78m.BaseTransition), $68e3d36378531a9f$var$resolveTransitionProps(props), slots);
$68e3d36378531a9f$export$be58926105124dd4.displayName = "Transition";
const $68e3d36378531a9f$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $68e3d36378531a9f$var$TransitionPropsValidators = $68e3d36378531a9f$export$be58926105124dd4.props = /* @__PURE__ */ (0, $l44RV.extend)({}, (0, $6A78m.BaseTransitionPropsValidators), $68e3d36378531a9f$var$DOMTransitionPropsValidators);
const $68e3d36378531a9f$var$callHook = (hook, args = [])=>{
    if ((0, $l44RV.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $68e3d36378531a9f$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $l44RV.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $68e3d36378531a9f$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $68e3d36378531a9f$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $68e3d36378531a9f$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        $68e3d36378531a9f$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $68e3d36378531a9f$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $68e3d36378531a9f$var$removeTransitionClass(el, leaveFromClass);
        $68e3d36378531a9f$var$removeTransitionClass(el, leaveToClass);
        $68e3d36378531a9f$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $68e3d36378531a9f$var$callHook(hook, [
                el,
                resolve
            ]);
            $68e3d36378531a9f$var$nextFrame(()=>{
                $68e3d36378531a9f$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $68e3d36378531a9f$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$68e3d36378531a9f$var$hasExplicitCallback(hook)) $68e3d36378531a9f$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $l44RV.extend)(baseProps, {
        onBeforeEnter (el) {
            $68e3d36378531a9f$var$callHook(onBeforeEnter, [
                el
            ]);
            $68e3d36378531a9f$var$addTransitionClass(el, enterFromClass);
            $68e3d36378531a9f$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $68e3d36378531a9f$var$callHook(onBeforeAppear, [
                el
            ]);
            $68e3d36378531a9f$var$addTransitionClass(el, appearFromClass);
            $68e3d36378531a9f$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $68e3d36378531a9f$var$addTransitionClass(el, leaveFromClass);
            $68e3d36378531a9f$var$forceReflow();
            $68e3d36378531a9f$var$addTransitionClass(el, leaveActiveClass);
            $68e3d36378531a9f$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $68e3d36378531a9f$var$removeTransitionClass(el, leaveFromClass);
                $68e3d36378531a9f$var$addTransitionClass(el, leaveToClass);
                if (!$68e3d36378531a9f$var$hasExplicitCallback(onLeave)) $68e3d36378531a9f$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $68e3d36378531a9f$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            $68e3d36378531a9f$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            $68e3d36378531a9f$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $68e3d36378531a9f$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $68e3d36378531a9f$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $l44RV.isObject)(duration)) return [
        $68e3d36378531a9f$var$NumberOf(duration.enter),
        $68e3d36378531a9f$var$NumberOf(duration.leave)
    ];
    else {
        const n = $68e3d36378531a9f$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $68e3d36378531a9f$var$NumberOf(val) {
    const res = (0, $l44RV.toNumber)(val);
    return res;
}
function $68e3d36378531a9f$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el._vtc || (el._vtc = /* @__PURE__ */ new Set())).add(cls);
}
function $68e3d36378531a9f$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const { _vtc: _vtc } = el;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = void 0;
    }
}
function $68e3d36378531a9f$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $68e3d36378531a9f$var$endId = 0;
function $68e3d36378531a9f$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$68e3d36378531a9f$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $68e3d36378531a9f$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $68e3d36378531a9f$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$68e3d36378531a9f$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$68e3d36378531a9f$var$TRANSITION}Duration`);
    const transitionTimeout = $68e3d36378531a9f$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$68e3d36378531a9f$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$68e3d36378531a9f$var$ANIMATION}Duration`);
    const animationTimeout = $68e3d36378531a9f$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $68e3d36378531a9f$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $68e3d36378531a9f$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $68e3d36378531a9f$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $68e3d36378531a9f$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $68e3d36378531a9f$var$TRANSITION : $68e3d36378531a9f$var$ANIMATION : null;
        propCount = type ? type === $68e3d36378531a9f$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $68e3d36378531a9f$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${$68e3d36378531a9f$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $68e3d36378531a9f$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$68e3d36378531a9f$var$toMs(d) + $68e3d36378531a9f$var$toMs(delays[i])));
}
function $68e3d36378531a9f$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $68e3d36378531a9f$var$forceReflow() {
    return document.body.offsetHeight;
}
const $68e3d36378531a9f$var$positionMap = /* @__PURE__ */ new WeakMap();
const $68e3d36378531a9f$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $68e3d36378531a9f$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $l44RV.extend)({}, $68e3d36378531a9f$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $6A78m.getCurrentInstance)();
        const state = (0, $6A78m.useTransitionState)();
        let prevChildren;
        let children;
        (0, $6A78m.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$68e3d36378531a9f$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($68e3d36378531a9f$var$callPendingCbs);
            prevChildren.forEach($68e3d36378531a9f$var$recordPosition);
            const movedChildren = prevChildren.filter($68e3d36378531a9f$var$applyTranslation);
            $68e3d36378531a9f$var$forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $68e3d36378531a9f$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el._moveCb = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $68e3d36378531a9f$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, $57ryt.toRaw)(props);
            const cssTransitionProps = $68e3d36378531a9f$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $6A78m.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $6A78m.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $6A78m.setTransitionHooks)(child, (0, $6A78m.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(let i = 0; i < prevChildren.length; i++){
                const child = prevChildren[i];
                (0, $6A78m.setTransitionHooks)(child, (0, $6A78m.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                $68e3d36378531a9f$var$positionMap.set(child, child.el.getBoundingClientRect());
            }
            return (0, $6A78m.createVNode)(tag, null, children);
        };
    }
};
const $68e3d36378531a9f$var$removeMode = (props)=>delete props.mode;
/* @__PURE__ */ $68e3d36378531a9f$var$removeMode($68e3d36378531a9f$var$TransitionGroupImpl.props);
const $68e3d36378531a9f$export$19ffa8f511f7bc2e = $68e3d36378531a9f$var$TransitionGroupImpl;
function $68e3d36378531a9f$var$callPendingCbs(c) {
    const el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $68e3d36378531a9f$var$recordPosition(c) {
    $68e3d36378531a9f$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $68e3d36378531a9f$var$applyTranslation(c) {
    const oldPos = $68e3d36378531a9f$var$positionMap.get(c);
    const newPos = $68e3d36378531a9f$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $68e3d36378531a9f$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $68e3d36378531a9f$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $68e3d36378531a9f$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $l44RV.isArray)(fn) ? (value)=>(0, $l44RV.invokeArrayFns)(fn, value) : fn;
};
function $68e3d36378531a9f$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $68e3d36378531a9f$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $68e3d36378531a9f$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $68e3d36378531a9f$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $68e3d36378531a9f$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $l44RV.looseToNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $68e3d36378531a9f$var$addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            $68e3d36378531a9f$var$addEventListener(el, "compositionstart", $68e3d36378531a9f$var$onCompositionStart);
            $68e3d36378531a9f$var$addEventListener(el, "compositionend", $68e3d36378531a9f$var$onCompositionEnd);
            $68e3d36378531a9f$var$addEventListener(el, "change", $68e3d36378531a9f$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el._assign = $68e3d36378531a9f$var$getModelAssigner(vnode);
        if (el.composing) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy) return;
            if (trim && el.value.trim() === value) return;
            if ((number || el.type === "number") && (0, $l44RV.looseToNumber)(el.value) === value) return;
        }
        const newValue = value == null ? "" : value;
        if (el.value !== newValue) el.value = newValue;
    }
};
const $68e3d36378531a9f$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el._assign = $68e3d36378531a9f$var$getModelAssigner(vnode);
        $68e3d36378531a9f$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $68e3d36378531a9f$var$getValue(el);
            const checked = el.checked;
            const assign = el._assign;
            if ((0, $l44RV.isArray)(modelValue)) {
                const index = (0, $l44RV.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $l44RV.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($68e3d36378531a9f$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $68e3d36378531a9f$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el._assign = $68e3d36378531a9f$var$getModelAssigner(vnode);
        $68e3d36378531a9f$var$setChecked(el, binding, vnode);
    }
};
function $68e3d36378531a9f$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    if ((0, $l44RV.isArray)(value)) el.checked = (0, $l44RV.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $l44RV.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $l44RV.looseEqual)(value, $68e3d36378531a9f$var$getCheckboxValue(el, true));
}
const $68e3d36378531a9f$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $l44RV.looseEqual)(value, vnode.props.value);
        el._assign = $68e3d36378531a9f$var$getModelAssigner(vnode);
        $68e3d36378531a9f$var$addEventListener(el, "change", ()=>{
            el._assign($68e3d36378531a9f$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el._assign = $68e3d36378531a9f$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $l44RV.looseEqual)(value, vnode.props.value);
    }
};
const $68e3d36378531a9f$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $l44RV.isSet)(value);
        $68e3d36378531a9f$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $l44RV.looseToNumber)($68e3d36378531a9f$var$getValue(o)) : $68e3d36378531a9f$var$getValue(o));
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $68e3d36378531a9f$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $68e3d36378531a9f$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el._assign = $68e3d36378531a9f$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        $68e3d36378531a9f$var$setSelected(el, value);
    }
};
function $68e3d36378531a9f$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    if (isMultiple && !(0, $l44RV.isArray)(value) && !(0, $l44RV.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $68e3d36378531a9f$var$getValue(option);
        if (isMultiple) {
            if ((0, $l44RV.isArray)(value)) option.selected = (0, $l44RV.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $l44RV.looseEqual)($68e3d36378531a9f$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $68e3d36378531a9f$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $68e3d36378531a9f$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $68e3d36378531a9f$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $68e3d36378531a9f$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $68e3d36378531a9f$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $68e3d36378531a9f$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $68e3d36378531a9f$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $68e3d36378531a9f$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $68e3d36378531a9f$export$87d227567b51ca39;
        case "TEXTAREA":
            return $68e3d36378531a9f$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $68e3d36378531a9f$export$8847c2e532b35714;
                case "radio":
                    return $68e3d36378531a9f$export$b4356c59b38b7aa9;
                default:
                    return $68e3d36378531a9f$export$f1f88689f5728478;
            }
    }
}
function $68e3d36378531a9f$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $68e3d36378531a9f$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $68e3d36378531a9f$var$initVModelForSSR() {
    $68e3d36378531a9f$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $68e3d36378531a9f$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $l44RV.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $68e3d36378531a9f$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $l44RV.isArray)(value)) {
            if (vnode.props && (0, $l44RV.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $l44RV.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $68e3d36378531a9f$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $68e3d36378531a9f$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $68e3d36378531a9f$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $68e3d36378531a9f$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$68e3d36378531a9f$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $68e3d36378531a9f$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    return (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $68e3d36378531a9f$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    };
};
const $68e3d36378531a9f$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $68e3d36378531a9f$export$f691a8759658f782 = (fn, modifiers)=>{
    return (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $l44RV.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $68e3d36378531a9f$var$keyNames[k] === eventKey)) return fn(event);
    };
};
const $68e3d36378531a9f$export$5cb4fcdc6937d7e1 = {
    beforeMount (el, { value: value }, { transition: transition }) {
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $68e3d36378531a9f$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $68e3d36378531a9f$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $68e3d36378531a9f$var$setDisplay(el, false);
            });
        } else $68e3d36378531a9f$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $68e3d36378531a9f$var$setDisplay(el, value);
    }
};
function $68e3d36378531a9f$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
function $68e3d36378531a9f$var$initVShowForSSR() {
    $68e3d36378531a9f$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $68e3d36378531a9f$var$rendererOptions = /* @__PURE__ */ (0, $l44RV.extend)({
    patchProp: $68e3d36378531a9f$var$patchProp
}, $68e3d36378531a9f$var$nodeOps);
let $68e3d36378531a9f$var$renderer;
let $68e3d36378531a9f$var$enabledHydration = false;
function $68e3d36378531a9f$var$ensureRenderer() {
    return $68e3d36378531a9f$var$renderer || ($68e3d36378531a9f$var$renderer = (0, $6A78m.createRenderer)($68e3d36378531a9f$var$rendererOptions));
}
function $68e3d36378531a9f$var$ensureHydrationRenderer() {
    $68e3d36378531a9f$var$renderer = $68e3d36378531a9f$var$enabledHydration ? $68e3d36378531a9f$var$renderer : (0, $6A78m.createHydrationRenderer)($68e3d36378531a9f$var$rendererOptions);
    $68e3d36378531a9f$var$enabledHydration = true;
    return $68e3d36378531a9f$var$renderer;
}
const $68e3d36378531a9f$export$b3890eb0ae9dca99 = (...args)=>{
    $68e3d36378531a9f$var$ensureRenderer().render(...args);
};
const $68e3d36378531a9f$export$fa8d919ba61d84db = (...args)=>{
    $68e3d36378531a9f$var$ensureHydrationRenderer().hydrate(...args);
};
const $68e3d36378531a9f$export$4e373c34abfa8c68 = (...args)=>{
    const app = $68e3d36378531a9f$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $68e3d36378531a9f$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $l44RV.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        const proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $68e3d36378531a9f$export$35800275c0037383 = (...args)=>{
    const app = $68e3d36378531a9f$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $68e3d36378531a9f$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $68e3d36378531a9f$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $l44RV.isHTMLTag)(tag) || (0, $l44RV.isSVGTag)(tag),
        writable: false
    });
}
function $68e3d36378531a9f$var$injectCompilerOptionsCheck(app) {
    if ((0, $6A78m.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $6A78m.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $6A78m.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $6A78m.warn)(msg);
            }
        });
    }
}
function $68e3d36378531a9f$var$normalizeContainer(container) {
    if ((0, $l44RV.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $68e3d36378531a9f$var$ssrDirectiveInitialized = false;
const $68e3d36378531a9f$export$800b28255aa678d9 = ()=>{
    if (!$68e3d36378531a9f$var$ssrDirectiveInitialized) {
        $68e3d36378531a9f$var$ssrDirectiveInitialized = true;
        $68e3d36378531a9f$var$initVModelForSSR();
        $68e3d36378531a9f$var$initVShowForSSR();
    }
};

});



parcelRequire.register("j7YgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $decd6bfd50a9f4ec$export$2e2bcd8739ae039; });
let $decd6bfd50a9f4ec$var$NOOP = ()=>{};
var $decd6bfd50a9f4ec$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("3z8PI", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ "use strict";
function $298b7e134d7e3d3d$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $298b7e134d7e3d3d$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, "assign", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $298b7e134d7e3d3d$var$assign
    });
}
module.exports = {
    assign: $298b7e134d7e3d3d$var$assign,
    polyfill: $298b7e134d7e3d3d$var$polyfill
};

});

parcelRequire.register("d7Qcu", function(module, exports) {
"use strict";
var $98e46bc0de802de9$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $a7Et4 = parcelRequire("a7Et4");
var $98e46bc0de802de9$var$VueLogger = /** @class */ function() {
    function VueLogger() {
        this.errorMessage = "Provided options for vuejs-logger are not valid.";
        this.logLevels = Object.keys($a7Et4.LogLevels).map(function(l) {
            return l.toLowerCase();
        });
    }
    VueLogger.prototype.install = function(Vue, options) {
        options = Object.assign(this.getDefaultOptions(), options);
        if (this.isValidOptions(options, this.logLevels)) {
            Vue.$log = this.initLoggerInstance(options, this.logLevels);
            Vue.provide("vuejs3-logger", Vue.$log);
            Vue.config.globalProperties.$log = Vue.$log;
        } else throw new Error(this.errorMessage);
    };
    VueLogger.prototype.isValidOptions = function(options, logLevels) {
        if (!(options.logLevel && typeof options.logLevel === "string" && logLevels.indexOf(options.logLevel) > -1)) return false;
        if (options.stringifyArguments && typeof options.stringifyArguments !== "boolean") return false;
        if (options.showLogLevel && typeof options.showLogLevel !== "boolean") return false;
        if (options.showConsoleColors && typeof options.showConsoleColors !== "boolean") return false;
        if (options.separator && (typeof options.separator !== "string" || typeof options.separator === "string" && options.separator.length > 3)) return false;
        if (typeof options.isEnabled !== "boolean") return false;
        return !(options.showMethodName && typeof options.showMethodName !== "boolean");
    };
    VueLogger.prototype.getMethodName = function() {
        var error = {};
        try {
            throw new Error("");
        } catch (e) {
            error = e;
        }
        // IE9 does not have .stack property
        if (error.stack === undefined) return "";
        var stackTrace = error.stack.split("\n")[3];
        if (/ /.test(stackTrace)) stackTrace = stackTrace.trim().split(" ")[1];
        if (stackTrace && stackTrace.indexOf(".") > -1) stackTrace = stackTrace.split(".")[1];
        return stackTrace;
    };
    VueLogger.prototype.initLoggerInstance = function(options, logLevels) {
        var _this = this;
        var logger = {};
        logLevels.forEach(function(logLevel) {
            if (logLevels.indexOf(logLevel) >= logLevels.indexOf(options.logLevel) && options.isEnabled) logger[logLevel] = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var methodName = _this.getMethodName();
                var methodNamePrefix = options.showMethodName ? methodName + (" " + options.separator + " ") : "";
                var logLevelPrefix = options.showLogLevel ? logLevel + (" " + options.separator + " ") : "";
                var formattedArguments = options.stringifyArguments ? args.map(function(a) {
                    return JSON.stringify(a);
                }) : args;
                var logMessage = logLevelPrefix + " " + methodNamePrefix;
                _this.printLogMessage(logLevel, logMessage, options.showConsoleColors, formattedArguments);
                return logMessage + " " + formattedArguments.toString();
            };
            else logger[logLevel] = function() {
                return undefined;
            };
        });
        return logger;
    };
    VueLogger.prototype.printLogMessage = function(logLevel, logMessage, showConsoleColors, formattedArguments) {
        if (showConsoleColors && (logLevel === "warn" || logLevel === "error" || logLevel === "fatal")) console[logLevel === "fatal" ? "error" : logLevel].apply(console, $98e46bc0de802de9$var$__spreadArrays([
            logMessage
        ], formattedArguments));
        else console.log.apply(console, $98e46bc0de802de9$var$__spreadArrays([
            logMessage
        ], formattedArguments));
    };
    VueLogger.prototype.getDefaultOptions = function() {
        return {
            isEnabled: true,
            logLevel: $a7Et4.LogLevels.DEBUG,
            separator: "|",
            showConsoleColors: false,
            showLogLevel: false,
            showMethodName: false,
            stringifyArguments: false
        };
    };
    return VueLogger;
}();
module.exports.default = new $98e46bc0de802de9$var$VueLogger();

});
parcelRequire.register("a7Et4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $75e9f2ed9a318366$var$LogLevels;
(function(LogLevels) {
    LogLevels["DEBUG"] = "debug";
    LogLevels["INFO"] = "info";
    LogLevels["WARN"] = "warn";
    LogLevels["ERROR"] = "error";
    LogLevels["FATAL"] = "fatal";
})($75e9f2ed9a318366$var$LogLevels = module.exports.LogLevels || (module.exports.LogLevels = {}));

});


var $05e20ce016aface8$exports = {};

(parcelRequire("dLcGf")).register(JSON.parse('{"a4hVz":"index.bf2d322c.js","jY4bm":"logo-sts-de.cec32996.png","8ZjZd":"logo-sts-fr.09bc97d4.png","b3rVS":"logo-sts-it.d4f8a0ed.png","kPVET":"logo-blv-de-1000.2926a4fe.png","l35Q3":"logo-blv-de-vertical-600.e281d985.png","aTEjB":"logo-blv-fr-1000.2e10576f.png","aHDCm":"logo-blv-fr-vertical-600.06052e07.png","dXkPS":"logo-blv-it-1000.d05e8c46.png","cFdiX":"logo-blv-it-vertical-600.9571e9ab.png","3Sb0H":"icon-68.09aeeae5.png","5vOAG":"icon-warning-black.ae49ec2f.svg","iZ9dP":"icon-warning-white.3b12959f.svg","2TqXA":"length-lizards.79d21368.png","5ih3K":"length-snakes.d363c517.png","i9E6K":"length-turtles.d9cd0911.png","fUpOD":"equidae-withers.168994a2.png","3ETZs":"rodents.737ff55f.jpg","d6Ply":"rodents-320w.650fa225.jpg","fzxxb":"rodents-480w.0cc9d3ab.jpg","bibHD":"rodents-640w.29a2a3ac.jpg","6lmMf":"leopardgecko.1ee27d4c.jpg","9MBi1":"leopardgecko-320w.0e1da082.jpg","l46AA":"leopardgecko-480w.9baf2fe8.jpg","7UL1x":"leopardgecko-640w.8b0875a1.jpg","2atpP":"nymphensittich.6d795f00.jpg","k1uG6":"nymphensittich-320w.0065a257.jpg","8649q":"nymphensittich-480w.41c0671b.jpg","7yWcA":"nymphensittich-640w.1aba83c9.jpg","fJCvy":"multiple-birds.87279a60.jpg","lJG3Q":"multiple-birds-320w.a22152d0.jpg","4k5as":"multiple-birds-480w.2ee07a3a.jpg","6rvLH":"multiple-birds-640w.2d8cb1c2.jpg","jkY6N":"pferd.0c52809a.jpg","iGSFZ":"pferd-320w.1894b93d.jpg","jHdtW":"pferd-480w.2f124760.jpg","4blqD":"pferd-640w.b5c14644.jpg","Hu3v5":"degu.b8cabb32.jpg","bPoJz":"degu-320w.bfcdab11.jpg","6xA3l":"degu-480w.1a3881fa.jpg","caGBU":"degu-640w.27bdd134.jpg","je4k7":"farbmaus.9ea0da8b.jpg","6lEil":"farbmaus-320w.7731c0a0.jpg","BtUBK":"farbmaus-480w.c815aced.jpg","7dEWJ":"farbmaus-640w.9fecce91.jpg","8i9XK":"goldhamster.3ba762d4.jpg","jZbt7":"goldhamster-320w.36be10ae.jpg","4OC3A":"goldhamster-480w.49770d90.jpg","8L2Vi":"goldhamster-640w.e16d00b9.jpg","7oSro":"kaninchen.294600e1.jpg","1osmp":"kaninchen-320w.d8ad187f.jpg","dHoKZ":"kaninchen-480w.1c425b0f.jpg","iT0aN":"kaninchen-640w.d81e6041.jpg","bux6D":"meerschweinchen.784c2564.jpg","6yWTY":"meerschweinchen-320w.fc537270.jpg","JZMjB":"meerschweinchen-480w.7e7d4993.jpg","8ldT9":"meerschweinchen-640w.aef741a3.jpg","aDnsR":"ratte.91c11b9f.jpg","3xuqo":"ratte-320w.cd60c728.jpg","fF6Fw":"ratte-480w.66033831.jpg","74W4F":"ratte-640w.724eb398.jpg","gBFtS":"rennmaus.1272a277.jpg","eMoo2":"rennmaus-320w.f671a26f.jpg","EkB08":"rennmaus-480w.ed3f4745.jpg","3ovpu":"rennmaus-640w.244849ab.jpg","4AN6m":"zwerghamster.95b02425.jpg","3G98G":"zwerghamster-320w.7a5aadb8.jpg","hvsc7":"zwerghamster-480w.acbd6013.jpg","kmbCO":"zwerghamster-640w.7ee12ffb.jpg","cGEq8":"koenigspython.79e93257.jpg","2dLiz":"koenigspython-320w.2131366e.jpg","gQ2lg":"koenigspython-480w.7dade00e.jpg","aasbI":"koenigspython-640w.960326ed.jpg","6TqiD":"kornnatter.13935b1c.jpg","5Yiai":"kornnatter-320w.d04b03d2.jpg","ey0sZ":"kornnatter-480w.2e9f997d.jpg","7tXLx":"kornnatter-640w.033a942f.jpg","37ilj":"griechische_landschildkroete.288052e4.jpg","5ihCS":"griechische_landschildkroete-320w.40631d7f.jpg","kFbEu":"griechische_landschildkroete-480w.46739d1e.jpg","hX6D8":"griechische_landschildkroete-640w.1a4590e8.jpg","7qhqF":"maurische_landschildkroete.bdd5e32f.jpg","8rcRF":"maurische_landschildkroete-320w.a9f87751.jpg","aw63G":"maurische_landschildkroete-480w.fdd2256a.jpg","czTlV":"maurische_landschildkroete-640w.512f8869.jpg","6nnTr":"breitrandschildkroete.e6b447e7.jpg","g3FCn":"breitrandschildkroete-320w.8bc08692.jpg","56yQj":"breitrandschildkroete-480w.13d26c68.jpg","cxCFP":"breitrandschildkroete-640w.26d8437c.jpg","1VCyG":"kronengecko.8c70ca3b.jpg","hUffu":"kronengecko-320w.ca55c6ca.jpg","avmnH":"kronengecko-480w.0a394efd.jpg","7wKS0":"kronengecko-640w.ae2a14bd.jpg","3L384":"abgottschlange.dce38ad0.jpg","7zLxF":"abgottschlange-320w.8b4c5b7e.jpg","drMAt":"abgottschlange-480w.65d48cfa.jpg","iMsTD":"abgottschlange-640w.ebdbbb26.jpg","cBiA3":"gewoehnliche_moschusschildkroete.d5d06bf0.jpg","dMMW0":"gewoehnliche_moschusschildkroete-320w.e3ac5c90.jpg","7pcnh":"gewoehnliche_moschusschildkroete-480w.86813f3a.jpg","cElOz":"gewoehnliche_moschusschildkroete-640w.4a02f318.jpg","cCOIM":"dreiecksnatter.3f4fb641.jpg","2MvAA":"dreiecksnatter-320w.07c6de6d.jpg","g7yWT":"dreiecksnatter-480w.89cd89bf.jpg","aTlcS":"dreiecksnatter-640w.d9b68a3c.jpg","cdaQq":"grosser_madagaskar_taggecko.3eee11b5.jpg","3pYfn":"grosser_madagaskar_taggecko-320w.b0402b29.jpg","lrknx":"grosser_madagaskar_taggecko-480w.5625a58b.jpg","izluQ":"grosser_madagaskar_taggecko-640w.9e2b7e71.jpg","9Zr3K":"goldstaub_taggecko.276c9b6d.jpg","k7s45":"goldstaub_taggecko-320w.0bd9db5b.jpg","fWr2r":"goldstaub_taggecko-480w.1b25c1e1.jpg","7gBty":"goldstaub_taggecko-640w.64f495d9.jpg","hKQX7":"zwergbartagame.bdb513ac.jpg","3LPto":"zwergbartagame-320w.50427b08.jpg","dBDJC":"zwergbartagame-480w.08820ee1.jpg","cCyu7":"zwergbartagame-640w.c4b051d9.jpg","9elqM":"streifenkoepfige_bartagame.0d5e5444.jpg","1cLrY":"streifenkoepfige_bartagame-320w.f6eeef5c.jpg","a6buq":"streifenkoepfige_bartagame-480w.ea3acdb3.jpg","lvnRf":"streifenkoepfige_bartagame-640w.e04d011f.jpg","8QDQW":"wellensittich.da582c72.jpg","1xw5u":"wellensittich-320w.bb53ba4f.jpg","kpt4O":"wellensittich-480w.386a1afa.jpg","9x37q":"wellensittich-640w.70f7cb4c.jpg","b3HWt":"agapornid.a957fb76.jpg","bgYj5":"agapornid-320w.d0f04b54.jpg","b1Iq7":"agapornid-480w.e4263c6e.jpg","cJT1i":"agapornid-640w.a36cce03.jpg","9fiKX":"amazone.ff3d903e.jpg","bxOMi":"amazone-320w.ce77e399.jpg","i2wOh":"amazone-480w.2f11c01c.jpg","jQi9F":"amazone-640w.350b4213.jpg","6f2zm":"kongo-graupapagei.d65d0a5a.jpg","isBGw":"kongo-graupapagei-320w.3428c8ee.jpg","9I5ya":"kongo-graupapagei-480w.6380c812.jpg","37MWX":"kongo-graupapagei-640w.ff9334cc.jpg","fJg2G":"tarantapapagei.9674024a.jpg","knXjb":"tarantapapagei-320w.e036bd6f.jpg","dY6hS":"tarantapapagei-480w.fba113d8.jpg","SpUba":"tarantapapagei-640w.fb12dbb0.jpg","1aGlb":"rosellasittich.9dce369d.jpg","2wuIu":"rosellasittich-320w.90403c4d.jpg","FLy8b":"rosellasittich-480w.5f8d3fe9.jpg","kdas1":"rosellasittich-640w.3aca8cbf.jpg","jXCiD":"schoensittich.01347f96.jpg","h1Ccd":"schoensittich-320w.4f9720c8.jpg","466qm":"schoensittich-480w.9db90150.jpg","iuOgR":"schoensittich-640w.79bed7b5.jpg","gVGaS":"kanarienvogel.7fdc504f.jpg","bC3qB":"kanarienvogel-320w.8e0919a3.jpg","dpzrj":"kanarienvogel-480w.61b5520b.jpg","gwQ80":"kanarienvogel-640w.f620f66a.jpg","bhb7P":"gouldamadinen.18566dae.jpg","dM2ST":"gouldamadinen-320w.6c4dab6a.jpg","1FmQ9":"gouldamadinen-480w.38d81aee.jpg","3ELMP":"gouldamadinen-640w.6101bc65.jpg","37dOA":"zebrafink.aba9085d.jpg","aWJC0":"zebrafink-320w.a48c920b.jpg","6Fyh0":"zebrafink-480w.2d7459e3.jpg","9uHvS":"zebrafink-640w.7c0eafba.jpg","amIiM":"goldbruestchen.93ca554b.jpg","jkB3n":"goldbruestchen-320w.e78860ee.jpg","7RvSV":"goldbruestchen-480w.15d0a110.jpg","2zcGU":"goldbruestchen-640w.8c81d7db.jpg","dW1Kg":"grauastrild.feb2e800.jpg","gpYen":"grauastrild-320w.0eaf0793.jpg","cUXNh":"grauastrild-480w.9b3a694a.jpg","7Hpyv":"grauastrild-640w.af0d149f.jpg","dkUCF":"diamanttaeubchen.7c7313fe.jpg","fDxHZ":"diamanttaeubchen-320w.3def9bd8.jpg","4MGI6":"diamanttaeubchen-480w.90d46595.jpg","iPfHZ":"diamanttaeubchen-640w.e69b8abd.jpg","8QGTr":"ara.19a7e8da.jpg","4C1hb":"ara-320w.227ccb4f.jpg","ep6VQ":"ara-480w.6240ddf0.jpg","5YteT":"ara-640w.365987c8.jpg","dlAIQ":"kakadu.fe0aa26b.jpg","11RzX":"kakadu-320w.b427c010.jpg","fuIsP":"kakadu-480w.81f92ce0.jpg","6ct3X":"kakadu-640w.c37cda68.jpg","62Hjr":"pony.7368b12e.jpg","3nOqd":"pony-320w.f8861c42.jpg","bWbd2":"pony-480w.d062eff2.jpg","9x0FD":"pony-640w.13fa6001.jpg","ldoTN":"esel.987b3fb0.jpg","76dZU":"esel-320w.a3006879.jpg","iRtWm":"esel-480w.08ae7a88.jpg","2E2Et":"esel-640w.52adff4e.jpg","2txkT":"maultier.37956dc4.jpg","45RDH":"maultier-320w.e8fc3d3d.jpg","b9HK5":"maultier-480w.d092a2d6.jpg","1F0LH":"maultier-640w.8108c732.jpg","224TU":"maulesel.b9e91e73.jpg","j6xpQ":"maulesel-320w.0d674fa7.jpg","98DtU":"maulesel-480w.b40a911b.jpg","59pW8":"maulesel-640w.882a930d.jpg","dBCut":"index.981dc3ef.css"}'));

parcelRequire("ecovD");
var $90kfS = parcelRequire("90kfS");
let $ad5a9047874b1a56$var$script;




let $ad5a9047874b1a56$var$initialize = ()=>{
    $ad5a9047874b1a56$var$script = (parcelRequire("8xKIn"));
    if ($ad5a9047874b1a56$var$script.__esModule) $ad5a9047874b1a56$var$script = $ad5a9047874b1a56$var$script.default;
    $ad5a9047874b1a56$var$script.render = (parcelRequire("ghqC1")).render;
    $ad5a9047874b1a56$var$script.__cssModules = {};
    (parcelRequire("j7YgL")).default($ad5a9047874b1a56$var$script);
    $ad5a9047874b1a56$var$script.__scopeId = "data-v-e74703";
    $ad5a9047874b1a56$var$script.__file = "App.vue";
};
$ad5a9047874b1a56$var$initialize();
var $ad5a9047874b1a56$export$2e2bcd8739ae039 = $ad5a9047874b1a56$var$script;


/*!
  * vue-i18n v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ /*!
  * shared v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ /**
 * Original Utilities
 * written by kazuya kawaguchi
 */ const $82c18ee15207f03a$export$620a268685f0ac45 = typeof window !== "undefined";
let $82c18ee15207f03a$export$bf7f2fce5c1cf636;
let $82c18ee15207f03a$export$83602b44513dc228;
var $82c18ee15207f03a$var$tag, $82c18ee15207f03a$var$name, $82c18ee15207f03a$var$startTag, $82c18ee15207f03a$var$endTag;
const $82c18ee15207f03a$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $82c18ee15207f03a$export$d9468344d3651243(message, ...args) {
    if (args.length === 1 && $82c18ee15207f03a$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($82c18ee15207f03a$var$RE_ARGS, (match, identifier)=>{
        return args.hasOwnProperty(identifier) ? args[identifier] : "";
    });
}
const $82c18ee15207f03a$var$hasSymbol = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
const $82c18ee15207f03a$export$cd133c5e04906ece = (name)=>$82c18ee15207f03a$var$hasSymbol ? Symbol(name) : name;
const $82c18ee15207f03a$export$5024ef1f92c9a364 = (locale, key, source)=>$82c18ee15207f03a$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
const $82c18ee15207f03a$export$d704025436eaed65 = (json)=>JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
const $82c18ee15207f03a$export$7e4aa119212bc614 = (val)=>typeof val === "number" && isFinite(val);
const $82c18ee15207f03a$export$871608497c498473 = (val)=>$82c18ee15207f03a$export$1dccc787cc36538b(val) === "[object Date]";
const $82c18ee15207f03a$export$49841c62b9eff15 = (val)=>$82c18ee15207f03a$export$1dccc787cc36538b(val) === "[object RegExp]";
const $82c18ee15207f03a$export$83b788b1a3698c03 = (val)=>$82c18ee15207f03a$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
function $82c18ee15207f03a$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== "undefined") {
        console.warn(`[intlify] ` + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
const $82c18ee15207f03a$export$e6e34fd1f2686227 = Object.assign;
let $82c18ee15207f03a$var$_globalThis;
const $82c18ee15207f03a$export$ff5f2eeb11fc7e14 = ()=>{
    // prettier-ignore
    return $82c18ee15207f03a$var$_globalThis || ($82c18ee15207f03a$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
function $82c18ee15207f03a$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const $82c18ee15207f03a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $82c18ee15207f03a$export$b5a638e9b3fff9f3(obj, key) {
    return $82c18ee15207f03a$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ const $82c18ee15207f03a$export$43bee75e5e14138e = Array.isArray;
const $82c18ee15207f03a$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $82c18ee15207f03a$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $82c18ee15207f03a$export$f9ce7b637dfbe238 = (val)=>typeof val === "boolean";
const $82c18ee15207f03a$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $82c18ee15207f03a$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $82c18ee15207f03a$export$4369c812aac99591 = (val)=>{
    return $82c18ee15207f03a$export$a6cdc56e425d0d0a(val) && $82c18ee15207f03a$export$f6e2535fb5126e54(val.then) && $82c18ee15207f03a$export$f6e2535fb5126e54(val.catch);
};
const $82c18ee15207f03a$export$830c053460e5ddf6 = Object.prototype.toString;
const $82c18ee15207f03a$export$1dccc787cc36538b = (value)=>$82c18ee15207f03a$export$830c053460e5ddf6.call(value);
const $82c18ee15207f03a$export$53b83ca8eaab0383 = (val)=>$82c18ee15207f03a$export$1dccc787cc36538b(val) === "[object Object]";
// for converting list and named values to displayed strings.
const $82c18ee15207f03a$export$b5b1545233b45293 = (val)=>{
    return val == null ? "" : $82c18ee15207f03a$export$43bee75e5e14138e(val) || $82c18ee15207f03a$export$53b83ca8eaab0383(val) && val.toString === $82c18ee15207f03a$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
const $82c18ee15207f03a$var$RANGE = 2;
function $82c18ee15207f03a$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    const lines = source.split(/\r?\n/);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(let j = i - $82c18ee15207f03a$var$RANGE; j <= i + $82c18ee15207f03a$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(3 - String(line).length)}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    const pad = start - (count - lineLength) + 1;
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $82c18ee15207f03a$export$6f5e8f34570e3ad1() {
    const events = new Map();
    const emitter = {
        events: events,
        on (event, handler) {
            const handlers = events.get(event);
            const added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off (event, handler) {
            const handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit (event, payload) {
            (events.get(event) || []).slice().map((handler)=>handler(payload));
            (events.get("*") || []).slice().map((handler)=>handler(event, payload));
        }
    };
    return emitter;
}


/*!
  * core-base v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ 
/*!
  * message-compiler v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ 
const $0746c8fcb985621f$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 15
};
/** @internal */ const $0746c8fcb985621f$export$d8bd0967cb58683 = {
    // tokenizer error messages
    [$0746c8fcb985621f$export$77436aae039469c4.EXPECTED_TOKEN]: `Expected token: '{0}'`,
    [$0746c8fcb985621f$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER]: `Invalid token in placeholder: '{0}'`,
    [$0746c8fcb985621f$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: `Unterminated single quote in placeholder`,
    [$0746c8fcb985621f$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE]: `Unknown escape sequence: \\{0}`,
    [$0746c8fcb985621f$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE]: `Invalid unicode escape sequence: {0}`,
    [$0746c8fcb985621f$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE]: `Unbalanced closing brace`,
    [$0746c8fcb985621f$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE]: `Unterminated closing brace`,
    [$0746c8fcb985621f$export$77436aae039469c4.EMPTY_PLACEHOLDER]: `Empty placeholder`,
    [$0746c8fcb985621f$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER]: `Not allowed nest placeholder`,
    [$0746c8fcb985621f$export$77436aae039469c4.INVALID_LINKED_FORMAT]: `Invalid linked format`,
    // parser error messages
    [$0746c8fcb985621f$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL]: `Plural must have messages`,
    [$0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER]: `Unexpected empty linked modifier`,
    [$0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY]: `Unexpected empty linked key`,
    [$0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS]: `Unexpected lexical analysis in token: '{0}'`
};
function $0746c8fcb985621f$export$21efa8bb37d5fecb(code, loc, options = {}) {
    const { domain: domain, messages: messages, args: args } = options;
    const msg = code;
    const error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $0746c8fcb985621f$export$ad0eb2c702f03471(error) {
    throw error;
}
const $0746c8fcb985621f$export$9ba8fa38cb18b1f3 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $0746c8fcb985621f$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $0746c8fcb985621f$export$90c043f1c57770b8(start, end, source) {
    const loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
const $0746c8fcb985621f$var$CHAR_SP = " ";
const $0746c8fcb985621f$var$CHAR_CR = "\r";
const $0746c8fcb985621f$var$CHAR_LF = "\n";
const $0746c8fcb985621f$var$CHAR_LS = String.fromCharCode(0x2028);
const $0746c8fcb985621f$var$CHAR_PS = String.fromCharCode(0x2029);
function $0746c8fcb985621f$var$createScanner(str) {
    const _buf = str;
    let _index = 0;
    let _line = 1;
    let _column = 1;
    let _peekOffset = 0;
    const isCRLF = (index)=>_buf[index] === $0746c8fcb985621f$var$CHAR_CR && _buf[index + 1] === $0746c8fcb985621f$var$CHAR_LF;
    const isLF = (index)=>_buf[index] === $0746c8fcb985621f$var$CHAR_LF;
    const isPS = (index)=>_buf[index] === $0746c8fcb985621f$var$CHAR_PS;
    const isLS = (index)=>_buf[index] === $0746c8fcb985621f$var$CHAR_LS;
    const isLineEnd = (index)=>isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    const index = ()=>_index;
    const line = ()=>_line;
    const column = ()=>_column;
    const peekOffset = ()=>_peekOffset;
    const charAt = (offset)=>isCRLF(offset) || isPS(offset) || isLS(offset) ? $0746c8fcb985621f$var$CHAR_LF : _buf[offset];
    const currentChar = ()=>charAt(_index);
    const currentPeek = ()=>charAt(_index + _peekOffset);
    function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    }
    function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    }
    function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    }
    function resetPeek(offset = 0) {
        _peekOffset = offset;
    }
    function skipToPeek() {
        const target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while(target !== _index)next();
        _peekOffset = 0;
    }
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
const $0746c8fcb985621f$var$EOF = undefined;
const $0746c8fcb985621f$var$LITERAL_DELIMITER = "'";
const $0746c8fcb985621f$var$ERROR_DOMAIN$1 = "tokenizer";
function $0746c8fcb985621f$var$createTokenizer(source, options = {}) {
    const location = options.location !== false;
    const _scnr = $0746c8fcb985621f$var$createScanner(source);
    const currentOffset = ()=>_scnr.index();
    const currentPosition = ()=>$0746c8fcb985621f$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    const _initLoc = currentPosition();
    const _initOffset = currentOffset();
    const _context = {
        currentType: 14 /* EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ""
    };
    const context = ()=>_context;
    const { onError: onError } = options;
    function emitError(code, pos, offset, ...args) {
        const ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            const loc = $0746c8fcb985621f$export$90c043f1c57770b8(ctx.startLoc, pos);
            const err = $0746c8fcb985621f$export$21efa8bb37d5fecb(code, loc, {
                domain: $0746c8fcb985621f$var$ERROR_DOMAIN$1,
                args: args
            });
            onError(err);
        }
    }
    function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        const token = {
            type: type
        };
        if (location) token.loc = $0746c8fcb985621f$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    }
    const getEndToken = (context)=>getToken(context, 14 /* EOF */ );
    function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($0746c8fcb985621f$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return "";
        }
    }
    function peekSpaces(scnr) {
        let buf = "";
        while(scnr.currentPeek() === $0746c8fcb985621f$var$CHAR_SP || scnr.currentPeek() === $0746c8fcb985621f$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    }
    function skipSpaces(scnr) {
        const buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    }
    function isIdentifierStart(ch) {
        if (ch === $0746c8fcb985621f$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    }
    function isNumberStart(ch) {
        if (ch === $0746c8fcb985621f$var$EOF) return false;
        const cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    }
    function isNamedIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isListIdentifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
        const ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    }
    function isLiteralStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === $0746c8fcb985621f$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDotStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 8 /* LinkedAlias */ ) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "." /* LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedModifierStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 9 /* LinkedDot */ ) return false;
        peekSpaces(scnr);
        const ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    }
    function isLinkedDelimiterStart(scnr, context) {
        const { currentType: currentType } = context;
        if (!(currentType === 8 /* LinkedAlias */  || currentType === 12 /* LinkedModifier */ )) return false;
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === ":" /* LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    }
    function isLinkedReferStart(scnr, context) {
        const { currentType: currentType } = context;
        if (currentType !== 10 /* LinkedDelimiter */ ) return false;
        const fn = ()=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* LinkedAlias */  || ch === "%" /* Modulo */  || ch === "|" /* Pipe */  || ch === ":" /* LinkedDelimiter */  || ch === "." /* LinkedDot */  || ch === $0746c8fcb985621f$var$CHAR_SP || !ch) return false;
            else if (ch === $0746c8fcb985621f$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isIdentifierStart(ch);
        };
        const ret = fn();
        scnr.resetPeek();
        return ret;
    }
    function isPluralStart(scnr) {
        peekSpaces(scnr);
        const ret = scnr.currentPeek() === "|" /* Pipe */ ;
        scnr.resetPeek();
        return ret;
    }
    function detectModuloStart(scnr) {
        const spaces = peekSpaces(scnr);
        const ret = scnr.currentPeek() === "%" /* Modulo */  && scnr.peek() === "{" /* BraceLeft */ ;
        scnr.resetPeek();
        return {
            isModulo: ret,
            hasSpace: spaces.length > 0
        };
    }
    function isTextStart(scnr, reset = true) {
        const fn = (hasSpace = false, prev = "", detectModulo = false)=>{
            const ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */ ) return prev === "%" /* Modulo */  ? false : hasSpace;
            else if (ch === "@" /* LinkedAlias */  || !ch) return prev === "%" /* Modulo */  ? true : hasSpace;
            else if (ch === "%" /* Modulo */ ) {
                scnr.peek();
                return fn(hasSpace, "%" /* Modulo */ , true);
            } else if (ch === "|" /* Pipe */ ) return prev === "%" /* Modulo */  || detectModulo ? true : !(prev === $0746c8fcb985621f$var$CHAR_SP || prev === $0746c8fcb985621f$var$CHAR_LF);
            else if (ch === $0746c8fcb985621f$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $0746c8fcb985621f$var$CHAR_SP, detectModulo);
            } else if (ch === $0746c8fcb985621f$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $0746c8fcb985621f$var$CHAR_LF, detectModulo);
            } else return true;
        };
        const ret = fn();
        reset && scnr.resetPeek();
        return ret;
    }
    function takeChar(scnr, fn) {
        const ch = scnr.currentChar();
        if (ch === $0746c8fcb985621f$var$EOF) return $0746c8fcb985621f$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    }
    function takeIdentifierChar(scnr) {
        const closure = (ch)=>{
            const cc = ch.charCodeAt(0);
            return cc >= 97 && cc <= 122 || // a-z
            cc >= 65 && cc <= 90 || // A-Z
            cc >= 48 && cc <= 57 || // 0-9
            cc === 95 || // _
            cc === 36 // $
            ;
        };
        return takeChar(scnr, closure);
    }
    function takeDigit(scnr) {
        const closure = (ch)=>{
            const cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57; // 0-9
        };
        return takeChar(scnr, closure);
    }
    function takeHexDigit(scnr) {
        const closure = (ch)=>{
            const cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57 || // 0-9
            cc >= 65 && cc <= 70 || // A-F
            cc >= 97 && cc <= 102; // a-f
        };
        return takeChar(scnr, closure);
    }
    function getDigits(scnr) {
        let ch = "";
        let num = "";
        while(ch = takeDigit(scnr))num += ch;
        return num;
    }
    function readModulo(scnr) {
        skipSpaces(scnr);
        const ch = scnr.currentChar();
        if (ch !== "%" /* Modulo */ ) emitError($0746c8fcb985621f$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
        scnr.next();
        return "%" /* Modulo */ ;
    }
    function readText(scnr) {
        let buf = "";
        while(true){
            const ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */  || ch === "}" /* BraceRight */  || ch === "@" /* LinkedAlias */  || ch === "|" /* Pipe */  || !ch) break;
            else if (ch === "%" /* Modulo */ ) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else break;
            } else if (ch === $0746c8fcb985621f$var$CHAR_SP || ch === $0746c8fcb985621f$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    }
    function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $0746c8fcb985621f$var$EOF) emitError($0746c8fcb985621f$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    }
    function readListIdentifier(scnr) {
        skipSpaces(scnr);
        let value = "";
        if (scnr.currentChar() === "-") {
            scnr.next();
            value += `-${getDigits(scnr)}`;
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $0746c8fcb985621f$var$EOF) emitError($0746c8fcb985621f$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    }
    function readLiteral(scnr) {
        skipSpaces(scnr);
        eat(scnr, `\'`);
        let ch = "";
        let literal = "";
        const fn = (x)=>x !== $0746c8fcb985621f$var$LITERAL_DELIMITER && x !== $0746c8fcb985621f$var$CHAR_LF;
        while(ch = takeChar(scnr, fn))if (ch === "\\") literal += readEscapeSequence(scnr);
        else literal += ch;
        const current = scnr.currentChar();
        if (current === $0746c8fcb985621f$var$CHAR_LF || current === $0746c8fcb985621f$var$EOF) {
            emitError($0746c8fcb985621f$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $0746c8fcb985621f$var$CHAR_LF) {
                scnr.next();
                eat(scnr, `\'`);
            }
            return literal;
        }
        eat(scnr, `\'`);
        return literal;
    }
    function readEscapeSequence(scnr) {
        const ch = scnr.currentChar();
        switch(ch){
            case "\\":
            case `\'`:
                scnr.next();
                return `\\${ch}`;
            case "u":
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case "U":
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($0746c8fcb985621f$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return "";
        }
    }
    function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        let sequence = "";
        for(let i = 0; i < digits; i++){
            const ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($0746c8fcb985621f$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, `\\${unicode}${sequence}${scnr.currentChar()}`);
                break;
            }
            sequence += ch;
        }
        return `\\${unicode}${sequence}`;
    }
    function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        let ch = "";
        let identifiers = "";
        const closure = (ch)=>ch !== "{" /* BraceLeft */  && ch !== "}" /* BraceRight */  && ch !== $0746c8fcb985621f$var$CHAR_SP && ch !== $0746c8fcb985621f$var$CHAR_LF;
        while(ch = takeChar(scnr, closure))identifiers += ch;
        return identifiers;
    }
    function readLinkedModifier(scnr) {
        let ch = "";
        let name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    }
    function readLinkedRefer(scnr) {
        const fn = (detect = false, buf)=>{
            const ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */  || ch === "%" /* Modulo */  || ch === "@" /* LinkedAlias */  || ch === "|" /* Pipe */  || !ch) return buf;
            else if (ch === $0746c8fcb985621f$var$CHAR_SP) return buf;
            else if (ch === $0746c8fcb985621f$var$CHAR_LF) {
                buf += ch;
                scnr.next();
                return fn(detect, buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(true, buf);
            }
        };
        return fn(false, "");
    }
    function readPlural(scnr) {
        skipSpaces(scnr);
        const plural = eat(scnr, "|" /* Pipe */ );
        skipSpaces(scnr);
        return plural;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        let token = null;
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* BraceLeft */ :
                if (context.braceNest >= 1) emitError($0746c8fcb985621f$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* BraceLeft */ , "{" /* BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* BraceLeft */ ) emitError($0746c8fcb985621f$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* BraceRight */ , "}" /* BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* LinkedAlias */ :
                if (context.braceNest > 0) emitError($0746c8fcb985621f$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                let validNamedIdentifier = true;
                let validListIdentifier = true;
                let validLiteral = true;
                if (isPluralStart(scnr)) {
                    if (context.braceNest > 0) emitError($0746c8fcb985621f$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (context.braceNest > 0 && (context.currentType === 5 /* Named */  || context.currentType === 6 /* List */  || context.currentType === 7 /* Literal */ )) {
                    emitError($0746c8fcb985621f$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    context.braceNest = 0;
                    return readToken(scnr, context);
                }
                if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                    token = getToken(context, 5 /* Named */ , readNamedIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                    token = getToken(context, 6 /* List */ , readListIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (validLiteral = isLiteralStart(scnr, context)) {
                    token = getToken(context, 7 /* Literal */ , readLiteral(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                    // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                    token = getToken(context, 13 /* InvalidPlace */ , readInvalidIdentifier(scnr));
                    emitError($0746c8fcb985621f$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                    skipSpaces(scnr);
                    return token;
                }
                break;
        }
        return token;
    }
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        const { currentType: currentType } = context;
        let token = null;
        const ch = scnr.currentChar();
        if ((currentType === 8 /* LinkedAlias */  || currentType === 9 /* LinkedDot */  || currentType === 12 /* LinkedModifier */  || currentType === 10 /* LinkedDelimiter */ ) && (ch === $0746c8fcb985621f$var$CHAR_LF || ch === $0746c8fcb985621f$var$CHAR_SP)) emitError($0746c8fcb985621f$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* LinkedAlias */ :
                scnr.next();
                token = getToken(context, 8 /* LinkedAlias */ , "@" /* LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* LinkedDot */ , "." /* LinkedDot */ );
            case ":" /* LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* LinkedDelimiter */ , ":" /* LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 11 /* LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 8 /* LinkedAlias */ ) emitError($0746c8fcb985621f$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        let token = {
            type: 14 /* EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        const ch = scnr.currentChar();
        switch(ch){
            case "{" /* BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* BraceRight */ :
                emitError($0746c8fcb985621f$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* BraceRight */ , "}" /* BraceRight */ );
            case "@" /* LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                const { isModulo: isModulo, hasSpace: hasSpace } = detectModuloStart(scnr);
                if (isModulo) return hasSpace ? getToken(context, 0 /* Text */ , readText(scnr)) : getToken(context, 4 /* Modulo */ , readModulo(scnr));
                if (isTextStart(scnr)) return getToken(context, 0 /* Text */ , readText(scnr));
                break;
        }
        return token;
    }
    function nextToken() {
        const { currentType: currentType, offset: offset, startLoc: startLoc, endLoc: endLoc } = _context;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $0746c8fcb985621f$var$EOF) return getToken(_context, 14 /* EOF */ );
        return readToken(_scnr, _context);
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
const $0746c8fcb985621f$export$9838302824baa7fa = "parser";
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
const $0746c8fcb985621f$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $0746c8fcb985621f$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case `\\\\`:
            return `\\`;
        case `\\\'`:
            return `\'`;
        default:
            {
                const codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "�";
            }
    }
}
function $0746c8fcb985621f$export$88a1156fad04455f(options = {}) {
    const location = options.location !== false;
    const { onError: onError } = options;
    function emitError(tokenzer, code, start, offset, ...args) {
        const end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            const loc = $0746c8fcb985621f$export$90c043f1c57770b8(start, end);
            const err = $0746c8fcb985621f$export$21efa8bb37d5fecb(code, loc, {
                domain: $0746c8fcb985621f$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    }
    function startNode(type, offset, loc) {
        const node = {
            type: type,
            start: offset,
            end: offset
        };
        if (location) node.loc = {
            start: loc,
            end: loc
        };
        return node;
    }
    function endNode(node, offset, pos, type) {
        node.end = offset;
        if (type) node.type = type;
        if (location && node.loc) node.loc.end = pos;
    }
    function parseText(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(3 /* Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseList(tokenizer, index) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(5 /* List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseNamed(tokenizer, key) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(4 /* Named */ , offset, loc);
        node.key = key;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLiteral(tokenizer, value) {
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get brace left loc
        const node = startNode(9 /* Literal */ , offset, loc);
        node.value = value.replace($0746c8fcb985621f$var$KNOWN_ESCAPES, $0746c8fcb985621f$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinkedModifier(tokenizer) {
        const token = tokenizer.nextToken();
        const context = tokenizer.context();
        const { lastOffset: offset, lastStartLoc: loc } = context; // get linked dot loc
        const node = startNode(8 /* LinkedModifier */ , offset, loc);
        if (token.type !== 12 /* LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = "";
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
        node.value = token.value || "";
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    }
    function parseLinkedKey(tokenizer, value) {
        const context = tokenizer.context();
        const node = startNode(7 /* LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseLinked(tokenizer) {
        const context = tokenizer.context();
        const linkedNode = startNode(6 /* Linked */ , context.offset, context.startLoc);
        let token = tokenizer.nextToken();
        if (token.type === 9 /* LinkedDot */ ) {
            const parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* LinkedDelimiter */ ) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 11 /* LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
                break;
            case 5 /* Named */ :
                if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || "");
                break;
            case 6 /* List */ :
                if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || "");
                break;
            case 7 /* Literal */ :
                if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || "");
                break;
            default:
                // empty key
                emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                const nextContext = tokenizer.context();
                const emptyLinkedKeyNode = startNode(7 /* LinkedKey */ , nextContext.offset, nextContext.startLoc);
                emptyLinkedKeyNode.value = "";
                endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                linkedNode.key = emptyLinkedKeyNode;
                endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                return {
                    nextConsumeToken: token,
                    node: linkedNode
                };
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    }
    function parseMessage(tokenizer) {
        const context = tokenizer.context();
        const startOffset = context.currentType === 1 /* Pipe */  ? tokenizer.currentOffset() : context.offset;
        const startLoc = context.currentType === 1 /* Pipe */  ? context.endLoc : context.startLoc;
        const node = startNode(2 /* Message */ , startOffset, startLoc);
        node.items = [];
        let nextToken = null;
        do {
            const token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* Text */ :
                    if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ""));
                    break;
                case 6 /* List */ :
                    if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ""));
                    break;
                case 5 /* Named */ :
                    if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || ""));
                    break;
                case 7 /* Literal */ :
                    if (token.value == null) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $0746c8fcb985621f$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ""));
                    break;
                case 8 /* LinkedAlias */ :
                    const parsed = parseLinked(tokenizer);
                    node.items.push(parsed.node);
                    nextToken = parsed.nextConsumeToken || null;
                    break;
            }
        }while (context.currentType !== 14 /* EOF */  && context.currentType !== 1 /* Pipe */ );
        // adjust message node loc
        const endOffset = context.currentType === 1 /* Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        const endLoc = context.currentType === 1 /* Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    }
    function parsePlural(tokenizer, offset, loc, msgNode) {
        const context = tokenizer.context();
        let hasEmptyMessage = msgNode.items.length === 0;
        const node = startNode(1 /* Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            const msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 14 /* EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    function parseResource(tokenizer) {
        const context = tokenizer.context();
        const { offset: offset, startLoc: startLoc } = context;
        const msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    }
    function parse(source) {
        const tokenizer = $0746c8fcb985621f$var$createTokenizer(source, (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, options));
        const context = tokenizer.context();
        const node = startNode(0 /* Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* EOF */ ) emitError(tokenizer, $0746c8fcb985621f$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || "");
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    }
    return {
        parse: parse
    };
}
function $0746c8fcb985621f$var$getTokenCaption(token) {
    if (token.type === 14 /* EOF */ ) return "EOF";
    const name = (token.value || "").replace(/\r?\n/gu, "\\n");
    return name.length > 10 ? name.slice(0, 9) + "…" : name;
}
function $0746c8fcb985621f$var$createTransformer(ast, options = {} // eslint-disable-line
) {
    const _context = {
        ast: ast,
        helpers: new Set()
    };
    const context = ()=>_context;
    const helper = (name)=>{
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $0746c8fcb985621f$var$traverseNodes(nodes, transformer) {
    for(let i = 0; i < nodes.length; i++)$0746c8fcb985621f$var$traverseNode(nodes[i], transformer);
}
function $0746c8fcb985621f$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* Plural */ :
            $0746c8fcb985621f$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* PLURAL */ );
            break;
        case 2 /* Message */ :
            $0746c8fcb985621f$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* Linked */ :
            const linked = node;
            $0746c8fcb985621f$var$traverseNode(linked.key, transformer);
            transformer.helper("linked" /* LINKED */ );
            transformer.helper("type" /* TYPE */ );
            break;
        case 5 /* List */ :
            transformer.helper("interpolate" /* INTERPOLATE */ );
            transformer.helper("list" /* LIST */ );
            break;
        case 4 /* Named */ :
            transformer.helper("interpolate" /* INTERPOLATE */ );
            transformer.helper("named" /* NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $0746c8fcb985621f$var$transform(ast, options = {} // eslint-disable-line
) {
    const transformer = $0746c8fcb985621f$var$createTransformer(ast);
    transformer.helper("normalize" /* NORMALIZE */ );
    // traverse
    ast.body && $0746c8fcb985621f$var$traverseNode(ast.body, transformer);
    // set meta information
    const context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $0746c8fcb985621f$var$createCodeGenerator(ast, options) {
    const { sourceMap: sourceMap, filename: filename, breakLineCode: breakLineCode, needIndent: _needIndent } = options;
    const _context = {
        source: ast.loc.source,
        filename: filename,
        code: "",
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    const context = ()=>_context;
    function push(code, node) {
        _context.code += code;
    }
    function _newline(n, withBreakLine = true) {
        const _breakLineCode = withBreakLine ? breakLineCode : "";
        push(_needIndent ? _breakLineCode + `  `.repeat(n) : _breakLineCode);
    }
    function indent(withNewLine = true) {
        const level = ++_context.indentLevel;
        withNewLine && _newline(level);
    }
    function deindent(withNewLine = true) {
        const level = --_context.indentLevel;
        withNewLine && _newline(level);
    }
    function newline() {
        _newline(_context.indentLevel);
    }
    const helper = (key)=>`_${key}`;
    const needIndent = ()=>_context.needIndent;
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $0746c8fcb985621f$var$generateLinkedNode(generator, node) {
    const { helper: helper } = generator;
    generator.push(`${helper("linked" /* LINKED */ )}(`);
    $0746c8fcb985621f$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(`, `);
        $0746c8fcb985621f$var$generateNode(generator, node.modifier);
        generator.push(`, _type`);
    } else generator.push(`, undefined, _type`);
    generator.push(`)`);
}
function $0746c8fcb985621f$var$generateMessageNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    generator.push(`${helper("normalize" /* NORMALIZE */ )}([`);
    generator.indent(needIndent());
    const length = node.items.length;
    for(let i = 0; i < length; i++){
        $0746c8fcb985621f$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push("])");
}
function $0746c8fcb985621f$var$generatePluralNode(generator, node) {
    const { helper: helper, needIndent: needIndent } = generator;
    if (node.cases.length > 1) {
        generator.push(`${helper("plural" /* PLURAL */ )}([`);
        generator.indent(needIndent());
        const length = node.cases.length;
        for(let i = 0; i < length; i++){
            $0746c8fcb985621f$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(", ");
        }
        generator.deindent(needIndent());
        generator.push(`])`);
    }
}
function $0746c8fcb985621f$var$generateResource(generator, node) {
    if (node.body) $0746c8fcb985621f$var$generateNode(generator, node.body);
    else generator.push("null");
}
function $0746c8fcb985621f$var$generateNode(generator, node) {
    const { helper: helper } = generator;
    switch(node.type){
        case 0 /* Resource */ :
            $0746c8fcb985621f$var$generateResource(generator, node);
            break;
        case 1 /* Plural */ :
            $0746c8fcb985621f$var$generatePluralNode(generator, node);
            break;
        case 2 /* Message */ :
            $0746c8fcb985621f$var$generateMessageNode(generator, node);
            break;
        case 6 /* Linked */ :
            $0746c8fcb985621f$var$generateLinkedNode(generator, node);
            break;
        case 8 /* LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* List */ :
            generator.push(`${helper("interpolate" /* INTERPOLATE */ )}(${helper("list" /* LIST */ )}(${node.index}))`, node);
            break;
        case 4 /* Named */ :
            generator.push(`${helper("interpolate" /* INTERPOLATE */ )}(${helper("named" /* NAMED */ )}(${JSON.stringify(node.key)}))`, node);
            break;
        case 9 /* Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
    }
}
// generate code from AST
const $0746c8fcb985621f$var$generate = (ast, options = {} // eslint-disable-line
)=>{
    const mode = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.mode) ? options.mode : "normal";
    const filename = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.filename) ? options.filename : "message.intl";
    const sourceMap = !!options.sourceMap;
    // prettier-ignore
    const breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
    const needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
    const helpers = ast.helpers || [];
    const generator = $0746c8fcb985621f$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === "normal" ? `function __msg__ (ctx) {` : `(ctx) => {`);
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push(`const { ${helpers.map((s)=>`${s}: _${s}`).join(", ")} } = ctx`);
        generator.newline();
    }
    generator.push(`return `);
    $0746c8fcb985621f$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push(`}`);
    const { code: code, map: map } = generator.context();
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $0746c8fcb985621f$export$3243579822c486a0(source, options = {}) {
    const assignedOptions = (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, options);
    // parse source codes
    const parser = $0746c8fcb985621f$export$88a1156fad04455f(assignedOptions);
    const ast = parser.parse(source);
    // transform ASTs
    $0746c8fcb985621f$var$transform(ast, assignedOptions);
    // generate javascript codes
    return $0746c8fcb985621f$var$generate(ast, assignedOptions);
}


/*!
  * devtools-if v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ const $64327d4c34e920e5$export$2058f72d18e5183a = {
    I18nInit: "i18n:init",
    FunctionTranslate: "function:translate"
};


const $17caac8d5bf4dbbf$var$pathStateMachine = [];
$17caac8d5bf4dbbf$var$pathStateMachine[0 /* BEFORE_PATH */ ] = {
    ["w" /* WORKSPACE */ ]: [
        0 /* BEFORE_PATH */ 
    ],
    ["i" /* IDENT */ ]: [
        3 /* IN_IDENT */ ,
        0 /* APPEND */ 
    ],
    ["[" /* LEFT_BRACKET */ ]: [
        4 /* IN_SUB_PATH */ 
    ],
    ["o" /* END_OF_FAIL */ ]: [
        7 /* AFTER_PATH */ 
    ]
};
$17caac8d5bf4dbbf$var$pathStateMachine[1 /* IN_PATH */ ] = {
    ["w" /* WORKSPACE */ ]: [
        1 /* IN_PATH */ 
    ],
    ["." /* DOT */ ]: [
        2 /* BEFORE_IDENT */ 
    ],
    ["[" /* LEFT_BRACKET */ ]: [
        4 /* IN_SUB_PATH */ 
    ],
    ["o" /* END_OF_FAIL */ ]: [
        7 /* AFTER_PATH */ 
    ]
};
$17caac8d5bf4dbbf$var$pathStateMachine[2 /* BEFORE_IDENT */ ] = {
    ["w" /* WORKSPACE */ ]: [
        2 /* BEFORE_IDENT */ 
    ],
    ["i" /* IDENT */ ]: [
        3 /* IN_IDENT */ ,
        0 /* APPEND */ 
    ],
    ["0" /* ZERO */ ]: [
        3 /* IN_IDENT */ ,
        0 /* APPEND */ 
    ]
};
$17caac8d5bf4dbbf$var$pathStateMachine[3 /* IN_IDENT */ ] = {
    ["i" /* IDENT */ ]: [
        3 /* IN_IDENT */ ,
        0 /* APPEND */ 
    ],
    ["0" /* ZERO */ ]: [
        3 /* IN_IDENT */ ,
        0 /* APPEND */ 
    ],
    ["w" /* WORKSPACE */ ]: [
        1 /* IN_PATH */ ,
        1 /* PUSH */ 
    ],
    ["." /* DOT */ ]: [
        2 /* BEFORE_IDENT */ ,
        1 /* PUSH */ 
    ],
    ["[" /* LEFT_BRACKET */ ]: [
        4 /* IN_SUB_PATH */ ,
        1 /* PUSH */ 
    ],
    ["o" /* END_OF_FAIL */ ]: [
        7 /* AFTER_PATH */ ,
        1 /* PUSH */ 
    ]
};
$17caac8d5bf4dbbf$var$pathStateMachine[4 /* IN_SUB_PATH */ ] = {
    ["'" /* SINGLE_QUOTE */ ]: [
        5 /* IN_SINGLE_QUOTE */ ,
        0 /* APPEND */ 
    ],
    ['"' /* DOUBLE_QUOTE */ ]: [
        6 /* IN_DOUBLE_QUOTE */ ,
        0 /* APPEND */ 
    ],
    ["[" /* LEFT_BRACKET */ ]: [
        4 /* IN_SUB_PATH */ ,
        2 /* INC_SUB_PATH_DEPTH */ 
    ],
    ["]" /* RIGHT_BRACKET */ ]: [
        1 /* IN_PATH */ ,
        3 /* PUSH_SUB_PATH */ 
    ],
    ["o" /* END_OF_FAIL */ ]: 8 /* ERROR */ ,
    ["l" /* ELSE */ ]: [
        4 /* IN_SUB_PATH */ ,
        0 /* APPEND */ 
    ]
};
$17caac8d5bf4dbbf$var$pathStateMachine[5 /* IN_SINGLE_QUOTE */ ] = {
    ["'" /* SINGLE_QUOTE */ ]: [
        4 /* IN_SUB_PATH */ ,
        0 /* APPEND */ 
    ],
    ["o" /* END_OF_FAIL */ ]: 8 /* ERROR */ ,
    ["l" /* ELSE */ ]: [
        5 /* IN_SINGLE_QUOTE */ ,
        0 /* APPEND */ 
    ]
};
$17caac8d5bf4dbbf$var$pathStateMachine[6 /* IN_DOUBLE_QUOTE */ ] = {
    ['"' /* DOUBLE_QUOTE */ ]: [
        4 /* IN_SUB_PATH */ ,
        0 /* APPEND */ 
    ],
    ["o" /* END_OF_FAIL */ ]: 8 /* ERROR */ ,
    ["l" /* ELSE */ ]: [
        6 /* IN_DOUBLE_QUOTE */ ,
        0 /* APPEND */ 
    ]
};
/**
 * Check if an expression is a literal value.
 */ const $17caac8d5bf4dbbf$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $17caac8d5bf4dbbf$var$isLiteral(exp) {
    return $17caac8d5bf4dbbf$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $17caac8d5bf4dbbf$var$stripQuotes(str) {
    const a = str.charCodeAt(0);
    const b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $17caac8d5bf4dbbf$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* END_OF_FAIL */ ;
    const code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* WORKSPACE */ ;
    }
    return "i" /* IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $17caac8d5bf4dbbf$var$formatSubPath(path) {
    const trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === "0" && isNaN(parseInt(path))) return false;
    return $17caac8d5bf4dbbf$var$isLiteral(trimmed) ? $17caac8d5bf4dbbf$var$stripQuotes(trimmed) : "*" /* ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $17caac8d5bf4dbbf$export$98e6a39c04603d36(path) {
    const keys = [];
    let index = -1;
    let mode = 0 /* BEFORE_PATH */ ;
    let subPathDepth = 0;
    let c;
    let key; // eslint-disable-line
    let newChar;
    let type;
    let transition;
    let action;
    let typeMap;
    const actions = [];
    actions[0 /* APPEND */ ] = ()=>{
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* PUSH */ ] = ()=>{
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* INC_SUB_PATH_DEPTH */ ] = ()=>{
        actions[0 /* APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* PUSH_SUB_PATH */ ] = ()=>{
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* IN_SUB_PATH */ ;
            actions[0 /* APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $17caac8d5bf4dbbf$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* PUSH */ ]();
        }
    };
    function maybeUnescapeQuote() {
        const nextChar = path[index + 1];
        if (mode === 5 /* IN_SINGLE_QUOTE */  && nextChar === "'" /* SINGLE_QUOTE */  || mode === 6 /* IN_DOUBLE_QUOTE */  && nextChar === '"' /* DOUBLE_QUOTE */ ) {
            index++;
            newChar = "\\" + nextChar;
            actions[0 /* APPEND */ ]();
            return true;
        }
    }
    while(mode !== null){
        index++;
        c = path[index];
        if (c === "\\" && maybeUnescapeQuote()) continue;
        type = $17caac8d5bf4dbbf$var$getPathCharType(c);
        typeMap = $17caac8d5bf4dbbf$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* ELSE */ ] || 8 /* ERROR */ ;
        // check parse error
        if (transition === 8 /* ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* AFTER_PATH */ ) return keys;
    }
}
// path token cache
const $17caac8d5bf4dbbf$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $17caac8d5bf4dbbf$export$b365de4c3506886c(obj, path) {
    return (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $17caac8d5bf4dbbf$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(obj)) return null;
    // parse path
    let hit = $17caac8d5bf4dbbf$var$cache.get(path);
    if (!hit) {
        hit = $17caac8d5bf4dbbf$export$98e6a39c04603d36(path);
        if (hit) $17caac8d5bf4dbbf$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    const len = hit.length;
    let last = obj;
    let i = 0;
    while(i < len){
        const val = last[hit[i]];
        if (val === undefined) return null;
        last = val;
        i++;
    }
    return last;
}
const $17caac8d5bf4dbbf$var$DEFAULT_MODIFIER = (str)=>str;
const $17caac8d5bf4dbbf$var$DEFAULT_MESSAGE = (ctx)=>""; // eslint-disable-line
const $17caac8d5bf4dbbf$export$12b53af6b8529bfc = "text";
const $17caac8d5bf4dbbf$var$DEFAULT_NORMALIZE = (values)=>values.length === 0 ? "" : values.join("");
const $17caac8d5bf4dbbf$var$DEFAULT_INTERPOLATE = (0, $82c18ee15207f03a$export$b5b1545233b45293);
function $17caac8d5bf4dbbf$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $17caac8d5bf4dbbf$var$getPluralIndex(options) {
    // prettier-ignore
    const index = (0, $82c18ee15207f03a$export$7e4aa119212bc614)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(options.named.count) || (0, $82c18ee15207f03a$export$7e4aa119212bc614)(options.named.n)) ? (0, $82c18ee15207f03a$export$7e4aa119212bc614)(options.named.count) ? options.named.count : (0, $82c18ee15207f03a$export$7e4aa119212bc614)(options.named.n) ? options.named.n : index : index;
}
function $17caac8d5bf4dbbf$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $17caac8d5bf4dbbf$export$70de3b14beda2f5e(options = {}) {
    const locale = options.locale;
    const pluralIndex = $17caac8d5bf4dbbf$var$getPluralIndex(options);
    const pluralRule = (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $82c18ee15207f03a$export$844ec244b1367d54)(locale) && (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? options.pluralRules[locale] : $17caac8d5bf4dbbf$var$pluralDefault;
    const orgPluralRule = (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $82c18ee15207f03a$export$844ec244b1367d54)(locale) && (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? $17caac8d5bf4dbbf$var$pluralDefault : undefined;
    const plural = (messages)=>{
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    const _list = options.list || [];
    const list = (index)=>_list[index];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const _named = options.named || {};
    (0, $82c18ee15207f03a$export$7e4aa119212bc614)(options.pluralIndex) && $17caac8d5bf4dbbf$var$normalizeNamed(pluralIndex, _named);
    const named = (key)=>_named[key];
    function message(key) {
        // prettier-ignore
        const msg = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.messages) ? options.messages(key) : (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $17caac8d5bf4dbbf$var$DEFAULT_MESSAGE : msg;
    }
    const _modifier = (name)=>options.modifiers ? options.modifiers[name] : $17caac8d5bf4dbbf$var$DEFAULT_MODIFIER;
    const normalize = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.processor) && (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.processor.normalize) ? options.processor.normalize : $17caac8d5bf4dbbf$var$DEFAULT_NORMALIZE;
    const interpolate = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.processor) && (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.processor.interpolate) ? options.processor.interpolate : $17caac8d5bf4dbbf$var$DEFAULT_INTERPOLATE;
    const type = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.processor) && (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.processor.type) ? options.processor.type : $17caac8d5bf4dbbf$export$12b53af6b8529bfc;
    const linked = (key, ...args)=>{
        const [arg1, arg2] = args;
        let type = "text";
        let modifier = "";
        if (args.length === 1) {
            if ((0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            } else if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
        } else if (args.length === 2) {
            if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
            if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg2)) type = arg2 || type;
        }
        let msg = message(key)(ctx);
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        if (type === "vnode" && (0, $82c18ee15207f03a$export$43bee75e5e14138e)(msg) && modifier) msg = msg[0];
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    const ctx = {
        ["list" /* LIST */ ]: list,
        ["named" /* NAMED */ ]: named,
        ["plural" /* PLURAL */ ]: plural,
        ["linked" /* LINKED */ ]: linked,
        ["message" /* MESSAGE */ ]: message,
        ["type" /* TYPE */ ]: type,
        ["interpolate" /* INTERPOLATE */ ]: interpolate,
        ["normalize" /* NORMALIZE */ ]: normalize
    };
    return ctx;
}
let $17caac8d5bf4dbbf$var$devtools = null;
function $17caac8d5bf4dbbf$export$c893d6c8966908b9(hook) {
    $17caac8d5bf4dbbf$var$devtools = hook;
}
function $17caac8d5bf4dbbf$export$8bd08e70642dc6f4() {
    return $17caac8d5bf4dbbf$var$devtools;
}
function $17caac8d5bf4dbbf$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $17caac8d5bf4dbbf$var$devtools && $17caac8d5bf4dbbf$var$devtools.emit((0, $64327d4c34e920e5$export$2058f72d18e5183a).I18nInit, {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
const $17caac8d5bf4dbbf$export$190d71a47ff3f767 = /* #__PURE__*/ $17caac8d5bf4dbbf$var$createDevToolsHook((0, $64327d4c34e920e5$export$2058f72d18e5183a).FunctionTranslate);
function $17caac8d5bf4dbbf$var$createDevToolsHook(hook) {
    return (payloads)=>$17caac8d5bf4dbbf$var$devtools && $17caac8d5bf4dbbf$var$devtools.emit(hook, payloads);
}
const $17caac8d5bf4dbbf$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: 1,
    FALLBACK_TO_TRANSLATE: 2,
    CANNOT_FORMAT_NUMBER: 3,
    FALLBACK_TO_NUMBER_FORMAT: 4,
    CANNOT_FORMAT_DATE: 5,
    FALLBACK_TO_DATE_FORMAT: 6,
    __EXTEND_POINT__: 7
};
/** @internal */ const $17caac8d5bf4dbbf$var$warnMessages = {
    [$17caac8d5bf4dbbf$export$b6a676a18b27d4c8.NOT_FOUND_KEY]: `Not found '{key}' key in '{locale}' locale messages.`,
    [$17caac8d5bf4dbbf$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE]: `Fall back to translate '{key}' key with '{target}' locale.`,
    [$17caac8d5bf4dbbf$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER]: `Cannot format a number value due to not supported Intl.NumberFormat.`,
    [$17caac8d5bf4dbbf$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT]: `Fall back to number format '{key}' key with '{target}' locale.`,
    [$17caac8d5bf4dbbf$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE]: `Cannot format a date value due to not supported Intl.DateTimeFormat.`,
    [$17caac8d5bf4dbbf$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT]: `Fall back to datetime format '{key}' key with '{target}' locale.`
};
function $17caac8d5bf4dbbf$export$ae7a7631f2b2bb7(code, ...args) {
    return (0, $82c18ee15207f03a$export$d9468344d3651243)($17caac8d5bf4dbbf$var$warnMessages[code], ...args);
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $17caac8d5bf4dbbf$export$e3330076537ef9d1(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return [
        ...new Set([
            start,
            ...(0, $82c18ee15207f03a$export$43bee75e5e14138e)(fallback) ? fallback : (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(fallback) ? Object.keys(fallback) : (0, $82c18ee15207f03a$export$844ec244b1367d54)(fallback) ? [
                fallback
            ] : [
                start
            ]
        ])
    ];
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $17caac8d5bf4dbbf$export$71df9db82dc445(ctx, fallback, start) {
    const startLocale = (0, $82c18ee15207f03a$export$844ec244b1367d54)(start) ? start : $17caac8d5bf4dbbf$export$1af4c7e47ad72f44;
    const context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    let chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        let block = [
            start
        ];
        // while any intervening block found
        while((0, $82c18ee15207f03a$export$43bee75e5e14138e)(block))block = $17caac8d5bf4dbbf$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        const defaults = (0, $82c18ee15207f03a$export$43bee75e5e14138e)(fallback) || !(0, $82c18ee15207f03a$export$53b83ca8eaab0383)(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
        // convert defaults to array
        block = (0, $82c18ee15207f03a$export$844ec244b1367d54)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(block)) $17caac8d5bf4dbbf$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $17caac8d5bf4dbbf$var$appendBlockToChain(chain, block, blocks) {
    let follow = true;
    for(let i = 0; i < block.length && (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(follow); i++){
        const locale = block[i];
        if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(locale)) follow = $17caac8d5bf4dbbf$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $17caac8d5bf4dbbf$var$appendLocaleToChain(chain, locale, blocks) {
    let follow;
    const tokens = locale.split("-");
    do {
        const target = tokens.join("-");
        follow = $17caac8d5bf4dbbf$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $17caac8d5bf4dbbf$var$appendItemToChain(chain, target, blocks) {
    let follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== "!";
            const locale = target.replace(/!/g, "");
            chain.push(locale);
            if (((0, $82c18ee15207f03a$export$43bee75e5e14138e)(blocks) || (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ const $17caac8d5bf4dbbf$export$a4ad2735b021c132 = "9.2.2";
const $17caac8d5bf4dbbf$export$b7f13a18d1d0f835 = -1;
const $17caac8d5bf4dbbf$export$1af4c7e47ad72f44 = "en-US";
const $17caac8d5bf4dbbf$export$a04371e9dbb3870b = "";
const $17caac8d5bf4dbbf$var$capitalize = (str)=>`${str.charAt(0).toLocaleUpperCase()}${str.substr(1)}`;
function $17caac8d5bf4dbbf$var$getDefaultLinkedModifiers() {
    return {
        upper: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $82c18ee15207f03a$export$844ec244b1367d54)(val) ? val.toUpperCase() : type === "vnode" && (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val;
        },
        lower: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $82c18ee15207f03a$export$844ec244b1367d54)(val) ? val.toLowerCase() : type === "vnode" && (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val;
        },
        capitalize: (val, type)=>{
            // prettier-ignore
            return type === "text" && (0, $82c18ee15207f03a$export$844ec244b1367d54)(val) ? $17caac8d5bf4dbbf$var$capitalize(val) : type === "vnode" && (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? $17caac8d5bf4dbbf$var$capitalize(val.children) : val;
        }
    };
}
let $17caac8d5bf4dbbf$var$_compiler;
function $17caac8d5bf4dbbf$export$6ee2fbe83628b40b(compiler) {
    $17caac8d5bf4dbbf$var$_compiler = compiler;
}
let $17caac8d5bf4dbbf$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $17caac8d5bf4dbbf$export$45dacdc710815463(resolver) {
    $17caac8d5bf4dbbf$var$_resolver = resolver;
}
let $17caac8d5bf4dbbf$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $17caac8d5bf4dbbf$export$fd8ec9dd8067edec(fallbacker) {
    $17caac8d5bf4dbbf$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
let $17caac8d5bf4dbbf$var$_additionalMeta = null;
const $17caac8d5bf4dbbf$export$605703447dca72aa = (meta)=>{
    $17caac8d5bf4dbbf$var$_additionalMeta = meta;
};
const $17caac8d5bf4dbbf$export$817795a14e5c6622 = ()=>$17caac8d5bf4dbbf$var$_additionalMeta;
let $17caac8d5bf4dbbf$var$_fallbackContext = null;
const $17caac8d5bf4dbbf$export$e16aca6786e72a5e = (context)=>{
    $17caac8d5bf4dbbf$var$_fallbackContext = context;
};
const $17caac8d5bf4dbbf$export$3adddc434faa9e35 = ()=>$17caac8d5bf4dbbf$var$_fallbackContext;
// ID for CoreContext
let $17caac8d5bf4dbbf$var$_cid = 0;
function $17caac8d5bf4dbbf$export$3599d465b05a74a5(options = {}) {
    // setup options
    const version = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.version) ? options.version : $17caac8d5bf4dbbf$export$a4ad2735b021c132;
    const locale = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.locale) ? options.locale : $17caac8d5bf4dbbf$export$1af4c7e47ad72f44;
    const fallbackLocale = (0, $82c18ee15207f03a$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.fallbackLocale) || (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    const messages = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.messages) ? options.messages : {
        [locale]: {}
    };
    const datetimeFormats = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [locale]: {}
    };
    const numberFormats = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [locale]: {}
    };
    const modifiers = (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, options.modifiers || {}, $17caac8d5bf4dbbf$var$getDefaultLinkedModifiers());
    const pluralRules = options.pluralRules || {};
    const missing = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    const missingWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $82c18ee15207f03a$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    const fallbackWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $82c18ee15207f03a$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    const fallbackFormat = !!options.fallbackFormat;
    const unresolving = !!options.unresolving;
    const postTranslation = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    const processor = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.processor) ? options.processor : null;
    const warnHtmlMessage = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const escapeParameter = !!options.escapeParameter;
    const messageCompiler = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.messageCompiler) ? options.messageCompiler : $17caac8d5bf4dbbf$var$_compiler;
    const messageResolver = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.messageResolver) ? options.messageResolver : $17caac8d5bf4dbbf$var$_resolver || $17caac8d5bf4dbbf$export$b365de4c3506886c;
    const localeFallbacker = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.localeFallbacker) ? options.localeFallbacker : $17caac8d5bf4dbbf$var$_fallbacker || $17caac8d5bf4dbbf$export$e3330076537ef9d1;
    const fallbackContext = (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(options.fallbackContext) ? options.fallbackContext : undefined;
    const onWarn = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.onWarn) ? options.onWarn : (0, $82c18ee15207f03a$export$c106dd0671a0fc2d);
    // setup internal options
    const internalOptions = options;
    const __datetimeFormatters = (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    const __numberFormatters = (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    const __meta = (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(internalOptions.__meta) ? internalOptions.__meta : {};
    $17caac8d5bf4dbbf$var$_cid++;
    const context = {
        version: version,
        cid: $17caac8d5bf4dbbf$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        fallbackContext: fallbackContext,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) $17caac8d5bf4dbbf$export$725afc6a300324a0(context, version, __meta);
    return context;
}
/** @internal */ function $17caac8d5bf4dbbf$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $17caac8d5bf4dbbf$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $17caac8d5bf4dbbf$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    const { missing: missing, onWarn: onWarn } = context;
    if (missing !== null) {
        const ret = missing(context, locale, key, type);
        return (0, $82c18ee15207f03a$export$844ec244b1367d54)(ret) ? ret : key;
    } else return key;
}
/** @internal */ function $17caac8d5bf4dbbf$export$c743ad8a3cc01530(ctx, locale, fallback) {
    const context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ const $17caac8d5bf4dbbf$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
const $17caac8d5bf4dbbf$var$WARN_MESSAGE = `Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.`;
function $17caac8d5bf4dbbf$var$checkHtmlMessage(source, options) {
    const warnHtmlMessage = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    if (warnHtmlMessage && $17caac8d5bf4dbbf$var$RE_HTML_TAG.test(source)) (0, $82c18ee15207f03a$export$c106dd0671a0fc2d)((0, $82c18ee15207f03a$export$d9468344d3651243)($17caac8d5bf4dbbf$var$WARN_MESSAGE, {
        source: source
    }));
}
const $17caac8d5bf4dbbf$var$defaultOnCacheKey = (source)=>source;
let $17caac8d5bf4dbbf$var$compileCache = Object.create(null);
function $17caac8d5bf4dbbf$export$2683c80ae3fe544() {
    $17caac8d5bf4dbbf$var$compileCache = Object.create(null);
}
function $17caac8d5bf4dbbf$export$1ea8807c727891fc(source, options = {}) {
    {
        // check caches
        const onCacheKey = options.onCacheKey || $17caac8d5bf4dbbf$var$defaultOnCacheKey;
        const key = onCacheKey(source);
        const cached = $17caac8d5bf4dbbf$var$compileCache[key];
        if (cached) return cached;
        // compile error detecting
        let occurred = false;
        const onError = options.onError || (0, $0746c8fcb985621f$export$ad0eb2c702f03471);
        options.onError = (err)=>{
            occurred = true;
            onError(err);
        };
        // compile
        const { code: code } = (0, $0746c8fcb985621f$export$3243579822c486a0)(source, options);
        // evaluate function
        const msg = new Function(`return ${code}`)();
        // if occurred compile error, don't cache
        return !occurred ? $17caac8d5bf4dbbf$var$compileCache[key] = msg : msg;
    }
}
let $17caac8d5bf4dbbf$var$code = (0, $0746c8fcb985621f$export$77436aae039469c4).__EXTEND_POINT__;
const $17caac8d5bf4dbbf$var$inc = ()=>++$17caac8d5bf4dbbf$var$code;
const $17caac8d5bf4dbbf$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: $17caac8d5bf4dbbf$var$code,
    INVALID_DATE_ARGUMENT: $17caac8d5bf4dbbf$var$inc(),
    INVALID_ISO_DATE_ARGUMENT: $17caac8d5bf4dbbf$var$inc(),
    __EXTEND_POINT__: $17caac8d5bf4dbbf$var$inc() // 18
};
function $17caac8d5bf4dbbf$export$3d702f7ac45b0a6b(code) {
    return (0, $0746c8fcb985621f$export$21efa8bb37d5fecb)(code, null, undefined);
}
/** @internal */ const $17caac8d5bf4dbbf$var$errorMessages = {
    [$17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_ARGUMENT]: "Invalid arguments",
    [$17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
    [$17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string"
};
const $17caac8d5bf4dbbf$var$NOOP_MESSAGE_FUNCTION = ()=>"";
const $17caac8d5bf4dbbf$export$92c0a039cf358271 = (val)=>(0, $82c18ee15207f03a$export$f6e2535fb5126e54)(val);
// implementation of `translate` function
function $17caac8d5bf4dbbf$export$d73ee8ef04f5226a(context, ...args) {
    const { fallbackFormat: fallbackFormat, postTranslation: postTranslation, unresolving: unresolving, messageCompiler: messageCompiler, fallbackLocale: fallbackLocale, messages: messages } = context;
    const [key, options] = $17caac8d5bf4dbbf$export$8d9616744e22681a(...args);
    const missingWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const escapeParameter = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    const resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    const defaultMsgOrKey = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.default) || (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.default) // default by function option
     ? !(0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.default) ? options.default : !messageCompiler ? ()=>key : key : fallbackFormat // default by `fallbackFormat` option
     ? !messageCompiler ? ()=>key : key : "";
    const enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
    const locale = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    // escape params
    escapeParameter && $17caac8d5bf4dbbf$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    let [formatScope, targetLocale, message] = !resolvedMessage ? $17caac8d5bf4dbbf$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || {}
    ];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    let format = formatScope;
    // if you use default message, set it as message format!
    let cacheBaseKey = key;
    if (!resolvedMessage && !((0, $82c18ee15207f03a$export$844ec244b1367d54)(format) || $17caac8d5bf4dbbf$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $82c18ee15207f03a$export$844ec244b1367d54)(format) || $17caac8d5bf4dbbf$export$92c0a039cf358271(format)) || !(0, $82c18ee15207f03a$export$844ec244b1367d54)(targetLocale))) return unresolving ? $17caac8d5bf4dbbf$export$b7f13a18d1d0f835 : key;
    // setup compile error detecting
    let occurred = false;
    const errorDetector = ()=>{
        occurred = true;
    };
    // compile message format
    const msg = !$17caac8d5bf4dbbf$export$92c0a039cf358271(format) ? $17caac8d5bf4dbbf$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    const ctxOptions = $17caac8d5bf4dbbf$var$getMessageContextOptions(context, targetLocale, message, options);
    const msgContext = $17caac8d5bf4dbbf$export$70de3b14beda2f5e(ctxOptions);
    const messaged = $17caac8d5bf4dbbf$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    const ret = postTranslation ? postTranslation(messaged, key) : messaged;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        const payloads = {
            timestamp: Date.now(),
            key: (0, $82c18ee15207f03a$export$844ec244b1367d54)(key) ? key : $17caac8d5bf4dbbf$export$92c0a039cf358271(format) ? format.key : "",
            locale: targetLocale || ($17caac8d5bf4dbbf$export$92c0a039cf358271(format) ? format.locale : ""),
            format: (0, $82c18ee15207f03a$export$844ec244b1367d54)(format) ? format : $17caac8d5bf4dbbf$export$92c0a039cf358271(format) ? format.source : "",
            message: ret
        };
        payloads.meta = (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, context.__meta, $17caac8d5bf4dbbf$export$817795a14e5c6622() || {});
        $17caac8d5bf4dbbf$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $17caac8d5bf4dbbf$var$escapeParams(options) {
    if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(options.list)) options.list = options.list.map((item)=>(0, $82c18ee15207f03a$export$844ec244b1367d54)(item) ? (0, $82c18ee15207f03a$export$4cf11838cdc2a8a8)(item) : item);
    else if ((0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(options.named)) Object.keys(options.named).forEach((key)=>{
        if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(options.named[key])) options.named[key] = (0, $82c18ee15207f03a$export$4cf11838cdc2a8a8)(options.named[key]);
    });
}
function $17caac8d5bf4dbbf$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    const { messages: messages, onWarn: onWarn, messageResolver: resolveValue, localeFallbacker: localeFallbacker } = context;
    const locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    let message = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "translate";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        message = messages[targetLocale] || {};
        // for vue-devtools timeline event
        let start = null;
        let startTag;
        let endTag;
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(format) || (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(format)) break;
        const missingRet = $17caac8d5bf4dbbf$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
        if (missingRet !== key) format = missingRet;
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $17caac8d5bf4dbbf$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) {
    const { messageCompiler: messageCompiler, warnHtmlMessage: warnHtmlMessage } = context;
    if ($17caac8d5bf4dbbf$export$92c0a039cf358271(format)) {
        const msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        const msg = ()=>format;
        msg.locale = targetLocale;
        msg.key = key;
        return msg;
    }
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const msg = messageCompiler(format, $17caac8d5bf4dbbf$var$getCompileOptions(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, errorDetector));
    msg.locale = targetLocale;
    msg.key = key;
    msg.source = format;
    return msg;
}
function $17caac8d5bf4dbbf$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    let start = null;
    let startTag;
    let endTag;
    const messaged = msg(msgCtx);
    return messaged;
}
/** @internal */ function $17caac8d5bf4dbbf$export$8d9616744e22681a(...args) {
    const [arg1, arg2, arg3] = args;
    const options = {};
    if (!(0, $82c18ee15207f03a$export$844ec244b1367d54)(arg1) && !(0, $82c18ee15207f03a$export$7e4aa119212bc614)(arg1) && !$17caac8d5bf4dbbf$export$92c0a039cf358271(arg1)) throw $17caac8d5bf4dbbf$export$3d702f7ac45b0a6b($17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    const key = (0, $82c18ee15207f03a$export$7e4aa119212bc614)(arg1) ? String(arg1) : $17caac8d5bf4dbbf$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
    else if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg2)) options.default = arg2;
    else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg2) && !(0, $82c18ee15207f03a$export$83b788b1a3698c03)(arg2)) options.named = arg2;
    else if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(arg2)) options.list = arg2;
    if ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(arg3)) options.plural = arg3;
    else if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg3)) options.default = arg3;
    else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg3)) (0, $82c18ee15207f03a$export$e6e34fd1f2686227)(options, arg3);
    return [
        key,
        options
    ];
}
function $17caac8d5bf4dbbf$var$getCompileOptions(context, locale, key, source, warnHtmlMessage, errorDetector) {
    return {
        warnHtmlMessage: warnHtmlMessage,
        onError: (err)=>{
            errorDetector && errorDetector(err);
            throw err;
        },
        onCacheKey: (source)=>(0, $82c18ee15207f03a$export$5024ef1f92c9a364)(locale, key, source)
    };
}
function $17caac8d5bf4dbbf$var$getMessageContextOptions(context, locale, message, options) {
    const { modifiers: modifiers, pluralRules: pluralRules, messageResolver: resolveValue, fallbackLocale: fallbackLocale, fallbackWarn: fallbackWarn, missingWarn: missingWarn, fallbackContext: fallbackContext } = context;
    const resolveMessage = (key)=>{
        let val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            const [, , message] = $17caac8d5bf4dbbf$var$resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn);
            val = resolveValue(message, key);
        }
        if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(val)) {
            let occurred = false;
            const errorDetector = ()=>{
                occurred = true;
            };
            const msg = $17caac8d5bf4dbbf$var$compileMessageFormat(context, key, locale, val, key, errorDetector);
            return !occurred ? msg : $17caac8d5bf4dbbf$var$NOOP_MESSAGE_FUNCTION;
        } else if ($17caac8d5bf4dbbf$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $17caac8d5bf4dbbf$var$NOOP_MESSAGE_FUNCTION;
    };
    const ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
const $17caac8d5bf4dbbf$var$intlDefined = typeof Intl !== "undefined";
const $17caac8d5bf4dbbf$var$Availabilities = {
    dateTimeFormat: $17caac8d5bf4dbbf$var$intlDefined && typeof Intl.DateTimeFormat !== "undefined",
    numberFormat: $17caac8d5bf4dbbf$var$intlDefined && typeof Intl.NumberFormat !== "undefined"
};
// implementation of `datetime` function
function $17caac8d5bf4dbbf$export$7ba4466dbd0f07e1(context, ...args) {
    const { datetimeFormats: datetimeFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __datetimeFormatters: __datetimeFormatters } = context;
    const [key, value, options, overrides] = $17caac8d5bf4dbbf$export$165524b21a0d6b5e(...args);
    const missingWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $82c18ee15207f03a$export$844ec244b1367d54)(key) || key === "") return new Intl.DateTimeFormat(locale, overrides).format(value);
    // resolve format
    let datetimeFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "datetime format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(format)) break;
        $17caac8d5bf4dbbf$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $82c18ee15207f03a$export$53b83ca8eaab0383)(format) || !(0, $82c18ee15207f03a$export$844ec244b1367d54)(targetLocale)) return unresolving ? $17caac8d5bf4dbbf$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $82c18ee15207f03a$export$83b788b1a3698c03)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $17caac8d5bf4dbbf$export$c77049eaf05b1508 = [
    "localeMatcher",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "formatMatcher",
    "hour12",
    "timeZone",
    "dateStyle",
    "timeStyle",
    "calendar",
    "dayPeriod",
    "numberingSystem",
    "hourCycle",
    "fractionalSecondDigits"
];
/** @internal */ function $17caac8d5bf4dbbf$export$165524b21a0d6b5e(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    let value;
    if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        const matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $17caac8d5bf4dbbf$export$3d702f7ac45b0a6b($17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        const dateTime = matches[3] ? matches[3].trim().startsWith("T") ? `${matches[1].trim()}${matches[3].trim()}` : `${matches[1].trim()}T${matches[3].trim()}` : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch (e) {
            throw $17caac8d5bf4dbbf$export$3d702f7ac45b0a6b($17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $82c18ee15207f03a$export$871608497c498473)(arg1)) {
        if (isNaN(arg1.getTime())) throw $17caac8d5bf4dbbf$export$3d702f7ac45b0a6b($17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(arg1)) value = arg1;
    else throw $17caac8d5bf4dbbf$export$3d702f7ac45b0a6b($17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($17caac8d5bf4dbbf$export$c77049eaf05b1508.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $17caac8d5bf4dbbf$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $17caac8d5bf4dbbf$export$98e628dec113755e(context, ...args) {
    const { numberFormats: numberFormats, unresolving: unresolving, fallbackLocale: fallbackLocale, onWarn: onWarn, localeFallbacker: localeFallbacker } = context;
    const { __numberFormatters: __numberFormatters } = context;
    const [key, value, options, overrides] = $17caac8d5bf4dbbf$export$d0e2eec8b686cf72(...args);
    const missingWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    const fallbackWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    const part = !!options.part;
    const locale = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    const locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $82c18ee15207f03a$export$844ec244b1367d54)(key) || key === "") return new Intl.NumberFormat(locale, overrides).format(value);
    // resolve format
    let numberFormat = {};
    let targetLocale;
    let format = null;
    let from = locale;
    let to = null;
    const type = "number format";
    for(let i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(format)) break;
        $17caac8d5bf4dbbf$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $82c18ee15207f03a$export$53b83ca8eaab0383)(format) || !(0, $82c18ee15207f03a$export$844ec244b1367d54)(targetLocale)) return unresolving ? $17caac8d5bf4dbbf$export$b7f13a18d1d0f835 : key;
    let id = `${targetLocale}__${key}`;
    if (!(0, $82c18ee15207f03a$export$83b788b1a3698c03)(overrides)) id = `${id}__${JSON.stringify(overrides)}`;
    let formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ const $17caac8d5bf4dbbf$export$c39a7c3789c46ed6 = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "currencySign",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "roundingMode",
    "roundingPriority",
    "roundingIncrement",
    "trailingZeroDisplay"
];
/** @internal */ function $17caac8d5bf4dbbf$export$d0e2eec8b686cf72(...args) {
    const [arg1, arg2, arg3, arg4] = args;
    const options = {};
    let overrides = {};
    if (!(0, $82c18ee15207f03a$export$7e4aa119212bc614)(arg1)) throw $17caac8d5bf4dbbf$export$3d702f7ac45b0a6b($17caac8d5bf4dbbf$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    const value = arg1;
    if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach((key)=>{
        if ($17caac8d5bf4dbbf$export$c39a7c3789c46ed6.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $17caac8d5bf4dbbf$export$6a8717b3043a4f23(ctx, locale, format) {
    const context = ctx;
    for(const key in format){
        const id = `${locale}__${key}`;
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $82c18ee15207f03a$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;


parcelRequire("ecovD");
var $6A78m = parcelRequire("6A78m");
var $57ryt = parcelRequire("57ryt");
function $271a4466ef5e9cfc$export$5a2d366b2d9f38f6() {
    return $271a4466ef5e9cfc$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $271a4466ef5e9cfc$export$c22522a4dfa48e9c() {
    // @ts-ignore
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
}
const $271a4466ef5e9cfc$export$bc32a04c49ed7464 = typeof Proxy === "function";


const $5b2bb8b48a82750b$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
const $5b2bb8b48a82750b$export$a0897f44accbe922 = "plugin:settings:set";



let $9bef096921b3fe3b$var$supported;
let $9bef096921b3fe3b$var$perf;
function $9bef096921b3fe3b$export$70d26280bc1ca547() {
    var _a;
    if ($9bef096921b3fe3b$var$supported !== undefined) return $9bef096921b3fe3b$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $9bef096921b3fe3b$var$supported = true;
        $9bef096921b3fe3b$var$perf = window.performance;
    } else if (typeof $parcel$global !== "undefined" && ((_a = $parcel$global.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $9bef096921b3fe3b$var$supported = true;
        $9bef096921b3fe3b$var$perf = $parcel$global.perf_hooks.performance;
    } else $9bef096921b3fe3b$var$supported = false;
    return $9bef096921b3fe3b$var$supported;
}
function $9bef096921b3fe3b$export$461939dd4422153() {
    return $9bef096921b3fe3b$export$70d26280bc1ca547() ? $9bef096921b3fe3b$var$perf.now() : Date.now();
}


class $93e457455b7d3a11$export$5728f3776e9b2ac1 {
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $9bef096921b3fe3b$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $5b2bb8b48a82750b$export$a0897f44accbe922), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === "on") return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
}





function $b3b34e3731d6e861$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $271a4466ef5e9cfc$export$c22522a4dfa48e9c)();
    const hook = (0, $271a4466ef5e9cfc$export$5a2d366b2d9f38f6)();
    const enableProxy = (0, $271a4466ef5e9cfc$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $5b2bb8b48a82750b$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $93e457455b7d3a11$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


/*!
  * vue-devtools v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ const $34356d918d4fafde$export$587da00aa063e3b8 = {
    ["vue-devtools-plugin-vue-i18n" /* PLUGIN */ ]: "Vue I18n devtools",
    ["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ]: "I18n Resources",
    ["vue-i18n-timeline" /* TIMELINE */ ]: "Vue I18n"
};
const $34356d918d4fafde$export$51fbf4f94c542453 = {
    ["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ]: "Search for scopes ..."
};
const $34356d918d4fafde$export$9698bf68c8ec8b3c = {
    ["vue-i18n-timeline" /* TIMELINE */ ]: 0xffcd19
};


/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ const $315a3f3f8869d00f$export$a4ad2735b021c132 = "9.2.2";
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $315a3f3f8869d00f$var$initFeatureFlags() {
    let needWarn = false;
    if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") {
        needWarn = true;
        (0, $82c18ee15207f03a$export$ff5f2eeb11fc7e14)().__VUE_I18N_FULL_INSTALL__ = true;
    }
    if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") {
        needWarn = true;
        (0, $82c18ee15207f03a$export$ff5f2eeb11fc7e14)().__VUE_I18N_LEGACY_API__ = true;
    }
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $82c18ee15207f03a$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
}
let $315a3f3f8869d00f$var$code$1 = (0, $17caac8d5bf4dbbf$export$b6a676a18b27d4c8).__EXTEND_POINT__;
const $315a3f3f8869d00f$var$inc$1 = ()=>++$315a3f3f8869d00f$var$code$1;
const $315a3f3f8869d00f$var$I18nWarnCodes = {
    FALLBACK_TO_ROOT: $315a3f3f8869d00f$var$code$1,
    NOT_SUPPORTED_PRESERVE: $315a3f3f8869d00f$var$inc$1(),
    NOT_SUPPORTED_FORMATTER: $315a3f3f8869d00f$var$inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: $315a3f3f8869d00f$var$inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: $315a3f3f8869d00f$var$inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: $315a3f3f8869d00f$var$inc$1(),
    NOT_FOUND_PARENT_SCOPE: $315a3f3f8869d00f$var$inc$1() // 13
};
const $315a3f3f8869d00f$var$warnMessages = {
    [$315a3f3f8869d00f$var$I18nWarnCodes.FALLBACK_TO_ROOT]: `Fall back to {type} '{key}' with root locale.`,
    [$315a3f3f8869d00f$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE]: `Not supported 'preserve'.`,
    [$315a3f3f8869d00f$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER]: `Not supported 'formatter'.`,
    [$315a3f3f8869d00f$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: `Not supported 'preserveDirectiveContent'.`,
    [$315a3f3f8869d00f$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX]: `Not supported 'getChoiceIndex'.`,
    [$315a3f3f8869d00f$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE]: `Component name legacy compatible: '{name}' -> 'i18n'`,
    [$315a3f3f8869d00f$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE]: `Not found parent scope. use the global scope.`
};
function $315a3f3f8869d00f$var$getWarnMessage(code, ...args) {
    return (0, $82c18ee15207f03a$export$d9468344d3651243)($315a3f3f8869d00f$var$warnMessages[code], ...args);
}
let $315a3f3f8869d00f$var$code = (0, $0746c8fcb985621f$export$77436aae039469c4).__EXTEND_POINT__;
const $315a3f3f8869d00f$var$inc = ()=>++$315a3f3f8869d00f$var$code;
const $315a3f3f8869d00f$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $315a3f3f8869d00f$var$code,
    // legacy module errors
    INVALID_ARGUMENT: $315a3f3f8869d00f$var$inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: $315a3f3f8869d00f$var$inc(),
    NOT_INSLALLED: $315a3f3f8869d00f$var$inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: $315a3f3f8869d00f$var$inc(),
    // directive module errors
    REQUIRED_VALUE: $315a3f3f8869d00f$var$inc(),
    INVALID_VALUE: $315a3f3f8869d00f$var$inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: $315a3f3f8869d00f$var$inc(),
    NOT_INSLALLED_WITH_PROVIDE: $315a3f3f8869d00f$var$inc(),
    // unexpected error
    UNEXPECTED_ERROR: $315a3f3f8869d00f$var$inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: $315a3f3f8869d00f$var$inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: $315a3f3f8869d00f$var$inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: $315a3f3f8869d00f$var$inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: $315a3f3f8869d00f$var$inc(),
    // for enhancement
    __EXTEND_POINT__: $315a3f3f8869d00f$var$inc() // 29
};
function $315a3f3f8869d00f$var$createI18nError(code, ...args) {
    return (0, $0746c8fcb985621f$export$21efa8bb37d5fecb)(code, null, undefined);
}
const $315a3f3f8869d00f$var$errorMessages = {
    [$315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
    [$315a3f3f8869d00f$var$I18nErrorCodes.INVALID_ARGUMENT]: "Invalid argument",
    [$315a3f3f8869d00f$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
    [$315a3f3f8869d00f$var$I18nErrorCodes.NOT_INSLALLED]: "Need to install with `app.use` function",
    [$315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_ERROR]: "Unexpected error",
    [$315a3f3f8869d00f$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
    [$315a3f3f8869d00f$var$I18nErrorCodes.REQUIRED_VALUE]: `Required in value: {0}`,
    [$315a3f3f8869d00f$var$I18nErrorCodes.INVALID_VALUE]: `Invalid value`,
    [$315a3f3f8869d00f$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: `Cannot setup vue-devtools plugin`,
    [$315a3f3f8869d00f$var$I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE]: "Need to install with `provide` function",
    [$315a3f3f8869d00f$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
    [$315a3f3f8869d00f$var$I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
    [$315a3f3f8869d00f$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
    [$315a3f3f8869d00f$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
};
const $315a3f3f8869d00f$var$TransrateVNodeSymbol = /* #__PURE__*/ (0, $82c18ee15207f03a$export$cd133c5e04906ece)("__transrateVNode");
const $315a3f3f8869d00f$var$DatetimePartsSymbol = /* #__PURE__*/ (0, $82c18ee15207f03a$export$cd133c5e04906ece)("__datetimeParts");
const $315a3f3f8869d00f$var$NumberPartsSymbol = /* #__PURE__*/ (0, $82c18ee15207f03a$export$cd133c5e04906ece)("__numberParts");
const $315a3f3f8869d00f$var$EnableEmitter = /* #__PURE__*/ (0, $82c18ee15207f03a$export$cd133c5e04906ece)("__enableEmitter");
const $315a3f3f8869d00f$var$DisableEmitter = /* #__PURE__*/ (0, $82c18ee15207f03a$export$cd133c5e04906ece)("__disableEmitter");
const $315a3f3f8869d00f$var$SetPluralRulesSymbol = (0, $82c18ee15207f03a$export$cd133c5e04906ece)("__setPluralRules");
(0, $82c18ee15207f03a$export$cd133c5e04906ece)("__intlifyMeta");
const $315a3f3f8869d00f$var$InejctWithOption = /* #__PURE__*/ (0, $82c18ee15207f03a$export$cd133c5e04906ece)("__injectWithOption");
const $315a3f3f8869d00f$var$__VUE_I18N_BRIDGE__ = "__VUE_I18N_BRIDGE__";
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $315a3f3f8869d00f$var$handleFlatJson(obj) {
    // check obj
    if (!(0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(obj)) return obj;
    for(const key in obj){
        // check key
        if (!(0, $82c18ee15207f03a$export$b5a638e9b3fff9f3)(obj, key)) continue;
        // handle for normal json
        if (!key.includes(".")) // recursive process value if value is also a object
        {
            if ((0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(obj[key])) $315a3f3f8869d00f$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            const subKeys = key.split(".");
            const lastIndex = subKeys.length - 1;
            let currentObj = obj;
            for(let i = 0; i < lastIndex; i++){
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = {};
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            currentObj[subKeys[lastIndex]] = obj[key];
            delete obj[key];
            // recursive process value if value is also a object
            if ((0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(currentObj[subKeys[lastIndex]])) $315a3f3f8869d00f$var$handleFlatJson(currentObj[subKeys[lastIndex]]);
        }
    }
    return obj;
}
function $315a3f3f8869d00f$var$getLocaleMessages(locale, options) {
    const { messages: messages, __i18n: __i18n, messageResolver: messageResolver, flatJson: flatJson } = options;
    // prettier-ignore
    const ret = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(messages) ? messages : (0, $82c18ee15207f03a$export$43bee75e5e14138e)(__i18n) ? {} : {
        [locale]: {}
    };
    // merge locale messages of i18n custom block
    if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(__i18n)) __i18n.forEach((custom)=>{
        if ("locale" in custom && "resource" in custom) {
            const { locale: locale, resource: resource } = custom;
            if (locale) {
                ret[locale] = ret[locale] || {};
                $315a3f3f8869d00f$var$deepCopy(resource, ret[locale]);
            } else $315a3f3f8869d00f$var$deepCopy(resource, ret);
        } else (0, $82c18ee15207f03a$export$844ec244b1367d54)(custom) && $315a3f3f8869d00f$var$deepCopy(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(const key in ret)if ((0, $82c18ee15207f03a$export$b5a638e9b3fff9f3)(ret, key)) $315a3f3f8869d00f$var$handleFlatJson(ret[key]);
    }
    return ret;
}
const $315a3f3f8869d00f$var$isNotObjectOrIsArray = (val1)=>!(0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(val1) || (0, $82c18ee15207f03a$export$43bee75e5e14138e)(val1);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $315a3f3f8869d00f$var$deepCopy(src, des) {
    // src and des should both be objects, and non of then can be a array
    if ($315a3f3f8869d00f$var$isNotObjectOrIsArray(src) || $315a3f3f8869d00f$var$isNotObjectOrIsArray(des)) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.INVALID_VALUE);
    for(const key in src)if ((0, $82c18ee15207f03a$export$b5a638e9b3fff9f3)(src, key)) {
        if ($315a3f3f8869d00f$var$isNotObjectOrIsArray(src[key]) || $315a3f3f8869d00f$var$isNotObjectOrIsArray(des[key])) // replace with src[key] when:
        // src[key] or des[key] is not a object, or
        // src[key] or des[key] is a array
        des[key] = src[key];
        else // src[key] and des[key] are both object, merge them
        $315a3f3f8869d00f$var$deepCopy(src[key], des[key]);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $315a3f3f8869d00f$var$getComponentOptions(instance) {
    return instance.type;
}
function $315a3f3f8869d00f$var$adjustI18nResources(global, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    let messages = (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(options.messages) ? options.messages : {};
    if ("__i18nGlobal" in componentOptions) messages = $315a3f3f8869d00f$var$getLocaleMessages(global.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    const locales = Object.keys(messages);
    if (locales.length) locales.forEach((locale)=>{
        global.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ((0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(options.datetimeFormats)) {
        const locales = Object.keys(options.datetimeFormats);
        if (locales.length) locales.forEach((locale)=>{
            global.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ((0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(options.numberFormats)) {
        const locales = Object.keys(options.numberFormats);
        if (locales.length) locales.forEach((locale)=>{
            global.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $315a3f3f8869d00f$var$createTextNode(key) {
    return (0, $6A78m.createVNode)((0, $6A78m.Text), null, key, 0);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ // extend VNode interface
const $315a3f3f8869d00f$var$DEVTOOLS_META = "__INTLIFY_META__";
let $315a3f3f8869d00f$var$composerID = 0;
function $315a3f3f8869d00f$var$defineCoreMissingHandler(missing) {
    return (ctx, locale, key, type)=>{
        return missing(locale, key, (0, $6A78m.getCurrentInstance)() || undefined, type);
    };
}
// for Intlify DevTools
const $315a3f3f8869d00f$var$getMetaInfo = ()=>{
    const instance = (0, $6A78m.getCurrentInstance)();
    let meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = $315a3f3f8869d00f$var$getComponentOptions(instance)[$315a3f3f8869d00f$var$DEVTOOLS_META]) ? {
        [$315a3f3f8869d00f$var$DEVTOOLS_META]: meta
    } // eslint-disable-line @typescript-eslint/no-explicit-any
     : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $315a3f3f8869d00f$var$createComposer(options = {}, VueI18nLegacy) {
    const { __root: __root } = options;
    const _isGlobal = __root === undefined;
    let _inheritLocale = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : true;
    const _locale = (0, $57ryt.ref)(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $17caac8d5bf4dbbf$export$1af4c7e47ad72f44));
    const _fallbackLocale = (0, $57ryt.ref)(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.fallbackLocale) || (0, $82c18ee15207f03a$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = (0, $57ryt.ref)($315a3f3f8869d00f$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0, $57ryt.ref)((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = (0, $57ryt.ref)((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // warning suppress options
    // prettier-ignore
    let _missingWarn = __root ? __root.missingWarn : (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $82c18ee15207f03a$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    let _fallbackWarn = __root ? __root.fallbackWarn : (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $82c18ee15207f03a$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    let _fallbackRoot = __root ? __root.fallbackRoot : (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    let _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    let _missing = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    let _runtimeMissing = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.missing) ? $315a3f3f8869d00f$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    let _postTranslation = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    let _warnHtmlMessage = __root ? __root.warnHtmlMessage : (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    let _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    const _modifiers = __root ? __root.modifiers : (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    let _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    let _context;
    const getCoreContext = ()=>{
        _isGlobal && (0, $17caac8d5bf4dbbf$export$e16aca6786e72a5e)(null);
        const ctxOptions = {
            version: $315a3f3f8869d00f$export$a4ad2735b021c132,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            __meta: {
                framework: "vue"
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(_context) ? _context.__numberFormatters : undefined;
        const ctx = (0, $17caac8d5bf4dbbf$export$3599d465b05a74a5)(ctxOptions);
        _isGlobal && (0, $17caac8d5bf4dbbf$export$e16aca6786e72a5e)(ctx);
        return ctx;
    };
    _context = getCoreContext();
    (0, $17caac8d5bf4dbbf$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $57ryt.computed)({
        get: ()=>_locale.value,
        set: (val1)=>{
            _locale.value = val1;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $57ryt.computed)({
        get: ()=>_fallbackLocale.value,
        set: (val1)=>{
            _fallbackLocale.value = val1;
            _context.fallbackLocale = _fallbackLocale.value;
            (0, $17caac8d5bf4dbbf$export$c743ad8a3cc01530)(_context, _locale.value, val1);
        }
    });
    // messages
    const messages = (0, $57ryt.computed)(()=>_messages.value);
    // datetimeFormats
    const datetimeFormats = /* #__PURE__*/ (0, $57ryt.computed)(()=>_datetimeFormats.value);
    // numberFormats
    const numberFormats = /* #__PURE__*/ (0, $57ryt.computed)(()=>_numberFormats.value);
    // getPostTranslationHandler
    function getPostTranslationHandler() {
        return (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(_postTranslation) ? _postTranslation : null;
    }
    // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    }
    // getMissingHandler
    function getMissingHandler() {
        return _missing;
    }
    // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $315a3f3f8869d00f$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    }
    function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== "translate" || !arg.resolvedMessage;
    }
    const wrapWithDeps = (fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition)=>{
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        let ret;
        if (__INTLIFY_PROD_DEVTOOLS__) try {
            (0, $17caac8d5bf4dbbf$export$605703447dca72aa)($315a3f3f8869d00f$var$getMetaInfo());
            if (!_isGlobal) _context.fallbackContext = __root ? (0, $17caac8d5bf4dbbf$export$3adddc434faa9e35)() : undefined;
            ret = fn(_context);
        } finally{
            (0, $17caac8d5bf4dbbf$export$605703447dca72aa)(null);
            if (!_isGlobal) _context.fallbackContext = undefined;
        }
        else ret = fn(_context);
        if ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(ret) && ret === (0, $17caac8d5bf4dbbf$export$b7f13a18d1d0f835)) {
            const [key, arg2] = argumentParser();
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    };
    // t
    function t(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $17caac8d5bf4dbbf$export$d73ee8ef04f5226a), null, [
                context,
                ...args
            ]), ()=>(0, $17caac8d5bf4dbbf$export$8d9616744e22681a)(...args), "translate", (root)=>Reflect.apply(root.t, root, [
                ...args
            ]), (key)=>key, (val1)=>(0, $82c18ee15207f03a$export$844ec244b1367d54)(val1));
    }
    // rt
    function rt(...args) {
        const [arg1, arg2, arg3] = args;
        if (arg3 && !(0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(arg3)) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t(...[
            arg1,
            arg2,
            (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    }
    // d
    function d(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $17caac8d5bf4dbbf$export$7ba4466dbd0f07e1), null, [
                context,
                ...args
            ]), ()=>(0, $17caac8d5bf4dbbf$export$165524b21a0d6b5e)(...args), "datetime format", (root)=>Reflect.apply(root.d, root, [
                ...args
            ]), ()=>(0, $17caac8d5bf4dbbf$export$a04371e9dbb3870b), (val1)=>(0, $82c18ee15207f03a$export$844ec244b1367d54)(val1));
    }
    // n
    function n(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $17caac8d5bf4dbbf$export$98e628dec113755e), null, [
                context,
                ...args
            ]), ()=>(0, $17caac8d5bf4dbbf$export$d0e2eec8b686cf72)(...args), "number format", (root)=>Reflect.apply(root.n, root, [
                ...args
            ]), ()=>(0, $17caac8d5bf4dbbf$export$a04371e9dbb3870b), (val1)=>(0, $82c18ee15207f03a$export$844ec244b1367d54)(val1));
    }
    // for custom processor
    function normalize(values) {
        return values.map((val1)=>(0, $82c18ee15207f03a$export$844ec244b1367d54)(val1) || (0, $82c18ee15207f03a$export$7e4aa119212bc614)(val1) || (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(val1) ? $315a3f3f8869d00f$var$createTextNode(String(val1)) : val1);
    }
    const interpolate = (val1)=>val1;
    const processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: "vnode"
    };
    // transrateVNode, using for `i18n-t` component
    function transrateVNode(...args) {
        return wrapWithDeps((context)=>{
            let ret;
            const _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply((0, $17caac8d5bf4dbbf$export$d73ee8ef04f5226a), null, [
                    _context,
                    ...args
                ]);
            } finally{
                _context.processor = null;
            }
            return ret;
        }, ()=>(0, $17caac8d5bf4dbbf$export$8d9616744e22681a)(...args), "translate", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$315a3f3f8869d00f$var$TransrateVNodeSymbol](...args), (key)=>[
                $315a3f3f8869d00f$var$createTextNode(key)
            ], (val1)=>(0, $82c18ee15207f03a$export$43bee75e5e14138e)(val1));
    }
    // numberParts, using for `i18n-n` component
    function numberParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $17caac8d5bf4dbbf$export$98e628dec113755e), null, [
                context,
                ...args
            ]), ()=>(0, $17caac8d5bf4dbbf$export$d0e2eec8b686cf72)(...args), "number format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$315a3f3f8869d00f$var$NumberPartsSymbol](...args), ()=>[], (val1)=>(0, $82c18ee15207f03a$export$844ec244b1367d54)(val1) || (0, $82c18ee15207f03a$export$43bee75e5e14138e)(val1));
    }
    // datetimeParts, using for `i18n-d` component
    function datetimeParts(...args) {
        return wrapWithDeps((context)=>Reflect.apply((0, $17caac8d5bf4dbbf$export$7ba4466dbd0f07e1), null, [
                context,
                ...args
            ]), ()=>(0, $17caac8d5bf4dbbf$export$165524b21a0d6b5e)(...args), "datetime format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (root)=>root[$315a3f3f8869d00f$var$DatetimePartsSymbol](...args), ()=>[], (val1)=>(0, $82c18ee15207f03a$export$844ec244b1367d54)(val1) || (0, $82c18ee15207f03a$export$43bee75e5e14138e)(val1));
    }
    function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    }
    // te
    function te(key, locale) {
        const targetLocale = (0, $82c18ee15207f03a$export$844ec244b1367d54)(locale) ? locale : _locale.value;
        const message = getLocaleMessage(targetLocale);
        return _context.messageResolver(message, key) !== null;
    }
    function resolveMessages(key) {
        let messages = null;
        const locales = (0, $17caac8d5bf4dbbf$export$71df9db82dc445)(_context, _fallbackLocale.value, _locale.value);
        for(let i = 0; i < locales.length; i++){
            const targetLocaleMessages = _messages.value[locales[i]] || {};
            const messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    }
    // tm
    function tm(key) {
        const messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    }
    // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    }
    // setLocaleMessage
    function setLocaleMessage(locale, message) {
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    }
    // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        $315a3f3f8869d00f$var$deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    }
    // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    }
    // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $17caac8d5bf4dbbf$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = (0, $82c18ee15207f03a$export$e6e34fd1f2686227)(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $17caac8d5bf4dbbf$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    }
    // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    }
    // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        (0, $17caac8d5bf4dbbf$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = (0, $82c18ee15207f03a$export$e6e34fd1f2686227)(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        (0, $17caac8d5bf4dbbf$export$6a8717b3043a4f23)(_context, locale, format);
    }
    // for debug
    $315a3f3f8869d00f$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root && (0, $82c18ee15207f03a$export$620a268685f0ac45)) {
        (0, $6A78m.watch)(__root.locale, (val1)=>{
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                (0, $17caac8d5bf4dbbf$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0, $6A78m.watch)(__root.fallbackLocale, (val1)=>{
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                (0, $17caac8d5bf4dbbf$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    const composer = {
        id: $315a3f3f8869d00f$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                (0, $17caac8d5bf4dbbf$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        [$315a3f3f8869d00f$var$SetPluralRulesSymbol]: setPluralRules
    };
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$315a3f3f8869d00f$var$InejctWithOption] = options.__injectWithOption;
    composer[$315a3f3f8869d00f$var$TransrateVNodeSymbol] = transrateVNode;
    composer[$315a3f3f8869d00f$var$DatetimePartsSymbol] = datetimeParts;
    composer[$315a3f3f8869d00f$var$NumberPartsSymbol] = numberParts;
    var emitter;
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $315a3f3f8869d00f$var$convertComposerOptions(options) {
    const locale = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $17caac8d5bf4dbbf$export$1af4c7e47ad72f44);
    const fallbackLocale = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.fallbackLocale) || (0, $82c18ee15207f03a$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    const missing = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.missing) ? options.missing : undefined;
    const missingWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.silentTranslationWarn) || (0, $82c18ee15207f03a$export$49841c62b9eff15)(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    const fallbackWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.silentFallbackWarn) || (0, $82c18ee15207f03a$export$49841c62b9eff15)(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    const fallbackRoot = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    const fallbackFormat = !!options.formatFallbackMessages;
    const modifiers = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    const pluralizationRules = options.pluralizationRules;
    const postTranslation = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : undefined;
    const warnHtmlMessage = (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
    const escapeParameter = !!options.escapeParameterHtml;
    const inheritLocale = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.sync) ? options.sync : true;
    let messages = options.messages;
    if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.sharedMessages)) {
        const sharedMessages = options.sharedMessages;
        const locales = Object.keys(sharedMessages);
        messages = locales.reduce((messages, locale)=>{
            const message = messages[locale] || (messages[locale] = {});
            (0, $82c18ee15207f03a$export$e6e34fd1f2686227)(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    const { __i18n: __i18n, __root: __root, __injectWithOption: __injectWithOption } = options;
    const datetimeFormats = options.datetimeFormats;
    const numberFormats = options.numberFormats;
    const flatJson = options.flatJson;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $315a3f3f8869d00f$var$createVueI18n(options = {}, VueI18nLegacy) {
    {
        const composer = $315a3f3f8869d00f$var$createComposer($315a3f3f8869d00f$var$convertComposerOptions(options));
        // defines VueI18n
        const vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale () {
                return composer.locale.value;
            },
            set locale (val){
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale () {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale (val){
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages () {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats () {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats () {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales () {
                return composer.availableLocales;
            },
            // formatter
            get formatter () {
                // dummy
                return {
                    interpolate () {
                        return [];
                    }
                };
            },
            set formatter (val){},
            // missing
            get missing () {
                return composer.getMissingHandler();
            },
            set missing (handler){
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn () {
                return (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
            },
            set silentTranslationWarn (val){
                composer.missingWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn () {
                return (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
            },
            set silentFallbackWarn (val){
                composer.fallbackWarn = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // modifiers
            get modifiers () {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages () {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages (val){
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation () {
                return composer.getPostTranslationHandler();
            },
            set postTranslation (handler){
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync () {
                return composer.inheritLocale;
            },
            set sync (val){
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage () {
                return composer.warnHtmlMessage ? "warn" : "off";
            },
            set warnHtmlInMessage (val){
                composer.warnHtmlMessage = val !== "off";
            },
            // escapeParameterHtml
            get escapeParameterHtml () {
                return composer.escapeParameter;
            },
            set escapeParameterHtml (val){
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent () {
                return true;
            },
            set preserveDirectiveContent (val){},
            // pluralizationRules
            get pluralizationRules () {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {};
                let list = null;
                let named = null;
                if (!(0, $82c18ee15207f03a$export$844ec244b1367d54)(arg1)) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            rt (...args) {
                return Reflect.apply(composer.rt, composer, [
                    ...args
                ]);
            },
            // tc
            tc (...args) {
                const [arg1, arg2, arg3] = args;
                const options = {
                    plural: 1
                };
                let list = null;
                let named = null;
                if (!(0, $82c18ee15207f03a$export$844ec244b1367d54)(arg1)) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.INVALID_ARGUMENT);
                const key = arg1;
                if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
                else if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(arg3)) options.locale = arg3;
                else if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            // te
            te (key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm (key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage (locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage (locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage (locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d (...args) {
                return Reflect.apply(composer.d, composer, [
                    ...args
                ]);
            },
            // getDateTimeFormat
            getDateTimeFormat (locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat (locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat (locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n (...args) {
                return Reflect.apply(composer.n, composer, [
                    ...args
                ]);
            },
            // getNumberFormat
            getNumberFormat (locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat (locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat (locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex (choice, choicesLength) {
                return -1;
            },
            // for internal
            __onComponentInstanceCreated (target) {
                const { componentInstanceCreatedListener: componentInstanceCreatedListener } = options;
                if (componentInstanceCreatedListener) componentInstanceCreatedListener(target, vueI18n);
            }
        };
        var emitter;
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */ const $315a3f3f8869d00f$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: (val1 /* ComponetI18nScope */ )=>val1 === "parent" || val1 === "global",
        default: "parent" /* ComponetI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
function $315a3f3f8869d00f$var$getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
{ slots: slots }, keys) {
    if (keys.length === 1 && keys[0] === "default") {
        // default slot with list
        const ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce((slot, current)=>{
            return slot = [
                ...slot,
                ...(0, $82c18ee15207f03a$export$43bee75e5e14138e)(current.children) ? current.children : [
                    current
                ]
            ];
        }, []);
    } else // named slots
    return keys.reduce((arg, key)=>{
        const slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, {});
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $315a3f3f8869d00f$var$getFragmentableTag(tag) {
    return 0, $6A78m.Fragment;
}
/**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n path="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ const $315a3f3f8869d00f$export$b63289fbda65eed1 = /* defineComponent */ {
    /* eslint-disable */ name: "i18n-t",
    props: (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: (val1)=>(0, $82c18ee15207f03a$export$7e4aa119212bc614)(val1) || !isNaN(val1)
        }
    }, $315a3f3f8869d00f$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const { slots: slots, attrs: attrs } = context;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        const i18n = props.i18n || $315a3f3f8869d00f$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return ()=>{
            const keys = Object.keys(slots).filter((key)=>key !== "_");
            const options = {};
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = (0, $82c18ee15207f03a$export$844ec244b1367d54)(props.plural) ? +props.plural : props.plural;
            const arg = $315a3f3f8869d00f$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const children = i18n[$315a3f3f8869d00f$var$TransrateVNodeSymbol](props.keypath, arg, options);
            const assignedAttrs = (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, attrs);
            const tag = (0, $82c18ee15207f03a$export$844ec244b1367d54)(props.tag) || (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $315a3f3f8869d00f$var$getFragmentableTag();
            return (0, $6A78m.h)(tag, assignedAttrs, children);
        };
    }
};
function $315a3f3f8869d00f$var$isVNode(target) {
    return (0, $82c18ee15207f03a$export$43bee75e5e14138e)(target) && !(0, $82c18ee15207f03a$export$844ec244b1367d54)(target[0]);
}
function $315a3f3f8869d00f$var$renderFormatter(props, context, slotKeys, partFormatter) {
    const { slots: slots, attrs: attrs } = context;
    return ()=>{
        const options = {
            part: true
        };
        let overrides = {};
        if (props.locale) options.locale = props.locale;
        if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(props.format)) options.key = props.format;
        else if ((0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce((options, prop)=>{
                return slotKeys.includes(prop) ? (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, options, {
                    [prop]: props.format[prop]
                }) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, {});
        }
        const parts = partFormatter(...[
            props.value,
            options,
            overrides
        ]);
        let children = [
            options.key
        ];
        if ((0, $82c18ee15207f03a$export$43bee75e5e14138e)(parts)) children = parts.map((part, index)=>{
            const slot = slots[part.type];
            const node = slot ? slot({
                [part.type]: part.value,
                index: index,
                parts: parts
            }) : [
                part.value
            ];
            if ($315a3f3f8869d00f$var$isVNode(node)) node[0].key = `${part.type}-${index}`;
            return node;
        });
        else if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(parts)) children = [
            parts
        ];
        const assignedAttrs = (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, attrs);
        const tag = (0, $82c18ee15207f03a$export$844ec244b1367d54)(props.tag) || (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $315a3f3f8869d00f$var$getFragmentableTag();
        return (0, $6A78m.h)(tag, assignedAttrs, children);
    };
}
/**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ const $315a3f3f8869d00f$export$27bce688931fdfcc = /* defineComponent */ {
    /* eslint-disable */ name: "i18n-n",
    props: (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $315a3f3f8869d00f$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $315a3f3f8869d00f$export$3f3caade1c12f8c9({
            useScope: "parent",
            __useComponent: true
        });
        return $315a3f3f8869d00f$var$renderFormatter(props, context, (0, $17caac8d5bf4dbbf$export$c39a7c3789c46ed6), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$315a3f3f8869d00f$var$NumberPartsSymbol](...args));
    }
};
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ const $315a3f3f8869d00f$export$64ca50867510e64e = /*defineComponent */ {
    /* eslint-disable */ name: "i18n-d",
    props: (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $315a3f3f8869d00f$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup (props, context) {
        const i18n = props.i18n || $315a3f3f8869d00f$export$3f3caade1c12f8c9({
            useScope: "parent",
            __useComponent: true
        });
        return $315a3f3f8869d00f$var$renderFormatter(props, context, (0, $17caac8d5bf4dbbf$export$c77049eaf05b1508), (...args)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            i18n[$315a3f3f8869d00f$var$DatetimePartsSymbol](...args));
    }
};
function $315a3f3f8869d00f$var$getComposer$2(i18n, instance) {
    const i18nInternal = i18n;
    if (i18n.mode === "composition") return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        const vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
function $315a3f3f8869d00f$export$8a5a05546006d0b5(i18n) {
    const _process = (binding)=>{
        const { instance: instance, modifiers: modifiers, value: value } = binding;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const composer = $315a3f3f8869d00f$var$getComposer$2(i18n, instance.$);
        const parsedValue = $315a3f3f8869d00f$var$parseValue(value);
        return [
            Reflect.apply(composer.t, composer, [
                ...$315a3f3f8869d00f$var$makeParams(parsedValue)
            ]),
            composer
        ];
    };
    const register = (el, binding)=>{
        const [textContent, composer] = _process(binding);
        if ((0, $82c18ee15207f03a$export$620a268685f0ac45) && i18n.global === composer) // global scope only
        el.__i18nWatcher = (0, $6A78m.watch)(composer.locale, ()=>{
            binding.instance && binding.instance.$forceUpdate();
        });
        el.__composer = composer;
        el.textContent = textContent;
    };
    const unregister = (el)=>{
        if ((0, $82c18ee15207f03a$export$620a268685f0ac45) && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    const update = (el, { value: value })=>{
        if (el.__composer) {
            const composer = el.__composer;
            const parsedValue = $315a3f3f8869d00f$var$parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, [
                ...$315a3f3f8869d00f$var$makeParams(parsedValue)
            ]);
        }
    };
    const getSSRProps = (binding)=>{
        const [textContent] = _process(binding);
        return {
            textContent: textContent
        };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function $315a3f3f8869d00f$var$parseValue(value) {
    if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(value)) return {
        path: value
    };
    else if ((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(value)) {
        if (!("path" in value)) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.REQUIRED_VALUE, "path");
        return value;
    } else throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.INVALID_VALUE);
}
function $315a3f3f8869d00f$var$makeParams(value) {
    const { path: path, locale: locale, args: args, choice: choice, plural: plural } = value;
    const options = {};
    const named = args || {};
    if ((0, $82c18ee15207f03a$export$844ec244b1367d54)(locale)) options.locale = locale;
    if ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(choice)) options.plural = choice;
    if ((0, $82c18ee15207f03a$export$7e4aa119212bc614)(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $315a3f3f8869d00f$var$apply(app, i18n, ...options) {
    const pluginOptions = (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options[0]) ? options[0] : {};
    const useI18nComponentName = !!pluginOptions.useI18nComponentName;
    const globalInstall = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall) {
        // install components
        app.component(!useI18nComponentName ? $315a3f3f8869d00f$export$b63289fbda65eed1.name : "i18n", $315a3f3f8869d00f$export$b63289fbda65eed1);
        app.component($315a3f3f8869d00f$export$27bce688931fdfcc.name, $315a3f3f8869d00f$export$27bce688931fdfcc);
        app.component($315a3f3f8869d00f$export$64ca50867510e64e.name, $315a3f3f8869d00f$export$64ca50867510e64e);
    }
    app.directive("t", $315a3f3f8869d00f$export$8a5a05546006d0b5(i18n));
}
const $315a3f3f8869d00f$var$VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties";
let $315a3f3f8869d00f$var$devtoolsApi;
async function $315a3f3f8869d00f$var$enableDevTools(app, i18n) {
    return new Promise((resolve, reject)=>{
        try {
            (0, $b3b34e3731d6e861$export$63b9a9bba9f20f3e)({
                id: "vue-devtools-plugin-vue-i18n" /* PLUGIN */ ,
                label: (0, $34356d918d4fafde$export$587da00aa063e3b8)["vue-devtools-plugin-vue-i18n" /* PLUGIN */ ],
                packageName: "vue-i18n",
                homepage: "https://vue-i18n.intlify.dev",
                logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
                componentStateTypes: [
                    $315a3f3f8869d00f$var$VUE_I18N_COMPONENT_TYPES
                ],
                app: app // eslint-disable-line @typescript-eslint/no-explicit-any
            }, (api)=>{
                $315a3f3f8869d00f$var$devtoolsApi = api;
                api.on.visitComponentTree(({ componentInstance: componentInstance, treeNode: treeNode })=>{
                    $315a3f3f8869d00f$var$updateComponentTreeTags(componentInstance, treeNode, i18n);
                });
                api.on.inspectComponent(({ componentInstance: componentInstance, instanceData: instanceData })=>{
                    if (componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData) {
                        if (i18n.mode === "legacy") // ignore global scope on legacy mode
                        {
                            if (componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer) $315a3f3f8869d00f$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                        } else $315a3f3f8869d00f$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                    }
                });
                api.addInspector({
                    id: "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ,
                    label: (0, $34356d918d4fafde$export$587da00aa063e3b8)["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ],
                    icon: "language",
                    treeFilterPlaceholder: (0, $34356d918d4fafde$export$51fbf4f94c542453)["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ]
                });
                api.on.getInspectorTree((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ) $315a3f3f8869d00f$var$registerScope(payload, i18n);
                });
                const roots = new Map();
                api.on.getInspectorState(async (payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ) {
                        api.unhighlightElement();
                        $315a3f3f8869d00f$var$inspectScope(payload, i18n);
                        if (payload.nodeId === "global") {
                            if (!roots.has(payload.app)) {
                                const [root] = await api.getComponentInstances(payload.app);
                                roots.set(payload.app, root);
                            }
                            api.highlightElement(roots.get(payload.app));
                        } else {
                            const instance = $315a3f3f8869d00f$var$getComponentInstance(payload.nodeId, i18n);
                            instance && api.highlightElement(instance);
                        }
                    }
                });
                api.on.editInspectorState((payload)=>{
                    if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ) $315a3f3f8869d00f$var$editScope(payload, i18n);
                });
                api.addTimelineLayer({
                    id: "vue-i18n-timeline" /* TIMELINE */ ,
                    label: (0, $34356d918d4fafde$export$587da00aa063e3b8)["vue-i18n-timeline" /* TIMELINE */ ],
                    color: (0, $34356d918d4fafde$export$9698bf68c8ec8b3c)["vue-i18n-timeline" /* TIMELINE */ ]
                });
                resolve(true);
            });
        } catch (e) {
            console.error(e);
            reject(false);
        }
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $315a3f3f8869d00f$var$getI18nScopeLable(instance) {
    return instance.type.name || instance.type.displayName || instance.type.__file || "Anonymous";
}
function $315a3f3f8869d00f$var$updateComponentTreeTags(instance, treeNode, i18n) {
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) // add custom tags local scope only
    {
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            const tag = {
                label: `i18n (${$315a3f3f8869d00f$var$getI18nScopeLable(instance)} Scope)`,
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function $315a3f3f8869d00f$var$inspectComposer(instanceData, composer) {
    const type = $315a3f3f8869d00f$var$VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: "locale",
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: "availableLocales",
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: "fallbackLocale",
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: "inheritLocale",
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: "messages",
        editable: false,
        value: $315a3f3f8869d00f$var$getLocaleMessageValue(composer.messages.value)
    });
    instanceData.state.push({
        type: type,
        key: "datetimeFormats",
        editable: false,
        value: composer.datetimeFormats.value
    });
    instanceData.state.push({
        type: type,
        key: "numberFormats",
        editable: false,
        value: composer.numberFormats.value
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $315a3f3f8869d00f$var$getLocaleMessageValue(messages) {
    const value = {};
    Object.keys(messages).forEach((key)=>{
        const v = messages[key];
        if ((0, $82c18ee15207f03a$export$f6e2535fb5126e54)(v) && "source" in v) value[key] = $315a3f3f8869d00f$var$getMessageFunctionDetails(v);
        else if ((0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(v)) value[key] = $315a3f3f8869d00f$var$getLocaleMessageValue(v);
        else value[key] = v;
    });
    return value;
}
const $315a3f3f8869d00f$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
function $315a3f3f8869d00f$var$escape(s) {
    return s.replace(/[<>"&]/g, $315a3f3f8869d00f$var$escapeChar);
}
function $315a3f3f8869d00f$var$escapeChar(a) {
    return $315a3f3f8869d00f$var$ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $315a3f3f8869d00f$var$getMessageFunctionDetails(func) {
    const argString = func.source ? `("${$315a3f3f8869d00f$var$escape(func.source)}")` : `(?)`;
    return {
        _custom: {
            type: "function",
            display: `<span>ƒ</span> ${argString}`
        }
    };
}
function $315a3f3f8869d00f$var$registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: "global",
        label: "Global Scope"
    });
    // prettier-ignore
    const global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    for (const [keyInstance, instance] of i18n.__instances){
        // prettier-ignore
        const composer = i18n.mode === "composition" ? instance : instance.__composer;
        if (global === composer) continue;
        payload.rootNodes.push({
            id: composer.id.toString(),
            label: `${$315a3f3f8869d00f$var$getI18nScopeLable(keyInstance)} Scope`
        });
    }
}
function $315a3f3f8869d00f$var$getComponentInstance(nodeId, i18n) {
    let instance = null;
    if (nodeId !== "global") {
        for (const [component, composer] of i18n.__instances.entries())if (composer.id.toString() === nodeId) {
            instance = component;
            break;
        }
    }
    return instance;
}
function $315a3f3f8869d00f$var$getComposer$1(nodeId, i18n) {
    if (nodeId === "global") return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    else {
        const instance = Array.from(i18n.__instances.values()).find((item)=>item.id.toString() === nodeId);
        if (instance) return i18n.mode === "composition" ? instance : instance.__composer;
        else return null;
    }
}
function $315a3f3f8869d00f$var$inspectScope(payload, i18n) {
    const composer = $315a3f3f8869d00f$var$getComposer$1(payload.nodeId, i18n);
    if (composer) // TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload.state = $315a3f3f8869d00f$var$makeScopeInspectState(composer);
    return null;
}
function $315a3f3f8869d00f$var$makeScopeInspectState(composer) {
    const state = {};
    const localeType = "Locale related info";
    const localeStates = [
        {
            type: localeType,
            key: "locale",
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: "fallbackLocale",
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: "availableLocales",
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: "inheritLocale",
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    const localeMessagesType = "Locale messages info";
    const localeMessagesStates = [
        {
            type: localeMessagesType,
            key: "messages",
            editable: false,
            value: $315a3f3f8869d00f$var$getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        const datetimeFormatsType = "Datetime formats info";
        const datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: "datetimeFormats",
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        const numberFormatsType = "Datetime formats info";
        const numberFormatsStates = [
            {
                type: numberFormatsType,
                key: "numberFormats",
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function $315a3f3f8869d00f$var$addTimelineEvent(event, payload) {
    if ($315a3f3f8869d00f$var$devtoolsApi) {
        let groupId;
        if (payload && "groupId" in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        $315a3f3f8869d00f$var$devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* TIMELINE */ ,
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* COMPILE_ERROR */  ? "error" : event === "fallback" /* FALBACK */  || event === "missing" /* MISSING */  ? "warning" : "default"
            }
        });
    }
}
function $315a3f3f8869d00f$var$editScope(payload, i18n) {
    const composer = $315a3f3f8869d00f$var$getComposer$1(payload.nodeId, i18n);
    if (composer) {
        const [field] = payload.path;
        if (field === "locale" && (0, $82c18ee15207f03a$export$844ec244b1367d54)(payload.state.value)) composer.locale.value = payload.state.value;
        else if (field === "fallbackLocale" && ((0, $82c18ee15207f03a$export$844ec244b1367d54)(payload.state.value) || (0, $82c18ee15207f03a$export$43bee75e5e14138e)(payload.state.value) || (0, $82c18ee15207f03a$export$a6cdc56e425d0d0a)(payload.state.value))) composer.fallbackLocale.value = payload.state.value;
        else if (field === "inheritLocale" && (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(payload.state.value)) composer.inheritLocale = payload.state.value;
    }
}
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $315a3f3f8869d00f$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate () {
            const instance = (0, $6A78m.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_ERROR);
            const options = this.$options;
            if (options.i18n) {
                const optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) this.$i18n = $315a3f3f8869d00f$var$mergeToRoot(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    this.$i18n = $315a3f3f8869d00f$var$createVueI18n(optionsI18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) this.$i18n = $315a3f3f8869d00f$var$mergeToRoot(vuei18n, options);
                else this.$i18n = $315a3f3f8869d00f$var$createVueI18n({
                    __i18n: options.__i18n,
                    __injectWithOption: true,
                    __root: composer
                });
            } else // set global
            this.$i18n = vuei18n;
            if (options.__i18nGlobal) $315a3f3f8869d00f$var$adjustI18nResources(composer, options, options);
            vuei18n.__onComponentInstanceCreated(this.$i18n);
            i18n.__setInstance(instance, this.$i18n);
            // defines vue-i18n legacy APIs
            this.$t = (...args)=>this.$i18n.t(...args);
            this.$rt = (...args)=>this.$i18n.rt(...args);
            this.$tc = (...args)=>this.$i18n.tc(...args);
            this.$te = (key, locale)=>this.$i18n.te(key, locale);
            this.$d = (...args)=>this.$i18n.d(...args);
            this.$n = (...args)=>this.$i18n.n(...args);
            this.$tm = (key)=>this.$i18n.tm(key);
        },
        mounted () {
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$i18n) {
                this.$el.__VUE_I18N__ = this.$i18n.__composer;
                const emitter = this.__v_emitter = (0, $82c18ee15207f03a$export$6f5e8f34570e3ad1)();
                const _vueI18n = this.$i18n;
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on("*", $315a3f3f8869d00f$var$addTimelineEvent);
            }
        },
        unmounted () {
            const instance = (0, $6A78m.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_ERROR);
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$el.__VUE_I18N__) {
                if (this.__v_emitter) {
                    this.__v_emitter.off("*", $315a3f3f8869d00f$var$addTimelineEvent);
                    delete this.__v_emitter;
                }
                if (this.$i18n) {
                    const _vueI18n = this.$i18n;
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete this.$el.__VUE_I18N__;
                }
            }
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function $315a3f3f8869d00f$var$mergeToRoot(root, options) {
    root.locale = options.locale || root.locale;
    root.fallbackLocale = options.fallbackLocale || root.fallbackLocale;
    root.missing = options.missing || root.missing;
    root.silentTranslationWarn = options.silentTranslationWarn || root.silentFallbackWarn;
    root.silentFallbackWarn = options.silentFallbackWarn || root.silentFallbackWarn;
    root.formatFallbackMessages = options.formatFallbackMessages || root.formatFallbackMessages;
    root.postTranslation = options.postTranslation || root.postTranslation;
    root.warnHtmlInMessage = options.warnHtmlInMessage || root.warnHtmlInMessage;
    root.escapeParameterHtml = options.escapeParameterHtml || root.escapeParameterHtml;
    root.sync = options.sync || root.sync;
    root.__composer[$315a3f3f8869d00f$var$SetPluralRulesSymbol](options.pluralizationRules || root.pluralizationRules);
    const messages = $315a3f3f8869d00f$var$getLocaleMessages(root.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach((locale)=>root.mergeLocaleMessage(locale, messages[locale]));
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach((locale)=>root.mergeDateTimeFormat(locale, options.datetimeFormats[locale]));
    if (options.numberFormats) Object.keys(options.numberFormats).forEach((locale)=>root.mergeNumberFormat(locale, options.numberFormats[locale]));
    return root;
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ const $315a3f3f8869d00f$export$b19990ca6e622dd2 = /* #__PURE__*/ (0, $82c18ee15207f03a$export$cd133c5e04906ece)("global-vue-i18n");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $315a3f3f8869d00f$export$920091e3d72d80ee(options = {}, VueI18nLegacy) {
    // prettier-ignore
    const __legacyMode = __VUE_I18N_LEGACY_API__ && (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    const __globalInjection = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.globalInjection) ? options.globalInjection : true;
    // prettier-ignore
    const __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
    const __instances = new Map();
    const [globalScope, __global] = $315a3f3f8869d00f$var$createGlobal(options, __legacyMode);
    const symbol = (0, $82c18ee15207f03a$export$cd133c5e04906ece)("");
    function __getInstance(component) {
        return __instances.get(component) || null;
    }
    function __setInstance(component, instance) {
        __instances.set(component, instance);
    }
    function __deleteInstance(component) {
        __instances.delete(component);
    }
    {
        const i18n = {
            // mode
            get mode () {
                return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
            },
            // allowComposition
            get allowComposition () {
                return __allowComposition;
            },
            // install plugin
            async install (app, ...options) {
                if (__VUE_PROD_DEVTOOLS__ && true) app.__VUE_I18N__ = i18n;
                // setup global provider
                app.__VUE_I18N_SYMBOL__ = symbol;
                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                // global method and properties injection for Composition API
                if (!__legacyMode && __globalInjection) $315a3f3f8869d00f$var$injectGlobalFields(app, i18n.global);
                // install built-in components and directive
                if (__VUE_I18N_FULL_INSTALL__) $315a3f3f8869d00f$var$apply(app, i18n, ...options);
                // setup mixin for Legacy API
                if (__VUE_I18N_LEGACY_API__ && __legacyMode) app.mixin($315a3f3f8869d00f$var$defineMixin(__global, __global.__composer, i18n));
                // release global scope
                const unmountApp = app.unmount;
                app.unmount = ()=>{
                    i18n.dispose();
                    unmountApp();
                };
                // setup vue-devtools plugin
                if (__VUE_PROD_DEVTOOLS__ && true) {
                    const ret = await $315a3f3f8869d00f$var$enableDevTools(app, i18n);
                    if (!ret) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                    const emitter = (0, $82c18ee15207f03a$export$6f5e8f34570e3ad1)();
                    if (__legacyMode) {
                        const _vueI18n = __global;
                        _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                    } else {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const _composer = __global;
                        _composer[$315a3f3f8869d00f$var$EnableEmitter] && _composer[$315a3f3f8869d00f$var$EnableEmitter](emitter);
                    }
                    emitter.on("*", $315a3f3f8869d00f$var$addTimelineEvent);
                }
            },
            // global accessor
            get global () {
                return __global;
            },
            dispose () {
                globalScope.stop();
            },
            __instances: // @internal
            __instances,
            __getInstance: // @internal
            __getInstance,
            __setInstance: // @internal
            __setInstance,
            __deleteInstance: // @internal
            __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $315a3f3f8869d00f$export$3f3caade1c12f8c9(options = {}) {
    const instance = (0, $6A78m.getCurrentInstance)();
    if (instance == null) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.NOT_INSLALLED);
    const i18n = $315a3f3f8869d00f$var$getI18nInstance(instance);
    const global = $315a3f3f8869d00f$var$getGlobalComposer(i18n);
    const componentOptions = $315a3f3f8869d00f$var$getComponentOptions(instance);
    const scope = $315a3f3f8869d00f$var$getScope(options, componentOptions);
    if (__VUE_I18N_LEGACY_API__) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {
        if (i18n.mode === "legacy" && !options.__useComponent) {
            if (!i18n.allowComposition) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
            return $315a3f3f8869d00f$var$useI18nForLegacy(instance, scope, global, options);
        }
    }
    if (scope === "global") {
        $315a3f3f8869d00f$var$adjustI18nResources(global, options, componentOptions);
        return global;
    }
    if (scope === "parent") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let composer = $315a3f3f8869d00f$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) composer = global;
        return composer;
    }
    const i18nInternal = i18n;
    let composer = i18nInternal.__getInstance(instance);
    if (composer == null) {
        const composerOptions = (0, $82c18ee15207f03a$export$e6e34fd1f2686227)({}, options);
        if ("__i18n" in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (global) composerOptions.__root = global;
        composer = $315a3f3f8869d00f$var$createComposer(composerOptions);
        $315a3f3f8869d00f$var$setupLifeCycle(i18nInternal, instance, composer);
        i18nInternal.__setInstance(instance, composer);
    }
    return composer;
}
/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 */ const $315a3f3f8869d00f$export$ec8a89fa64fbfb0 = (i18n)=>{
    if (!($315a3f3f8869d00f$var$__VUE_I18N_BRIDGE__ in i18n)) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);
    return i18n;
};
function $315a3f3f8869d00f$var$createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const scope = (0, $57ryt.effectScope)();
    {
        const obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(()=>$315a3f3f8869d00f$var$createVueI18n(options)) : scope.run(()=>$315a3f3f8869d00f$var$createComposer(options));
        if (obj == null) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_ERROR);
        return [
            scope,
            obj
        ];
    }
}
function $315a3f3f8869d00f$var$getI18nInstance(instance) {
    {
        const i18n = (0, $6A78m.inject)(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $315a3f3f8869d00f$export$b19990ca6e622dd2);
        /* istanbul ignore if */ if (!i18n) throw $315a3f3f8869d00f$var$createI18nError(!instance.isCE ? $315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_ERROR : $315a3f3f8869d00f$var$I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE);
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $315a3f3f8869d00f$var$getScope(options, componentOptions) {
    // prettier-ignore
    return (0, $82c18ee15207f03a$export$83b788b1a3698c03)(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function $315a3f3f8869d00f$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
function $315a3f3f8869d00f$var$getComposer(i18n, target, useComponent = false) {
    let composer = null;
    const root = target.root;
    let current = target.parent;
    while(current != null){
        const i18nInternal = i18n;
        if (i18n.mode === "composition") composer = i18nInternal.__getInstance(current);
        else if (__VUE_I18N_LEGACY_API__) {
            const vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$315a3f3f8869d00f$var$InejctWithOption] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $315a3f3f8869d00f$var$setupLifeCycle(i18n, target, composer) {
    let emitter = null;
    (0, $6A78m.onMounted)(()=>{
        // inject composer instance to DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = (0, $82c18ee15207f03a$export$6f5e8f34570e3ad1)();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _composer = composer;
            _composer[$315a3f3f8869d00f$var$EnableEmitter] && _composer[$315a3f3f8869d00f$var$EnableEmitter](emitter);
            emitter.on("*", $315a3f3f8869d00f$var$addTimelineEvent);
        }
    }, target);
    (0, $6A78m.onUnmounted)(()=>{
        // remove composer instance from DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el && target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off("*", $315a3f3f8869d00f$var$addTimelineEvent);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const _composer = composer;
            _composer[$315a3f3f8869d00f$var$DisableEmitter] && _composer[$315a3f3f8869d00f$var$DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
    }, target);
}
function $315a3f3f8869d00f$var$useI18nForLegacy(instance, scope, root, options = {} // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    const isLocale = scope === "local";
    const _composer = (0, $57ryt.shallowRef)(null);
    if (isLocale && instance.proxy && !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
    const _inheritLocale = (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : true;
    const _locale = (0, $57ryt.ref)(// prettier-ignore
    isLocale && _inheritLocale ? root.locale.value : (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $17caac8d5bf4dbbf$export$1af4c7e47ad72f44));
    const _fallbackLocale = (0, $57ryt.ref)(// prettier-ignore
    isLocale && _inheritLocale ? root.fallbackLocale.value : (0, $82c18ee15207f03a$export$844ec244b1367d54)(options.fallbackLocale) || (0, $82c18ee15207f03a$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    const _messages = (0, $57ryt.ref)($315a3f3f8869d00f$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    const _datetimeFormats = (0, $57ryt.ref)((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _numberFormats = (0, $57ryt.ref)((0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : {
        [_locale.value]: {}
    });
    // prettier-ignore
    const _missingWarn = isLocale ? root.missingWarn : (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $82c18ee15207f03a$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    const _fallbackWarn = isLocale ? root.fallbackWarn : (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $82c18ee15207f03a$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    const _fallbackRoot = isLocale ? root.fallbackRoot : (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    const _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    const _missing = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    // postTranslation handler
    const _postTranslation = (0, $82c18ee15207f03a$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    const _warnHtmlMessage = isLocale ? root.warnHtmlMessage : (0, $82c18ee15207f03a$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    const _escapeParameter = !!options.escapeParameter;
    // prettier-ignore
    const _modifiers = isLocale ? root.modifiers : (0, $82c18ee15207f03a$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    const _pluralRules = options.pluralRules || isLocale && root.pluralRules;
    // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    }
    // locale
    const locale = (0, $57ryt.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.locale.value : _locale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.locale.value = val1;
            _locale.value = val1;
        }
    });
    // fallbackLocale
    const fallbackLocale = (0, $57ryt.computed)({
        get: ()=>{
            return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
        },
        set: (val1)=>{
            if (_composer.value) _composer.value.fallbackLocale.value = val1;
            _fallbackLocale.value = val1;
        }
    });
    // messages
    const messages = (0, $57ryt.computed)(()=>{
        if (_composer.value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _composer.value.messages.value;
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _messages.value;
    });
    const datetimeFormats = (0, $57ryt.computed)(()=>_datetimeFormats.value);
    const numberFormats = (0, $57ryt.computed)(()=>_numberFormats.value);
    function getPostTranslationHandler() {
        return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
    }
    function setPostTranslationHandler(handler1) {
        if (_composer.value) _composer.value.setPostTranslationHandler(handler1);
    }
    function getMissingHandler() {
        return _composer.value ? _composer.value.getMissingHandler() : _missing;
    }
    function setMissingHandler(handler1) {
        if (_composer.value) _composer.value.setMissingHandler(handler1);
    }
    function warpWithDeps(fn) {
        trackReactivityValues();
        return fn();
    }
    function t(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.t, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function rt(...args) {
        return _composer.value ? Reflect.apply(_composer.value.rt, null, [
            ...args
        ]) : "";
    }
    function d(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.d, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function n(...args) {
        return _composer.value ? warpWithDeps(()=>Reflect.apply(_composer.value.n, null, [
                ...args
            ])) : warpWithDeps(()=>"");
    }
    function tm(key) {
        return _composer.value ? _composer.value.tm(key) : {};
    }
    function te(key, locale) {
        return _composer.value ? _composer.value.te(key, locale) : false;
    }
    function getLocaleMessage(locale) {
        return _composer.value ? _composer.value.getLocaleMessage(locale) : {};
    }
    function setLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.setLocaleMessage(locale, message);
            _messages.value[locale] = message;
        }
    }
    function mergeLocaleMessage(locale, message) {
        if (_composer.value) _composer.value.mergeLocaleMessage(locale, message);
    }
    function getDateTimeFormat(locale) {
        return _composer.value ? _composer.value.getDateTimeFormat(locale) : {};
    }
    function setDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setDateTimeFormat(locale, format);
            _datetimeFormats.value[locale] = format;
        }
    }
    function mergeDateTimeFormat(locale, format) {
        if (_composer.value) _composer.value.mergeDateTimeFormat(locale, format);
    }
    function getNumberFormat(locale) {
        return _composer.value ? _composer.value.getNumberFormat(locale) : {};
    }
    function setNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setNumberFormat(locale, format);
            _numberFormats.value[locale] = format;
        }
    }
    function mergeNumberFormat(locale, format) {
        if (_composer.value) _composer.value.mergeNumberFormat(locale, format);
    }
    const wrapper = {
        get id () {
            return _composer.value ? _composer.value.id : -1;
        },
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        get inheritLocale () {
            return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
        },
        set inheritLocale (val){
            if (_composer.value) _composer.value.inheritLocale = val;
        },
        get availableLocales () {
            return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
        },
        get modifiers () {
            return _composer.value ? _composer.value.modifiers : _modifiers;
        },
        get pluralRules () {
            return _composer.value ? _composer.value.pluralRules : _pluralRules;
        },
        get isGlobal () {
            return _composer.value ? _composer.value.isGlobal : false;
        },
        get missingWarn () {
            return _composer.value ? _composer.value.missingWarn : _missingWarn;
        },
        set missingWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackWarn () {
            return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
        },
        set fallbackWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackRoot () {
            return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
        },
        set fallbackRoot (val){
            if (_composer.value) _composer.value.fallbackRoot = val;
        },
        get fallbackFormat () {
            return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
        },
        set fallbackFormat (val){
            if (_composer.value) _composer.value.fallbackFormat = val;
        },
        get warnHtmlMessage () {
            return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            if (_composer.value) _composer.value.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
        },
        set escapeParameter (val){
            if (_composer.value) _composer.value.escapeParameter = val;
        },
        t: t,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        rt: rt,
        d: d,
        n: n,
        tm: tm,
        te: te,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getDateTimeFormat: getDateTimeFormat,
        setDateTimeFormat: setDateTimeFormat,
        mergeDateTimeFormat: mergeDateTimeFormat,
        getNumberFormat: getNumberFormat,
        setNumberFormat: setNumberFormat,
        mergeNumberFormat: mergeNumberFormat
    };
    function sync(composer) {
        composer.locale.value = _locale.value;
        composer.fallbackLocale.value = _fallbackLocale.value;
        Object.keys(_messages.value).forEach((locale)=>{
            composer.mergeLocaleMessage(locale, _messages.value[locale]);
        });
        Object.keys(_datetimeFormats.value).forEach((locale)=>{
            composer.mergeDateTimeFormat(locale, _datetimeFormats.value[locale]);
        });
        Object.keys(_numberFormats.value).forEach((locale)=>{
            composer.mergeNumberFormat(locale, _numberFormats.value[locale]);
        });
        composer.escapeParameter = _escapeParameter;
        composer.fallbackFormat = _fallbackFormat;
        composer.fallbackRoot = _fallbackRoot;
        composer.fallbackWarn = _fallbackWarn;
        composer.missingWarn = _missingWarn;
        composer.warnHtmlMessage = _warnHtmlMessage;
    }
    (0, $6A78m.onBeforeMount)(()=>{
        if (instance.proxy == null || instance.proxy.$i18n == null) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const composer = _composer.value = instance.proxy.$i18n.__composer;
        if (scope === "global") {
            _locale.value = composer.locale.value;
            _fallbackLocale.value = composer.fallbackLocale.value;
            _messages.value = composer.messages.value;
            _datetimeFormats.value = composer.datetimeFormats.value;
            _numberFormats.value = composer.numberFormats.value;
        } else if (isLocale) sync(composer);
    });
    return wrapper;
}
const $315a3f3f8869d00f$var$globalExportProps = [
    "locale",
    "fallbackLocale",
    "availableLocales"
];
const $315a3f3f8869d00f$var$globalExportMethods = [
    "t",
    "rt",
    "d",
    "n",
    "tm"
];
function $315a3f3f8869d00f$var$injectGlobalFields(app, composer) {
    const i18n = Object.create(null);
    $315a3f3f8869d00f$var$globalExportProps.forEach((prop)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_ERROR);
        const wrap = (0, $57ryt.isRef)(desc.value) // check computed props
         ? {
            get () {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set (val1) {
                desc.value.value = val1;
            }
        } : {
            get () {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $315a3f3f8869d00f$var$globalExportMethods.forEach((method)=>{
        const desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $315a3f3f8869d00f$var$createI18nError($315a3f3f8869d00f$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, `$${method}`, desc);
    });
}
// register message compiler at vue-i18n
(0, $17caac8d5bf4dbbf$export$6ee2fbe83628b40b)((0, $17caac8d5bf4dbbf$export$1ea8807c727891fc));
// register message resolver at vue-i18n
(0, $17caac8d5bf4dbbf$export$45dacdc710815463)((0, $17caac8d5bf4dbbf$export$d812c8e1906863d0));
// register fallback locale at vue-i18n
(0, $17caac8d5bf4dbbf$export$fd8ec9dd8067edec)((0, $17caac8d5bf4dbbf$export$71df9db82dc445));
$315a3f3f8869d00f$var$initFeatureFlags();
// NOTE: experimental !!
if (__INTLIFY_PROD_DEVTOOLS__) {
    const target = (0, $82c18ee15207f03a$export$ff5f2eeb11fc7e14)();
    target.__INTLIFY__ = true;
    (0, $17caac8d5bf4dbbf$export$c893d6c8966908b9)(target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}


var $3fef6818d98ebd0f$exports = {};
$3fef6818d98ebd0f$exports = {
    "de_CH": {
        "txt": {
            "title": "Tierhaltungs-Rechner",
            "buttonNext": "Weiter",
            "buttonPrevious": "Zur\xfcck",
            "buttonClose": "Schliessen",
            "buttonAcceptWarning": "Verstanden",
            "domain": "tierhaltungsrechner.ch",
            "link": "https://www.tierhaltungsrechner.ch",
            "trButton": {
                "cta": "Erfahre mehr \xfcber artgerechte Haltung:",
                "buttonText": "Tierhaltungsrechner \xf6ffnen"
            },
            "categories": {
                "rodents": {
                    "name": "Nager & Kaninchen"
                },
                "reptiles": {
                    "name": "Reptilien"
                },
                "birds": {
                    "name": "V\xf6gel"
                },
                "equidae": {
                    "name": "Equiden"
                }
            },
            "animals": {
                "rodents": {
                    "degu": {
                        "name": "Degu",
                        "namePlural": "Degus",
                        "minAnimalsErrorMessage": "Degus sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Degus sollten in Gruppen von 2-5 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Degus sollten in Gruppen von 2-5 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 - 5 Tiere\nGruppenzusammenstellung: reine Weibchengruppe, reine M\xe4nnchengruppe, ein kastriertes M\xe4nnchen mit mehreren Weibchen\n"
                        },
                        "laws": {
                            "furnishing": "Geeignete Einstreu zum Graben, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste), Sandbad\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Degus sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Degu",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_degu_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "dwarfHamster": {
                        "name": "Zwerghamster",
                        "namePlural": "Zwerghamster",
                        "minAnimalsWarningMessage": "Achtung, die Haltung von Zwerghamstern ist sehr anspruchsvoll und h\xf6chstens f\xfcr erfahrene Nagerhalter m\xf6glich.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich!",
                        "recommendations": {
                            "socialStructure": "Die Zwerghamsterhaltung ist anspruchsvoll und erfordert viel Erfahrung. Erkundigen Sie sich vor dem Kauf bei Fachpersonen, welche Arten in welchen Gruppengr\xf6ssen und Gruppenzusammenstellungen gehalten werden k\xf6nnen.\n"
                        },
                        "laws": {
                            "furnishing": "Kletterm\xf6glichkeiten, geeignete Einstreu zum Graben, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu, Stroh, K\xf6rnerbeimischungen), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Sowohl die Einzel- wie auch Gruppenhaltung von Zwerghamstern ist erlaubt.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "fancyMouse": {
                        "name": "Farbmaus",
                        "namePlural": "Farbm\xe4use",
                        "minAnimalsErrorMessage": "Farbm\xe4use sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Farbm\xe4use sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Farbm\xe4use sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 - 6 Tiere\nGruppenzusammenstellung: reine Weibchengruppe, ein kastriertes M\xe4nnchen mit mehreren Weibchen\n"
                        },
                        "laws": {
                            "furnishing": "Kletterm\xf6glichkeiten, geeignete Einstreu, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu, Stroh, K\xf6rnerbeimischungen), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Farbm\xe4use sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Farbmaus",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "gerbil": {
                        "name": "Rennmaus",
                        "namePlural": "Rennm\xe4use",
                        "minAnimalsErrorMessage": "Rennm\xe4use sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Rennm\xe4use sollten in Gruppen von 2 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Rennm\xe4use sollten in Gruppen von 2 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 Tiere\nGruppenzusammenstellung: reine Weibchengruppe, reine M\xe4nnchengruppe, ein kastriertes M\xe4nnchen mit einem Weibchen\n"
                        },
                        "laws": {
                            "furnishing": "Geeignete Einstreu zum Graben, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste), Sandbad\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Rennm\xe4use sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Rennmaus",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_rennmaus_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "goldenHamster": {
                        "name": "Goldhamster",
                        "namePlural": "Goldhamster",
                        "maxAnimalsErrorMessage": "Goldhamster sind Einzelg\xe4nger und m\xfcssen alleine gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: Einzelhaltung\n"
                        },
                        "laws": {
                            "furnishing": "Kletterm\xf6glichkeiten, geeignete Einstreu zum Graben, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu, Stroh, K\xf6rnerbeimischungen), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Goldhamster sind Einzelg\xe4nger und m\xfcssen alleine gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Goldhamster",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_goldhamster_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "guineaPig": {
                        "name": "Meerschweinchen",
                        "namePlural": "Meerschweinchen",
                        "minAnimalsErrorMessage": "Meerschweinchen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Meerschweinchen sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Meerschweinchen sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 - 6 Tiere\nGruppenzusammenstellung: reine Weibchengruppe, ein kastriertes M\xe4nnchen mit mehreren Weibchen, z.T. auch reine M\xe4nnchengruppen m\xf6glich\n"
                        },
                        "laws": {
                            "furnishing": "Geeignete Einstreu, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere,  grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste), Vitamin C-haltiges Futter\n",
                            "raisedAreas": "Begehbare erh\xf6hte Fl\xe4chen k\xf6nnen bis zu einem Drittel der geforderten Mindestfl\xe4che angerechnet werden, vorausgesetzt die Fl\xe4che unter der erh\xf6hten Ebene kann von den Tieren auch genutzt werden.\n",
                            "socialStructure": "Meerschweinchen sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Meerschweinchen",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_meerschweinchen_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "rabbit": {
                        "name": "Kaninchen",
                        "namePlural": "Kaninchen",
                        "minAnimalsErrorMessage": "Kaninchen sind soziale Tiere. Die Einzelhaltung ist nur erlaubt, wenn H\xf6r- bzw. Geruchkontakt zu Artgenossen besteht!",
                        "maxAnimalsWarningMessage": "Ab einer Gruppengr\xf6sse von 3 Tieren existieren derzeit nur Empfehlungen zur Mindestfl\xe4che. Die aktuellen Fl\xe4chenempfehlungen sind sehr klein und werden derzeit \xfcberarbeitet.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Kaninchen sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 - 6 Tiere\nGruppenzusammenstellung: ein kastriertes M\xe4nnchen mit 1 oder 2 Weibchen, 2 kastrierte M\xe4nnchen mit 2 - 4 Weibchen, reine Weibchengruppen z.T. auch m\xf6glich\n"
                        },
                        "laws": {
                            "furnishing": "R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Begehbare erh\xf6hte Fl\xe4chen k\xf6nnen der geforderten Mindestfl\xe4che angerechnet werden, vorausgesetzt die Fl\xe4che unter der erh\xf6hten Ebene kann von den Tieren auch genutzt werden (mind. 20 cm).\n",
                            "socialStructure": "Kaninchen sind soziale Tiere. Eine Einzelhaltung ist nur erlaubt, wenn sie H\xf6r- und Geruchkontakt zu Artgenossen haben.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Kaninchen",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_kaninchen_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "rat": {
                        "name": "Ratte",
                        "namePlural": "Ratten",
                        "minAnimalsErrorMessage": "Ratten sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Ratten sollten in Gruppen von 2 - 6 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Ratten sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Empfohlene Gruppengr\xf6sse: 2 - 6 Tiere\nGruppenzusammenstellungen: reine M\xe4nnchengruppen, reine Weibchengruppen, gemischte Gruppe mit kastrierten M\xe4nnchen\n"
                        },
                        "laws": {
                            "furnishing": "geeignete Einstreu, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Ratten sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Ratten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_ratten_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    }
                },
                "reptiles": {
                    "royalPython": {
                        "name": "K\xf6nigspython",
                        "namePlural": "K\xf6nigspythons",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schlangen wird die gesamte K\xf6rperl\xe4nge gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigspythons. K\xf6nigspythons sind gut zu vergesellschaften mit Artgenossen.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigspythons. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigspythons. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Badem\xf6glichkeit, Versteckm\xf6glichkeiten, artgem\xe4sse Temperatur und klimatische Bedingungen, Kletterm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "Ja"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die Beleuchtung muss so installiert sein, dass sich die Tiere nicht daran verbrennen k\xf6nnen, Kletterm\xf6glichkeiten, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, \xc4ste und erh\xf6hte Fl\xe4chen,  Wetbox, Badebecken,  Wasser sowie artgem\xe4sses Futter (Futtertiere)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 26-32\xb0C, lokaler W\xe4rmespot 36\xb0C, nachts Abk\xfchlung, K\xf6nigspythons sind untereinander recht gut vertr\xe4glich und k\xf6nnen bei ausreichend grossem Terrarium auch zu zweit oder zu dritt gehalten werden.\n",
                            "waterBasin": "Badebecken"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt K\xf6nigspython",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_k%C3%B6nigspython_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "cornSnake": {
                        "name": "Kornnatter",
                        "namePlural": "Kornnattern",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schlangen wird die gesamte K\xf6rperl\xe4nge gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kornnattern. Kornnattern sind gut zu vergesellschaften mit Artgenossen.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kornnattern. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kornnattern. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Artgem\xe4sse Temperatur und klimatische Bedingungen, Versteckm\xf6glichkeiten, Kletterm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die Beleuchtung muss so installiert sein, dass sich die Tiere nicht daran verbrennen k\xf6nnen, Badebecken, Kletterm\xf6glichkeiten, lockeres Bodensubstrat, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, \xc4ste, Wetbox, Wasser sowie artgem\xe4sses Futter (Futtertiere)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 24-28\xb0C, lokaler W\xe4rmespot 35\xb0C, nachts Abk\xfchlung, je nach Herkunftsklima ist eine k\xfchle \xdcberwinterung zu empfehlen.\n",
                            "waterBasin": "Badebecken"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Kornnatter",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_kornnatter_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "greekTortoise": {
                        "name": "Griechische Landschildkr\xf6te",
                        "namePlural": "Griechische Landschildkr\xf6ten",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schildkr\xf6ten wird die Panzerl\xe4nge des gr\xf6ssten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten und Boden zum Graben, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Zugang zu nat\xfcrlichem Sonnenlicht, zus\xe4tzlich Auslauf im Freien, M\xf6glichkeit zum \xdcberwintern\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Freilandgehege mit ausbruchsicherer Umz\xe4unung und Abtrennm\xf6glichkeiten, Schutzhaus, z.B. Treibhaus, Fr\xfchbeet, abwechslungsreicher, teilweise grabbarer Bodengrund (Steine, Sand, Kies, Jurakalk etc.), Sonnenpl\xe4tze, R\xfcckzugsm\xf6glichkeiten, z.B. Bepflanzung, Wurzeln, Steine etc., Wasser sowie artgem\xe4sses Futter (Heu, Kr\xe4uter)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die \xdcberwinterung, an die Einrichtung des Geheges und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Eine sichere \xdcberwinterungsm\xf6glichkeit ist wichtig.\n",
                            "more": "Landschildkr\xf6ten haben eine sehr hohe Lebenserwartung (40-80 Jahre)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Europ\xe4ische Landschildkr\xf6ten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_de.pdf"
                            },
                            "1": {
                                "text": "Tierfreundliche Schildkr\xf6tenhaltung in der Praxis",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_de.pdf"
                            },
                            "2": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "moorishTortoise": {
                        "name": "Maurische Landschildkr\xf6te",
                        "namePlural": "Maurische Landschildkr\xf6ten",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schildkr\xf6ten wird die Panzerl\xe4nge des gr\xf6ssten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten und Boden zum Graben, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Zugang zu nat\xfcrlichem Sonnenlicht, zus\xe4tzlich Auslauf im Freien, M\xf6glichkeit zum \xdcberwintern\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Freilandgehege mit ausbruchsicherer Umz\xe4unung und Abtrennm\xf6glichkeiten, Schutzhaus, z.B. Treibhaus, Fr\xfchbeet, abwechslungsreicher, teilweise grabbarer Bodengrund (Steine, Sand, Kies, Jurakalk etc.), Sonnenpl\xe4tze, R\xfcckzugsm\xf6glichkeiten, z.B. Bepflanzung, Wurzeln, Steine etc., Wasser sowie artgem\xe4sses Futter (Heu, Kr\xe4uter)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die \xdcberwinterung, an die Einrichtung des Geheges und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Eine sichere \xdcberwinterungsm\xf6glichkeit ist wichtig.\n",
                            "more": "Landschildkr\xf6ten haben eine sehr hohe Lebenserwartung (40-80 Jahre)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Europ\xe4ische Landschildkr\xf6ten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_de.pdf"
                            },
                            "1": {
                                "text": "Tierfreundliche Schildkr\xf6tenhaltung in der Praxis",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_de.pdf"
                            },
                            "2": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "wideShelledTortoise": {
                        "name": "Breitrandschildkr\xf6te",
                        "namePlural": "Breitrandschildkr\xf6ten",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schildkr\xf6ten wird die Panzerl\xe4nge des gr\xf6ssten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten und Boden zum Graben, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Zugang zu nat\xfcrlichem Sonnenlicht, zus\xe4tzlich Auslauf im Freien, M\xf6glichkeit zum \xdcberwintern\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Freilandgehege mit ausbruchsicherer Umz\xe4unung und Abtrennm\xf6glichkeiten, Schutzhaus, z.B. Treibhaus, Fr\xfchbeet, abwechslungsreicher, teilweise grabbarer Bodengrund (Steine, Sand, Kies, Jurakalk etc.), Sonnenpl\xe4tze, R\xfcckzugsm\xf6glichkeiten, z.B. Bepflanzung, Wurzeln, Steine etc., Wasser sowie artgem\xe4sses Futter (Heu, Kr\xe4uter)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die \xdcberwinterung, an die Einrichtung des Geheges und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Eine sichere \xdcberwinterungsm\xf6glichkeit ist wichtig.\n",
                            "more": "Landschildkr\xf6ten haben eine sehr hohe Lebenserwartung (40-80 Jahre)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Europ\xe4ische Landschildkr\xf6ten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_de.pdf"
                            },
                            "1": {
                                "text": "Tierfreundliche Schildkr\xf6tenhaltung in der Praxis",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_de.pdf"
                            },
                            "2": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "crownedGecko": {
                        "name": "Kronengecko",
                        "namePlural": "Kronengeckos",
                        "article": "der",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kronengeckos. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kronengeckos. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kronengeckos. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten, artgem\xe4sse Temperatur und klimatische Bedingungen, Kletterm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere (z.B. Korkr\xf6hren, Wurzeln, Pflanzen), Kletterm\xf6glichkeiten (z.B. fein verzweigte \xc4ste, Pflanzen), Bodengrund zum Graben, Wasser sowie artgem\xe4sses Futter (Insekten)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, nachts Abk\xfchlung. Wintertemperaturen 5\xb0-6\xb0C tiefer. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich, ihre Vergesellschaftung ist nicht vorzusehen.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "boaConstrictor": {
                        "name": "Abgottschlange",
                        "namePlural": "Abgottschlangen",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schlangen wird die gesamte K\xf6rperl\xe4nge gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Abgottschlangen. Abgottschlangen sind untereinander recht gut vertr\xe4glich und k\xf6nnen bei ausreichend grossem Terrarium auch zu zweit oder zu dritt gehalten werden.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Abgottschlangen. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Abgottschlangen. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Badem\xf6glichkeit, Versteckm\xf6glichkeiten, artgem\xe4sse Temperatur und klimatische Bedingungen, Kletterm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "Ja"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die Beleuchtung muss so installiert sein, dass sich die Tiere nicht daran verbrennen k\xf6nnen, Kletterm\xf6glichkeiten, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, \xc4ste und erh\xf6hte Fl\xe4chen,  Wetbox, Badebecken,  Wasser sowie artgem\xe4sses Futter (Futtertiere)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 26-32\xb0C, lokaler W\xe4rmespot 36\xb0C, nachts Abk\xfchlung, Abgottschlangen sind untereinander recht gut vertr\xe4glich und k\xf6nnen bei ausreichend grossem Terrarium auch zu zweit oder zu dritt gehalten werden.\n",
                            "more": "Abgottschlangen k\xf6nnen \xfcber 4m lang werden. Die hier angegebenen Werte gelten f\xfcr Tiere bis 250cm L\xe4nge. Gr\xf6ssere Tiere ben\xf6tigen gr\xf6ssere Gehege.\n",
                            "waterBasin": "Badebecken 0.5 m\xb2"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "muskTurtle": {
                        "name": "Gew\xf6hnliche Moschusschildkr\xf6te",
                        "namePlural": "Gew\xf6hnliche Moschusschildkr\xf6ten",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schildkr\xf6ten wird die Panzerl\xe4nge des gr\xf6ssten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Moschusschildkr\xf6ten. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Moschusschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Moschusschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Artgem\xe4sse Temperatur und klimatische Bedingungen, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Versteckm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "zus\xe4tzlich zur Fl\xe4che"
                        },
                        "recommendations": {
                            "furnishing": "Artgem\xe4sse Temperatur und klimatische Bedingungen, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Versteckm\xf6glichkeiten\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-28\xb0C, lokaler W\xe4rmespot 35\xb0C, nachts Abk\xfchlung, eine k\xfchle \xdcberwinterung ist zu empfehlen.\n",
                            "waterBasin": "der Gesamtfl\xe4che"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "kingSnake": {
                        "name": "K\xf6nigsnatter",
                        "namePlural": "K\xf6nigsnattern",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schlangen wird die gesamte K\xf6rperl\xe4nge gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigsnattern.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigsnattern. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigsnattern. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Artgem\xe4sse Temperatur und klimatische Bedingungen, Versteckm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die Beleuchtung muss so installiert sein, dass sich die Tiere nicht daran verbrennen k\xf6nnen, Badebecken, Kletterm\xf6glichkeiten, lockeres Bodensubstrat, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, \xc4ste, Wetbox, Wasser sowie artgem\xe4sses Futter (Futtertiere)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 35\xb0C, nachts Abk\xfchlung, je nach Herkunftsklima ist eine k\xfchle \xdcberwinterung zu empfehlen.\n",
                            "more": "K\xf6nigsnattern ern\xe4hren sich auch von anderen Schlangen und d\xfcrfen deshalb nicht mit anderen Schlangen vergesellschaftet werden.\n",
                            "waterBasin": "Badebecken"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "madagascarDayGecko": {
                        "name": "Grosser Madagaskar Taggecko",
                        "namePlural": "Grosse Madagaskar Taggeckos",
                        "article": "der",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Horizontale und vertikale Kletterm\xf6glichkeiten, Versteckm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Sonnenplatz sowie eine UV-emittierende Lichtquelle\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die UV-Beleuchtung muss so installiert sein, dass alle Tiere Zugang zum Licht haben (passende Platzierung und ausreichende Anzahl Sonnenpl\xe4tze), sich aber nicht an den Lampen verbrennen k\xf6nnen, System zur Produktion der f\xfcr die jeweilige Art n\xf6tigen Luftfeuchtigkeit, z.B. Vernebler, Beregnungsanlage, Spr\xfchflasche, Bepflanzung, Wasserfall etc., Messsystem f\xfcr Temperatur und Luftfeuchtigkeit, vielf\xe4ltige und artgem\xe4sse, mindestens k\xf6rperdicke Kletterm\xf6glichkeiten (R\xfcckwand, \xc4ste, Bambusst\xe4be, breitbl\xe4ttrige Pflanzen etc.), artgem\xe4sse R\xfcckzugsm\xf6glichkeiten durch Bepflanzung, Wurzeln, Steine, aufgeschnittene Bambusrohre etc., artgem\xe4sser Bodengrund, Wasser sowie artgem\xe4sses Futter (Insekten, Nektar, Fruchtbrei)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 40\xb0C, nachts Abk\xfchlung. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich, ihre Vergesellschaftung ist nicht vorzusehen.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Grosser Madagaskar-Taggecko",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_taggecko_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "goldDustDayGecko": {
                        "name": "Goldstaub Taggecko",
                        "namePlural": "Goldstaub Taggeckos",
                        "article": "der",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Horizontale und vertikale Kletterm\xf6glichkeiten, Versteckm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Sonnenplatz sowie eine UV-emittierende Lichtquelle\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die UV-Beleuchtung muss so installiert sein, dass alle Tiere Zugang zum Licht haben (passende Platzierung und ausreichende Anzahl Sonnenpl\xe4tze), sich aber nicht an den Lampen verbrennen k\xf6nnen, System zur Produktion der f\xfcr die jeweilige Art n\xf6tigen Luftfeuchtigkeit, z.B. Vernebler, Beregnungsanlage, Spr\xfchflasche, Bepflanzung, Wasserfall etc., Messsystem f\xfcr Temperatur und Luftfeuchtigkeit, vielf\xe4ltige und artgem\xe4sse, mindestens k\xf6rperdicke Kletterm\xf6glichkeiten (R\xfcckwand, \xc4ste, Bambusst\xe4be, breitbl\xe4ttrige Pflanzen etc.), artgem\xe4sse R\xfcckzugsm\xf6glichkeiten durch Bepflanzung, Wurzeln, Steine, aufgeschnittene Bambusrohre etc., artgem\xe4sser Bodengrund, Wasser sowie artgem\xe4sses Futter (Insekten, Nektar, Fruchtbrei)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 40\xb0C, nachts Abk\xfchlung. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich, ihre Vergesellschaftung ist nicht vorzusehen.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Grosser Madagaskar-Taggecko",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_taggecko_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "leopardGecko": {
                        "name": "Leopardgecko",
                        "namePlural": "Leopardgeckos",
                        "article": "der",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Leopardgeckos. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Leopardgeckos. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Leopardgeckos. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten, Grabm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Beleuchtung.\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung; Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere (z.B. Korkr\xf6hren, Wurzeln, mind. ein leicht feuchtes Versteck), Kletterm\xf6glichkeiten (z.B. Steinaufbauten, R\xfcckwand, Wurzeln), Bodengrund zum Graben, Wasser sowie artgem\xe4sses Futter (Insekten)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Winterruhe, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 22-28\xb0C, lokaler W\xe4rmespot 35\xb0C, nachts Abk\xfchlung. M\xe4nnliche Tiere sind territorial, ihre Vergesellschaftung ist nicht empfehlenswert.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Grosser Leopardgeckos",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_leopardgecko_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "dwarfBeardedDragon": {
                        "name": "Zwergbartagame",
                        "namePlural": "Zwergbartagamen",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Kletter- und Versteckm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Sonnenplatz sowie eine UV-emittierende Lichtquelle.\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Erh\xf6hte Liegefl\xe4chen, UV-emittierende Lampen und Grundbeleuchtung, die UV-Beleuchtung muss so installiert sein, dass alle Tiere Zugang haben (passende Platzierung und ausreichende Anzahl Sonnenpl\xe4tze), sich aber nicht daran verbrennen k\xf6nnen (kein direkter Kontakt zum Leuchtk\xf6rper m\xf6glich), Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, Badem\xf6glichkeit, Kletterm\xf6glichkeiten und Felsen, Sand zum Graben, Wasser sowie artgem\xe4sses Futter (Frischfutter, Insekten)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Winterruhe, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 45\xb0C, nachts Abk\xfchlung, je nach Herkunftsklima ist eine k\xfchle \xdcberwinterung zu empfehlen. Auch wenn Bartagamen ausserhalb der Paarungszeit Einzelg\xe4nger sind, ist die Gesellschaft von Artgenossen eine wichtige Bereicherung der Verhaltensoptionen im Terrarium, sofern die Tiere vertr\xe4glich sind.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Streifenk\xf6pfige Bartagame",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "centralBeardedDragon": {
                        "name": "Streifenk\xf6pfige Bartagame",
                        "namePlural": "Streifenk\xf6pfige Bartagamen",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Kletter- und Versteckm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Sonnenplatz sowie eine UV-emittierende Lichtquelle.\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Erh\xf6hte Liegefl\xe4chen, UV-emittierende Lampen und Grundbeleuchtung, die UV-Beleuchtung muss so installiert sein, dass alle Tiere Zugang haben (passende Platzierung und ausreichende Anzahl Sonnenpl\xe4tze), sich aber nicht daran verbrennen k\xf6nnen (kein direkter Kontakt zum Leuchtk\xf6rper m\xf6glich), Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, Badem\xf6glichkeit, Kletterm\xf6glichkeiten und Felsen, Sand zum Graben, Wasser sowie artgem\xe4sses Futter (Frischfutter, Insekten)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Winterruhe, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 45\xb0C, nachts Abk\xfchlung, je nach Herkunftsklima ist eine k\xfchle \xdcberwinterung zu empfehlen. Auch wenn Bartagamen ausserhalb der Paarungszeit Einzelg\xe4nger sind, ist die Gesellschaft von Artgenossen eine wichtige Bereicherung der Verhaltensoptionen im Terrarium, sofern die Tiere vertr\xe4glich sind.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Streifenk\xf6pfige Bartagame",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    }
                },
                "birds": {
                    "diamondDove": {
                        "name": "Diamantt\xe4ubchen",
                        "namePlural": "Diamantt\xe4ubchen",
                        "minAnimalsErrorMessage": "Diamantt\xe4ubchen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Diamantt\xe4ubchen gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein, und in Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Diamantt\xe4ubchen sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung mit mehreren Brutpaaren.",
                            "indoor": "Diamantt\xe4ubchen k\xf6nnen in Innenr\xe4umen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Variante der Haltung von Diamantt\xe4ubchen stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicher) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Diamantt\xe4ubchen sind generell sehr friedlich und k\xf6nnen bei entsprechendem Fachwissen mit anderen friedlichen Vogelarten gemeinsam gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "canary": {
                        "name": "Kanarienvogel",
                        "namePlural": "Kanarienv\xf6gel",
                        "minAnimalsErrorMessage": "Kanarienv\xf6gel sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Kanarien gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Kanarienv\xf6gel sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Kanarienv\xf6gel k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Variante der Kanarienhaltung stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicherem) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Eine gemeinsame Haltung mit einer anderen Vogelart ist nur f\xfcr Personen mit viel Fachwissen empfehlenswert.\nAchtung: Bei Kanarienv\xf6geln gibt es  Zuchtrichtungen (z.B. einige Positurkanarien), welche zu den Qualzuchten geh\xf6ren, bitte keine solchen Tiere kaufen."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Kanarienvogel",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_kanarien_de.pdf"
                            }
                        }
                    },
                    "zebraFinch": {
                        "name": "Zebrafink",
                        "namePlural": "Zebrafinken",
                        "minAnimalsErrorMessage": "Zebrafinken sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Zebrafinken gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Zebrafinken sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Zebrafinken k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Variante der Zebrafinkenhaltung stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (mindestens 12\xb0C)  Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden. Achtung: Im Winterhalbjahr Innenhaltung n\xf6tig!",
                            "specificNeeds": "Eine gemeinsame Haltung mit einer anderen Vogelart ist nur f\xfcr Personen mit viel Fachwissen empfehlenswert."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Zebrafinken",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_zebrafinken_de.pdf"
                            }
                        }
                    },
                    "grayWaxbill": {
                        "name": "Grauastrild",
                        "namePlural": "Grauastrilden",
                        "minAnimalsErrorMessage": "Grauastrilden sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Grauastrilden gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Grauastrilden sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Grauastrilden k\xf6nnen in Innenr\xe4umen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Nur im Sommerhalbjahr m\xf6glich, da Gouldamadinen k\xe4lteempfindlich sind. Im Sommerhalbjahr Aussengehege, welche aus einer Voliere und einem angrenzenden, beheizbaren (mindestens 18\xb0C) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Eine gemeinsame Haltung mit einer anderen Vogelart ist nur f\xfcr Personen mit viel Fachwissen empfehlenswert."
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "goldenBreasted": {
                        "name": "Goldbr\xfcstchen",
                        "namePlural": "Goldbr\xfcstchen",
                        "minAnimalsErrorMessage": "Goldbr\xfcstchen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Goldbr\xfcstchen gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Goldbr\xfcstchen sollten paarweise gehalten werden, da die M\xe4nnchen w\xe4hrend der Brutzeit auf artgleiche Rivalen aggressiv reagieren k\xf6nnen.",
                            "indoor": "Goldbr\xfcstchen k\xf6nnen in Innenr\xe4umen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Nur im Sommerhalbjahr m\xf6glich, da Goldbr\xfcstchen k\xe4lteempfindlich sind. Im Sommerhalbjahr Aussengehege, welche aus einer Voliere und einem angrenzenden, beheizbaren (mindestens 15\xb0C) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.\n",
                            "specificNeeds": '"langlebig, sehr aktiver Vogel, braucht ger\xe4umige Voliere mit Gras und Schilf. \nEine gemeinsame Haltung mit einer anderen Vogelart ist anspruchsvoll und nur f\xfcr Personen mit viel Fachwissen empfehlenswert."'
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "gouldianMadine": {
                        "name": "Gouldamadine",
                        "namePlural": "Gouldamadinen",
                        "minAnimalsErrorMessage": "Gouldamadinen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Gouldamadinen sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Gouldamadinen k\xf6nnen in Innenr\xe4umen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Nur im Sommerhalbjahr m\xf6glich, da Gouldamadinen k\xe4lteempfindlich sind. Im Sommerhalbjahr Aussengehege, welche aus einer Voliere und einem angrenzenden, beheizbaren (mindestens 18\xb0C) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden. Im Winterhalbjahr brauchen Gouldamadinen zwingend Innenhaltung (siehe oben).",
                            "specificNeeds": "Viel Deckung und gen\xfcgend Versteckm\xf6glichkeiten sind f\xfcr die scheuen V\xf6gel elementar. \n\nEine gemeinsame Haltung mit einer anderen Vogelart ist anspruchsvoll und nur f\xfcr Personen mit viel Fachwissen empfehlenswert.\nAuf den Kauf von Farbzuchtmorphen sollte verzichtet werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Gouldamadinen",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Gouldamadinen_de.pdf"
                            }
                        }
                    },
                    "budgerigar": {
                        "name": "Wellensittich",
                        "namePlural": "Wellensittiche",
                        "minAnimalsErrorMessage": "Wellensittiche sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Wellensittiche sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren (mindestens 2, besser 3) Brutpaaren. Daf\xfcr ist eine grosse Voliere n\xf6tig, da M\xe4nnchen w\xe4hrend der Brutzeit den Nistplatz verteidigen.",
                            "indoor": "Wellensittiche k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicher) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.\n",
                            "specificNeeds": '"Wellensittiche brauchen vielf\xe4ltige Kletterm\xf6glichkeiten in Form von verschiedenen, nat\xfcrlichen \xc4sten (Hasel, Weide, Buche, ungespritzte Obstb\xe4ume). Diese dienen gleichzeitig als Nagematerial und sollten regelm\xe4ssig erneuert werden.\n\nEine Vergesellschaftung mit anderen Arten ist m\xf6glich, jedoch nur f\xfcr fachkundige Vogelhalter empfehlenswert. Extreme Zuchtformen (Bsp. V\xf6gel mit Federhauben) sollen nicht erworben werden. "'
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Wellensittiche",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_wellensittiche_de.pdf"
                            }
                        }
                    },
                    "agapornid": {
                        "name": "Agapornid (Unzertrennliche)",
                        "namePlural": "Agaporniden (Unzertrennliche)",
                        "minAnimalsErrorMessage": "Agaporniden sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Agaporniden sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Agaporniden k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicherem) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.\n\n",
                            "specificNeeds": '"F\xfcr die Heimtierhaltung kommen in erster Linie Pfirsichk\xf6pfchen, Rosenk\xf6pfchen, Schwarzk\xf6pfchen und Russk\xf6pfchen in Frage. Die anderen Agapornidenarten sind anspruchsvoller und daher f\xfcr Anf\xe4nger nicht empfehlenswert.\nEinige Agapornidenarten k\xf6nnen ziemlich aggressiv sein und sind nicht f\xfcr die gemeinsame Haltung mit anderen Arten geeignet.\n\nAgaporniden k\xf6nnen ziemlich laut sein. Daher muss auch die Nachbarschaft mit der Haltung einverstanden sein."'
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Agaporniden",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_de.pdf"
                            }
                        }
                    },
                    "tarantaParrot": {
                        "name": "Tarantapapagei (Bergpapagei)",
                        "namePlural": "Tarantapapageien (Bergpapageien)",
                        "minAnimalsErrorMessage": "Tarantapapageien sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Tarantapapageien sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Tarantapapageien k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicherem) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.\n\n",
                            "specificNeeds": "Tarantapapageien stellen die gr\xf6sste Art der Agaporniden (Unzertrennliche) dar. \nDie Haltung von dieser Agaporniden-Art ist anspruchsvoll und nicht f\xfcr Anf\xe4nger geeignet.\nEine Vergesellschaftung mit anderen Arten ist m\xf6glich, jedoch nur f\xfcr fachkundige Vogelhalter empfehlenswert. \nTarantapapageien k\xf6nnen zudem ziemlich laut sein. Daher muss auch die Nachbarschaft mit der Haltung einverstanden sein."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Agaporniden",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_de.pdf"
                            }
                        }
                    },
                    "cockatiel": {
                        "name": "Nymphensittich",
                        "namePlural": "Nymphensittiche",
                        "minAnimalsErrorMessage": "Nymphensittiche sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Nymphensittiche sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Nymphensittiche k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicherem) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Nymphensittiche brauchen vielf\xe4ltige Kletterm\xf6glichkeiten in Form von verschiedenen, nat\xfcrlichen \xc4sten (Hasel, Weide, Buche, ungespritzte Obstb\xe4ume). Diese dienen gleichzeitig als Nagematerial und sollten regelm\xe4ssig erneuert werden.\n\nEine Vergesellschaftung mit anderen Arten ist m\xf6glich, jedoch nur f\xfcr fachkundige Vogelhalter empfehlenswert."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Nymphensittiche",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Nymphensittiche_de.pdf"
                            }
                        }
                    },
                    "beautifulParakeet": {
                        "name": "Sch\xf6nsittich",
                        "namePlural": "Sch\xf6nsittiche",
                        "minAnimalsErrorMessage": "Sch\xf6nsittiche sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung eines Brutpaares ist am tiergerechtesten. Es muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, denn Sch\xf6nsittiche k\xf6nnen sowohl auf Artgenossen als auch auf andere Vogelarten ziemlich aggressiv  reagieren.",
                        "maxAnimalsErrorMessage": "Achtung! Die Haltung von Sch\xf6nsittichen ist aspruchsvoll: Sch\xf6nsittiche sollten als Paar gehalten werden, da sie aggressiv auf Artgenossen und andere Vogelarten reagieren k\xf6nnen.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein, und in Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Sch\xf6nsittiche sind sehr gesellig, k\xf6nnen aber sehr aggressiv gegen\xfcber anderen V\xf6geln, auch Artgenossen, sein. F\xfcr Sch\xf6nsittiche ist daher eine Paarhaltung zu empfehlen.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicher) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": '"Sch\xf6nsittiche ben\xf6tigen eine m\xf6glichst grosse Freiflugfl\xe4che, da ihr Flug geradlinig ist. Sie ben\xf6tigen zudem ausreichend Besch\xe4ftigung und Nagem\xf6glichkeiten in Form von verschiedenen ungiftigen, frischen \xc4sten.\nVon einer Vergesellschaftung mit anderen Vogelarten ist abzuraten , da sie aggressiv reagieren k\xf6nnen. "'
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "rosellaConure": {
                        "name": "Rosellasittich",
                        "namePlural": "Rosellasittiche",
                        "minAnimalsErrorMessage": "Rosellasittiche sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Rosellasittiche sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren. Bei der Haltung von mehreren Paaren muss die Voliere sehr gross sein, da die M\xe4nnchen w\xe4hrend der der Balz- und Brutzeit sehr aggressiv sind.",
                            "indoor": "Rosellasittiche k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicheren) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": '"Rosellasittiche ben\xf6tigen eine m\xf6glichst grosse Freiflugfl\xe4che, da sie sehr lebhaft sind. Sie ben\xf6tigen zudem ausreichend Besch\xe4ftigung und Nagem\xf6glichkeiten in Form von verschiedenen ungiftigen, frischen \xc4sten.\nEine Vergesellschaftung mit anderen Arten ist m\xf6glich, jedoch nur f\xfcr fachkundige Vogelhalter empfehlenswert. "'
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "cockatoo": {
                        "name": "Kakadu",
                        "namePlural": "Kakadus",
                        "minAnimalsErrorMessage": "Kakadus sind soziale Tiere. Die Einzelhaltung ist deshalb verboten! Die Haltung von Kakadus (ausser Nymphensittich) ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Kakakdus zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "maxAnimalsWarningMessage": "Die Haltung von Kakadus (ausser Nymphensittich) ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Kakakdus zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "maxAnimalsErrorMessage": "Die Haltung von Kakadus (ausser Nymphensittich) ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Kakakdus zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "laws": {},
                        "recommendations": {
                            "general": "Aus Tierschutzgr\xfcnden r\xe4t der Schweizer Tierschutz STS von der privaten Ara-/Kakadu-Haltung ab. Der Platzbedarf f\xfcr eine tiergerechte Ara-/Kakadu-Haltung ist immens und kann von privaten Haltern meistens nicht erf\xfcllt werden. Die Haltung von Kakadus oder Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Vor dem Kauf eines Kakadus oder Aras muss ein Sachkundekurs (SKN) absolviert werden. Zudem muss ein Gesuch an das kantonale Veterin\xe4ramt des Wohnsitzkantons gestellt werden und gezeigt werden, dass alle gesetzlich vorgeschriebenen Anforderungen in Bezug auf Haltung, Pflege und Erwerb erf\xfcllt werden k\xf6nnen. Wenn Sie beabsichtigen  Kakadus oder Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons."
                        },
                        "links": {
                            "0": {
                                "text": "Fachinformation Tierschutz - Bewilligungspflicht f\xfcr die Haltung von Grosspapageien - Bundesamt f\xfcr Lebensmittelsicherheit und Veterin\xe4rwesen BLV",
                                "file": "https://www.blv.admin.ch/dam/blv/de/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/D_3.1_Fachinformation_Bewilligungspflicht_f%C3%BCr_Grosspapageien.pdf"
                            }
                        }
                    },
                    "macaw": {
                        "name": "Ara",
                        "namePlural": "Aras",
                        "minAnimalsErrorMessage": "Aras sind soziale Tiere. Die Einzelhaltung ist deshalb verboten! \nDie Haltung von Grosspapageien wie Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "maxAnimalsWarningMessage": "Die Haltung von Grosspapageien wie Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "maxAnimalsErrorMessage": "Die Haltung von Grosspapageien wie Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "laws": {},
                        "recommendations": {
                            "general": "Aus Tierschutzgr\xfcnden r\xe4t der Schweizer Tierschutz STS von der privaten Ara-/Kakadu-Haltung ab. Der Platzbedarf f\xfcr eine tiergerechte Ara-/Kakadu-Haltung ist immens und kann von privaten Haltern meistens nicht erf\xfcllt werden. Die Haltung von Kakadus oder Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Vor dem Kauf eines Kakadus oder Aras muss ein Sachkundekurs (SKN) absolviert werden. Zudem muss ein Gesuch an das kantonale Veterin\xe4ramt des Wohnsitzkantons gestellt werden und gezeigt werden, dass alle gesetzlich vorgeschriebenen Anforderungen in Bezug auf Haltung, Pflege und Erwerb erf\xfcllt werden k\xf6nnen. Wenn Sie beabsichtigen  Kakadus oder Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons."
                        },
                        "links": {
                            "0": {
                                "text": "Fachinformation Tierschutz - Bewilligungspflicht f\xfcr die Haltung von Grosspapageien - Bundesamt f\xfcr Lebensmittelsicherheit und Veterin\xe4rwesen BLV",
                                "file": "https://www.blv.admin.ch/dam/blv/de/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/D_3.1_Fachinformation_Bewilligungspflicht_f%C3%BCr_Grosspapageien.pdf"
                            }
                        }
                    },
                    "congoGreyParrot": {
                        "name": "Kongo-Graupapagei",
                        "namePlural": "Kongo-Graupapageien",
                        "minAnimalsErrorMessage": "Graupapageien sind soziale Tiere. Die Einzelhaltung ist daher verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 6 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Graupapageien sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Eine reine Innenhaltung ist f\xfcr Graupapageien nicht tiergerecht. ",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicher) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Eine tiergerechte Haltung von Graupapgageien ist h\xf6chst anspruchsvoll. \nDer Handel mit diesen \xe4usserst langlebigen Tieren boomt und es gibt sehr viele Angebote von skrupellosen Anbieteren (z.B. Handaufzuchten, Importe aus unklarer Quelle). Graupapageien k\xf6nnen laut sein, daher muss die Nachbarschaft mit der Haltung ebenfalls einverstanden sein. \n\nAus Tierschutzgr\xfcnden sollten Sie auf den Kauf von Tieren aus Handaufzuchten verzichten."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Graupapageien",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_graupapageien_de.pdf"
                            }
                        }
                    },
                    "amazon": {
                        "name": "Amazone",
                        "namePlural": "Amazonen",
                        "minAnimalsErrorMessage": "Amazonen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 6 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein, und in Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Amazonen sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Eine reine Innenhaltung ist f\xfcr Amazonen nicht tiergerecht. ",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostfrei) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Amazonen sind laute V\xf6gel, daher muss die Nachbarschaft mit der Haltung ebenfalls einverstanden sein. \n\nEs existieren verschiedene Amazonenarten, und nicht jede ist als Heimtier geeignet. Am h\xe4ufigsten ist die Blaustirnamazone. Jede Art hat ihre eigenen, artspezifischen Bed\xfcrfnisse in Bezug auf Haltung, Klima, F\xfctterung, und Sozialstruktur. Bitte informieren Sie sich bei ausgewiesenen Fachpersonen oder absolvieren Sie einen Sachkundekurs vor dem Kauf.\nAus Tierschutzgr\xfcnden sollten Sie auf den Kauf von Tieren aus Handaufzuchten verzichten."
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    }
                },
                "equidae": {
                    "horse": {
                        "name": "Pferd",
                        "namePlural": "Pferde",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontakt zu anderen Equiden haben. Optimalerweise mit einem Artgenossen, also einem anderen Pferd.",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Wenn immer m\xf6glich",
                            "socialStructure": "Pferde sollten direkten Kontakt zu anderen Pferden haben. Pferde und Esel sprechen eine andere Sprache und haben unterschiedliche Anforderungen an ihre Haltung und F\xfctterung.",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Pferde 2 x 2 h / Woche; Ungenutzte Pferde t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Pferdehaltung",
                                "file": "https://www.tierschutz.com/pferde"
                            },
                            "1": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    },
                    "pony": {
                        "name": "Pony",
                        "namePlural": "Ponys",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontakt zu anderen Equiden haben. Optimalerweise mit einem Artgenossen, also mit einem anderen Pony oder Pferd.",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Wenn immer m\xf6glich, jedoch dem Ern\xe4hrungszustand anpassen!",
                            "socialStructure": "Ponys sollten direkten Kontakt zu anderen Ponys oder Pferden haben. ",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden.",
                            "specialRequirements": "Bei jungem, eiwei\xdf- bzw. fruktanreichem Gras besteht insbesondere bei Ponys eine gesteigerte Gefahr an Verfettung, vor allem wenn die Ponys nicht ausreichend bewegt werden."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Ponys 2 x 2 h / Woche; Ungenutzte Ponys t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Pferdehaltung",
                                "file": "https://www.tierschutz.com/pferde"
                            },
                            "1": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    },
                    "donkey": {
                        "name": "Esel",
                        "namePlural": "Esel",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontakt zu anderen Equiden haben. Optimalerweise mit einem Artgenossen, also in diesem Fall mit einem anderen Esel.  ",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Begrenzter Weidegang f\xfcr Esel, mehr Bewegung auf grossen Trockenpl\xe4tzen",
                            "socialStructure": "Esel brauchen den direkten Kontakt zu Artgenossen, also anderen Eseln. Sie unterscheiden sich in ihrem Verhalten und ihrer Physiologie von den Pferden. Zus\xe4tzliche Futter- und Besch\xe4ftigungsangebote mit hohem Faseranteil wie \xc4ste und Stroh sind vorzusehen.",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden.",
                            "specialRequirements": "Esel sind sehr effiziente Futterverwerter. Sie brauchen energiearme Nahrung mit niedrigem Zucker- und Proteingehalt, aber hohem Rohfaseranteil. Das Fell der Esel ist kaum wasserabweisend. Bei N\xe4sse sind Esel krankheitsanf\xe4llig. Sie brauchen stets einen trockenen Unterstand. Esel ben\xf6tigen trockenen Untergrund, sonst drohen Hufprobleme."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Esel 2 x 2 h / Woche; Ungenutzte Esel t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Esel",
                                "file": "https://www.tierschutz.com/esel"
                            },
                            "1": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    },
                    "mule": {
                        "name": "Maultier",
                        "namePlural": "Maultiere",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontaktt zu anderen Equiden haben. Optimalerweise mit einem anderen Maultier",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Begrenzter Weidegang",
                            "socialStructure": "Maultiere bevorzugen den Kontakt zu anderen Maultieren. Selbstverst\xe4ndlich k\xf6nnen Maultiere mit ihrer Mutterstute gehalten werden. Dabei ist aber ihre Physiologie in Bezug auf die F\xfctterung und Weidegang zu beachten. ",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Maultiere 2 x 2 h / Woche; Ungenutzte Maultiere t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Pferdehaltung",
                                "file": "https://www.tierschutz.com/pferde"
                            },
                            "1": {
                                "text": "STS Webseite Esel",
                                "file": "https://www.tierschutz.com/esel"
                            },
                            "2": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    },
                    "hinny": {
                        "name": "Maulesel",
                        "namePlural": "Maulesel",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontakt zu anderen Equiden haben. Optimalerweise mit einem anderen Maulesel.",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Begrenzter Weidegang",
                            "socialStructure": "Maultesel bevorzugen den direkten Kontakt zu Mauleseln. Sie k\xf6nnen aber auch mit Esel und/oder Pferden gehalten werden. Dabei ist aber ihre Physiologie in Bezug auf die F\xfctterung und Weidegang zu beachten.",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Maulesel 2 x 2 h / Woche; Ungenutzte Maulesel t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Pferdehaltung",
                                "file": "https://www.tierschutz.com/pferde"
                            },
                            "1": {
                                "text": "STS Webseite Esel",
                                "file": "https://www.tierschutz.com/esel"
                            },
                            "2": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    }
                }
            },
            "screenCategory": {
                "title": "Kategorie ausw\xe4hlen"
            },
            "screenAnimal": {
                "title": "Welches Tier m\xf6chtest du halten?",
                "multipleBirdsButton": "Mehrere Arten zusammen halten",
                "equidaeInfo": "Die berechneten Werte gelten nur f\xfcr Equiden \xfcber 30 Monaten."
            },
            "screenMultipleBirds": {
                "warning": "Um zwei oder mehr Vogelarten zusammen zu halten, muss die Gehegegr\xf6sse f\xfcr alle Arten separat berechnet werden, aber mit der Gesamtzahl V\xf6gel. Das gr\xf6sste berechnete Gehege entspricht den gesetzlichen Mindestmassen.",
                "infoText": "Werden in einem Gehege zwei oder mehr Vogelarten gemeinsam gehalten, so entspricht die gesetzliche Gehegemindestgr\xf6sse immer den Platz-Anforderungen an die gr\xf6sste Vogelart. Werden zum Beispiel zwei Wellensittiche und zwei Nymphensittiche in einem Gehege zusammen gehalten, entspricht die minimale Gehegegr\xf6sse den Anforderungen f\xfcr vier Nymphensittiche, da dies die gr\xf6sste Vogelart im Gehege ist. Die gemeinsame Haltung von mehreren Vogelarten ist nur f\xfcr erfahrene Vogelhalter geeignet. Informieren Sie sich stets sorgf\xe4ltig, welche Vogelarten gemeinsam gehalten werden k\xf6nnen."
            },
            "screenNumber": {
                "title": "Wie viele {animals} m\xf6chtest du halten?"
            },
            "screenWeight": {
                "title": "Wie schwer sind die {animals}?"
            },
            "screenLength": {
                "title": "Wie lange ist {article} gr\xf6sste {animal}?",
                "error": "Bitte eine Zahl zwischen {min} und {max} eingeben."
            },
            "screenWithersHeight": {
                "title": "Wie hoch ist die Widerrist-H\xf6he der einzelnen Tiere?",
                "error": "Bitte eine Zahl zwischen {min} und {max} eingeben.",
                "animal": "Tier"
            },
            "screenResults": {
                "title": "So solltest du {number} {animals} halten",
                "example": "Beispiel",
                "exampleEquidae": "Beispiel f\xfcr Boxengr\xf6sse",
                "stsRecommendation": "Tierschutz-Empfehlung",
                "law": "Gesetz",
                "stsAreaRecommendation": "Mindestfl\xe4che (Innenmasse)",
                "stsLengthRecommendation": {
                    "upto2reptiles": "Mindestl\xe4nge (Innenmasse)",
                    "morethan2reptiles": "Zus\xe4tzlich mindestens in der L\xe4nge"
                },
                "stsWidthRecommendation": {
                    "upto2reptiles": "Mindestbreite (Innenmasse)",
                    "morethan2reptiles": "Zus\xe4tzlich mindestens in der Breite"
                },
                "stsHeightRecommendation": "Mindesth\xf6he Gehege (Innenmasse)",
                "stsBeddingRecommendation": "Mindesteinstreutiefe",
                "stsWaterBasinRecommendation": "Wasserbecken",
                "tolerance": "Toleranzwert",
                "toleranceInfo": "Am 1. September 2008 bestehende Stallungen, die die Toleranzwerte erf\xfcllen, m\xfcssen nicht angepasst werden. Muss ein Stall wegen Unterschreiten eines Toleranzwertes angepasst werden, so bleibt der Anspruch auf den anderen Toleranzwert erhalten.",
                "noTolerance": "kein Toleranzwert",
                "stsLayingAreaRecommendation": "Liegefl\xe4che",
                "stsClearWidthRecommendation": "Lichte Breite",
                "stsClearWidthRecommendationInfo": "2 x Widerrist des gr\xf6ssten Tieres",
                "stsClearHeightRecommendation": "Lichte H\xf6he",
                "stsRunoutTimeRecommendation": "Auslaufzeit",
                "stsRunoutTimeRecommendationText": "Am besten 24 h freier Zugang zum Allwetterauslauf aber mindestens 4 Stunden t\xe4glich",
                "stsRunoutAreaRecommendation": "Auslauffl\xe4che",
                "stsPasturingRecommendation": "Weidegang",
                "stsLatticeSpacing": "Maximaler Gitterabstand",
                "lawMinimalArea": "Mindestfl\xe4che (Innenmasse)",
                "lawMinimalLength": "Mindestl\xe4nge (Innenmasse)",
                "lawMinimalWidth": "Mindestbreite (Innenmasse)",
                "lawMinimalHeight": "Mindesth\xf6he Gehege (Innenmasse)",
                "lawMinimalBedding": "Mindesteinstreutiefe",
                "lawWaterBasin": "Wasserbecken",
                "lawReptilesInfo": {
                    "text": "Bei der Haltung der eingegebenen Anzahl Tiere muss sichergestellt werden, dass f\xfcr die jeweilige Tierart s\xe4mtliche gesetzlichen Anforderungen {link} erf\xfcllt sind.",
                    "linkText": "gem\xe4ss Anhang 2, Tabelle 5 TSchV",
                    "linkURL": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                },
                "lawVolume": "Volumen",
                "lawLayingArea": "Liegefl\xe4che Einraumlaufstall",
                "layingAreaInfo": "Liegefl\xe4chen r\xe4umlich nicht vom Fressbereich getrennt, weitere Bedingungen siehe Tierschutzverordnung Tabelle 7.",
                "lawLayingAreaMultiroom": "Liegefl\xe4che Mehrraumlaufstall",
                "layingAreaMultiroomInfo": "Liegefl\xe4che sind r\xe4umlich, z. B. durch eine Wand oder andere Raumteiler, vom Fress- und Bewegungsbereich getrennt. Weitere Bedingungen siehe Tierschutzverordnung Tabelle 7.",
                "lawClearWidth": "Lichte Breite",
                "lawClearWidthInfo": "1.5 x Widerrist des gr\xf6ssten Tieres",
                "lawClearHeight": "Lichte H\xf6he",
                "lawRunoutTime": "Auslaufzeit",
                "lawRunoutAreaAdjacent": "Auslauffl\xe4che angrenzend",
                "lawRunoutAreaNonadjacent": "Auslauffl\xe4che nicht angrenzend",
                "lawPasturing": "Weidegang",
                "additionalRecommendations": {
                    "title": "Weitere Empfehlungen",
                    "furnishing": "Einrichtung",
                    "socialStructure": "Sozialstruktur",
                    "socialSturctureAndSpecificNeeds": "Sozialstruktur und artspezifische Bed\xfcrfnisse",
                    "indoorOutdoor": "Aussen- oder Innenhaltung",
                    "indoor": "Innenhaltung",
                    "outdoor": "Aussenhaltung",
                    "specificNeeds": "Besondere artspezifische Bed\xfcrfnisse",
                    "specialRequirements": "Spezielle Anforderungen",
                    "more": "Weiteres",
                    "activity": "Bewegung"
                },
                "additionalLaws": {
                    "title": "Weitere gesetzliche Vorschriften",
                    "furnishing": "Einrichtung",
                    "raisedAreas": "Erh\xf6hte Fl\xe4chen",
                    "socialStructure": "Sozialstruktur",
                    "structuring": "Strukturierung",
                    "activity": "Bewegung",
                    "exercise": "Besch\xe4ftigung"
                },
                "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestvorschriften nur um das absolute Minimum handelt. Tiere in kleineren Gehegen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. \nF\xfcr eine tiergerechte Haltung braucht es sehr viel gr\xf6ssere Fl\xe4chen und eine gut strukturierte Einrichtung (siehe Empfehlungen).",
                "furnishing": "Gesetzlich geforderte Einrichtung",
                "additionalInfo": "F\xfcr mehr Informationen"
            }
        }
    },
    "fr_CH": {
        "txt": {
            "title": "Calculateur enclos animaux",
            "buttonNext": "Suivant",
            "buttonPrevious": "Retour",
            "buttonClose": "Fermer",
            "buttonAcceptWarning": "Compris",
            "domain": "calculateur-enclos-animaux.ch",
            "link": "https://www.calculateur-enclos-animaux.ch/",
            "trButton": {
                "cta": "Pour en savoir plus sur le bien-\xeatre des animaux :",
                "buttonText": "Ouvrir le calculateur des enclos pour animaux"
            },
            "categories": {
                "rodents": {
                    "name": "Rongeurs & lapins"
                },
                "reptiles": {
                    "name": "Reptiles"
                },
                "birds": {
                    "name": "Oiseaux"
                },
                "equidae": {
                    "name": "\xc9quid\xe9s"
                }
            },
            "animals": {
                "rodents": {
                    "degu": {
                        "name": "D\xe8gue",
                        "namePlural": "D\xe8gues",
                        "minAnimalsErrorMessage": "Les d\xe8gues sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les d\xe8gues doivent \xeatre d\xe9tenus en groupes de 2 \xe0 5 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les d\xe8gues doivent \xeatre d\xe9tenus en groupes de 2 \xe0 5 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe: 2 \xe0 5 animaux\nComposition du groupe: groupe uniquement de femelles, groupe uniquement de m\xe2les, un m\xe2le castr\xe9 avec plusieurs femelles\n"
                        },
                        "laws": {
                            "furnishing": "Liti\xe8re adapt\xe9e pour creuser, possibilit\xe9s de retrait pour tous les animaux, fourrage grossier (foin ou paille), objets \xe0 ronger (branches fra\xeeches...), bain de sable\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les d\xe8gues sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenus sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: D\xe8gue du Chili",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_degu_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "dwarfHamster": {
                        "name": "Hamster nain",
                        "namePlural": "Hamsters nains",
                        "minAnimalsWarningMessage": "Attention, la d\xe9tention de hamsters nains est tr\xe8s d\xe9licate et r\xe9serv\xe9e \xe0 des d\xe9tenteurs de rongeurs exp\xe9riment\xe9s.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe!",
                        "recommendations": {
                            "socialStructure": "La d\xe9tention de hamsters nains est d\xe9licate et demande beaucoup d’exp\xe9rience. Avant d’acheter, renseignez-vous aupr\xe8s des professionnels pour savoir quelles esp\xe8ces peuvent \xeatre d\xe9tenues dans quelles tailles et compositions de groupes\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper, liti\xe8re adapt\xe9e pour creuser, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel de nidification appropri\xe9, fourrage grossier (foin, paille, m\xe9langes de graines), objets \xe0 ronger (branches fra\xeeches...)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "La d\xe9tention individuelle et en groupe de hamsters nains est autoris\xe9e.\n"
                        },
                        "links": {
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "fancyMouse": {
                        "name": "Souris domestique",
                        "namePlural": "Souris domestiques",
                        "minAnimalsErrorMessage": "Les souris domestiques sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les souris domestiques doivent \xeatre d\xe9tenues en groupes de 2 \xe0 6 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les souris domestiques doivent \xeatre d\xe9tenues en groupes de 2 \xe0 6 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \xe0 6 animaux\nComposition du groupe: groupe uniquement de femelles, un m\xe2le castr\xe9 avec plusieurs femelles\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper, liti\xe8re adapt\xe9e, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel de nidification appropri\xe9, fourrage grossier (foin, paille, m\xe9langes de graines), objets \xe0 ronger (branches fra\xeeches...)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les souris domestiques sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenues sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Souris domestique",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_farbm%C3%A4use_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "gerbil": {
                        "name": "Gerbille",
                        "namePlural": "Gerbilles",
                        "minAnimalsErrorMessage": "Les gerbilles sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les gerbilles doivent \xeatre d\xe9tenues en groupes de 2 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les gerbilles doivent \xeatre d\xe9tenues en groupes de 2 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \nComposition du groupe: groupe uniquement de femelles, groupe uniquement de m\xe2les, un m\xe2le castr\xe9 avec une femelle\n"
                        },
                        "laws": {
                            "furnishing": "Liti\xe8re adapt\xe9e pour creuser, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel adapt\xe9 pour faire un nid, fourrage grossier (foin ou paille), objets \xe0 ronger (branches fra\xeeches...), bain de sable\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les gerbilles sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenues sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Gerbilles de Mongolie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_rennmaus_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "goldenHamster": {
                        "name": "Hamster dor\xe9",
                        "namePlural": "Hamsters dor\xe9s",
                        "maxAnimalsErrorMessage": "Les hamsters dor\xe9s sont des animaux solitaires et doivent \xeatre d\xe9tenus seuls.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 1\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper, liti\xe8re adapt\xe9e pour creuser, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel de nidification appropri\xe9, fourrage grossier (foin, paille, m\xe9langes de graines), objets \xe0 ronger (branches fra\xeeches...)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les hamsters dor\xe9s sont des animaux solitaires et doivent \xeatre d\xe9tenus seuls.\n",
                            "links": {
                                "0": {
                                    "text": "Feulle d’information PSA: Hamster dor\xe9 de Syrie",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_goldhamster_fr.pdf"
                                },
                                "1": {
                                    "text": "D\xe9tenir des rongeurs et des Lapins",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                                },
                                "2": {
                                    "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                                },
                                "3": {
                                    "text": "Assortiment des animaleries et boutiques en ligne",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                                },
                                "4": {
                                    "text": "Check-list animaleries",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                                }
                            }
                        }
                    },
                    "guineaPig": {
                        "name": "Cochon d’Inde",
                        "namePlural": "Cochons d’Inde",
                        "minAnimalsErrorMessage": "Les cochons d’Inde sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les cochons d’Inde doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les cochons d’Inde doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \xe0 6 animaux\nComposition du groupe: groupe uniquement de femelles ou un m\xe2le castr\xe9 avec plusieurs femelles, parfois aussi en groupes uniquement de m\xe2les\n"
                        },
                        "laws": {
                            "furnishing": "Liti\xe8re adapt\xe9e, possibilit\xe9s de retrait pour tous les animaux, objets \xe0 ronger (branches fra\xeeches...), fourrage grossier (foin ou paille), aliments contenant de la vitamine C\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es praticables peuvent \xeatre compt\xe9es jusqu’\xe0 un tiers de la surface minimale requise, \xe0 condition que la surface inf\xe9rieure soit aussi utilisable par les animaux.\n",
                            "socialStructure": "Les cochons d’Inde sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenus sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Cochons d’Inde",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_meerschweinchen_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "rabbit": {
                        "name": "Lapin",
                        "namePlural": "Lapins",
                        "minAnimalsErrorMessage": "Les lapins sont des animaux sociaux. La d\xe9tention individuelle n’est autoris\xe9e qu’en cas de contact auditif ou olfactif avec d’autres cong\xe9n\xe8res!",
                        "maxAnimalsWarningMessage": "Actuellement, \xe0 partir d'une taille de groupe de trois animaux, les recommandations concernent uniquement la surface minimale. Les recommandations actuelles en mati\xe8re de surface sont tr\xe8s r\xe9duites et en cours de r\xe9vision.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les lapins doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \xe0 6 animaux\nComposition du groupe: un m\xe2le castr\xe9 avec 1 ou 2 femelles, 2 m\xe2les castr\xe9s avec 2 \xe0 4 femelles, des groupes uniquement de femelles sont parfois aussi possibles\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe9s de retrait pour tous les animaux, objets \xe0 ronger (branches fra\xeeches...), fourrage grossier (foin ou paille)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es praticables peuvent \xeatre compt\xe9es dans la surface minimale requise, \xe0 condition que la surface inf\xe9rieure soit aussi utilisable par les animaux.\n",
                            "socialStructure": "Les lapins sont des animaux sociaux. La d\xe9tention individuelle n’est autoris\xe9e qu’en cas de contact auditif et olfactif avec d’autres cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Lapin",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_kaninchen_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "rat": {
                        "name": "Rat",
                        "namePlural": "Rats",
                        "minAnimalsErrorMessage": "Les rats sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les rats doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les rats doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \xe0 6 animaux\nComposition du groupe: groupes uniquement de m\xe2les, groupes uniquement de femelles, groupe mixte avec m\xe2les castr\xe9s\n"
                        },
                        "laws": {
                            "furnishing": "Liti\xe8re adapt\xe9e, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel de nidification appropri\xe9, fourrage grossier (foin, paille, m\xe9langes de graines), objets \xe0 ronger (branches fra\xeeches...)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les rats sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenus sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Le rat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_ratten_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    }
                },
                "reptiles": {
                    "royalPython": {
                        "name": "Python royal",
                        "namePlural": "Pythons royaux",
                        "textLength": "Pour les serpents, on mesure toute la longueur du corps.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des pythons royaux. Les pythons royaux cohabitent bien avec leurs cong\xe9n\xe8res.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des pythons royaux. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des pythons royaux. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9 de baignade, possibilit\xe9s de se cacher, temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de grimper\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "Oui"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, possibilit\xe9s de grimper, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, branches et plateformes sur\xe9lev\xe9es, Wetbox, bassin, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 26-32 \xb0C, spot chauffant \xe0 36 \xb0C, baisser la temp\xe9rature la nuit, les pythons royaux s’entendent tr\xe8s bien entre eux et peuvent \xeatre d\xe9tenus par deux ou par trois si le terrarium est assez grand.\n",
                            "waterBasin": "Bassins"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Python royal",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_k%C3%B6nigspython_fr.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "cornSnake": {
                        "name": "Serpent des bl\xe9s",
                        "namePlural": "Serpents des bl\xe9s",
                        "textLength": "Pour les serpents, on mesure toute la longueur du corps.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des serpents des bl\xe9s. Les serpents des bl\xe9s cohabitent bien avec leurs cong\xe9n\xe8res.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des serpents des bl\xe9s. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des serpents des bl\xe9s. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de se cacher, possibilit\xe9s de grimper\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, bassin, possibilit\xe9s de grimper, substrat meuble, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, branches, Wetbox, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 24-28 \xb0C, spot chauffant \xe0 35 \xb0C, baisser la temp\xe9rature la nuit; selon le climat d’origine, hibernation dans un endroit frais recommand\xe9e.\n",
                            "waterBasin": "Bassins"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Serpent des bl\xe9s",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_kornnatter_fr.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "greekTortoise": {
                        "name": "Tortue d’Hermann",
                        "namePlural": "Tortues d’Hermann",
                        "textLength": "Pour les tortues, on mesure la longueur de la carapace.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et sol pour creuser, place au soleil ainsi que des lampes \xe9mettand des UV, acc\xe8s \xe0 la lumi\xe8re naturelle du soleil, sorties \xe0 l’ext\xe9rieur, possibilit\xe9 d’hiberner\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Enclos ext\xe9rieur avec cl\xf4ture anti-fugue et possibilit\xe9s de s\xe9paration, abri clos, p. ex. serre, couche \xe0 semis, substrat vari\xe9 en partie creusable (pierres, sable, gravier, calcaire du Jura…), points chauds, possibilit\xe9 de retrait, p. ex. v\xe9g\xe9tation, racines, pierres etc., eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (foin, herbes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’hibernation, d’am\xe9nagement de l’enclos et d’alimentation. La possibilit\xe9 d’hiberner en toute s\xe9curit\xe9 est importante.\n",
                            "more": "Les tortues terrestres ont une esp\xe9rance de vie tr\xe8s longue (40-80 ans)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informations de base sur la d\xe9tention des Tortues terrestres europ\xe9ennes,",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tention respectueuse des tortues dans la pratique",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_fr.pdff"
                            },
                            "2": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "moorishTortoise": {
                        "name": "Tortue mauresque",
                        "namePlural": "Tortues mauresques",
                        "textLength": "Pour les tortues, on mesure la longueur de la carapace.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et sol pour creuser, place au soleil ainsi que des lampes \xe9mettand des UV, acc\xe8s \xe0 la lumi\xe8re naturelle du soleil, sorties \xe0 l’ext\xe9rieur, possibilit\xe9 d’hiberner\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Enclos ext\xe9rieur avec cl\xf4ture anti-fugue et possibilit\xe9s de s\xe9paration, abri clos, p. ex. serre, couche \xe0 semis, substrat vari\xe9 en partie creusable (pierres, sable, gravier, calcaire du Jura…), points chauds, possibilit\xe9 de retrait, p. ex. v\xe9g\xe9tation, racines, pierres etc., eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (foin, herbes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’hibernation, d’am\xe9nagement de l’enclos et d’alimentation. La possibilit\xe9 d’hiberner en toute s\xe9curit\xe9 est importante.\n",
                            "more": "Les tortues terrestres ont une esp\xe9rance de vie tr\xe8s longue (40-80 ans)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informations de base sur la d\xe9tention des Tortues terrestres europ\xe9ennes,",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tention respectueuse des tortues dans la pratique",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_fr.pdff"
                            },
                            "2": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "wideShelledTortoise": {
                        "name": "Tortue bord\xe9e",
                        "namePlural": "Tortues bord\xe9es",
                        "textLength": "Pour les tortues, on mesure la longueur de la carapace.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et sol pour creuser, place au soleil ainsi que des lampes \xe9mettand des UV, acc\xe8s \xe0 la lumi\xe8re naturelle du soleil, sorties \xe0 l’ext\xe9rieur, possibilit\xe9 d’hiberner\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Enclos ext\xe9rieur avec cl\xf4ture anti-fugue et possibilit\xe9s de s\xe9paration, abri clos, p. ex. serre, couche \xe0 semis, substrat vari\xe9 en partie creusable (pierres, sable, gravier, calcaire du Jura…), points chauds, possibilit\xe9 de retrait, p. ex. v\xe9g\xe9tation, racines, pierres etc., eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (foin, herbes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’hibernation, d’am\xe9nagement de l’enclos et d’alimentation. La possibilit\xe9 d’hiberner en toute s\xe9curit\xe9 est importante.\n",
                            "more": "Les tortues terrestres ont une esp\xe9rance de vie tr\xe8s longue (40-80 ans)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informations de base sur la d\xe9tention des Tortues terrestres europ\xe9ennes,",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tention respectueuse des tortues dans la pratique",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_fr.pdff"
                            },
                            "2": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "crownedGecko": {
                        "name": "Gecko \xe0 cr\xeate",
                        "namePlural": "Geckos \xe0 cr\xeate",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos \xe0 cr\xeate. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos \xe0 cr\xeate. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des geckos \xe0 cr\xeate. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher, temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de grimper\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux (p. ex. tubes de li\xe8ge, racines, plantes), possibilit\xe9s de grimper (p. ex. branches finement ramifi\xe9es, plantes), substrat pour creuser, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (insectes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, baisser la temp\xe9rature la nuit. Temp\xe9ratures hivernales inf\xe9rieures de 5-6 \xb0C. Les m\xe2les ne s’entendent pas entre eux, ne pas compter sur leur socialisation.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "boaConstrictor": {
                        "name": "Boa constricteur",
                        "namePlural": "Boas constricteurs",
                        "textLength": "Pour les serpents, on mesure toute la longueur du corps.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des boas constricteurs. Les boas constricteurs s’entendent tr\xe8s bien entre eux et peuvent \xeatre d\xe9tenus par deux ou par trois si le terrarium est assez grand.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des boas constricteurs. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des boas constricteurs. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9 de baignade, possibilit\xe9s de se cacher, temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de grimper\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, possibilit\xe9s de grimper, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, branches et plateformes sur\xe9lev\xe9es, Wetbox, bassin, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 22-30 \xb0C, spot chauffant \xe0 35 \xb0C, baisser la temp\xe9rature la nuit, les boas constricteurs s’entendent tr\xe8s bien entre eux et peuvent \xeatre d\xe9tenus par deux ou par trois si le terrarium est assez grand.\n",
                            "more": "Les boas constricteurs peuvent atteindre plus de 4 m de long. Les donn\xe9es indiqu\xe9es ici concernent des animaux mesurant jusqu’\xe0 250 cm de longueur. Les animaux plus grands ont besoin de plus grands enclos.\n",
                            "waterBasin": "Bassin 0.5 m\xb2"
                        },
                        "links": {
                            "0": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "muskTurtle": {
                        "name": "Sternotherus odoratus",
                        "namePlural": "Sternotherus odoratus",
                        "textLength": "Pour les tortues, on mesure la longueur de la carapace.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des sternotherus odoratus. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des sternotherus odoratus. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des sternotherus odoratus. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, place au soleil ainsi que des lampes \xe9mettand des UV, possibilit\xe9s de se cacher\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "en plus de la surface"
                        },
                        "recommendations": {
                            "furnishing": "D\xe9tention en ext\xe9rieur recommand\xe9e en \xe9t\xe9, lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. racines, branches, pierres, feuillage, partie terrestre facilement accessible, nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-28 \xb0C, spot chauffant \xe0 35 \xb0C, baisser la temp\xe9rature la nuit, hibernation dans un endroit frais recommand\xe9e.\n",
                            "waterBasin": "de la surface totale"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierschutz.com/publikationen/heimtiere/infothek/gehege/broschuere_gehege_reptilien.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "http://www.tierschutz.com/publikationen/heimtiere/infothek/reptilien/reptilien_heimtiere.pdf"
                            }
                        }
                    },
                    "kingSnake": {
                        "name": "Serpent roi",
                        "namePlural": "Serpents rois",
                        "textLength": "Pour les serpents, on mesure toute la longueur du corps.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des serpents rois.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des serpents rois. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des serpents rois. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de se cacher\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, bassin, possibilit\xe9s de grimper, substrat meuble, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, branches, Wetbox, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 35 \xb0C, baisser la temp\xe9rature la nuit; selon le climat d’origine, hibernation dans un endroit frais recommand\xe9e.\n",
                            "more": "Les serpents rois se nourrissent \xe9galement d’autres serpents et ne doivent donc pas \xeatre d\xe9tenus avec d’autres serpents.\n",
                            "waterBasin": "Bassins"
                        },
                        "links": {
                            "0": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "madagascarDayGecko": {
                        "name": "Gecko diurne de Madagascar",
                        "namePlural": "Geckos diurnes de Madagascar",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos diurnes. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos diurnes. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des geckos diurnes. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper \xe0 l’horizontale et \xe0 la verticale, possibilit\xe9s de se cacher, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et place au soleil ainsi que des lampes \xe9mettand des UV\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage UV doit \xeatre install\xe9 de mani\xe8re \xe0 ce que tous les animaux aient acc\xe8s \xe0 la lumi\xe8re (placement appropri\xe9 et nombre suffisant de points chauds), mais ne puissent pas se br\xfbler aux lampes, syst\xe8me de production de l’humidit\xe9 de l’air n\xe9cessaire, p. ex. n\xe9buliseur, syst\xe8me d’aspersion, vaporisateur, v\xe9g\xe9tation, cascade, etc., syst\xe8me de mesure de la temp\xe9rature et de l’humidit\xe9 de l’air, possibilit\xe9s de grimper vari\xe9es et adapt\xe9es \xe0 l’esp\xe8ce, au moins de l’\xe9paisseur du corps (paroi arri\xe8re, branches, b\xe2tons de bambou, plantes \xe0 feuilles larges, etc.), possibilit\xe9s de retrait adapt\xe9es \xe0 l’esp\xe8ce (v\xe9g\xe9tation, racines, pierres, tiges de bambou coup\xe9es, etc.), substrat adapt\xe9, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (insectes, nectar, pulpe de fruit)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 40\xb0C, baisser la temp\xe9rature la nuit. Les m\xe2les ne s’entendent pas entre eux, ne pas compter sur leur socialisation.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Grand gecko diurne de Madagascar",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_taggecko_it.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "goldDustDayGecko": {
                        "name": "Gecko diurne \xe0 poussi\xe8re d’or",
                        "namePlural": "Geckos diurnes \xe0 poussi\xe8re d’or",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos diurnes. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos diurnes. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des geckos diurnes. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper \xe0 l’horizontale et \xe0 la verticale, possibilit\xe9s de se cacher, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et place au soleil ainsi que des lampes \xe9mettand des UV\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage UV doit \xeatre install\xe9 de mani\xe8re \xe0 ce que tous les animaux aient acc\xe8s \xe0 la lumi\xe8re (placement appropri\xe9 et nombre suffisant de points chauds), mais ne puissent pas se br\xfbler aux lampes, syst\xe8me de production de l’humidit\xe9 de l’air n\xe9cessaire, p. ex. n\xe9buliseur, syst\xe8me d’aspersion, vaporisateur, v\xe9g\xe9tation, cascade, etc., syst\xe8me de mesure de la temp\xe9rature et de l’humidit\xe9 de l’air, possibilit\xe9s de grimper vari\xe9es et adapt\xe9es \xe0 l’esp\xe8ce, au moins de l’\xe9paisseur du corps (paroi arri\xe8re, branches, b\xe2tons de bambou, plantes \xe0 feuilles larges, etc.), possibilit\xe9s de retrait adapt\xe9es \xe0 l’esp\xe8ce (v\xe9g\xe9tation, racines, pierres, tiges de bambou coup\xe9es, etc.), substrat adapt\xe9, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (insectes, nectar, pulpe de fruit)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 40\xb0C, baisser la temp\xe9rature la nuit. Les animaux m\xe2les ne s’entendent pas entre eux, ne pas compter sur leur socialisation.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "leopardGecko": {
                        "name": "Gecko l\xe9opard",
                        "namePlural": "Gecko l\xe9opards",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos l\xe9opards. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos l\xe9opards. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des geckos l\xe9opards. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher, possibilit\xe9s de creuser, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et \xe9clairage\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux (p. ex. tubes de li\xe8ge, racines, au moins une cachette l\xe9g\xe8rement humide), possibilit\xe9s de grimper (p. ex. structures rocheuses, paroi arri\xe8re, racines), substrat pour creuser, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (insectes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, de repos hivernal, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 22-28 \xb0C, spot chauffant \xe0 35\xb0C, baisser la temp\xe9rature la nuit. Les m\xe2les sont territoriaux et la socialisation n’est pas recommand\xe9e.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Gecko l\xe9opard",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_leopardgecko_fr.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "dwarfBeardedDragon": {
                        "name": "Agame barbu nain",
                        "namePlural": "Agames barbus nains",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des agames barbus. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des agames barbus. Les m\xe2les ne s’entendent pas entre eux. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des agames barbus. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et de grimper, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et Possibilit\xe9s de grimper \xe0 l’horizontale et \xe0 la verticale, possibilit\xe9s de se cacher, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et place au soleil ainsi que des lampes \xe9mettand des UV\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Plateformes sur\xe9lev\xe9es, lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage UV doit \xeatre install\xe9 de mani\xe8re \xe0 ce que tous les animaux y aient acc\xe8s (placement appropri\xe9 et nombre suffisant de points chauds), mais ne puissent pas s’y br\xfbler (pas de contact direct possible avec la lampe), syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, possibilit\xe9 de baignade, possibilit\xe9s de grimper et rochers, sable pour creuser, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (nourriture fra\xeeche, insectes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, de repos hivernal, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 45 \xb0C, baisser la temp\xe9rature la nuit; selon le climat d’origine, hibernation dans un endroit frais recommand\xe9e. M\xeame si les agames barbus sont des solitaires en dehors de la p\xe9riode d’accouplement, la compagnie de cong\xe9n\xe8res est un enrichissement important, \xe0 condition que les animaux s’entendent.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Agame barbu",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_fr.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "centralBeardedDragon": {
                        "name": "Pogona vitticeps",
                        "namePlural": "Pogona vitticeps",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des agames barbus. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des agames barbus. Les m\xe2les ne s’entendent pas entre eux. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des agames barbus. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et de grimper, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et Possibilit\xe9s de grimper \xe0 l’horizontale et \xe0 la verticale, possibilit\xe9s de se cacher, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et place au soleil ainsi que des lampes \xe9mettand des UV\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Plateformes sur\xe9lev\xe9es, lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage UV doit \xeatre install\xe9 de mani\xe8re \xe0 ce que tous les animaux y aient acc\xe8s (placement appropri\xe9 et nombre suffisant de points chauds), mais ne puissent pas s’y br\xfbler (pas de contact direct possible avec la lampe), syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, possibilit\xe9 de baignade, possibilit\xe9s de grimper et rochers, sable pour creuser, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (nourriture fra\xeeche, insectes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, de repos hivernal, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 45 \xb0C, baisser la temp\xe9rature la nuit; selon le climat d’origine, hibernation dans un endroit frais recommand\xe9e. M\xeame si les agames barbus sont des solitaires en dehors de la p\xe9riode d’accouplement, la compagnie de cong\xe9n\xe8res est un enrichissement important, \xe0 condition que les animaux s’entendent.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Agame barbu",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_de.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    }
                },
                "birds": {
                    "diamondDove": {
                        "name": "Colombe (g\xe9op\xe9lie) diamant",
                        "namePlural": "Colombes (g\xe9op\xe9lies) diamants",
                        "minAnimalsErrorMessage": "Les colombes diamants sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des colombes diamants est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de baignade, perchoirs souples de diff\xe9rentes \xe9paisseurs et orientations ainsi qu’une mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les colombes diamants sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe avec plusieurs couples nicheurs.",
                            "indoor": "Les colombes diamants peuvent \xeatre d\xe9tenues \xe0 l’int\xe9rieur dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La variante la plus respectueuse des animaux pour d\xe9tenir des colombes diamants est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les colombes diamants sont g\xe9n\xe9ralement tr\xe8s paisibles et peuvent \xeatre d\xe9tenues avec d’autres esp\xe8ces d’oiseaux paisibles \xe0 condition d’avoir les comp\xe9tences n\xe9cessaires. \nLes colombes diamants aiment passer beaucoup de temps au sol pendant la journ\xe9e. Il est donc essentiel qu’elles disposent d’une surface au sol spacieuse. Elles sont tr\xe8s agiles en vol, elles doivent donc disposer aussi d’un espace de vol suffisant."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "canary": {
                        "name": "Canari",
                        "namePlural": "Canaris",
                        "minAnimalsErrorMessage": "Les canaris sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des canaris est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les canaris sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les canaris peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La variante la plus respectueuse des animaux pour d\xe9tenir des canaris est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "D\xe9tenir des canaris avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances. Attention: il existe des vari\xe9t\xe9s d’\xe9levage de canaris (p. ex. certains canaris de posture) qui font partie des pratiques d’\xe9levage associ\xe9es \xe0 de grandes souffrances qu’il est fortement d\xe9conseill\xe9 d’acheter."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Kanarienvogel",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_kanarien_fr.pdf"
                            }
                        }
                    },
                    "zebraFinch": {
                        "name": "Diamant mandarin",
                        "namePlural": "Diamants mandarins",
                        "minAnimalsErrorMessage": "Les diamants mandarins sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des diamants mandarins est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les diamants mandarins sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les diamants mandarins peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La variante la plus respectueuse des animaux pour d\xe9tenir des diamants mandarins est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (au moins 12 \xb0C). Une partie du toit de la voli\xe8re doit \xeatrecouverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.). Attention: il faut les d\xe9tenir en int\xe9rieur en automne et en hiver!",
                            "specificNeeds": "D\xe9tenir des diamants mandarins avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Zebrafinken",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_zebrafinken_fr.pdf"
                            }
                        }
                    },
                    "grayWaxbill": {
                        "name": "Astrild cendr\xe9",
                        "namePlural": "Astrilds cendr\xe9s",
                        "minAnimalsErrorMessage": "Les astrilds cendr\xe9s sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des astrilds cendr\xe9s est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les astrilds cendr\xe9s sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les astrilds cendr\xe9s peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "Possible uniquement au printemps et en \xe9t\xe9, car les astrilds cendr\xe9s sont sensibles au froid. Au printemps et en \xe9t\xe9, en enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin), chauffable (au moins 18 \xb0C).  Une partie du toit de la voli\xe8re doit \xeatre couvert (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "D\xe9tenir des astrilds cendr\xe9s avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "goldenBreasted": {
                        "name": "Bengali z\xe9br\xe9",
                        "namePlural": "Bengalis z\xe9br\xe9s",
                        "minAnimalsErrorMessage": "Les bengalis z\xe9br\xe9s sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des bengalis z\xe9br\xe9s est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les bengalis z\xe9br\xe9s doivent \xeatre d\xe9tenus en couple car les m\xe2les peuvent \xeatre agressifs envers des rivaux de la m\xeame esp\xe8ce pendant la p\xe9riode de nidification.",
                            "indoor": "Les bengalis z\xe9br\xe9s peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "Possible uniquement au printemps et en \xe9t\xe9, car les bengalis z\xe9br\xe9s sont sensibles au froid. Au printemps et en \xe9t\xe9, en enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin), chauffable (au moins 15 \xb0C).  Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Cet oiseau d’une grande long\xe9vit\xe9, tr\xe8s actif, a besoin d’une voli\xe8re spacieuse avec de l’herbe et des roseaux.\nD\xe9tenir des bengalis z\xe9br\xe9s avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "gouldianMadine": {
                        "name": "Diamant de Gould",
                        "namePlural": "Diamants de Gould",
                        "minAnimalsErrorMessage": "Les diamants de Gould sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des diamants de Gould est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les diamants de Gould sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe avec plusieurs couples nicheurs.",
                            "indoor": "Les diamants de Gould peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "Possible uniquement au printemps et en \xe9t\xe9, car les diamants de Gould sont sensibles au froid. Au printemps et en \xe9t\xe9, en enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin), chauffable (au moins 18 \xb0C).  Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.). Les diamants de Gould doivent \xeatre d\xe9tenus \xe0 l’int\xe9rieur en automne et en hiver (voir ci-dessus).",
                            "specificNeeds": '"Beaucoup de couvert et suffisamment de possibilit\xe9s de se cacher sont essentiels pour ces oiseaux craintifs. \n\nD\xe9tenir des diamants de Gould avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances.\nIl faut s’abstenir d’acheter des mutations de couleurs obtenues par \xe9levage. "'
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Gouldamadinen",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Gouldamadinen_fr.pdf"
                            }
                        }
                    },
                    "budgerigar": {
                        "name": "Perruche ondul\xe9e",
                        "namePlural": "Perruches ondul\xe9es",
                        "minAnimalsErrorMessage": "Les perruches ondul\xe9es sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des perruches ondul\xe9es est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les perruches ondul\xe9es sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs (au moins 2, de pr\xe9f\xe9rence 3). Cela n\xe9cessite une grande voli\xe8re, car les m\xe2les d\xe9fendent le nid en p\xe9riode de nidification.",
                            "indoor": "Les perruches ondul\xe9es peuvent \xeatre d\xe9tenues dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des perruches ondul\xe9es est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les perruches ondul\xe9es ont besoin de possibilit\xe9s de grimper vari\xe9es sous forme de branches naturelles p. ex. de noisetier, saule, h\xeatre, arbres fruitiers non trait\xe9s. Elles servent \xe9galement de mat\xe9riel \xe0 ronger et doivent \xeatre renouvel\xe9es r\xe9guli\xe8rement.\n\nLa socialisation avec d’autres esp\xe8ces est possible, mais uniquement recommand\xe9e \xe0 des d\xe9tenteurs d’oiseaux exp\xe9riment\xe9s. Il faut s’abstenir d’acheter des vari\xe9t\xe9s d’\xe9levage extr\xeames (p. ex. des oiseaux avec des huppes)."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Wellensittiche",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_wellensittiche_fr.pdf"
                            }
                        }
                    },
                    "agapornid": {
                        "name": "Ins\xe9parable",
                        "namePlural": "Ins\xe9parables",
                        "minAnimalsErrorMessage": "Les ins\xe9parables sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les ins\xe9parables sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les ins\xe9parables peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les ins\xe9parables de Fischer, les ins\xe9parables rosegorges, les ins\xe9parables masqu\xe9s et les ins\xe9parables \xe0 joues noires sont les principales esp\xe8ces \xe0 consid\xe9rer comme animaux de compagnie. Les autres esp\xe8ces d’ins\xe9parables sont plus exigeantes et donc d\xe9conseill\xe9es aux d\xe9butants.\nCertaines esp\xe8ces d’ins\xe9parables peuvent \xeatre assez agressives et ne conviennent pas pour \xeatre d\xe9tenues avec d’autres esp\xe8ces.\n\nLes ins\xe9parables peuvent \xeatre assez bruyants. Par cons\xe9quent, les voisins devraient \xeatres avertis."
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information SPA: Ins\xe9parables",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_fr.pdf"
                            }
                        }
                    },
                    "tarantaParrot": {
                        "name": "Ins\xe9parable d’Abyssinie",
                        "namePlural": "Ins\xe9parables d’Abyssinie",
                        "minAnimalsErrorMessage": "Les ins\xe9parables d’Abyssinie sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables d’Abyssinie est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les ins\xe9parables d’Abyssinie sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les ins\xe9parables d’Abyssinie peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel).  Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les ins\xe9parables d’Abyssinie sont la plus grande esp\xe8ce d’ins\xe9parables. \nLa d\xe9tention de cette esp\xe8ce d’ins\xe9parables est exigeante et ne convient pas aux d\xe9butants.\nLa socialisation avec d’autres esp\xe8ces est possible, mais uniquement recommand\xe9e \xe0 des d\xe9tenteurs d’oiseaux exp\xe9riment\xe9s. \nLes ins\xe9parables d’Abyssinie peuvent aussi \xeatre assez bruyants. Par cons\xe9quent, les voisins devraient \xeatres avertis."
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information SPA: Ins\xe9parables",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_fr.pdf"
                            }
                        }
                    },
                    "cockatiel": {
                        "name": "Calopsitte \xe9l\xe9gante",
                        "namePlural": "Calopsittes \xe9l\xe9gantes",
                        "minAnimalsErrorMessage": "Les calopsittes \xe9l\xe9gantes sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des calopsittes \xe9l\xe9gantes est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les calopsittes \xe9l\xe9gantes sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les calopsittes \xe9l\xe9gantes peuvent \xeatre d\xe9tenues dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les calopsittes \xe9l\xe9gantes ont besoin de possibilit\xe9s de grimper vari\xe9es sous forme de branches naturelles p. ex. de noisetier, saule, h\xeatre, arbres fruitiers non trait\xe9s. Elles servent \xe9galement de mat\xe9riel \xe0 ronger et doivent \xeatre renouvel\xe9es r\xe9guli\xe8rement.\n\nLa socialisation avec d’autres esp\xe8ces est possible, mais uniquement recommand\xe9e \xe0 des d\xe9tenteurs d’oiseaux exp\xe9riment\xe9s."
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information SPA: Calopsitte \xe9l\xe9gante",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Nymphensittiche_fr.pdf"
                            }
                        }
                    },
                    "beautifulParakeet": {
                        "name": "Perruche turquoisine",
                        "namePlural": "Perruches turquoisines",
                        "minAnimalsErrorMessage": "Les perruches turquoisines sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des perruches turquoisines est en couple nicheur. Il est essentiel d’\xeatre attentif aux compatibilit\xe9s individuelles des animaux, car les perruches turquoisines peuvent r\xe9agir de mani\xe8re assez agressive envers leurs cong\xe9n\xe8res ainsi qu’envers d’autres esp\xe8ces d’oiseaux.",
                        "maxAnimalsErrorMessage": "Attention! La d\xe9tention de perruches turquoisines est exigeante. Les perruches turquoisines doivent \xeatre d\xe9tenues en couple car elles peuvent \xeatre agressives envers leurs cong\xe9n\xe8res et d’autres esp\xe8ces d’oiseaux.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures, et dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les perruches turquoisines sont tr\xe8s sociables mais peuvent \xeatre tr\xe8s agressives envers les autres oiseaux, y compris ceux de leur propre esp\xe8ce. Il est donc recommand\xe9 de d\xe9tenir les perruches turquoisines en couple.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des perruches turquoisines est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les perruches turquoisines ont besoin d’une surface de vol libre aussi grande que possible, car leur vol est rectiligne. Elles ont \xe9galement besoin de beaucoup d’occupation et de possibilit\xe9s de ronger sous forme de branches fra\xeeches vari\xe9es non toxiques.\nIl n’est pas conseill\xe9 de les socialiser avec d’autres esp\xe8ces d’oiseaux, car elles peuvent r\xe9agir de mani\xe8re agressive."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "rosellaConure": {
                        "name": "Perruche omnicolore",
                        "namePlural": "Perruches omnicolores",
                        "minAnimalsErrorMessage": "Les perruches omnicolores sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des perruches omnicolores est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les perruches omnicolores sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs. Il faut une tr\xe8s grande voli\xe8re en cas de d\xe9tention de plusieurs couples, \xe9tant donn\xe9 que les m\xe2les sont tr\xe8s agressifs pendant la p\xe9riode de pariade et de nidification.",
                            "indoor": "Les perruches omnicolores peuvent \xeatre d\xe9tenues dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des perruches omnicolores est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les perruches omnicolores ont besoin d’une surface de vol libre aussi grande que possible, car elles sont tr\xe8s actives. Elles ont \xe9galement besoin de beaucoup d’occupation et de possibilit\xe9s de ronger sous forme de branches fra\xeeches vari\xe9es non toxiques.\nLa socialisation avec d’autres esp\xe8ces est possible, mais uniquement recommand\xe9e \xe0 des d\xe9tenteurs d’oiseaux exp\xe9riment\xe9s."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "cockatoo": {
                        "name": "Cacato\xe8s",
                        "namePlural": "Cacato\xe8s",
                        "minAnimalsErrorMessage": "Les cacato\xe8s sont des animaux sociaux. La d\xe9tention individuelle est donc interdite! La d\xe9tention de cacato\xe8s (\xe0 l’exception des calopsittes \xe9l\xe9gantes) est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des cacato\xe8s, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "maxAnimalsWarningMessage": "La d\xe9tention de cacato\xe8s (\xe0 l’exception des calopsittes \xe9l\xe9gantes) est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des cacato\xe8s, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "maxAnimalsErrorMessage": "La d\xe9tention de cacato\xe8s (\xe0 l’exception des calopsittes \xe9l\xe9gantes) est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des cacato\xe8s, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "laws": {},
                        "recommendations": {
                            "general": "Pour des raisons de protection des animaux, la Protection Suisse des Animaux PSA d\xe9conseille la d\xe9tention priv\xe9e d'ara/cacato\xe8s. . L'espace n\xe9cessaire \xe0 une d\xe9tention d'ara/cacato\xe8s conforme aux besoins des animaux est immense et ne peut g\xe9n\xe9ralement pas \xeatre rempli par des d\xe9tenteurs priv\xe9s. La d\xe9tention de cacato\xe8s ou d'aras est extr\xeamement exigeante et soumise \xe0 autorisation. Toute personne int\xe9ress\xe9e par l’achat de cacato\xe8s doit suivre un cours pour l’obtention de l’attestation de comp\xe9tences avant l’achat.\nEn outre, il faut d\xe9poser une demande aupr\xe8s de l’office v\xe9t\xe9rinaire cantonal du canton de domicile et prouver que toutes les exigences l\xe9gales en mati\xe8re de d\xe9tention, de soins et d’acquisition peuvent \xeatre remplies. Si vous avez l'intention de d\xe9tenir des cacato\xe8s ou des aras, veuillez vous adresser \xe0 l'office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour de plus amples informations."
                        },
                        "links": {
                            "0": {
                                "text": "Fachinformation Tierschutz - Bewilligungspflicht f\xfcr die Haltung von Grosspapageien - Bundesamt f\xfcr Lebensmittelsicherheit und Veterin\xe4rwesen BLV",
                                "file": "https://www.blv.admin.ch/dam/blv/de/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/D_3.1_Fachinformation_Bewilligungspflicht_f%C3%BCr_Grosspapageien.pdf"
                            }
                        }
                    },
                    "macaw": {
                        "name": "Ara",
                        "namePlural": "Aras",
                        "minAnimalsErrorMessage": "Les aras sont des animaux sociaux. La d\xe9tention individuelle est donc interdite! \nLa d\xe9tention de grands perroquets tels que les aras est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des aras, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "maxAnimalsWarningMessage": "La d\xe9tention de grands perroquets tels que les aras est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des aras, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "maxAnimalsErrorMessage": "La d\xe9tention de grands perroquets tels que les aras est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des aras, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de domicile pour en savoir plus.",
                        "laws": {},
                        "recommendations": {
                            "general": "Pour des raisons de protection des animaux, la Protection Suisse des Animaux PSA d\xe9conseille la d\xe9tention priv\xe9e d'ara/cacato\xe8s. . L'espace n\xe9cessaire \xe0 une d\xe9tention d'ara/cacato\xe8s conforme aux besoins des animaux est immense et ne peut g\xe9n\xe9ralement pas \xeatre rempli par des d\xe9tenteurs priv\xe9s. La d\xe9tention de cacato\xe8s ou d'aras est extr\xeamement exigeante et soumise \xe0 autorisation. Toute personne int\xe9ress\xe9e par l’achat de cacato\xe8s doit suivre un cours pour l’obtention de l’attestation de comp\xe9tences avant l’achat.\nEn outre, il faut d\xe9poser une demande aupr\xe8s de l’office v\xe9t\xe9rinaire cantonal du canton de domicile et prouver que toutes les exigences l\xe9gales en mati\xe8re de d\xe9tention, de soins et d’acquisition peuvent \xeatre remplies. Si vous avez l'intention de d\xe9tenir des cacato\xe8s ou des aras, veuillez vous adresser \xe0 l'office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour de plus amples informations."
                        },
                        "links": {
                            "0": {
                                "text": "Fachinformation Tierschutz - Bewilligungspflicht f\xfcr die Haltung von Grosspapageien - Bundesamt f\xfcr Lebensmittelsicherheit und Veterin\xe4rwesen BLV",
                                "file": "https://www.blv.admin.ch/dam/blv/de/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/D_3.1_Fachinformation_Bewilligungspflicht_f%C3%BCr_Grosspapageien.pdf"
                            }
                        }
                    },
                    "congoGreyParrot": {
                        "name": "Perroquet jaco/Gris du Gabon",
                        "namePlural": "Perroquets jaco",
                        "minAnimalsErrorMessage": "Les perroquets jaco sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des perroquets jaco est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 6.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les perroquets jaco sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "La d\xe9tention exclusivement \xe0 l’int\xe9rieur ne convient pas aux perroquets jaco.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des perroquets jaco est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "La d\xe9tention de perroquets jaco respectueuse des animaux est extr\xeamement exigeante. \nLe commerce de ces animaux d’une tr\xe8s grande long\xe9vit\xe9 est en plein essor et les offres de fournisseurs peu scrupuleux sont tr\xe8s nombreuses (p. ex. \xe9levage \xe0 la main, importations de sources peu claires). Les perroquets jaco peuvent \xeatre bruyants. Par cons\xe9quent, les voisins devraient \xeatres avertis.\n\nPour des raisons de protection des animaux, il faut s’abstenir d’acheter des animaux \xe9lev\xe9s \xe0 la main."
                        },
                        "links": {
                            "0": {
                                "text": "FEUILLE D’INFORMATION PSA - Perroquet jaco",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_graupapageien_fr.pdf"
                            }
                        }
                    },
                    "amazon": {
                        "name": "Amazone",
                        "namePlural": "Amazone",
                        "minAnimalsErrorMessage": "Les amazones sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des amazones est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 6.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures, et dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les amazones sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de couples nicheurs.",
                            "indoor": "La d\xe9tention exclusivement \xe0 l’int\xe9rieur ne convient pas aux amazones.",
                            "outdoor": "a forme de d\xe9tention la plus respectueuse des amazones est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les amazones sont des oiseaux bruyants. Par cons\xe9quent, les voisins devraient \xeatres avertis.\n\nIl existe diff\xe9rentes esp\xe8ces d’amazones, et toutes ne conviennent pas comme animaux de compagnie. La plus commune est l’amazone \xe0 front bleu. Chaque esp\xe8ce a ses propres besoins sp\xe9cifiques en termes de d\xe9tention, de climat, d’alimentation et de structure sociale. Vous pouvez obtenir des informations aupr\xe8s de sp\xe9cialistes chevronn\xe9s ou suivre un cours sp\xe9cialis\xe9 avant l’achat.\nPour des raisons de protection des animaux, il faut s’abstenir d’acheter des animaux \xe9lev\xe9s \xe0 la main."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    }
                },
                "equidae": {
                    "horse": {
                        "name": "Cheval",
                        "namePlural": "Chevaux",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement, avec un cong\xe9n\xe8re de la m\xeame esp\xe8ce, donc dans ce cas avec un autre cheval.",
                        "maxAnimalsWarningMessage": "Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.",
                        "recommendations": {
                            "pasturing": "Autant que possible",
                            "socialStructure": "Les chevaux doivent avoir un contact direct avec d'autres chevaux. Les chevaux et les \xe2nes parlent un langage diff\xe9rent et ont des besoins diff\xe9rents en mati\xe8re de d\xe9tention et d'alimentation.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement."
                        },
                        "laws": {
                            "runoutTime": "Chevaux utilis\xe9s : 2 x 2 h / semaine ; Chevaux non utilis\xe9s : 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition; de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des chevaux",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-de-chevaux/"
                            },
                            "1": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    },
                    "pony": {
                        "name": "Poney",
                        "namePlural": "Poneys",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement, avec un cong\xe9n\xe8re de la m\xeame esp\xe8ce, donc dans ce cas avec un autre poney ou un autre cheval.",
                        "maxAnimalsWarningMessage": '"Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.',
                        "recommendations": {
                            "pasturing": "Autant que possible, adapter toutefois l'alimentation \xe0 l'\xe9tat d’embonpoint !",
                            "socialStructure": "Les poneys doivent avoir un contact direct avec d'autres poneys ou d’autres chevaux.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement.",
                            "specialRequirements": "La jeune herbe, riche en prot\xe9ines ou en fructanes, repr\xe9sente un risque accru de surpoids, en particulier chez les poneys, et surtout s'ils ne font pas suffisamment d'exercice."
                        },
                        "laws": {
                            "runoutTime": "Poneys utilis\xe9s 2 x 2 h / semaine ; Poneys non utilis\xe9s 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des chevaux",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-de-chevaux/"
                            },
                            "1": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    },
                    "donkey": {
                        "name": "\xc2ne",
                        "namePlural": "\xc2nes",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement, avec un cong\xe9n\xe8re de la m\xeame esp\xe8ce, donc dans ce cas avec un autre \xe2ne.",
                        "maxAnimalsWarningMessage": "Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.",
                        "recommendations": {
                            "pasturing": "P\xe2turage limit\xe9 pour les \xe2nes, plus de mouvement sur de grandes places s\xe8ches",
                            "socialStructure": "Les \xe2nes ont besoin d'un contact direct avec des cong\xe9n\xe8res de la m\xeame esp\xe8ce, c'est-\xe0-dire avec d'autres \xe2nes. Leur comportement et leur physiologie diff\xe8rent de ceux des chevaux. Des aliments riches en fibres, comme des branches et de la paille, ainsi que des activit\xe9s suppl\xe9mentaires sont \xe0 pr\xe9voir.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement.",
                            "specialRequirements": "Les \xe2nes sont des transformateurs de fourrage tr\xe8s efficaces. Ils ont besoin d'une alimentation pauvre en \xe9nergie, \xe0 faible teneur en sucre et en prot\xe9ines, mais riche en fibres. Le pelage des \xe2nes n'est gu\xe8re imperm\xe9able. Les \xe2nes sont sensibles aux maladies lorsqu'ils sont mouill\xe9s. Ils ont besoin d'un abri sec accessible en permanence. Les \xe2nes ont besoin d'un sol sec, sinon ils risquent des probl\xe8mes de sabots."
                        },
                        "laws": {
                            "runoutTime": "\xc2nes utilis\xe9s : 2 x 2 h / semaine ; \xc2nes non utilis\xe9s : 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des \xe2nes",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-danes/"
                            },
                            "1": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    },
                    "mule": {
                        "name": "Mulet",
                        "namePlural": "Mulets",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement, avec un autre mulet.",
                        "maxAnimalsWarningMessage": "Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.",
                        "recommendations": {
                            "pasturing": "P\xe2turage limit\xe9",
                            "socialStructure": "Les mulets ont besoin de contact avec d'autres mulets. Ils peuvent bien entendu \xeatre d\xe9tenues avec des chevaux. Il faut toutefois tenir compte de leur physiologie en ce qui concerne l'alimentation et l’acc\xe8s au p\xe2turage.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement."
                        },
                        "laws": {
                            "runoutTime": "Mulets utilis\xe9s 2 x 2 h / semaine ; Mulets non utilis\xe9s 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des chevaux",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-de-chevaux/"
                            },
                            "1": {
                                "text": "Site web de la PSA sur la d\xe9tention des \xe2nes",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-danes/"
                            },
                            "2": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    },
                    "hinny": {
                        "name": "Bardot",
                        "namePlural": "Bardots",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement avec un autre bardot.",
                        "maxAnimalsWarningMessage": "Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.",
                        "recommendations": {
                            "pasturing": "P\xe2turage limit\xe9",
                            "socialStructure": "Les bardots ont besoin de contact direct avec d’autres bardots. Ils peuvent aussi \xeatre d\xe9tenus avec des \xe2nes. Il faut toutefois tenir compte de leur physiologie en ce qui concerne l'alimentation et l’acc\xe8s au p\xe2turage.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement."
                        },
                        "laws": {
                            "runoutTime": "Bardots utilis\xe9s 2 x 2 h / semaine ; Bardots non utilis\xe9s 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des chevaux",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-de-chevaux/"
                            },
                            "1": {
                                "text": "Site web de la PSA sur la d\xe9tention des \xe2nes",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-danes/"
                            },
                            "2": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    }
                }
            },
            "screenCategory": {
                "title": "S\xe9lectionner la cat\xe9gorie"
            },
            "screenAnimal": {
                "title": "Quel animal voudrais-tu d\xe9tenir?",
                "multipleBirdsButton": "Garder plusieurs esp\xe8ces ensemble",
                "equidaeInfo": "Les valeurs calcul\xe9es ne sont valables que pour les \xe9quid\xe9s de plus de 30 mois."
            },
            "screenMultipleBirds": {
                "warning": "Pour d\xe9tenir deux esp\xe8ces d'oiseaux ou plus ensemble, la taille de l'enclos doit \xeatre calcul\xe9e s\xe9par\xe9ment pour chaque esp\xe8ce, mais avec le nombre total d'oiseaux. Le plus grand enclos calcul\xe9 correspond aux dimensions minimales l\xe9gales.",
                "infoText": "Si deux esp\xe8ces d'oiseaux ou plus sont d\xe9tenues ensemble dans un enclos, la taille minimale l\xe9gale de l'enclos correspond toujours aux exigences en mati\xe8re de place pour la plus grande esp\xe8ce d'oiseaux. Par exemple, si deux perruches ondul\xe9es et deux perruches nymphes sont d\xe9tenues ensemble dans un enclos, la taille minimale de l'enclos correspond aux exigences pour quatre perruches nymphes, car il s'agit de la plus grande esp\xe8ce d'oiseaux dans l'enclos. La d\xe9tention commune de plusieurs esp\xe8ces d'oiseaux ne convient qu'aux d\xe9tenteurs d'oiseaux exp\xe9riment\xe9s. Informez-vous toujours soigneusement sur les esp\xe8ces d'oiseaux qui peuvent \xeatre d\xe9tenues ensemble."
            },
            "screenNumber": {
                "title": "Combien de {animals} aimerais-tu d\xe9tenir?"
            },
            "screenWeight": {
                "title": "Quel est le poids des {animals}?"
            },
            "screenLength": {
                "title": "Quelle est la longueur du / de la / de l’{animal} le/la plus grand/e?",
                "error": "Entrer un nombre entre {min} et {max}."
            },
            "screenWithersHeight": {
                "title": "Quelle est la hauteur au garrot de chaque animal ?",
                "error": "Entrer un nombre entre {min} et {max}.",
                "animal": "Animal"
            },
            "screenResults": {
                "title": "Tu devrais d\xe9tenir {number} {animals} ainsi",
                "example": "Par exemple",
                "exampleEquidae": "Exemple de taille de box",
                "stsRecommendation": "Recommandation Protection des animaux",
                "law": "Loi (Ordonnance suisse sur la protection des animaux)",
                "stsAreaRecommendation": "Surface minimale (dimensions int\xe9rieures)",
                "stsLengthRecommendation": {
                    "upto2reptiles": "Longueur minimale (dimensions int\xe9rieures)",
                    "morethan2reptiles": "En plus, au moins en longueur"
                },
                "stsWidthRecommendation": {
                    "upto2reptiles": "Largeur minimale (dimensions int\xe9rieures)",
                    "morethan2reptiles": "En plus, au moins en largeur"
                },
                "stsHeightRecommendation": "Hauteur minimale de l’enclos (dimensions int\xe9rieures)",
                "stsBeddingRecommendation": "Profondeur minimale de la liti\xe8re",
                "stsWaterBasinRecommendation": "Bassin d'eau",
                "tolerance": "Valeur de tol\xe9rance",
                "toleranceInfo": "Les \xe9curies existant le 1er septembre 2008 ne doivent pas \xeatre adapt\xe9es si leurs dimensions correspondent aux valeurs de tol\xe9rance. Si une \xe9curie doit \xeatre adapt\xe9e parce que l’une des valeurs de tol\xe9rance n’est pas respect\xe9e, l’autre valeur de tol\xe9rance reste valable.",
                "noTolerance": "Pas de valeur de tol\xe9rance",
                "stsLayingAreaRecommendation": "Surface de repos",
                "stsClearWidthRecommendation": "Largeur int\xe9rieure",
                "stsClearWidthRecommendationInfo": "2 x taille au garrot de l’animal le plus grand",
                "stsClearHeightRecommendation": "Hauteur int\xe9rieure",
                "stsRunoutTimeRecommendation": "Temps de sortie",
                "stsRunoutTimeRecommendationText": "De pr\xe9f\xe9rence libre acc\xe8s 24h/24 \xe0 l'aire de sortie tout temps mais au moins 4 heures par jour",
                "stsRunoutAreaRecommendation": "Surface de l'aire de sortie",
                "stsPasturingRecommendation": "P\xe2turage",
                "stsLatticeSpacing": "Distance maximale entre les barreaux",
                "lawMinimalArea": "Surface minimale (dimensions int\xe9rieures)",
                "lawMinimalLength": "Longueur minimale (dimensions int\xe9rieures)",
                "lawMinimalWidth": "Largeur minimale (dimensions int\xe9rieures)",
                "lawMinimalHeight": "Hauteur minimale de l’enclos (dimensions int\xe9rieures)",
                "lawMinimalBedding": "Profondeur minimale de la liti\xe8re",
                "lawWaterBasin": "Bassin d'eau",
                "lawReptilesInfo": {
                    "text": "Lors de la d\xe9tention du nombre d'animaux entr\xe9, il faut s'assurer que toutes les exigences l\xe9gales {link} sont remplies pour l'esp\xe8ce animale concern\xe9e.",
                    "linkText": "selon l'annexe 2, tableau 5 OPAn",
                    "linkURL": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                },
                "lawVolume": "Volume",
                "lawLayingArea": "Surface de repos en stabulation libre \xe0 un compartiment",
                "layingAreaInfo": "Aires de repos non s\xe9par\xe9es de l'aire d'alimentation ; pour les autres conditions, voir l'ordonnance sur la protection des animaux, tableau 7.",
                "lawLayingAreaMultiroom": "Surface de repos en stabulation libre \xe0 plusieurs compartiments",
                "layingAreaMultiroomInfo": "Aires de repos s\xe9par\xe9es de l'aire d'alimentation ; pour les autres conditions, voir l'ordonnance sur la protection des animaux, tableau 7.",
                "lawClearWidth": "Largeur int\xe9rieure ",
                "lawClearWidthInfo": "1,5 x taille au garrot de l’animal le plus grand ",
                "lawClearHeight": "Hauteur int\xe9rieure",
                "lawRunoutTime": "Temps de sortie",
                "lawRunoutAreaAdjacent": "Aire de sortie attenante \xe0 l'\xe9curie",
                "lawRunoutAreaNonadjacent": "Aire de sortie non attenante \xe0 l'\xe9curie",
                "lawPasturing": "P\xe2turage",
                "additionalRecommendations": {
                    "title": "Autres recommandations",
                    "furnishing": "Am\xe9nagement",
                    "socialStructure": "Structure sociale et besoins sp\xe9cifiques \xe0 l’esp\xe8ce",
                    "indoor": "D\xe9tention \xe0 l'int\xe9rieur",
                    "outdoor": "D\xe9tention \xe0 l'ext\xe9rieur",
                    "specificNeeds": "Besoins sp\xe9cifiques \xe0 l'esp\xe8ce",
                    "specialRequirements": "Exigences",
                    "activity": "Mouvement",
                    "more": "Autres"
                },
                "additionalLaws": {
                    "title": "Autres dispositions l\xe9gales",
                    "furnishing": "Am\xe9nagement",
                    "raisedAreas": "Plateformes sur\xe9lev\xe9es",
                    "socialStructure": "Structure sociale",
                    "structuring": "Structuration de l'espace",
                    "activity": "Mouvement",
                    "exercise": "Occupation"
                },
                "lawDetails": "Veuillez noter que les prescriptions l\xe9gales minimales ne correspondent qu’au strict minimum. La d\xe9tention des animaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. \nPour d\xe9tenir les animaux dans des conditions conformes \xe0 leurs besoins, il faut des surfaces nettement plus spacieuses et des am\xe9nagements bien structur\xe9s (voir recommandations).\n",
                "additionalInfo": "Pour plus d’informations"
            }
        }
    },
    "it_CH": {
        "txt": {
            "title": "Calcolatore per la detenzione di animali",
            "buttonNext": "Continua",
            "buttonPrevious": "Indietro",
            "buttonClose": "Chiudere",
            "buttonAcceptWarning": "Compreso",
            "domain": "calcolatore-detenzione-animali.ch",
            "link": "https://www.calcolatore-detenzione-animali.ch",
            "trButton": {
                "cta": "Per saperne di pi\xf9 sulla detezione adeguata alla specie:",
                "buttonText": "Aprire il calcolatore per la detenzione di animali"
            },
            "categories": {
                "rodents": {
                    "name": "Roditori e conigli"
                },
                "reptiles": {
                    "name": "Rettili"
                },
                "birds": {
                    "name": "Uccelli"
                },
                "equidae": {
                    "name": "Equidi"
                }
            },
            "animals": {
                "rodents": {
                    "degu": {
                        "name": "Degu",
                        "namePlural": "Degu",
                        "minAnimalsErrorMessage": "I degu sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I degu dovrebbero essere detenuti in gruppi di 2-5 animali.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I degu dovrebbero essere detenuti in gruppi di 2-5 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 5 animali\nComposizione del gruppo: gruppo di sole femmine, gruppo di soli maschi, un maschio castrato con pi\xf9 femmine\n"
                        },
                        "laws": {
                            "furnishing": "Lettiera adatta per scavare, possibilit\xe0 di rifugiarsi per tutti gli animali, foraggio grezzo (fieno o paglia), oggetti da rosicchiare come rami freschi, bagno di sabbia\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I degu sono animali sociali e non possono essere detenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Degu comune",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_degu_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "dwarfHamster": {
                        "name": "Criceto nano",
                        "namePlural": "Criceti nani",
                        "minAnimalsWarningMessage": "Attenzione, la detenzione dei criceti nani \xe8 molto impegnativa e possibile solamente per detentori di roditori esperti.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto!",
                        "recommendations": {
                            "socialStructure": "La detenzione di criceti nani \xe8 impegnativa e richiede molta esperienza. Prima di acquistare, informarsi presso degli esperti in merito a quali specie possono essere detenute in quali dimensioni del gruppo e con quale composizioni\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi, lettiera adatta per scavare, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale adatto alla preparazione del nido, foraggio grezzo (fieno, paglia, miscele di semi), oggetti da rosicchiare come rami freschi\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "Per i criceti nani \xe8 consentita sia la detenzione individuale sia in gruppo.\n"
                        },
                        "links": {
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "fancyMouse": {
                        "name": "Topo domestico",
                        "namePlural": "Topi domestici",
                        "minAnimalsErrorMessage": "I topi domestici sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I topi domestici dovrebbero essere detenuti in gruppi di 2-6 animali.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Farbm\xe4use sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 6 animali\nComposizione del gruppo: gruppo di sole femmine, un maschio castrato con pi\xf9 femmine\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi, lettiera adatta, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale adatto alla preparazione del nido, foraggio grezzo (fieno, paglia, miscele di semi), oggetti da rosicchiare come rami freschi\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I topi domestici sono animali sociali e non possono essere detenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Topo domestico",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_farbm%C3%A4use_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "gerbil": {
                        "name": "Gerbillino",
                        "namePlural": "Gerbillini",
                        "minAnimalsErrorMessage": "I gerbillini sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I gerbillini dovrebbero essere detenuti in gruppi di 2 animali.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I gerbillini dovrebbero essere detenuti in gruppi di 2 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 animali,\nComposizione del gruppo: gruppo di sole femmine, gruppo di soli maschi, un maschio castrato con una femmina\n"
                        },
                        "laws": {
                            "furnishing": "Lettiera adatta per scavare, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale per il nido adeguato, foraggio grezzo (fieno o paglia), bagno di sabbia, oggetti da rosicchiare (rami freschi)\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I gerbillini sono animali sociali e non possono essere detenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Mongolische Rennm\xe4use",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_rennmaus_de.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "goldenHamster": {
                        "name": "Criceto dorato",
                        "namePlural": "Criceti dorati",
                        "maxAnimalsErrorMessage": "I criceti dorati sono animali solitari e devono essere detenuti da soli.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 1 animale\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi, lettiera adatta per scavare, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale adatto alla preparazione del nido, foraggio grezzo (fieno, paglia, miscele di semi), oggetti da rosicchiare come rami freschi\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I criceti dorati sono animali solitari e devono essere detenuti da soli.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Il criceto dorato siriano",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_kaninchen_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "guineaPig": {
                        "name": "Porcellino d'India",
                        "namePlural": "porcellini d'India",
                        "minAnimalsErrorMessage": "I porcellini d'India sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I porcellini d'India dovrebbero essere tenuti in gruppi di 2-6 animali.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I porcellini d'India dovrebbero essere tenuti in gruppi di 2-6 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 6 animali\nComposizione del gruppo: gruppo di sole femmine oppure un maschio castrato con pi\xf9 femmine, in parte possibili anche gruppi di soli maschi\n"
                        },
                        "laws": {
                            "furnishing": "Lettiera adatta, possibilit\xe0 di rifugiarsi per tutti gli animali, oggetti da rosicchiare come rami freschi, foraggio grezzo (fieno o paglia), alimenti contenenti vitamina C\n",
                            "raisedAreas": "Le superfici rialzate calpestabili possono essere conteggiate fino a un terzo per la superficie minima richiesta, a condizione che l'area sotto il livello rialzato possa essere utilizzata anche dagli animali.\n",
                            "socialStructure": "I porcellini d'India sono animali sociali e non possono essere tenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Porcellini d’India – Cavia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_meerschweinchen_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "rabbit": {
                        "name": "Coniglio",
                        "namePlural": "Conigli",
                        "minAnimalsErrorMessage": "I conigli sono animali sociali. La detenzione individuale \xe8 consentita solo se gli animali hanno un contatto uditivo o olfattivo con i loro simili!",
                        "maxAnimalsWarningMessage": "A partire da un gruppo di 3 animali, attualmente esistono solo delle raccomandazioni per quanto concerne la superficie minima. Le superfici ad oggi raccomandate sono piuttosto piccole e attualmente sono in fase di revisione.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I conigli dovrebbero essere detenuti in gruppi di 2-6 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 6 animali\nComposizione del gruppo: un maschio castrato con 1 o 2 femmine, 2 maschi castrati con 2 - 4 femmine, in parte possibili anche gruppi di sole femmine\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe0 di rifugiarsi per tutti gli animali, oggetti da rosicchiare come rami freschi, foraggio grezzo (fieno o paglia)\n",
                            "raisedAreas": "Le superfici rialzate calpestabili possono essere conteggiate fino a un terzo per la superficie minima richiesta, a condizione che l'area sotto il livello rialzato possa essere utilizzata anche dagli animali.\n",
                            "socialStructure": "I conigli sono animali sociali. La detenzione individuale \xe8 consentita solo se gli animali hanno un contatto uditivo o olfattivo con i loro simili!\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Coniglio",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_kaninchen_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "rat": {
                        "name": "Ratto",
                        "namePlural": "Ratti",
                        "minAnimalsErrorMessage": "I ratti sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I ratti dovrebbero essere detenuti in gruppi di 2-6 animali.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I ratti dovrebbero essere detenuti in gruppi di 2-6 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 6 animali\nComposizione del gruppo: gruppo di soli maschi, gruppo di sole femmine, gruppo misto con maschi castrati\n"
                        },
                        "laws": {
                            "furnishing": "Lettiera adatta, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale adatto alla preparazione del nido, foraggio grezzo (fieno o paglia), oggetti da rosicchiare come rami freschi\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I ratti sono animali sociali e non possono essere detenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Ratto",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_ratten_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    }
                },
                "reptiles": {
                    "royalPython": {
                        "name": "Pitone reale",
                        "namePlural": "Pitoni reali",
                        "textLength": "Per i serpenti, si misura la lunghezza totale del corpo dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei pitoni reali. I pitoni reali sono adatti a socializzare con i conspecifici.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei pitoni reali. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei pitoni reali. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di fare il bagno, nascondigli, condizioni climatiche e di temperatura adatte alla specie, possibilit\xe0 di arrampicarsi\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "s\xec"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo tale che gli animali non possano scottarsi, possibilit\xe0 di arrampicarsi, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, rami e aree rialzate, wetbox, vasca d'acqua, acqua e cibo adatto alla specie (animali da mangiare)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 26-32\xb0C, spot di calore locale 36\xb0C, raffreddamento notturno, i pitoni reali sono abbastanza bene compatibili tra loro e possono essere tenuti anche in coppia o a tre se il terrario \xe8 abbastanza grande.\n",
                            "waterBasin": "Vasca d'acqua"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Pitone reale",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_k%C3%B6nigspython_it.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "cornSnake": {
                        "name": "Serpente del grano",
                        "namePlural": "Serpenti del grano",
                        "textLength": "Per i serpenti, si misura la lunghezza totale del corpo dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei serpenti del grano. I serpenti del grano sono adatti a socializzare con i conspecifici.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei serpenti del grano. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei serpenti del grano. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Condizioni climatiche e di temperatura adatte alla specie, nascondigli, possibilit\xe0 di arrampicarsi\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo che gli animali non possano bruciarsi, vasche d'acqua, possibilit\xe0 di arrampicarsi, substrato di fondo sciolto, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, rami, wetbox, acqua e cibo adatto alla specie (animali da mangiare)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 24-28\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno, a seconda del clima di origine si consiglia uno svernamento al fresco.\n",
                            "waterBasin": "Vasca d'acqua"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Serpe del grano",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_kornnatter_it.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "greekTortoise": {
                        "name": "Testuggine greca",
                        "namePlural": "Testuggini greche",
                        "textLength": "Per le testuggini o tartarughe, si misura la lunghezza del carapace dell'animale pi\xf9 grande.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Nascondigli e terreno su cui scavare, punt di sole e lampada a emissione UV, accesso alla luce naturale del sole, ulteriore uscita all'aperto, possibilit\xe0 di svernare\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Recinto esterno con recinzione a prova di fuga e possibilit\xe0 di separazione, casa riparo, ad esempio serra, letto caldo, substrato del terreno vario e parzialmente scavabile (sassi, sabbia, ghiaia, calcare giurassico, ecc.), aree per prendere il sole, possibilit\xe0 di ritirarsi, ad esempio con piante, radici, pietre, ecc., acqua e mangime adatto alla specie (fieno, erbe)\n",
                            "socialStructure": "\xc8 necessario tenere conto dei requisiti specifici della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, lo svernamento, la progettazione dello recinto e della mangiatoia. \xc8 importante disporre di una struttura di svernamento sicura.\n",
                            "more": "Le testuggini hanno un'aspettativa di vita molto elevata (40-80 anni)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni di base sulla detenzione di testuggini europee",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_it.pdf"
                            },
                            "1": {
                                "text": "Detenzione di tartarughe rispettosa degli animali nella pratica",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_it.pdf"
                            },
                            "2": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "moorishTortoise": {
                        "name": "Testuggine moresca",
                        "namePlural": "Testuggini moresche",
                        "textLength": "Per le testuggini o tartarughe, si misura la lunghezza del carapace dell'animale pi\xf9 grande.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Nascondigli e terreno su cui scavare, punt di sole e lampada a emissione UV, accesso alla luce naturale del sole, ulteriore uscita all'aperto, possibilit\xe0 di svernare\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Recinto esterno con recinzione a prova di fuga e possibilit\xe0 di separazione, casa riparo, ad esempio serra, letto caldo, substrato del terreno vario e parzialmente scavabile (sassi, sabbia, ghiaia, calcare giurassico, ecc.), aree per prendere il sole, possibilit\xe0 di ritirarsi, ad esempio con piante, radici, pietre, ecc., acqua e mangime adatto alla specie (fieno, erbe)\n",
                            "socialStructure": "\xc8 necessario tenere conto dei requisiti specifici della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, lo svernamento, la progettazione dello recinto e della mangiatoia. \xc8 importante disporre di una struttura di svernamento sicura.\n",
                            "more": "Le testuggini hanno un'aspettativa di vita molto elevata (40-80 anni)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni di base sulla detenzione di testuggini europee",
                                "file": "http://www.protezione-animali.com/pubblicazioni/animali_da_compagnia/infothek/reptilien/mb_landschildkroeten.pdf"
                            },
                            "1": {
                                "text": "Detenzione di tartarughe rispettosa degli animali nella pratica",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_it.pdf"
                            },
                            "2": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "wideShelledTortoise": {
                        "name": "Testuggine marginata",
                        "namePlural": "Testuggini marginate",
                        "textLength": "Per le testuggini o tartarughe, si misura la lunghezza del carapace dell'animale pi\xf9 grande.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Nascondigli e terreno su cui scavare, punt di sole e lampada a emissione UV, accesso alla luce naturale del sole, ulteriore uscita all'aperto, possibilit\xe0 di svernare\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Recinto esterno con recinzione a prova di fuga e possibilit\xe0 di separazione, casa riparo, ad esempio serra, letto caldo, substrato del terreno vario e parzialmente scavabile (sassi, sabbia, ghiaia, calcare giurassico, ecc.), aree per prendere il sole, possibilit\xe0 di ritirarsi, ad esempio con piante, radici, pietre, ecc., acqua e mangime adatto alla specie (fieno, erbe)\n",
                            "socialStructure": "\xc8 necessario tenere conto dei requisiti specifici della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, lo svernamento, la progettazione dello recinto e della mangiatoia. \xc8 importante disporre di una struttura di svernamento sicura.\n",
                            "more": "Le testuggini hanno un'aspettativa di vita molto elevata (40-80 anni)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni di base sulla detenzione di testuggini europee",
                                "file": "http://www.protezione-animali.com/pubblicazioni/animali_da_compagnia/infothek/reptilien/mb_landschildkroeten.pdf"
                            },
                            "1": {
                                "text": "Detenzione di tartarughe rispettosa degli animali nella pratica",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_it.pdf"
                            },
                            "2": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "crownedGecko": {
                        "name": "Geco coronato",
                        "namePlural": "Gechi coronati",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi coronati. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi coronati. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei gechi coronati. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Nascondigli, condizioni climatiche e di temperatura adatte alla specie, possibilit\xe0 di arrampicarsi\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritirarsi quanti sono gli animali (ad esempio tubi di sughero, radici, piante), possibilit\xe0 di arrampicarsi (ad esempio rami finemente ramificati, piante), substrato del terreno per scavare, acqua e cibo adatto alla specie (insetti)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-30\xb0C, raffreddamento notturno. Temperature invernali inferiori di 5\xb0-6\xb0C. I maschi sono incompatibili tra loro, la loro socializzazione non deve essere prevista.\n",
                            "waterBasin": "-"
                        }
                    },
                    "links": {
                        "0": {
                            "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                            "file": "https://www.tierschutz.com/publikationen/heimtiere/infothek/gehege/broschuere_gehege_reptilien.pdf"
                        },
                        "1": {
                            "text": "Merkblatt Reptilien als Heimtiere",
                            "file": "http://www.tierschutz.com/publikationen/heimtiere/infothek/reptilien/reptilien_heimtiere.pdf"
                        }
                    },
                    "boaConstrictor": {
                        "name": "Boa constrictor",
                        "namePlural": "Boa constrictor",
                        "textLength": "Per i serpenti, si misura la lunghezza totale del corpo dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei boa constrictor. I boa constrictor sono abbastanza compatibili tra loro e possono essere tenuti in coppia o a tre se il terrario \xe8 abbastanza grande.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei boa constrictor. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei boa constrictor. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di fare il bagno, nascondigli, condizioni climatiche e di temperatura adatte alla specie, possibilit\xe0 di arrampicarsi\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo tale che gli animali non possano scottarsi, possibilit\xe0 di arrampicarsi, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, rami e aree rialzate, wetbox, vasca d'acqua, acqua e cibo adatto alla specie (animali da mangiare)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 22-30\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno, i boa constrictor sono abbastanza compatibili tra loro e possono essere tenuti anche in coppia o a tre se il terrario \xe8 abbastanza grande.\n",
                            "more": "I boa constrictor possono superare i 4 metri di lunghezza. I valori qui indicati si riferiscono ad animali di lunghezza fino a 250 cm. Gli animali pi\xf9 grandi hanno bisogno di recinti pi\xf9 grandi.\n",
                            "waterBasin": "Vasca d'acqua 0.5 m\xb2"
                        },
                        "links": {
                            "0": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "muskTurtle": {
                        "name": "Tartaruga muschiata comune",
                        "namePlural": "Tartarughe muschiate comuni",
                        "textLength": "Per le testuggini o tartarughe, si misura la lunghezza del carapace dell'animale pi\xf9 grande.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale delle tartarughe muschiate. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale delle tartarughe muschiate. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale delle tartarughe muschiate. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Condizioni climatiche e di temperatura, di illuminazione adatte alla specie, punt di sole e lampada a emissione UV, nascondigli\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "in aggiunta all’area"
                        },
                        "recommendations": {
                            "furnishing": "Si raccomanda una sistemazione all'aperto in estate, lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo che gli animali non possano scottarsi, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di rifugiarsi quanti sono gli animali, ad esempio radici, rami, pietre, fogliame, parte di terreno facilmente accessibile, cibo adeguato alla specie (animali da pasto)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-28\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno, si consiglia uno svernamento al fresco.\n",
                            "waterBasin": "dell’area complessiva"
                        },
                        "links": {
                            "0": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "kingSnake": {
                        "name": "Serpente reale",
                        "namePlural": "Serpenti reali",
                        "textLength": "Per i serpenti, si misura la lunghezza totale del corpo dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei serpenti reali.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei serpenti reali. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei serpenti reali. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Condizioni climatiche e di temperatura adeguate alla specie, nascondigli\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo che gli animali non possano bruciarsi, vasche d'acqua, possibilit\xe0 di arrampicarsi, substrato di fondo sciolto, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, rami, wetbox, acqua e cibo adatto alla specie (animali da mangiare)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno, a seconda del clima di origine si consiglia uno svernamento al fresco.\n",
                            "more": "I serpenti reali si nutrono anche di altri serpenti e non devono quindi essere socializzati con altre serpenti.\n",
                            "waterBasin": "Vasca d'acqua"
                        },
                        "links": {
                            "0": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "madagascarDayGecko": {
                        "name": "Geco diurno gigante del Madagascar",
                        "namePlural": "Gechi diurni giganti del Madagascar",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi diurni. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi diurni. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei gechi diurni. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi orizzontalmente e verticalmente, nascondigli, condizioni climatiche e di illuminazione adatte alla specie, punt di sole e lampada a emissione UV\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione UV deve essere installata in modo che tutti gli animali abbiano accesso alla luce (collocazione adeguata e numero sufficiente di punti soleggiati), ma non possano scottarsi sulle lampade, sistema per produrre l'umidit\xe0 necessaria alle rispettive specie, ad esempio nebulizzatore, impianto di irrigazione, bottiglia a spruzzo, piantumazione, cascata, ecc. Sistema di misurazione della temperatura e dell'umidit\xe0 dell’aria, possibilit\xe0 di arrampicata diversificate e adatte alla specie, spesse almeno quanto il corpo (parete di fondo, rami, bastoni di bamb\xf9, piante a foglia larga, ecc.), possibilit\xe0 di ritiro adatte alla specie attraverso piante, radici, pietre, canne di bamb\xf9 tagliate, ecc., substrato adatto alla specie, acqua e cibo adatto alla specie (insetti, nettare, polpa di frutta).\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 40\xb0C, raffreddamento notturno. I maschi sono incompatibili tra loro, la loro socializzazione non deve essere prevista.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Geco gigante del Madagascar",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_taggecko_de.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "goldDustDayGecko": {
                        "name": "Geco diurno polvere d'oro",
                        "namePlural": "Gechi diurni polvere d'oro",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi diurni. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi diurni. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei gechi diurni. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi orizzontalmente e verticalmente, nascondigli, condizioni climatiche e di illuminazione adatte alla specie, punt di sole e lampada a emissione UV\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione UV deve essere installata in modo che tutti gli animali abbiano accesso alla luce (collocazione adeguata e numero sufficiente di punti soleggiati), ma non possano bruciarsi sulle lampade, sistema per produrre l'umidit\xe0 necessaria alle rispettive specie, ad esempio nebulizzatore, impianto di irrigazione, bottiglia a spruzzo, piantumazione, cascata ecc. Sistema di misurazione della temperatura e dell'umidit\xe0 dell’aria, possibilit\xe0 di arrampicata diversificate e adatte alla specie, spesse almeno quanto il corpo (parete di fondo, rami, bastoni di bamb\xf9, piante a foglia larga, ecc.), possibilit\xe0 di ritiro adatte alla specie attraverso piante, radici, pietre, canne di bamb\xf9 tagliate, ecc., substrato adatto alla specie, acqua e cibo adatto alla specie (insetti, nettare, polpa di frutta).\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 40\xb0C, raffreddamento notturno. I maschi sono incompatibili tra loro, la loro socializzazione non deve essere prevista.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "leopardGecko": {
                        "name": "Geco leopardo",
                        "namePlural": "Gechi leopardi",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi leopardo. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi leopardo. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei gechi leopardo. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Nascondigli, possibilit\xe0 di scavare, condizioni climatiche e di illuminazione adatte alla specie.\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base; sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno altrettante possibilit\xe0 di rifugio per gli animali (ad esempio tubi di sughero, radici, almeno un nascondiglio leggermente umido), possibilit\xe0 di arrampicarsi (ad esempio strutture in pietra, parete posteriore, radici), substrato per scavare, acqua e cibo adatto alla specie (insetti)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie in termini di habitat, comportamento sociale, clima, svernamento, allestimento del terrario e alimentazione. Temperatura di base 22-28\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno. I maschi sono territoriali, la loro socializzazione \xe8 sconsigliata.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Geco leopardo",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_leopardgecko_it.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "dwarfBeardedDragon": {
                        "name": "Drago barbuto nano",
                        "namePlural": "Draghi barbuti nani",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei draghi barbuti. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei draghi barbuti. I maschi sono incompatibili tra loro. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei draghi barbuti. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi e nascondersi, condizioni climatiche e di illuminazione adatte alla specie, Possibilit\xe0 di arrampicarsi orizzontalmente e verticalmente, nascondigli, condizioni climatiche e di illuminazione adatte alla specie, punt di sole e lampada a emissione UV\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Aree di riposo rialzate, lampade a emissione UV e illuminazione di base, l'illuminazione UV deve essere installata in modo tale che tutti gli animali possano accedervi (collocazione adeguata e numero sufficiente di punti soleggiati), ma non possano scottarsi sulla lampada (il contatto diretto con la fonte luminosa non deve essere possibile), sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, possibilit\xe0 di fare il bagno, possibilit\xe0 di arrampicarsi e rocce, sabbia per scavare, acqua e cibo adatto alla specie (cibo fresco, insetti)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie in termini di habitat, comportamento sociale, clima, svernamento, allestimento del terrario e alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 45\xb0C, raffreddamento notturno, a seconda del clima di origine si consiglia uno svernamento al fresco. Anche se i draghi barbuti sono animali solitari al di fuori della stagione degli amori, la compagnia di conspecifici \xe8 un importante arricchimento delle opzioni comportamentali nel terrario, purch\xe9 gli animali siano compatibili.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Drago barbuto dalla testa striata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_it.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "centralBeardedDragon": {
                        "name": "Drago barbuto dalla testa striata",
                        "namePlural": "Draghi barbuti dalla testa striata",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei draghi barbuti. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei draghi barbuti. I maschi sono incompatibili tra loro. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei draghi barbuti. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi e nascondersi, condizioni climatiche e di illuminazione adatte alla specie, Possibilit\xe0 di arrampicarsi orizzontalmente e verticalmente, nascondigli, condizioni climatiche e di illuminazione adatte alla specie, punt di sole e lampada a emissione UV\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Aree di riposo rialzate, lampade a emissione UV e illuminazione di base, l'illuminazione UV deve essere installata in modo tale che tutti gli animali possano accedervi (collocazione adeguata e numero sufficiente di punti soleggiati), ma non possano scottarsi sulla lampada (il contatto diretto con la fonte luminosa non deve essere possibile), sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, possibilit\xe0 di fare il bagno, possibilit\xe0 di arrampicarsi e rocce, sabbia per scavare, acqua e cibo adatto alla specie (cibo fresco, insetti)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie in termini di habitat, comportamento sociale, clima, svernamento, allestimento del terrario e alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 45\xb0C, raffreddamento notturno, a seconda del clima di origine si consiglia uno svernamento al fresco. Anche se i draghi barbuti sono animali solitari al di fuori della stagione degli amori, la compagnia di conspecifici \xe8 un importante arricchimento delle opzioni comportamentali nel terrario, purch\xe9 gli animali siano compatibili.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Drago barbuto dalla testa striata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_de.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    }
                },
                "birds": {
                    "diamondDove": {
                        "name": "Tortora diamantina",
                        "namePlural": "Tortore diamantine",
                        "minAnimalsErrorMessage": "Le tortore diamantine sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 tortore diamantine insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Le tortore diamantine sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppo con pi\xf9 coppie riproduttive.",
                            "indoor": "Le tortore diamantine possono essere detenute in voliere di grandi dimensioni o in stanze per uccelli. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La variante di detenzione pi\xf9 rispettosa per le tortore diamantine \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (protetta dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": '"Le tortore diamantine sono generalmente molto pacifiche e si possono detenere con altre specie di uccelli pacifici se si dispone di un’esperienza adeguata. \nAlle tortore diamantine piace trascorrere molto tempo a terra durante il giorno, quindi \xe8 necessario prestare particolare attenzione a garantire che la voliera abbia un’ampia superficie sul fondo. Sono agili volatrici, quindi \xe8 importante assicurare anche che ci sia spazio sufficiente per il volo."'
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "canary": {
                        "name": "Canarino",
                        "namePlural": "Canarini",
                        "minAnimalsErrorMessage": "I canarini sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 canarini insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I canarini sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "I canarini possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La variante di detenzione pi\xf9 rispettosa per i canarini \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetta dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "La detenzione comune insieme ad altre specie di uccelli \xe8 consigliata solo alle persone con molte conoscenze specialistiche.\nAttenzione: Per i canarini esistono delle razze d’allevamento (ad es. alcuni canarini di forma e posizione) che appartengono alle razze da tortura, quind si prega di non comprare questi animali"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA - Canarino",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_kanarien_it.pdf"
                            }
                        }
                    },
                    "zebraFinch": {
                        "name": "Diamante mandarino",
                        "namePlural": "Diamanti mandarini",
                        "minAnimalsErrorMessage": "I diamanti mandarini sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 diamanti mandarini insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I diamanti mandarini sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "I diamanti mandarini possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La variante di detenzione pi\xf9 rispettosa per i diamanti mandarini \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (minimo 12\xb0C) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.). Attenzione: Nella stagione invernale \xe8 necessaria la detenzione all’interno!",
                            "specificNeeds": "La detenzione comune insieme ad altre specie di uccelli \xe8 consigliata solo alle persone con molte conoscenze specialistiche."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA - Diamante mandarino",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_zebrafinken_it.pdf"
                            }
                        }
                    },
                    "grayWaxbill": {
                        "name": "Becco di corallo",
                        "namePlural": "Becchi di corallo",
                        "minAnimalsErrorMessage": "I becchi di corallo sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 becchi di corallo insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I becchi di corallo sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "I becchi di corallo possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "Possibile solo nei mesi estivi, poich\xe9 i becchi di corallo sono sensibili al freddo. Nei mesi estivi, parco esterno costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (minimo 18\xb0C) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "La detenzione comune insieme ad altre specie di uccelli \xe8 consigliata solo alle persone con molte conoscenze specialistiche."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "goldenBreasted": {
                        "name": "Bengalino ventre arancio",
                        "namePlural": "Bengalini ventre arancio",
                        "minAnimalsErrorMessage": "I bengalini ventre arancio sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 bengalini ventre arancio insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I bengalini ventre arancio dovrebbero essere detenuti in coppia poich\xe9 i maschi possono essere aggressivi nei confronti dei rivali della stessa specie durante la stagione riproduttiva.",
                            "indoor": "I bengalini ventre arancio possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "Possibile solo nei mesi estivi, poich\xe9 i bengalini ventre arancio sono sensibili al freddo. Nei mesi estivi, parco esterno costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (minimo 15\xb0C) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Uccello longevo, molto attivo, necessita di una voliera spaziosa con erba e canne. \nLa detenzione comune insieme ad altre specie di uccelli \xe8 impegnativa e consigliata solo alle persone con molte conoscenze specialistiche."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "gouldianMadine": {
                        "name": "Diamante di Gould",
                        "namePlural": "Diamanti di Gould",
                        "minAnimalsErrorMessage": "I diamante di Gould sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I diamanti di Gould sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "I diamanti di Gould possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "Possibile solo nei mesi estivi, poich\xe9 i diamanti di Gould sono sensibili al freddo. Nei mesi estivi, parco esterno costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (minimo 18\xb0C) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.). Nella stagione invernale, i diamanti di Gould devono assolutamente essere detenuti all’interno (vedi sopra).",
                            "specificNeeds": "Numerose possibilit\xe0 di riparo e abbastanza nascondigli sono essenziali per gli uccelli timidi. \nLa detenzione comune insieme ad altre specie di uccelli \xe8 impegnativa e consigliata solo alle persone con molte conoscenze specialistiche.\nEvitare l’acquisto di specie morfo-cromatico d’allevamento."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA - Diamanti di Gould",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Gouldamadinen_it.pdf"
                            }
                        }
                    },
                    "budgerigar": {
                        "name": "Parrocchetto ondulato",
                        "namePlural": "Parrocchetti ondulati",
                        "minAnimalsErrorMessage": "I parrocchetti ondulati sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I parrocchetti ondulati sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive (almeno 2, meglio 3). Ci\xf2 richiede una grande voliera, poich\xe9 i maschi difendono il sito di nidificazione durante la stagione riproduttiva.",
                            "indoor": "I parrocchetti ondulati possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "I parrocchetti ondulati hanno bisogno di svariate opportunit\xe0 di arrampicarsi sotto forma di vari rami naturali (nocciolo, salice, faggio, alberi da frutto non trattati). Questi servono anche come materiale da rosicchiare e devono essere rinnovati regolarmente.\n\nLa socializzazione con altre specie \xe8 possibile, ma consigliata solo per detentori esperti di uccelli. Evitare di acquistare forme di allevamento estreme (ad esempio uccelli con creste)."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA - Parrocchetto ondulato",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_wellensittiche_it.pdf"
                            }
                        }
                    },
                    "agapornid": {
                        "name": "Inseparabile",
                        "namePlural": "Inseparabili",
                        "minAnimalsErrorMessage": "Gli inseparabili sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.  Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Gli inseparabili sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "Gli inseparabili possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": " La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Per la detenzione domestica, considerare prima di tutto specie come inseparabili di Fischer, facciarosa, mascherato e guancenere. Le altre specie di agapornidi sono pi\xf9 impegnative e sono quindi sconsigliate per i principianti.\nAlcune specie di agapornidi possono essere piuttosto aggressive e non sono adatte per essere detenute con altre specie.\n\nGli agapornidi possono essere piuttosto rumorosi. Pertanto, anche il vicinato deve essere d'accordo con la loro detenzione."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA Inseparabili",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_it.pdf"
                            }
                        }
                    },
                    "tarantaParrot": {
                        "name": "Inseparabile alinere",
                        "namePlural": "Inseparabili alinere",
                        "minAnimalsErrorMessage": "Gli inseparabili alinere sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Gli inseparabili alinere sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "Gli inseparabili alinere possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Gli inseparabili alinere rappresentano la pi\xf9 grande specie di agapornidi (inseparabili). \nDetenere questa specie di agapornidi \xe8 impegnativo e non \xe8 quindi adatta ai principianti.\nLa socializzazione con altre specie \xe8 possibile, ma consigliata solo per detentori esperti di uccelli. \nGli inseparabili alinere possono essere piuttosto rumorosi. Pertanto, anche il vicinato deve essere d'accordo con la loro detenzione."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA Inseparabili",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_it.pdf"
                            }
                        }
                    },
                    "cockatiel": {
                        "name": "Calopsitta",
                        "namePlural": "Calopsitte",
                        "minAnimalsErrorMessage": "Le calopsitte sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Le calopsitte sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "Le calopsitte possono essere detenute in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Le calopsitte hanno bisogno di svariate opportunit\xe0 di arrampicarsi sotto forma di vari rami naturali (nocciolo, salice, faggio, alberi da frutto non trattati). Questi servono anche come materiale da rosicchiare e devono essere rinnovati regolarmente.\n\nLa socializzazione con altre specie \xe8 possibile, ma consigliata solo per detentori esperti di uccelli."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA Calopsitta",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Nymphensittiche_it.pdf"
                            }
                        }
                    },
                    "beautifulParakeet": {
                        "name": "Pappagallo turchese",
                        "namePlural": "Pappagalli turchesi",
                        "minAnimalsErrorMessage": "I pappagalli turchesi sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione comune di una coppia di riproduzione \xe8 la pi\xf9 rispettosa degli animali. \xc8 fondamentale prestare attenzione alla tolleranza individuale degli animali, perch\xe9 i pappagalli turchesi possono reagire in modo piuttosto aggressivo ai conspecifici cos\xec come ad altre specie di uccelli.",
                        "maxAnimalsErrorMessage": "Attenzione! La detenzione dei pappagalli turchesi \xe8  impegnativa: i pappagalli turchesi devono essere detenuti in coppia poich\xe9 possono reagire in modo aggressivo ai conspecifici e ad altre specie di uccelli.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I pappagalli turchesi sono molto socievoli, ma possono essere piuttosto aggressivi verso altri uccelli, anche conspecifici. Per i pappagalli turchesi si raccomanda quindi la detenzione in coppia.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "I pappagalli turchesi hanno bisogno di un'area di volo libera pi\xf9 ampia possibile perch\xe9 il loro volo \xe8 rettilineo. Hanno anche bisogno di essere occupati e di avere opportunit\xe0 di rosicchiare sotto forma di una variet\xe0 di rami freschi e non tossici.\nEvitare la socializzazione con altre specie di uccelli poich\xe9 possono reagire in modo aggressivo."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "rosellaConure": {
                        "name": "Rosella orientale",
                        "namePlural": "Roselle orientali",
                        "minAnimalsErrorMessage": "Le roselle orientali sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Le roselle orientali sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive. In caso di detenzione di pi\xf9 coppie, la voliera deve essere molto grande perch\xe9 i maschi sono molto aggressivi durante la stagione del corteggiamento e il periodo della cova.",
                            "indoor": "Le roselle orientali possono essere detenute in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Le roselle orientali hanno bisogno di un'area di volo libera pi\xf9 ampia possibile perch\xe9 sono molto vivaci. Hanno anche bisogno di essere occupati e di avere opportunit\xe0 di rosicchiare sotto forma di una variet\xe0 di rami freschi e non tossici.\nLa socializzazione con altre specie \xe8 possibile, ma consigliata solo per detentori esperti di uccelli."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "cockatoo": {
                        "name": "Cacatua",
                        "namePlural": "Cacatua",
                        "minAnimalsErrorMessage": "I cacatua sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata! La detenzione dei cacatua (ad eccezione delle calopsitte) \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere dei cacatua, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "maxAnimalsWarningMessage": "La detenzione dei cacatua (ad eccezione delle calopsitte) \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere dei cacatua, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "maxAnimalsErrorMessage": "La detenzione dei cacatua (ad eccezione delle calopsitte) \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere dei cacatua, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "laws": {},
                        "recommendations": {
                            "general": "Per motivi di benessere degli animali, la Protezione Svizzera degli Animali PSA sconsiglia l'allevamento privato di ara/cacatua. I requisiti di spazio per tenere gli ara/cacatua in modo rispettoso degli animali sono immensi e di solito non possono essere soddisfatti dai detentori privati. L'allevamento di cacatua o ara \xe8 estremamente impegnativo e richiede un'autorizzazione. Prima di acquistare un cacatua o un ara, \xe8 necessario completare un corso per esperti (SKN). Inoltre, \xe8 necessario presentare una domanda all'ufficio veterinario cantonale del cantone di residenza e dimostrare di poter soddisfare tutti i requisiti prescritti dalla legge in materia di detenzione, cura e acquisto. Se intendete allevare cacatua o ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per ulteriori informazioni."
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni tecniche − Protezione degli animali. Obbligo di autorizzazione per la detenzione di pappagalli di grossataglia",
                                "file": "https://www.blv.admin.ch/dam/blv/it/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/IT_3.1_Fachinformation_Bewilligungspflicht_fu%CC%88r_Grosspapageien_IT.pdf"
                            }
                        }
                    },
                    "macaw": {
                        "name": "Ara",
                        "namePlural": "Ara",
                        "minAnimalsErrorMessage": "Gli ara sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata! \nLa detenzione dei pappagalli di grandi dimensioni come gli ara \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere degi ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "maxAnimalsWarningMessage": "La detenzione dei pappagalli di grandi dimensioni come gli ara \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere degi ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "maxAnimalsErrorMessage": "La detenzione dei pappagalli di grandi dimensioni come gli ara \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere degi ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "laws": {},
                        "recommendations": {
                            "general": "Per motivi di benessere degli animali, la Protezione Svizzera degli Animali PSA sconsiglia l'allevamento privato di ara/cacatua. I requisiti di spazio per tenere gli ara/cacatua in modo rispettoso degli animali sono immensi e di solito non possono essere soddisfatti dai detentori privati. L'allevamento di cacatua o ara \xe8 estremamente impegnativo e richiede un'autorizzazione. Prima di acquistare un cacatua o un ara, \xe8 necessario completare un corso per esperti (SKN). Inoltre, \xe8 necessario presentare una domanda all'ufficio veterinario cantonale del cantone di residenza e dimostrare di poter soddisfare tutti i requisiti prescritti dalla legge in materia di detenzione, cura e acquisto. Se intendete allevare cacatua o ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per ulteriori informazioni."
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni tecniche − Protezione degli animali. Obbligo di autorizzazione per la detenzione di pappagalli di grossataglia",
                                "file": "https://www.blv.admin.ch/dam/blv/it/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/IT_3.1_Fachinformation_Bewilligungspflicht_fu%CC%88r_Grosspapageien_IT.pdf"
                            }
                        }
                    },
                    "congoGreyParrot": {
                        "name": "Pappagallo cenerino",
                        "namePlural": "Pappagalli cenerini",
                        "minAnimalsErrorMessage": "I pappagalli cenerini sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 6 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I pappagalli cenerini sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "La sola detenzione all’interno non \xe8 rispettosa degli animali per i pappagalli cenerini.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Una detenzione rispettosa dei pappagalli cenerini \xe8 estremamente impegnativa. \nIl commercio di questi animali estremamente longevi \xe8 in forte espansione e ci sono molte offerte da parte di fornitori senza scrupoli (ad es. allevamento a mano, importazioni da fonti poco chiare). I pappagalli cenerini possono essere piuttosto rumorosi,pertanto anche il vicinato deve essere d'accordo con la loro detenzione. \n\nPer motivi di protezione degli animali,evitare di acquistare animali provenienti da allevamenti a mano."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA Pappagallo cenerino",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_graupapageien_it.pdf"
                            }
                        }
                    },
                    "amazon": {
                        "name": "Amazzone",
                        "namePlural": "Amazzoni",
                        "minAnimalsErrorMessage": "Le amazzoni sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 6 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Le amazzoni sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "La sola detenzione all’interno non \xe8 rispettosa degli animali per le amazzoni",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Le amazzoni possono essere piuttosto rumorose,pertanto anche il vicinato deve essere d'accordo con la loro detenzione. \n\nEsistono diverse specie di amazzoni e non tutte sono adatte per la detenzione domestica. La pi\xf9 diffusa \xe8 l’amazzone fronteblu. Ogni specie ha le proprie esigenze specifiche in termini di detenzione, clima, alimentazione e struttura sociale. Si prega di richiedere informazioni a degli esperti riconosciuti o di seguire un corso specialistico prima dell'acquisto.\nPer motivi di protezione degli animali,evitare di acquistare animali provenienti da allevamenti a mano."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    }
                },
                "equidae": {
                    "horse": {
                        "name": "Cavallo",
                        "namePlural": "Cavalli",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro cavallo.",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Quando possibile",
                            "socialStructure": "I cavalli devono avere un contatto diretto con altri cavalli. I cavalli e gli asini parlano una lingua diversa e hanno esigenze differenti per quanto concerne la detenzione e l’alimentazione. ",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente."
                        },
                        "laws": {
                            "runoutTime": "Cavalli utilizzati 2 x 2 h / settimana; cavalli non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    },
                    "pony": {
                        "name": "Pony",
                        "namePlural": "Pony",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro pony o cavallo.",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Quando possibile, adeguare tuttavia lo stato dell’alimentazione!",
                            "socialStructure": "I pony devono avere un contatto diretto con altri pony o cavalli. ",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente.",
                            "specialRequirements": "Con l'erba giovane, ricca di proteine​e fruttani, sussiste un aumento del rischio di obesit\xe0, soprattutto nei pony, specie se questi ultimi non si muovono a sufficienza."
                        },
                        "laws": {
                            "runoutTime": "Pony utilizzati 2 x 2 h / settimana; pony non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    },
                    "donkey": {
                        "name": "Asino",
                        "namePlural": "Asini",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro asino.  ",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Pascolo limitato per gli asini, pi\xf9 movimento su ampie aree asciutte.",
                            "socialStructure": "Gli asini hanno bisogno del contatto diretto con i conspecifici, quindi con altri asini. Si differenziano dai cavalli per il comportamento e la fisiologia. Bisogna fornire loro cibo e occupazioni aggiuntivi con un alto contenuto di fibre come rami e paglia.",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente.",
                            "specialRequirements": "Gli asini sono animali che assimilano il cibo in modo molto efficiente. Hanno bisogno di alimenti ipocalorici a basso contenuto di zuccheri e proteine,​ma ricchi di fibre. Il manto degli asini \xe8 difficilmente idrorepellente, quindi quando sono bagnati, gli asini sono soggetti a malattie. Hanno sempre bisogno di un riparo asciutto. Gli asini hanno bisogno di terreno asciutto, altrimenti c'\xe8 il rischio che insorgano problemi agli zoccoli."
                        },
                        "laws": {
                            "runoutTime": "Muli utilizzati 2 x 2 h / settimana; muli non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    },
                    "mule": {
                        "name": "Mulo",
                        "namePlural": "Muli",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro mulo.",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Pascolo limitato",
                            "socialStructure": "I muli preferiscono il contatto con altri muli. Naturalmente i muli possono essere tenuti con la madre cavalla. Tuttavia, bisogna tenere conto della loro fisiologia per quanto concerne alimentazione e pascolo.  ",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente."
                        },
                        "laws": {
                            "runoutTime": "Muli utilizzati 2 x 2 h / settimana; muli non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    },
                    "hinny": {
                        "name": "Bardotto",
                        "namePlural": "Bardotti",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro bardotto. ",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Pascolo limitato",
                            "socialStructure": "I bardotti prediligono il contatto diretto con altri bardotti. Tuttavia possono anche essere detenuti con asini e/o cavalli. Tuttavia, bisogna tenere conto della loro fisiologia per quanto concerne alimentazione e pascolo.  ",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente."
                        },
                        "laws": {
                            "runoutTime": "Bardotti utilizzati 2 x 2 h / settimana; bardotti non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    }
                }
            },
            "screenCategory": {
                "title": "Selezionare la categoria"
            },
            "screenAnimal": {
                "title": "Quale animale vuoi detenere?",
                "multipleBirdsButton": "Tenere insieme pi\xf9 specie",
                "equidaeInfo": "I valori calcolati si applicano solo a equidi di et\xe0 superiore a 30 mesi."
            },
            "screenMultipleBirds": {
                "warning": "Per tenere insieme due o pi\xf9 specie di uccelli, le dimensioni dello stabulario devono essere calcolate separatamente per tutte le specie, ma con il numero totale di uccelli. Lo stabulario pi\xf9 grande calcolato rispetta le dimensioni minime previste dalla legge.",
                "infoText": "Se due o pi\xf9 specie di uccelli sono tenute insieme in uno stabulario, le dimensioni minime legali dello stabulario corrispondono sempre allo spazio necessario per la specie pi\xf9 grande. Ad esempio, se si tengono insieme due pappagallini e due cacatua in uno stesso recinto, le dimensioni minime dello stabulario saranno quelle richieste per quattro cacatua, in quanto si tratta della specie pi\xf9 grande presente nello stabulario. L'allevamento di pi\xf9 specie di uccelli insieme \xe8 adatto solo agli allevatori esperti. Informatevi sempre bene sulle specie di uccelli che possono essere tenute insieme."
            },
            "screenNumber": {
                "title": "Quanti {animals} vuoi detenere?"
            },
            "screenWeight": {
                "title": "Quanto pesano gli {animals}?"
            },
            "screenLength": {
                "title": "Quanto \xe8 lungo {animal} pi\xf9 grande?",
                "error": "Inserire un numero compreso tra {min} e {max}."
            },
            "screenWithersHeight": {
                "title": "Qual \xe8 l'altezza al garrese dei singoli animali?",
                "error": "Inserire un numero compreso tra {min} e {max}.",
                "animal": "Livello"
            },
            "screenResults": {
                "title": "Ecco come dovresti detenere {number} {animals}",
                "example": "Per esempio",
                "exampleEquidae": "Esempio per la dimensione del box",
                "stsRecommendation": "Raccomandazione della protezione degli animali",
                "law": "Legge (Ordinanza federale sulla protezione degli animali)",
                "stsAreaRecommendation": "Area minima (dimensioni interne)",
                "stsLengthRecommendation": {
                    "upto2reptiles": "Lunghezza minima (dimensioni interne)",
                    "morethan2reptiles": "In pi\xf9, come minimo in lunghezza"
                },
                "stsWidthRecommendation": {
                    "upto2reptiles": "Larghezza minima (dimensioni interne)",
                    "morethan2reptiles": "In pi\xf9, come minimo in larghezza"
                },
                "stsHeightRecommendation": "Altezza minima del recinto (dimensioni interne)",
                "stsBeddingRecommendation": "Profondit\xe0 minima della lettiera",
                "stsWaterBasinRecommendation": "Bacino d'acqua",
                "tolerance": "Valore di tolleranza",
                "toleranceInfo": "Le stalle esistenti al 1\xb0 settembre 2008 che soddisfano i valori di tolleranza non necessitano di adeguamento. Se una stalla deve essere modificata perch\xe9 scende al di sotto di un valore di tolleranza, rimane invariato il diritto all'altro valore di tolleranza.",
                "noTolerance": "Nessun valore di tolleranza",
                "stsLayingAreaRecommendation": "Superficie di riposo",
                "stsClearWidthRecommendation": "Larghezza netta",
                "stsClearWidthRecommendationInfo": "2 x garrese dell’animale pi\xf9 grande",
                "stsClearHeightRecommendation": "Altezza netta",
                "stsRunoutTimeRecommendation": "Tempo di uscita all’aperto",
                "stsRunoutTimeRecommendationText": "Preferibilmente accesso libero 24 ore dall’uscita all’aperto in qualsiasi stagione, ma almeno 4 ore al giorno",
                "stsRunoutAreaRecommendation": "Superficie di uscita all’aperto",
                "stsPasturingRecommendation": "Pascolo",
                "stsLatticeSpacing": "Distanza massima fra le sbarre",
                "lawMinimalArea": "Area minima (dimensioni interne)",
                "lawMinimalLength": "Lunghezza minima  (dimensioni interne)",
                "lawMinimalWidth": "Larghezza minima (dimensioni interne)",
                "lawMinimalHeight": "Altezza minima del recinto (dimensioni interne)",
                "lawMinimalBedding": "Profondit\xe0 minima della lettiera",
                "lawWaterBasin": "Bacino d'acqua",
                "lawReptilesInfo": {
                    "text": "Quando si detiene il numero di animali indicato, \xe8 necessario garantire che tutti i requisiti previsti dalla {link} siano soddisfatti per le rispettive specie animali.",
                    "linkText": "legge secondo l’allegato 2, tabella 5 OPan",
                    "linkURL": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                },
                "lawVolume": "Volume",
                "lawLayingArea": "Stalla a stabulazione singola",
                "layingAreaInfo": "Superfici di riposo non separate spazialmente dall’area di alimentazione, per ulteriori condizioni vedere l'Ordinanza sulla protezione degli animali, tabella 7.",
                "lawLayingAreaMultiroom": "La superficie di riposo \xe8 separata spazialmente dall'area di movimento e alimentazione, per ulteriori condizioni vedere l'Ordinanza sulla protezione degli animali, tabella 7.",
                "layingAreaMultiroomInfo": "Aires de repos s\xe9par\xe9es de l'aire d'alimentation ; pour les autres conditions, voir l'ordonnance sur la protection des animaux, tableau 7.",
                "lawClearWidth": "Larghezza netta",
                "lawClearWidthInfo": "1.5 x garrese dell’animale pi\xf9 grande",
                "lawClearHeight": "Altezza netta",
                "lawRunoutTime": "Tempo di uscita all’aperto",
                "lawRunoutAreaAdjacent": "Superficie di uscita all’aperto adiacente",
                "lawRunoutAreaNonadjacent": "Superficie di uscita all’aperto non adiacente",
                "lawPasturing": "Pascolo",
                "additionalRecommendations": {
                    "title": "Ulteriori raccomandazioni",
                    "furnishing": "Attrezzatura",
                    "socialStructure": "Struttura sociale e bisogni specifici della specie",
                    "indoor": "Detenzione interna",
                    "outdoor": "Detenzione all'aperto",
                    "specificNeeds": "Esigenze specifiche della specie",
                    "specialRequirements": "Altre esigenze",
                    "activity": "Movimento",
                    "more": "Inoltre"
                },
                "additionalLaws": {
                    "title": "Altre disposizioni di legge",
                    "furnishing": "Attrezzatura",
                    "raisedAreas": "Superfici rialzate",
                    "socialStructure": "Struttura sociale",
                    "structuring": "Struttura",
                    "activity": "Occupazione",
                    "exercise": "Movimento"
                },
                "lawDetails": "Si prega di notare che i requisiti minimi previsti per legge rappresentano solo dei valori minimi in assoluto. In Svizzera \xe8 vietato tenere animali in gabbie pi\xf9 piccole e maltrattarli. \nPer una detenzione rispettosa degli animali sono necessarie superfici molto pi\xf9 grandi e un’attrezzatura ben strutturata (vedi raccomandazioni).\n",
                "additionalInfo": "Per maggiori informazioni"
            }
        }
    }
};


var $0c7298f63c35bd07$exports = {};
"use strict";
var $0c7298f63c35bd07$var$__importDefault = $0c7298f63c35bd07$exports && $0c7298f63c35bd07$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0c7298f63c35bd07$exports, "__esModule", {
    value: true
});

var $0c7298f63c35bd07$var$es6_object_assign_1 = $0c7298f63c35bd07$var$__importDefault((parcelRequire("3z8PI")));
$0c7298f63c35bd07$var$es6_object_assign_1.default.polyfill();

var $0c7298f63c35bd07$var$vue3_logger_1 = $0c7298f63c35bd07$var$__importDefault((parcelRequire("d7Qcu")));
$0c7298f63c35bd07$exports.default = $0c7298f63c35bd07$var$vue3_logger_1.default;


var $16e82825b28a2514$exports = {};
$16e82825b28a2514$exports = "@import \"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;0,900;1,400&display=swap\";@-webkit-keyframes beat-e74703{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.075);transform:scale(1.075)}20%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes beat-e74703{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.075);transform:scale(1.075)}20%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes tooltips-vert-e74703{to{opacity:.9;-webkit-transform:translate(-50%);transform:translate(-50%)}}@keyframes tooltips-vert-e74703{to{opacity:.9;-webkit-transform:translate(-50%);transform:translate(-50%)}}@-webkit-keyframes tooltips-horz-e74703{to{opacity:.9;-webkit-transform:translateY(-50%);transform:translateY(-50%)}}@keyframes tooltips-horz-e74703{to{opacity:.9;-webkit-transform:translateY(-50%);transform:translateY(-50%)}}@-webkit-keyframes turn-e74703{0%{-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}50%{-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}to{-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}}@keyframes turn-e74703{0%{-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}50%{-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}to{-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}}@media (prefers-reduced-motion:reduce){body .tr-wrapper .screen-results .results .results-visual .cube-container .cube[data-v-e74703]{-webkit-animation:none;animation:none;-webkit-transform:rotate3d(1,1,0,45deg);transform:rotate3d(1,1,0,45deg)}}body .tr-wrapper[data-v-e74703],body .tr-wrapper[data-v-e74703]:before,body .tr-wrapper[data-v-e74703]:after,body .tr-wrapper [data-v-e74703],body .tr-wrapper [data-v-e74703]:before,body .tr-wrapper [data-v-e74703]:after{all:revert}body .tr-wrapper[data-v-e74703],body .tr-wrapper [data-v-e74703]{font-size:100%;font:inherit;vertical-align:baseline;box-sizing:content-box;border:0;margin:0;padding:0}body .tr-button[data-v-e74703]{color:#000;background-color:#fff;border:3px solid #ff7b00;border-radius:10px;flex-wrap:nowrap;padding:.5em 2em .5em .5em;font-family:Roboto,sans-serif;font-size:18px;font-weight:700;display:inline-flex}body .tr-button .logo[data-v-e74703]{margin-top:2px;margin-right:1em}body .tr-button .logo img[data-v-e74703]{max-width:100px}body .tr-button p[data-v-e74703]{margin:.5em 0 .75em}body .tr-button button[data-v-e74703]{color:#fff;letter-spacing:.02rem;cursor:pointer;background-color:#ff7b00;border:2px solid #ff7b00;border-radius:24px;flex-wrap:nowrap;align-content:center;justify-content:flex-start;margin-bottom:1em;padding:0;font-family:Roboto,sans-serif;font-size:18px;font-weight:700;transition:all .2s;display:inline-flex;position:relative;overflow:hidden}body .tr-button button[data-v-e74703]:hover{background-color:#5f4bb6;border-color:#5f4bb6;-webkit-transform:scale(1.02);transform:scale(1.02)}body .tr-button button span[data-v-e74703]{flex-grow:1}body .tr-button button span.tr-icon[data-v-e74703]{background-color:#ff7b00;justify-content:center;align-items:center;padding:5px 12px;display:flex}body .tr-button button span.tr-icon img[data-v-e74703]{height:34px;-webkit-animation:2.5s linear infinite beat-e74703;animation:2.5s linear infinite beat-e74703}body .tr-button button span.tr-button-text[data-v-e74703]{padding:10px 20px}body .tr-button.style-full[data-v-e74703],body .tr-button.hidden[data-v-e74703],body .tr-wrapper.style-button[data-v-e74703]:not(.open){display:none}body .tr-wrapper[data-v-e74703]{--tr-visual-3d-scale:1;color:#000;background-color:#fff;padding:2em 4em 4em;font-family:Roboto,sans-serif;font-size:16px;font-weight:400;position:relative;box-shadow:0 1em 2em -.5em rgba(0,0,0,.35)}body .tr-wrapper.style-button.open[data-v-e74703]{z-index:999;width:calc(96% - 8em);position:absolute;top:10px;left:2%}body .tr-wrapper .close-button[data-v-e74703]{cursor:pointer;z-index:99;background-color:#ff7b00;border-radius:20px;flex-flow:column;justify-content:center;align-items:center;width:65px;height:65px;transition:all .15s;display:none;position:absolute;top:20px;left:20px}body .tr-wrapper .close-button[data-v-e74703]:hover,body .tr-wrapper .close-button[data-v-e74703]:focus{background-color:#fff}body .tr-wrapper .close-button:hover .icon-cross[data-v-e74703]:before,body .tr-wrapper .close-button:hover .icon-cross[data-v-e74703]:after,body .tr-wrapper .close-button:focus .icon-cross[data-v-e74703]:before,body .tr-wrapper .close-button:focus .icon-cross[data-v-e74703]:after{background-color:#ff7b00}body .tr-wrapper .close-button .icon-cross[data-v-e74703]{background:0 0;border:0;width:40px;height:40px;margin:0;padding:0;position:relative}body .tr-wrapper .close-button .icon-cross[data-v-e74703]:before,body .tr-wrapper .close-button .icon-cross[data-v-e74703]:after{content:\"\";background:#fff;border-radius:6px;height:6px;position:absolute;top:17px;left:0;right:0}body .tr-wrapper .close-button .icon-cross[data-v-e74703]:before{-webkit-transform:rotate(45deg);transform:rotate(45deg)}body .tr-wrapper .close-button .icon-cross[data-v-e74703]:after{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}body .tr-wrapper .close-button .icon-cross span[data-v-e74703]{display:block}body .tr-wrapper.style-button.open .close-button[data-v-e74703]{display:flex}body .tr-wrapper .logos[data-v-e74703]{max-width:1450px;margin:0 auto;position:relative}body .tr-wrapper .logo.logo-sts[data-v-e74703]{max-width:350px}body .tr-wrapper .tierschutz-rechner[data-v-e74703]{max-width:1000px;margin:0 auto}body .tr-wrapper .footer[data-v-e74703]{flex-wrap:wrap;justify-content:space-between;padding-top:4rem;display:flex}body .tr-wrapper .footer .backlinks[data-v-e74703],body .tr-wrapper .footer .logos[data-v-e74703]{margin:2rem 0 0}body .tr-wrapper .footer .backlinks p[data-v-e74703]{margin-bottom:0}body .tr-wrapper .footer .backlinks a[data-v-e74703]{letter-spacing:.02em;font-family:Roboto,sans-serif;font-size:1.4rem;font-weight:600;text-decoration:none}body .tr-wrapper .footer .backlinks a[data-v-e74703]:hover{text-decoration:underline}body .tr-wrapper .footer .backlinks p.email a[data-v-e74703]{font-size:1.125rem}body .tr-wrapper .footer .logos[data-v-e74703]{text-align:right}body .tr-wrapper h2[data-v-e74703]{color:#000;text-align:center;letter-spacing:.02em;margin-top:.2em;margin-bottom:1em;font-family:Roboto,sans-serif;font-size:3em;font-weight:700}body .tr-wrapper p[data-v-e74703],body .tr-wrapper label[data-v-e74703],body .tr-wrapper h3[data-v-e74703]{color:#000;margin-bottom:1em;font-size:1.8em}body .tr-wrapper .screen>p[data-v-e74703]:first-child{font-family:Roboto,sans-serif;font-weight:700}body .tr-wrapper h3[data-v-e74703]{border-bottom:2px solid #ff7b00;padding-bottom:1em}body .tr-wrapper h4[data-v-e74703]{color:#000;margin-bottom:1rem;font-family:Roboto,sans-serif;font-size:2.4rem;font-weight:700}body .tr-wrapper h5[data-v-e74703]{color:#000;font-weight:700}body .tr-wrapper hr[data-v-e74703]{border-bottom:1px solid #333;margin-bottom:2em}body .tr-wrapper ul[data-v-e74703]{margin-left:1em}body .tr-wrapper ul li[data-v-e74703]{margin-bottom:.5em}body .tr-wrapper a[data-v-e74703],body .tr-wrapper a[data-v-e74703]:hover{color:#000}body .tr-wrapper span[data-tooltip][data-v-e74703]{color:#000;vertical-align:super;cursor:pointer;font-weight:700;position:relative}body .tr-wrapper span[data-tooltip][data-v-e74703]:before,body .tr-wrapper span[data-tooltip][data-v-e74703]:after{-webkit-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;opacity:0;font-size:1rem;display:none;position:absolute}body .tr-wrapper span[data-tooltip][data-v-e74703]:before{content:\"\";z-index:1000;border:5px solid transparent}body .tr-wrapper span[data-tooltip][data-v-e74703]:after{content:attr(data-tooltip);z-index:1000;text-align:center;white-space:normal;text-overflow:ellipsis;color:#fff;background:#333;border-radius:.3ch;min-width:12em;max-width:21em;padding:1ch 1.5ch;overflow:hidden;box-shadow:0 1em 2em -.5em rgba(0,0,0,.35)}body .tr-wrapper span[data-tooltip][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-v-e74703]:hover:after{display:block}body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):before,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:before{border-top-color:#333;border-bottom-width:0;bottom:100%}body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):after,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:after{bottom:calc(100% + 5px)}body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):before,body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):after,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:before,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:after{left:50%;-webkit-transform:translate(-50%,-.5em);transform:translate(-50%,-.5em)}body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:before{border-top-width:0;border-bottom-color:#333;top:100%}body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:after{top:calc(100% + 5px)}body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:before,body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:after{left:50%;-webkit-transform:translate(-50%,.5em);transform:translate(-50%,.5em)}body .tr-wrapper span[data-tooltip][data-flow^=left][data-v-e74703]:before{border-left-color:#333;border-right-width:0;top:50%;left:-5px;-webkit-transform:translate(-.5em,-50%);transform:translate(-.5em,-50%)}body .tr-wrapper span[data-tooltip][data-flow^=left][data-v-e74703]:after{top:50%;right:calc(100% + 5px);-webkit-transform:translate(-.5em,-50%);transform:translate(-.5em,-50%)}body .tr-wrapper span[data-tooltip][data-flow^=right][data-v-e74703]:before{border-left-width:0;border-right-color:#333;top:50%;right:-5px;-webkit-transform:translate(.5em,-50%);transform:translate(.5em,-50%)}body .tr-wrapper span[data-tooltip][data-flow^=right][data-v-e74703]:after{top:50%;left:calc(100% + 5px);-webkit-transform:translate(.5em,-50%);transform:translate(.5em,-50%)}body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):hover:before,body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):hover:after,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:hover:after,body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:hover:after{-webkit-animation:.3s ease-out forwards tooltips-vert-e74703;animation:.3s ease-out forwards tooltips-vert-e74703}body .tr-wrapper span[data-tooltip][data-flow^=left][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-flow^=left][data-v-e74703]:hover:after,body .tr-wrapper span[data-tooltip][data-flow^=right][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-flow^=right][data-v-e74703]:hover:after{-webkit-animation:.3s ease-out forwards tooltips-horz-e74703;animation:.3s ease-out forwards tooltips-horz-e74703}body .tr-wrapper span[data-tooltip=\"\"][data-v-e74703]:before,body .tr-wrapper span[data-tooltip=\"\"][data-v-e74703]:after{display:none!important}body .tr-wrapper .screen-image-wrapper[data-v-e74703]{aspect-ratio:5/3;background-color:#fff;border-radius:20px;max-width:325px;margin:2em 0;padding:10% 0;overflow:hidden;box-shadow:0 .6em 1.5em rgba(0,0,0,.2)}body .tr-wrapper .screen-image-wrapper img[data-v-e74703]{object-fit:cover;width:100%;margin-top:-16%;transition:opacity .2s;display:block}body .tr-wrapper .screen-length .screen-image-wrapper[data-v-e74703]{aspect-ratio:auto;max-width:546px;padding:80px 40px}body .tr-wrapper .screen-length .screen-image-wrapper img[data-v-e74703]{margin-top:0}body .tr-wrapper .bottom-navi[data-v-e74703]{margin-top:4rem}body .tr-wrapper .warning[data-v-e74703]{color:#000;text-align:center;background-color:#edd82e;border-radius:.7em;margin-bottom:1em;padding:1em;font-size:1rem;font-weight:700}body .tr-wrapper .warning p[data-v-e74703]{color:#000;margin-bottom:0;font-size:1.4rem}body .tr-wrapper input[data-v-e74703]:focus{outline:none}body .tr-wrapper input[type=number][data-v-e74703]{-webkit-appearance:textfield;-ms-appearance:textfield;appearance:textfield}body .tr-wrapper input[type=number][data-v-e74703]::-webkit-inner-spin-button{-webkit-appearance:none}body .tr-wrapper input[type=number][data-v-e74703]::-webkit-outer-spin-button{-webkit-appearance:none}body .tr-wrapper .number-input[data-v-e74703]{border:0;width:325px;margin-bottom:1em;margin-right:1em;display:inline-flex}body .tr-wrapper .number-input[data-v-e74703],body .tr-wrapper .number-input [data-v-e74703]{box-sizing:border-box}body .tr-wrapper .number-input button[data-v-e74703]{-webkit-appearance:none;cursor:pointer;background-color:#fff;border:none;border-radius:0 20px 20px 0;outline:none;justify-content:center;align-items:center;width:4rem;height:4rem;margin:0;position:relative}body .tr-wrapper .number-input button.minus[data-v-e74703]{border:1px solid #333;border-right:none;border-radius:20px 0 0 20px}body .tr-wrapper .number-input button.plus[data-v-e74703]{border:1px solid #333;border-left:none}body .tr-wrapper .number-input button[data-v-e74703]:after{color:#bcbcbc;content:\"-\";font-size:2em;display:inline-block}body .tr-wrapper .number-input button.plus[data-v-e74703]:after{content:\"+\"}body .tr-wrapper .number-input input[type=number][data-v-e74703]{text-align:center;color:#000;border:1px solid #333;border-left:2px;border-right:2px;width:100%;max-width:calc(100% - 8rem);height:4rem;padding:.5rem;font-size:1.8em}body .tr-wrapper .withers-height-input[data-v-e74703],body .tr-wrapper .length-input[data-v-e74703]{background-color:#fff;border:1px solid #333;border-radius:20px;width:325px;margin-bottom:1em;font-size:1.8em;display:inline-block}body .tr-wrapper .withers-height-input input[data-v-e74703],body .tr-wrapper .length-input input[data-v-e74703]{text-align:center;border-radius:20px;width:calc(100% - 2.5em);height:4rem}body .tr-wrapper .withers-height-input[data-v-e74703]{padding-left:1em;display:block}body .tr-wrapper .withers-height-input input[data-v-e74703]{width:calc(100% - 6em)}body .tr-wrapper .screen-withers-height .button-forward[data-v-e74703]{margin-left:0}body .tr-wrapper .select-wrapper[data-v-e74703]{margin-bottom:1em;display:inline-block;position:relative}body .tr-wrapper .select-wrapper select[data-v-e74703]{text-align:center;color:#000;-webkit-appearance:none;-ms-appearance:none;appearance:none;background-color:#fff;background-image:url(\"data:image/svg+xml;utf8,<svg width='24px' height='24px' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><rect x='0' fill='none' width='24' height='24'/><g><path d='M7 10l5 5 5-5'/></g></svg>\");background-position:right 12px center;background-repeat:no-repeat;background-size:3rem;border:none;border-radius:20px;width:325px;max-width:100%;height:4rem;font-size:1.8em;padding:0!important}body .tr-wrapper .button[data-v-e74703]{color:#fff;cursor:pointer;background-color:#ff7b00;border:none;border-radius:.7em;height:4rem;margin:0 1em;padding:0 1.5em;font-size:1.8em;line-height:4rem;transition:all .2s ease-out}body .tr-wrapper .button.button-forward[data-v-e74703]:after{content:\"→\";padding-left:1.2em;font-size:3.6rem;line-height:.5;position:relative;top:.3rem}body .tr-wrapper .button.button-back[data-v-e74703]{margin-left:0}body .tr-wrapper .button.button-back[data-v-e74703]:before{content:\"←\";padding-right:.4em;font-size:3.6rem;line-height:.5;position:relative;top:.3rem}body .tr-wrapper .button[data-v-e74703]:hover{color:#fff;background-color:#5f4bb6}body .tr-wrapper .error-overlay[data-v-e74703],body .tr-wrapper .message-overlay[data-v-e74703]{color:#fff;text-align:center;background-color:#d31c1c;border-radius:1.8em;width:80%;margin:0 auto;padding:3em;font-weight:700;position:absolute;top:5em;left:5%;box-shadow:3px 4px 4px rgba(1,1,1,.3)}body .tr-wrapper .error-overlay span.warning-icon[data-v-e74703],body .tr-wrapper .message-overlay span.warning-icon[data-v-e74703]{text-align:center;width:4em;height:4em;margin:0 auto 1em;display:block}body .tr-wrapper .error-overlay button[data-v-e74703],body .tr-wrapper .message-overlay button[data-v-e74703]{color:#fff;cursor:pointer;background-color:transparent;border:2px solid #fff;border-radius:.7em;padding:.4em 1em;font-size:1.8em}body .tr-wrapper .error-overlay button[data-v-e74703]:hover,body .tr-wrapper .message-overlay button[data-v-e74703]:hover{color:#d31c1c;background-color:#fff}body .tr-wrapper .message-container[data-v-e74703]{margin:4em 0;position:relative}body .tr-wrapper .message-container button.message-button[data-v-e74703]{margin:0}body .tr-wrapper .message-container .message-overlay[data-v-e74703]{z-index:10;background-color:#ff7b00;top:-3em}body .tr-wrapper .message-container .multiple-birds-info.message-overlay[data-v-e74703]{top:-22em}body .tr-wrapper .screen[data-v-e74703]{padding:0;position:relative}body .tr-wrapper .screen-category-selection .image-buttons[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons[data-v-e74703]{flex-wrap:wrap;align-content:flex-start;justify-content:left;align-items:flex-start;gap:40px;display:flex}body .tr-wrapper .screen-category-selection .image-buttons button.image-button[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button[data-v-e74703]{cursor:pointer;color:#fff;background-color:#ff7b00;border:none;border-radius:20px;max-width:220px;padding:0;transition:all .2s ease-out;box-shadow:0 .6em 1.5em rgba(0,0,0,.2)}body .tr-wrapper .screen-category-selection .image-buttons button.image-button .image-wrapper[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button .image-wrapper[data-v-e74703]{aspect-ratio:8/7;border:2px solid #ff7b00;border-radius:16px;transition:all .2s ease-out;overflow:hidden}body .tr-wrapper .screen-category-selection .image-buttons button.image-button img[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button img[data-v-e74703]{max-width:220px;margin-top:-6%;transition:opacity .2s;display:block}body .tr-wrapper .screen-category-selection .image-buttons button.image-button span[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button span[data-v-e74703]{padding:.5em 1em;font-size:1.2em;font-weight:700;display:block}body .tr-wrapper .screen-category-selection .image-buttons button.image-button[data-v-e74703]:hover,body .tr-wrapper .screen-animal-selection .image-buttons button.image-button[data-v-e74703]:hover{background-color:#5f4bb6}body .tr-wrapper .screen-category-selection .image-buttons button.image-button:hover .image-wrapper[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button:hover .image-wrapper[data-v-e74703]{border-color:#5f4bb6}body .tr-wrapper .screen-category-selection .animal-info[data-v-e74703],body .tr-wrapper .screen-animal-selection .animal-info[data-v-e74703]{margin-top:1em;font-size:1.4em}body .tr-wrapper .screen-results .warning[data-v-e74703]{text-align:left}body .tr-wrapper .screen-results span.warning-icon[data-v-e74703]{float:left;text-align:center;margin-top:.2rem;margin-bottom:.2em;margin-right:1em;display:block}body .tr-wrapper .screen-results span.warning-icon object[data-v-e74703]{width:3.5em;max-width:3.5em}body .tr-wrapper .screen-results .results[data-v-e74703]{flex-wrap:wrap;gap:20px;display:flex}body .tr-wrapper .screen-results .results .results-panel[data-v-e74703]{width:100%;max-width:calc(50% - 10px)}body .tr-wrapper .screen-results .results .results-text p[data-v-e74703]{font-size:1.4rem;font-weight:700}body .tr-wrapper .screen-results .results .results-text p .value[data-v-e74703]{color:#000;font-weight:400}body .tr-wrapper .screen-results .results .results-text p.recommendation-length[data-v-e74703],body .tr-wrapper .screen-results .results .results-text p.law-length[data-v-e74703]{border:2px solid #ff7b00;border-bottom:none;margin-bottom:0;padding:1em 1em 0;font-size:1.125rem}body .tr-wrapper .screen-results .results .results-text p.recommendation-width[data-v-e74703],body .tr-wrapper .screen-results .results .results-text p.law-width[data-v-e74703]{border:2px solid #ff7b00;border-top:none;padding:1em;font-size:1.125rem}body .tr-wrapper .screen-results .results .results-text p.reptiles-law-text[data-v-e74703]{border:2px solid #fff;padding:1em;font-size:1.125rem}body .tr-wrapper .screen-results .results .results-text .tolerance[data-v-e74703]{color:#000;font-weight:400}body .tr-wrapper .screen-results .results .results-text .tolerance span[data-tooltip][data-v-e74703]{color:#000}body .tr-wrapper .screen-results .results .results-visual[data-v-e74703]{padding-top:50%;position:relative}body .tr-wrapper .screen-results .results .results-visual .rectangle[data-v-e74703]{background-color:#fff;border:2px dashed #333;width:80%;height:33%;position:absolute;top:0;left:0}body .tr-wrapper .screen-results .results .results-visual .rectangle span[data-v-e74703]{color:#ed7b2e;font-size:1.2rem;font-weight:700}body .tr-wrapper .screen-results .results .results-visual .rectangle .right-pane[data-v-e74703]{border-left:2px solid #ed7b2e;width:20px;height:100%;position:absolute;right:0}body .tr-wrapper .screen-results .results .results-visual .rectangle .bottom-pane[data-v-e74703]{border-top:2px solid #ed7b2e;width:100%;height:20px;position:absolute;bottom:0}body .tr-wrapper .screen-results .results .results-visual .rectangle .area[data-v-e74703]{text-align:center;color:#fff;width:100%;position:absolute;top:calc(50% - 1em)}body .tr-wrapper .screen-results .results .results-visual .rectangle .width[data-v-e74703]{text-align:center;background-color:#fff;padding:.4em 1em;position:absolute;top:-1.2em;left:calc(50% - 2em)}body .tr-wrapper .screen-results .results .results-visual .rectangle .height[data-v-e74703]{text-align:right;background-color:#fff;width:4em;padding:.5em .4em;position:absolute;top:calc(50% - 1.2em);right:0}body .tr-wrapper .screen-results .results .results-visual .rectangle .caption[data-v-e74703]{font-size:1.25em;position:absolute;bottom:-2.5em}body .tr-wrapper .screen-results .results .results-visual .cube-container[data-v-e74703]{-webkit-perspective:500px;perspective:500px;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));-webkit-transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));-webkit-transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));-webkit-transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));width:200px;height:200px;margin:100px;position:absolute;top:0;left:0}body .tr-wrapper .screen-results .results .results-visual .cube-container .cube[data-v-e74703]{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));width:120px;height:200px;-webkit-animation:10s linear infinite turn-e74703;animation:10s linear infinite turn-e74703;position:relative}body .tr-wrapper .screen-results .results .results-visual .cube-container .face[data-v-e74703]{opacity:1;background:rgba(160,73,16,.3);border:1px solid #000;justify-content:center;align-items:center;width:200px;height:200px;font-size:1.4rem;transition:-webkit-transform .5s,-webkit-transform .5s,-webkit-transform .5s,-webkit-transform .5s,transform .5s;display:flex;position:absolute}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.front[data-v-e74703]{-webkit-transform:translateZ(100px);transform:translateZ(100px)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.back[data-v-e74703]{-webkit-transform:translateZ(-100px)rotateY(180deg);transform:translateZ(-100px)rotateY(180deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.left[data-v-e74703]{-webkit-transform:translate(-100px)rotateY(-90deg);transform:translate(-100px)rotateY(-90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.right[data-v-e74703]{-webkit-transform:translate(100px)rotateY(90deg);transform:translate(100px)rotateY(90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.top[data-v-e74703]{-webkit-transform:translateY(-100px)rotateX(90deg);transform:translateY(-100px)rotateX(90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.bottom[data-v-e74703]{-webkit-transform:translateY(100px)rotateX(-90deg);transform:translateY(100px)rotateX(-90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .measurement[data-v-e74703]{justify-content:center;align-items:flex-end;width:200px;height:200px;font-size:1.4rem;display:flex;position:absolute}body .tr-wrapper .screen-results .results .results-visual .cube-container .measurement.length[data-v-e74703]{-webkit-transform:translateZ(100px);transform:translateZ(100px)}body .tr-wrapper .screen-results .results .results-visual .cube-container .measurement.height[data-v-e74703]{-webkit-transform:translateZ(100px)rotate(90deg);transform:translateZ(100px)rotate(90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .measurement.width[data-v-e74703]{-webkit-transform:translate(-100px)rotateY(-90deg);transform:translate(-100px)rotateY(-90deg)}@media (prefers-reduced-motion:reduce){body .tr-wrapper .screen-results .results .results-visual .cube-container .cube[data-v-e74703]{-webkit-animation:none;animation:none;-webkit-transform:rotate3d(1,1,0,45deg);transform:rotate3d(1,1,0,45deg)}}body .tr-wrapper .screen-results .results .results-visual .cube-container .caption[data-v-e74703]{width:20em;font-size:1.25em;position:absolute;bottom:-2.5em;left:-1em}body .tr-wrapper .screen-results .details[data-v-e74703]{color:#000;font-size:1.4rem}body .tr-wrapper .screen-results .details p[data-v-e74703]{color:#000;margin:.5em 0;font-size:1.4rem}body .tr-wrapper .screen-results.madagascarDayGecko .results .results-visual .rectangle[data-v-e74703],body .tr-wrapper .screen-results.goldDustDayGecko .results .results-visual .rectangle[data-v-e74703]{height:41%}body .tr-wrapper .screen-results.macaw .results .results-panel[data-v-e74703],body .tr-wrapper .screen-results.cockatoo .results .results-panel[data-v-e74703]{display:none}body .tr-wrapper .screen-results.equidae .results[data-v-e74703]{justify-content:center}body .tr-wrapper .screen-results.equidae .results .results-visual[data-v-e74703]{max-width:50%;padding-top:32%}body .tr-wrapper .screen-results.equidae .results .results-visual .cube-container[data-v-e74703]{margin-top:20px}body .tr-wrapper .screen-results.equidae .results .results-text[data-v-e74703]{flex-wrap:wrap;gap:20px;max-width:100%;display:flex}body .tr-wrapper .screen-results.equidae .results .results-text .results-text-recommendations[data-v-e74703],body .tr-wrapper .screen-results.equidae .results .results-text .results-text-laws[data-v-e74703]{min-width:360px;max-width:calc(50% - 10px)}body .tr-wrapper .reptiles-revision .screen-animal-selection[data-v-e74703],body .tr-wrapper .reptiles-revision .screen-length[data-v-e74703],body .tr-wrapper .reptiles-revision .screen-number[data-v-e74703],body .tr-wrapper .reptiles-revision .screen-results[data-v-e74703]{display:none}body .sts-tierhaltungsrechner.max1400 .tr-wrapper.style-button.open[data-v-e74703]{padding-top:100px}body .sts-tierhaltungsrechner.max1400 .tr-wrapper .logos .logo.logo-sts[data-v-e74703]{max-width:300px}body .sts-tierhaltungsrechner.max1400 .tr-wrapper .footer[data-v-e74703]{max-width:1000px;margin:0 auto}body .sts-tierhaltungsrechner.max1400 .tr-wrapper h2[data-v-e74703]{text-align:left;max-width:75%}body .sts-tierhaltungsrechner.max884 .tr-wrapper[data-v-e74703]{padding:2em}body .sts-tierhaltungsrechner.max884 .tr-wrapper.style-button.open[data-v-e74703]{width:calc(96% - 4em);padding-top:100px}body .sts-tierhaltungsrechner.max884 .tr-wrapper .close-button[data-v-e74703]{left:2em;right:auto}body .sts-tierhaltungsrechner.max884 .tr-wrapper .footer .logos[data-v-e74703]{text-align:left}body .sts-tierhaltungsrechner.max884 .tr-wrapper .logo.logo-sts[data-v-e74703]{max-width:250px}body .sts-tierhaltungsrechner.max884 .tr-wrapper .screen-animal-selection .image-buttons[data-v-e74703]{gap:20px 2%}body .sts-tierhaltungsrechner.max884 .tr-wrapper .screen-animal-selection .image-buttons button.image-button[data-v-e74703]{max-width:32%}body .sts-tierhaltungsrechner.max884 .tr-wrapper .screen-animal-selection .image-buttons button.image-button img[data-v-e74703]{max-width:100%}body .sts-tierhaltungsrechner.max884 .tr-wrapper .screen-results.horse .results .results-visual .cube-container[data-v-e74703]{margin-top:0}body .sts-tierhaltungsrechner.max756 .tr-wrapper .logos .logo.logo-sts[data-v-e74703]{max-width:250px;top:1em}body .sts-tierhaltungsrechner.max756 .tr-wrapper h2[data-v-e74703]{text-align:left;max-width:70%;font-size:3.5em}body .sts-tierhaltungsrechner.max756 .tr-wrapper .number-input[data-v-e74703]{display:flex}body .sts-tierhaltungsrechner.max756 .tr-wrapper .button[data-v-e74703]{width:325px;margin:0!important;padding:0!important}body .sts-tierhaltungsrechner.max756 .tr-wrapper .message-container .message-overlay[data-v-e74703]{left:0;right:0}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-animal-selection .image-buttons button.image-button span[data-v-e74703]{font-size:1em}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-number .error-overlay[data-v-e74703]{width:calc(100% - 6em);left:0}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .results .results-panel[data-v-e74703]{max-width:100%}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .results .results-panel .rectangle[data-v-e74703]{width:100%;height:100%}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .results .results-visual[data-v-e74703]{margin-bottom:4em}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .results .results-visual .cube-container[data-v-e74703]{margin-top:60px}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .screen-results.horse .results .results-visual .cube-container[data-v-e74703]{margin-top:10px}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .screen-results.equidae .results .results-visual[data-v-e74703]{padding-top:40%}body .sts-tierhaltungsrechner.max540[data-v-e74703]{--tr-visual-3d-scale:.8}body .sts-tierhaltungsrechner.max540 .tr-button[data-v-e74703]{flex-wrap:wrap;justify-content:center;padding:1em}body .sts-tierhaltungsrechner.max540 .tr-button .logo[data-v-e74703]{margin-bottom:.5em;margin-right:.5em}body .sts-tierhaltungsrechner.max540 .tr-wrapper[data-v-e74703]{padding:2em 1em}body .sts-tierhaltungsrechner.max540 .tr-wrapper.style-button.open[data-v-e74703]{width:calc(96% - 2em);padding-top:100px}body .sts-tierhaltungsrechner.max540 .tr-wrapper .close-button[data-v-e74703]{left:1em}body .sts-tierhaltungsrechner.max540 .tr-wrapper h2[data-v-e74703]{text-align:left;max-width:70%;font-size:3em}body .sts-tierhaltungsrechner.max540 .tr-wrapper p[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper label[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper h3[data-v-e74703]{margin-bottom:1em;font-size:1.4rem}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-image-wrapper[data-v-e74703]{max-width:100%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-image-wrapper img[data-v-e74703]{width:80%;margin:-10% auto 0}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-length .screen-image-wrapper[data-v-e74703]{aspect-ratio:auto;padding:60px 20px}body .sts-tierhaltungsrechner.max540 .tr-wrapper .number-input[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper .withers-height-input[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper .length-input[data-v-e74703]{width:100%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .select-wrapper[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper .select-wrapper select[data-v-e74703]{width:100%!important}body .sts-tierhaltungsrechner.max540 .tr-wrapper .button[data-v-e74703]{width:100%;margin:0 0 1em}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-animal-selection .image-buttons[data-v-e74703]{gap:20px 2%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-animal-selection .image-buttons button.image-button[data-v-e74703]{max-width:48%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-animal-selection .image-buttons button.image-button img[data-v-e74703]{max-width:100%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-animal-selection .image-buttons button.image-button span[data-v-e74703]{font-size:1em}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results .results .results-visual[data-v-e74703]{margin-bottom:10em}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results .results .results-visual .cube-container[data-v-e74703]{margin:40px}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results.horse .results .results-visual[data-v-e74703]{padding-top:10%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results.horse .results .results-visual .cube-container[data-v-e74703]{margin-left:80px}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results.equidae .results .results-visual[data-v-e74703]{padding-top:30%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .bottom-navi[data-v-e74703]{margin-top:2em}";


const $b5390166f967b306$var$style = document.createElement("style");
$b5390166f967b306$var$style.appendChild(document.createTextNode((0, (/*@__PURE__*/$parcel$interopDefault($16e82825b28a2514$exports)))));
document.head.appendChild($b5390166f967b306$var$style);
const $b5390166f967b306$var$thrInit = function() {
    const appElements = document.querySelectorAll(".sts-tierhaltungsrechner");
    console.log(appElements);
    appElements.forEach((instance)=>{
        // Default Config
        const tierhaltungsrechnerDefaultConfig = {
            locale: "de_CH",
            enableLogs: false,
            preselectCategory: false,
            preselectAnimal: false,
            style: "full",
            historyMode: "internal"
        };
        let thrConfig = {};
        // Read config from global object tierhaltungsrechnerConfig.
        // Deprecated config method, but still implemented for compatibility.
        /* global tierhaltungsrechnerConfig */ if (typeof tierhaltungsrechnerConfig === "object") thrConfig = {
            ...tierhaltungsrechnerDefaultConfig,
            ...tierhaltungsrechnerConfig
        };
        else thrConfig = tierhaltungsrechnerDefaultConfig;
        // Read config from data attributes in the DOM element.
        if (typeof instance.dataset === "object") thrConfig = {
            ...thrConfig,
            ...instance.dataset
        };
        console.log(thrConfig);
        // Logging config
        const loggingOptions = {
            isEnabled: thrConfig.enableLogs,
            logLevel: "debug",
            stringifyArguments: true,
            showLogLevel: true,
            showMethodName: false,
            separator: "|",
            showConsoleColors: true
        };
        // I18N
        const i18n = (0, $315a3f3f8869d00f$export$920091e3d72d80ee)({
            locale: thrConfig.locale,
            fallbackLocale: tierhaltungsrechnerDefaultConfig.locale,
            messages: (/*@__PURE__*/$parcel$interopDefault($3fef6818d98ebd0f$exports))
        });
        // Initialize App
        const app = (0, $90kfS.createApp)((0, $ad5a9047874b1a56$export$2e2bcd8739ae039), {
            thrConfig: thrConfig
        });
        app.use(i18n);
        app.use((0, (/*@__PURE__*/$parcel$interopDefault($0c7298f63c35bd07$exports))), loggingOptions);
        app.mount(instance);
    });
    // Class names depending on width
    function trWidthClasses() {
        appElements.forEach((instance)=>{
            instance.classList.remove("max1400", "max884", "max756", "max540");
            if (instance.offsetWidth <= 1400) instance.classList.add("max1400");
            if (instance.offsetWidth <= 884) instance.classList.add("max884");
            if (instance.offsetWidth <= 756) instance.classList.add("max756");
            if (instance.offsetWidth <= 540) instance.classList.add("max540");
        //new ResizeObserver(trWidthClasses).observe(instance);
        });
    }
    // Events to set class names
    window.addEventListener("load", ()=>{
        trWidthClasses();
    });
    document.addEventListener("DOMContentLoaded", ()=>{
        trWidthClasses();
    });
/*

// Load Analytics
  function dynamicallyLoadScript(url) {
    var script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-K34PW3LPX1';

    document.head.appendChild(script);
  }

// Load a script
  function loadScript(url, callback) {
    var head = document.head;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

// Bind the event to the callback function.
    script.onreadystatechange = callback;
    script.onload = callback;

// Load script
    head.appendChild(script);
  }

// Start Analytics
  function runAnalytics() {
    window.dataLayer = window.dataLayer || [];

    window.gtagTR = function() {
      window.dataLayer.push(arguments);
    };

    window.gtagTR('js', new Date());

    window.gtagTR('config', 'G-K34PW3LPX1');
  }

  loadScript('https://www.googletagmanager.com/gtag/js?id=G-K34PW3LPX1',
      runAnalytics);

*/ };
$b5390166f967b306$var$thrInit();


//# sourceMappingURL=index.bf2d322c.js.map
